{
 " ao(à) paciente {nome}{cpf}": "（患者：{nome}{cpf}）",
 " junto ao plano de saúde {c}": "医療保険「{c}」への",
 " às {h}": " {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\"、\"1 / 10\"、\"ページ 1 / 10\" を好きな隅に表示します。",
 "\"{nome}\" está no {provedor}.": "「{nome}」は {provedor} にあります。",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" は JPG でも PNG でもありません。JPG に変換してもう一度お試しください。",
 "\"{nome}\" não é um PDF.": "\"{nome}\" は PDF ではありません。",
 "\"{nova}\" às {hora} coincide com: {outras}.": "「{nova}」（{hora}）は次の予定と重なっています：{outras}。",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "「{n}」はグループのものになりました。1分以内に他のメンバーにもすべて表示されます。",
 "\"{titulo}\" foi criada com os mesmos dados.": "「{titulo}」を同じ内容で作成しました。",
 "\"{titulo}\" já foi adicionado em {data}.": "「{titulo}」は {data} にすでに追加されています。",
 "% ao mês": "%（月利）",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "（管理者のパソコンで：32-LIGAR-DRIVE-ONEDRIVE.bat。）",
 "(cópia)": "（コピー）",
 "(sem título)": "（無題）",
 "+ Adicionar alerta": "+ アラートを追加",
 "+ Adicionar outra OAB": "+ 別の OAB を追加",
 "+ Adicionar pausa": "+ 休憩を追加",
 "+ Adicionar subtarefa": "+ サブタスクを追加",
 "+ Matéria em {nome}": "+ {nome}に科目を追加",
 "+ Perfil": "+ プロフィール",
 "+ Subtarefa": "+ サブタスク",
 "+5 min": "+5分",
 "+{n} acompanhante(s)": "+同伴者{n}人",
 "+{n} páginas acima da meta": "目標より +{n} ページ",
 ", carteirinha nº {n},": "、保険証番号 {n}、",
 ", pago em {d}{f}": "、{d}に支払い済み{f}",
 "1 cápsula": "1カプセル",
 "1 dose": "1回分",
 "1 dose (30 g)": "1回分（30 g）",
 "1 pessoa": "1人",
 "1 publicação nova": "新しい公告 1 件",
 "1 página": "1 ページ",
 "1 tarja no documento": "文書内の黒塗り 1 か所",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. My Planner をインストールしてアカウントを作成します。  2. このリンクをもう一度開きます（または 設定 › グループと招待 でコードを入力）。",
 "1. Quais dados tratamos": "1. 取り扱うデータ",
 "1. Sobre o app": "1. アプリについて",
 "1ª dose": "1回目",
 "2 por folha": "1 枚に 2 ページ",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "小麦粉 2カップ\n卵 3個\nベーキングパウダー 大さじ1",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "1 枚に 2、4、6、9 ページ（印刷用）。",
 "2. Para que usamos": "2. 利用目的",
 "2. Sua conta": "2. アカウント",
 "2ª dose": "2回目",
 "3 a 5 g": "3〜5 g",
 "3. Bases legais (LGPD)": "3. 法的根拠（LGPD）",
 "3. Uso correto": "3. 適切な利用",
 "3ª dose": "3回目",
 "4 por folha": "1 枚に 4 ページ",
 "4. Com quem compartilhamos": "4. 共有先",
 "4. Planos e testes": "4. プランと試用",
 "5. Limites": "5. 責任の範囲",
 "5. Segurança": "5. セキュリティ",
 "6 por folha": "1 枚に 6 ページ",
 "6. Por quanto tempo": "6. 保存期間",
 "7. Seus direitos (art. 18 da LGPD)": "7. あなたの権利（LGPD art. 18）",
 "8. Crianças e adolescentes": "8. 子どもと未成年者",
 "9 por folha": "1 枚に 9 ページ",
 "9. Mudanças": "9. 変更",
 "@letra-dom": "日",
 "@letra-qua": "水",
 "@letra-qui": "木",
 "@letra-sab": "土",
 "@letra-seg": "月",
 "@letra-sex": "金",
 "@letra-ter": "火",
 "A IA está classificando...": "AIが分類しています...",
 "A IA está lendo a caixa...": "AI がボックスを読み取っています...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "AI がページを読み取り、PDF を検索・コピーできるようにします。",
 "A IA lê o PDF e sugere um nome claro.": "AI が PDF を読み、わかりやすい名前を提案します。",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "AI の応答が想定した形式ではありませんでした。もう一度お試しください。",
 "A IA não encontrou dados para esta ficha no arquivo.": "AIはファイル内にこのカードのデータを見つけられませんでした。",
 "A IA não encontrou tarefas nesta caixa.": "AI はこのボックスにタスクを見つけられませんでした。",
 "A IA resume o PDF e responde perguntas.": "AI が PDF を要約し、質問に答えます。",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "SEFAZ に「この請求書を確認した」ことが記録されます（購入の承認や拒否ではありません）。完全な XML は次回の検索時、1 時間以内に取得できます。",
 "A VENCER (7 DIAS)": "もうすぐ期限（7日以内）",
 "A aba inteira": "タブ全体",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "タブ「{aba}」の容量が上限に近づいています。古い項目をアーカイブするか削除してください。",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "{aba}タブは未契約です。リンクは保存され、契約すると元に戻ります。",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "「{nome}」の検索範囲が広すぎます。フルネームを入力してください。",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "このアプリではGIF検索はまだ有効になっていません。それまではアニメーションスタンプ (🎉) をお使いください。",
 "A cada": "毎",
 "A cada N páginas": "N ページごと",
 "A cada quantos dias": "何日ごと",
 "A cada {n} dia(s)": "{n}日ごと",
 "A cada {n} mês(es)": "{n}か月ごと",
 "A cada {n} mês(es) · dia {d}": "{n}か月ごと · {d}日",
 "A cada {n} semana(s)": "{n}週間ごと",
 "A cada {n} semana(s) · {dia}": "{n}週間ごと · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "ボックスは{aba}の「受け取ったメモ」にあります。",
 "A caixa foi para {destino}.": "ボックスを{destino}に送りました。",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "キーはこの端末のシステム保管庫にのみ保存されます。別の端末では再登録してください。",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "キーはこのブラウザにのみ保存されます。個人のパソコンでご利用ください。",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "通信は暗号化されています。金庫はエンドツーエンド暗号化（AES-256）を使用しており、サポートでも読むことはできません。アプリはパスワード、パターン、生体認証でロックできます。",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "WhatsAppでの確認はまだサーバーで有効になっていません。",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "アカウントとクラウドに保存されたすべてのデータ（タスク、メモ、タブ、記録、メッセージ、アプリに送ったファイル、設定）。この端末のデータも削除されます。元に戻せません。",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "この色はバー、見出し、このタブに関連するタスクに表示されます。",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "My Plannerの色はアプリのアクセントカラーです。各タスクは詳細画面で個別の色を設定できます。",
 "A data de fim é anterior à de início.": "終了日が開始日より前になっています。",
 "A data inicial precisa ser antes da final.": "開始日は終了日より前にしてください。",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "チームがエラーを確認し、次回以降のアップデートで修正します。",
 "A equipe vê e altera conforme o papel de cada um": "チームは各自の役割に応じて閲覧・編集します",
 "A fazer": "未着手",
 "A foto passa de 8 MB.": "写真が 8 MB を超えています。",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "写真が大きすぎます。写真をトリミングするには、新しいバージョンのアプリをインストールしてください。",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "「nuvem」関数はまだサーバーに公開されていません。32-LIGAR-DRIVE-ONEDRIVE.bat を実行してください。",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "サーバーに「nuvem」関数がまだ公開されていません。9-LIGAR-DRIVE-ONEDRIVE.bat を実行してください（COMO RODAR のバージョン 0.15.1 を参照）。",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "録画はまだ準備中です。数分後にもう一度お試しください。",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "時刻はこのタイムゾーンで記録されます。別のタイムゾーンでは、換算した時刻で表示・通知します。",
 "A imagem original não está neste dispositivo.": "元の画像はこのデバイスにありません。",
 "A pagar": "未払い",
 "A pagar: {v}": "未払い：{v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "カレンダーへのアクセス許可が取り消されました。スマートフォンの設定でもう一度許可してください。",
 "A pessoa sai do grupo e deixa de receber os envios.": "この人はグループから退出し、配信を受け取らなくなります。",
 "A receber": "受取予定",
 "A receber: {v}": "受取予定：{v}",
 "A reunião ainda está sendo gravada.": "会議はまだ録画中です。",
 "A senha atual não confere.": "現在のパスワードが正しくありません。",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "金庫のパスワードは6文字以上にしてください。",
 "A senha precisa ter 8 caracteres ou mais.": "パスワードは8文字以上にしてください。",
 "A senha precisa ter pelo menos 8 caracteres.": "パスワードは8文字以上必要です。",
 "A senha é a mesma no celular e no My Planner Web.": "パスワードはスマートフォンと My Planner Web で共通です。",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "同期はアプリを開いたときと、変更のたびに行われます。カレンダーと連携したタスクには 📆 が表示されます。",
 "A sua equipe num lugar só": "チームをひとつの場所に",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "家事は自動では My Planner に入りません。「My Planner に送る」で詳細画面が開き、日付・時間・頻度・休憩・アラートを選べます。",
 "A validade não pode ser antes da emissão.": "有効期限は発行日より前にできません。",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "iPhone 版はまもなく App Store で公開予定です。それまでは My Planner Web をご利用ください。",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "iPhone 版は近日 App Store で公開予定です。それまでは My Planner Web をご利用ください。Safari で「共有」>「ホーム画面に追加」をタップすると、スマートフォンにアイコンとして追加できます。",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4、レター、A5、リーガルに、何も切らずに合わせます。",
 "ADICIONAR AMIGO": "友だちを追加",
 "AGUARDANDO RESPOSTA": "返信待ち",
 "AMIGOS": "友だち",
 "ANOTAÇÕES": "メモ",
 "ANOTAÇÕES RECEBIDAS · {aba}": "受け取ったメモ · {aba}",
 "ATIVIDADE": "アクティビティ",
 "ATIVIDADE FÍSICA": "運動",
 "ATRASADAS": "期限切れ",
 "Aba": "タブ",
 "Aba bloqueada": "ロック中のタブ",
 "Aba {nome}": "{nome}タブ",
 "Abas": "タブ",
 "Abas liberadas pelo suporte": "サポートが開放したタブ",
 "Abas para comprar": "購入できるタブ",
 "Abas que você já tem": "お持ちのタブ",
 "Abastecimento": "給油",
 "Abastecimentos": "給油",
 "Abdominal": "腹筋（クランチ）",
 "Abertura do prazo da declaração do IR": "確定申告の受付開始",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "会社を開いて「請求書を検索」をタップし、金庫のパスワードを入力してください。",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "My Planner Anne を開き、ID 番号とパスワードでログインします。",
 "Abra o My Planner no celular.": "スマートフォンでMy Plannerを開いてください。",
 "Abra o cofre": "金庫を開く",
 "Abra um PDF para começar.": "PDF を開いて始めましょう。",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "科目を開いて「今すぐ勉強」をタップすると計測できます。科目ごとに週の目標を設定しましょう。",
 "Abraço": "ハグ",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "スマートフォンの共有メニューを開きます：WhatsApp、メール、Google Drive、OneDrive、「ファイル」に保存など。",
 "Abre o PDF para ler aqui mesmo.": "PDF をこの場で開いて読めます。",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "PDF スキャナーを開きます（端と影を補正）。",
 "Abrir": "開く",
 "Abrir Ajustes": "設定を開く",
 "Abrir PDF": "PDF を開く",
 "Abrir PDF do celular, Drive ou OneDrive": "スマホ、Drive、OneDrive から PDF を開く",
 "Abrir a aba": "タブを開く",
 "Abrir a cópia guardada": "保存したコピーを開く",
 "Abrir a pasta no Drive": "Drive のフォルダを開く",
 "Abrir com outro app": "ほかのアプリで開く",
 "Abrir configurações": "設定を開く",
 "Abrir em outro app": "他のアプリで開く",
 "Abrir no DJEN": "DJENで開く",
 "Abrir no modo seguro": "セーフモードで開く",
 "Abrir normalmente": "通常どおり開く",
 "Abrir nota fiscal": "領収書を開く",
 "Abrir o PDF": "PDF を開く",
 "Abrir o PDF no {nome}": "{nome} で PDF を開く",
 "Abrir o XML": "XML を開く",
 "Abrir o app": "アプリを開く",
 "Abrir o app My Planner": "My Planner アプリを開く",
 "Abrir o cartão": "カードを開く",
 "Abrir o cofre": "金庫を開く",
 "Abrir o cofre para ver": "金庫を開いて表示",
 "Abrir o diário oficial": "官報を開く",
 "Abrir ou baixar": "開く／ダウンロード",
 "Abrir página": "ページを開く",
 "Abrir site": "サイトを開く",
 "Abrir {nome}": "{nome} を開く",
 "Acabamento": "仕上げ",
 "Acabou": "在庫切れ",
 "Academia": "ジム",
 "Aceitar": "承認",
 "Aceitar, editar ou recusar": "承認・編集・却下",
 "Aceite os termos para continuar.": "続けるには規約に同意してください。",
 "Aceito": "承認済み",
 "Aceito com alterações": "変更して承認",
 "Acerto de contas": "精算",
 "Acerto de contas: {v}": "精算：{v}",
 "Acessibilidade": "アクセシビリティ",
 "Acesso ilimitado": "無制限アクセス",
 "Acesso ilimitado a todas as funções, sem prazo": "すべての機能を期限なしで無制限に利用",
 "Achatar": "フラット化",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "費用を含めすべてを確認し、日誌に記録します。",
 "Acompanhamento": "副菜",
 "Acompanhantes": "同伴者",
 "Acrescentar no fim da página": "ページの末尾に追加",
 "Adaptador de tomada": "変換プラグ",
 "Adestramento": "しつけ",
 "Adicionar": "追加",
 "Adicionar amigo": "友だちを追加",
 "Adicionar amigos do app": "アプリの友だちを追加",
 "Adicionar ao Planner?": "Planner に追加しますか？",
 "Adicionar arquivo": "ファイルを追加",
 "Adicionar cômodo": "部屋を追加",
 "Adicionar fotos e vídeos": "写真と動画を追加",
 "Adicionar imagem": "画像を追加",
 "Adicionar item (ex.: 2 ovos mexidos)": "項目を追加（例：スクランブルエッグ 卵2個）",
 "Adicionar na página": "ページに追加",
 "Adicionar passo": "ステップを追加",
 "Adicionar país": "国を追加",
 "Adicionar página": "ページを追加",
 "Adicionar texto": "テキストを追加",
 "Adicionar {nome}": "{nome}を追加",
 "Adicionar à equipe": "チームに追加",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "相手のコードで友だちを追加するか、あなたのコードを送ってください。",
 "Admin": "管理者",
 "Administração": "経営学",
 "Adubar a cada quantos dias": "何日ごとに肥料",
 "Adubar: {p}": "肥料：{p}",
 "Adubei hoje": "今日肥料をあげた",
 "Advogado": "弁護士",
 "Advogados": "弁護士",
 "Afundo": "ランジ",
 "Agachamento": "スクワット",
 "Agenda do Google": "Google カレンダー",
 "Agenda limpa": "予定を整理しました",
 "Agenda não liberada": "カレンダーが許可されていません",
 "Agenda sincronizada ✓": "カレンダーを同期しました ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "予定、メモ、家計、学習、メッセージなどをひとつのアプリで。",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "予約、患者情報、支払い。カルテは除きます。",
 "Agendado": "予定済み",
 "Agendado no My Planner": "My Planner に予定済み",
 "Agendamento no pet shop": "ペットショップの予約",
 "Agendar": "予定に入れる",
 "Agendar no My Planner": "My Planner に予定を入れる",
 "Agendar no My Planner (dias e horários)": "My Planner に予定を入れる（曜日と時間）",
 "Agora não": "今はしない",
 "Agora o verso do documento.": "次は書類の裏面です。",
 "Agora, {hora}": "現在 {hora}",
 "Agora: {ml}": "現在：{ml}",
 "Aguardando o celular · {s}s": "スマートフォンを待っています · {s}秒",
 "Aguarde": "お待ちください",
 "Aguarde um pouco": "少しお待ちください",
 "Aguarde...": "お待ちください...",
 "Ainda a pagar no mês": "今月の未払い",
 "Ainda a receber no mês": "今月の未入金",
 "Ainda não confirmado": "未確認",
 "Ainda não disponível: falta configurar no servidor.": "まだ利用できません：サーバーの設定が必要です。",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "今月はまだ何も貯めていません。お金が入ったらすぐに{v}（入金の10%）を取り分けてみませんか？",
 "Ainda não há feriados deste país para este ano.": "この国の今年の祝日はまだありません。",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "このタブにはまだ共有できるものがありません。まず作成して（例：旅行）、ここに戻ってください。",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "グループにはまだ他のメンバーがいません（またはメンバー一覧を表示できません）。",
 "Ainda não marcado como feito. Toque para abrir.": "まだ完了になっていません。タップして開きます。",
 "Ainda não sincronizado": "まだ同期されていません",
 "Ainda sem chave neste dispositivo.": "この端末にはまだキーがありません。",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb、Booking、直接予約：予約、チェックアウト後の清掃、収入、経費、月の利益",
 "Ajuda na organização": "運営のお手伝い",
 "Ajudante": "手伝い",
 "Ajustar": "調整",
 "Ajustar a data final": "終了日を調整",
 "Ajustar a folha": "用紙を調整",
 "Ajustar tamanho da página": "ページサイズを調整",
 "Ajuste visual": "見た目の調整",
 "Ajustes": "設定",
 "Alarme dos remédios": "服薬アラーム",
 "Alarme que insiste até marcar como tomado": "服用済みにするまで鳴り続けるアラーム",
 "Alemão": "ドイツ語",
 "Alergia": "アレルギー",
 "Alergias": "アレルギー",
 "Alergias e alertas": "アレルギー・注意事項",
 "Alertas": "アラート",
 "Alertas das tarefas": "タスクのアラート",
 "Alertas dos compromissos": "予定の通知",
 "Algo deu errado, mas o app continua aberto": "問題が発生しましたが、アプリは開いたままです",
 "Alguns arquivos foram guardados em outro dispositivo.": "一部のファイルは別の端末に保存されています。",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "一部の時計（Huawei など）は Health Connect にデータを送信しない場合があります。その場合は手動で入力してください。",
 "Alguém": "誰か",
 "Alguém indicou o app para você?": "誰かにこのアプリを紹介されましたか？",
 "Alimentação": "食事",
 "Alimentação & Despensa": "食事＆食品ストック",
 "Alimentação {semana}": "食事 {semana}",
 "Alimento": "食品",
 "Alinhamento e balanceamento": "アライメントとバランス調整",
 "Almoço": "昼食",
 "Alongamento": "ストレッチ",
 "Alta": "高",
 "Alterado por último por {nome}": "最終更新者: {nome}",
 "Alterar metadados": "メタデータを変更",
 "Alterar o valor pago": "支払額を変更",
 "Alterações": "変更",
 "Alto-falante": "スピーカー",
 "Aluga como": "貸し方",
 "Alugar a casa ou um cômodo": "家や部屋を貸す",
 "Aluguel": "賃料",
 "Aluguel & Hospedagem": "賃貸・民泊",
 "Aluguel de carro": "レンタカー",
 "Aluno": "生徒",
 "Alunos": "生徒",
 "Alvará ou licença": "許可証・免許",
 "Alvenaria": "組積工事",
 "Alvo": "目標額",
 "Alíquota do ISS (%)": "ISS 税率（%）",
 "Alíquota do ISS deste serviço (%)": "このサービスの ISS 税率（%）",
 "Amanhã": "明日",
 "Ambiente": "環境",
 "Ameno": "穏やか",
 "Amigos": "友人",
 "Amor": "愛",
 "Amortização": "元金返済",
 "Ampliar a foto": "写真を拡大",
 "Amém": "アーメン",
 "Analisar com IA": "AI で分析",
 "Anamnese e histórico (no cofre)": "問診・既往歴（金庫内）",
 "Anexar arquivos": "ファイルを添付",
 "Anexar comprovante": "控えを添付",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "書類の添付、明細の取り込み、レポート・PDF・バックアップの保存に使います。",
 "Anexos": "添付ファイル",
 "Anexos guardados aqui no dispositivo: {n}": "この端末に保存された添付ファイル：{n}",
 "Animais e natureza": "動物と自然",
 "Animação": "アニメーション",
 "Anime": "アニメ",
 "Aniversário": "誕生日",
 "Aniversário de Campo Grande": "カンポ・グランデ市制記念日",
 "Aniversário de São Paulo": "サンパウロ市制記念日",
 "Ano": "年",
 "Ano anterior": "前年",
 "Ano de lançamento": "公開年",
 "Ano de {ano}": "{ano}年",
 "Ano passado": "昨年",
 "Anotar pela foto da página": "ページの写真からメモ",
 "Anotação": "メモ",
 "Anotação de {data}": "{data} のメモ",
 "Anotação do professor": "先生のメモ",
 "Anotação à mão": "手書きメモ",
 "Anotações": "メモ",
 "Anotações Rápidas": "クイックメモ",
 "Anotações arquivadas": "アーカイブしたメモ",
 "Anotações arquivadas ({n})": "アーカイブしたメモ（{n}）",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "予約ごとに日付、予約元、金額を記録しましょう。チェックアウト後の清掃は清掃リストに自動で追加されます。",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "工事の毎日を写真付きで記録します。写真をビフォーまたはアフターに設定すると、進み具合が見られます。",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "貸したもの・借りたものを写真と期限付きで記録します。返却日にアプリがお知らせします。",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "行きたい場所をメモしましょう。Google Maps や Waze で検索し、すべてを回るルートを作って、その日の旅程に追加します。",
 "Anteriores ({n})": "過去の会議（{n}）",
 "Antes": "ビフォー",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "始める前に、アプリが何をなぜ使うのかを確認してください。あとで 設定 > プライバシーと規約 からいつでも変更できます。",
 "Antes de uma data": "指定日より前",
 "Antes do início": "開始前",
 "Antes e depois": "ビフォー・アフター",
 "Antes: {lista}": "事前：{lista}",
 "Antipulgas": "ノミ対策",
 "Anual": "毎年",
 "Ao ar livre": "屋外",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "解約するとタブは白黒表示になり、タスクとのリンクは外れますが、データは削除されません。",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "アカウントを作成するか、アプリを引き続き利用することで、本規約および以下のプライバシーポリシーに同意したものとみなされます。",
 "Ao fechar, a página é salva.": "閉じるとページが保存されます。",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "保存すると金庫のパスワードが作成されます。この項目は端末上で暗号化されます。",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "「勉強」や「書類」で「ファイル」または「写真」をタップすると、スマホの選択画面に Google Drive、OneDrive、Dropbox（アプリがインストールされている場合）が表示されます。そこから直接ファイルを選んでください。",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "添付ファイルをタップすると、選んだスマホのアプリで開きます（Android では「1回のみ」または「常時」）。そこで編集した内容はファイル自体に保存されます。",
 "Apaga a conta e todos os vencimentos dela.": "この支払いとすべての期日を削除します。",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "このバインダーの科目とページを削除します。プランナーのタスクは残ります。",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "この科目のページを削除します。勉強時間の履歴は残ります。",
 "Apaga o cartão e as compras dele.": "このカードと購入履歴を削除します。",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "クラウドとこの端末にあるアカウントとすべてのデータを完全に削除します。元に戻せません。",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "過去と今後のすべてのタスクを予定から削除します。",
 "Apaga todas as {n} parcelas.": "{n}回分の分割払いをすべて削除します。",
 "Apaga todos os meses desta conta.": "この支払いのすべての月を削除します。",
 "Apagar": "削除",
 "Apagar \"{nome}\"?": "「{nome}」を削除しますか？",
 "Apagar a caixa?": "ボックスを削除しますか？",
 "Apagar a chave": "キーを削除",
 "Apagar a chave deste dispositivo?": "この端末のキーを削除しますか？",
 "Apagar a conta?": "アカウントを削除しますか？",
 "Apagar a lista de erros?": "エラー一覧を削除しますか？",
 "Apagar a pasta (os documentos continuam)": "フォルダーを削除（書類は残ります）",
 "Apagar as da agenda": "カレンダーの分を削除",
 "Apagar caixa": "ボックスを削除",
 "Apagar de verdade (as páginas com tarja viram imagem)": "完全に消去（黒塗りのあるページは画像になります）",
 "Apagar de vez": "完全に削除",
 "Apagar desenho": "描画を消去",
 "Apagar envio": "配信を削除",
 "Apagar lista": "一覧を削除",
 "Apagar minha conta": "アカウントを削除",
 "Apagar minha conta e todos os dados": "アカウントとすべてのデータを削除",
 "Apagar o escritório": "オフィスを削除",
 "Apagar o escritório?": "オフィスを削除しますか？",
 "Apagar o grupo": "グループを削除",
 "Apagar o grupo?": "グループを削除しますか？",
 "Apagar o lançamento?": "この記録を削除しますか？",
 "Apagar para todos": "全員から削除",
 "Apagar tudo": "すべて削除",
 "Apagar tudo antes de": "この日より前をすべて削除",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "今日、今月、指定期間、または名前でタスクをまとめて削除できます。削除前に対象を表示し、パスワードの入力を求めます。",
 "Aparece na barra quando estiver liberada": "利用可能になるとバーに表示されます",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Planner に表示されます。任意休日（カーニバル、灰の水曜日、聖体の祝日）も一緒に表示されます。",
 "Aplicar": "適用",
 "Aponte a câmera do celular para este QR Code.": "スマートフォンのカメラをこのQRコードに向けてください。",
 "Aponte para o QR Code na tela do computador": "パソコン画面のQRコードにカメラを向けてください",
 "Apostila": "テキスト",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "テキスト、問題集、スライド、動画、リンク、お知らせ。⋮ › グループに送信 で、生徒一人ひとりのアプリに届きます。",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "住所の「ルート」ボタンで使うアプリ（タスク、受診、旅行の行程、工事、学校など）。",
 "Apple Saúde": "Apple ヘルスケア",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch：すでにすべて iPhone の「ヘルスケア」App に記録されます。操作は不要です。",
 "Apresentação": "発表",
 "Aprovação": "承認待ち",
 "Aqui": "現地",
 "Ar-condicionado": "エアコン",
 "Arco-íris": "虹",
 "Arenoso": "砂質",
 "Armazenamento": "ストレージ",
 "Armário": "戸棚",
 "Arquivadas ({n})": "アーカイブ済み（{n}）",
 "Arquivados ({n})": "アーカイブ（{n}）",
 "Arquivar": "アーカイブ",
 "Arquivar a caixa de anotações?": "メモのボックスをアーカイブしますか？",
 "Arquivar conversa": "トークをアーカイブ",
 "Arquivo": "ファイル",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "ファイル（Drive、OneDrive、Dropbox、または端末内）",
 "Arquivo OFX ou CSV do banco": "銀行のOFXまたはCSVファイル",
 "Arquivo adicionado": "ファイルを追加しました",
 "Arquivo menor (para WhatsApp e e-mail)": "ファイルを小さく（WhatsApp・メール用）",
 "Arquivo menor para WhatsApp e e-mail.": "WhatsApp やメール向けに小さいファイルにします。",
 "Arquivo não encontrado.": "ファイルが見つかりません。",
 "Arquivo ou PDF": "ファイルまたは PDF",
 "Arquivo ou documento": "ファイル・書類",
 "Arquivos": "ファイル",
 "Arquivos (frente, verso, PDF)": "ファイル（表面、裏面、PDF）",
 "Arquivos (importar e exportar)": "ファイル（インポートとエクスポート）",
 "Arquivos de {nome}": "{nome}のファイル",
 "Arquivos na nuvem e cópias de segurança": "クラウドのファイルとバックアップ",
 "Arrasou!": "さすが！",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "丸いポイントを用紙の 4 隅までドラッグしてください。アプリがページを切り抜いてまっすぐにします。",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "隠したい部分を指でなぞってください。黒塗りをタップすると消せます。",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "右にスワイプで削除、左にスワイプで別のタブへ送信。",
 "Arraste para a direita para excluir.": "右にスワイプすると削除します。",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "ドラッグで並べ替え、回転、複製、削除、白紙ページの追加ができます。",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "ドラッグしてボードの続きを表示します。ボードは下と右に広がります。",
 "Arraste um documento para a direita para excluir.": "書類を右にスワイプすると削除します。",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "ボックスを左にスワイプするとアーカイブ、右にスワイプすると削除します。",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "ボックスを左にスワイプでアーカイブ、右にスワイプで削除。⋮⋮ を長押しで並べ替えできます。",
 "Arroz": "ご飯",
 "Artes": "美術",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Claude Pro、ChatGPT Plus、Gemini Advanced のサブスクリプションは他のアプリでは使えません。ここで AI を有効にするには、ご自分のアカウントで API キーを作成してください（Gemini は無料枠あり、Claude と ChatGPT は従量課金で、1 回の分析はごくわずかな金額です）。",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "サーバーで通話がまだ有効になっていません（17-LIGAR-MENSAGENS.bat）。",
 "As compras dele também saem das Finanças.": "このカードの購入もファイナンスから削除されます。",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "分割払いの購入はすべての回数分が登録され、次回以降の分は翌月以降の請求に表示されます。",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "この書類の写真はスキャンしたデバイスにあります。そちらで編集、共有、テキストの読み取りができます。",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "画像は、選んだ AI にだけ、あなたのキーで送信されます。",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "チェックアウト後の清掃はここに自動で表示されます。チェックリストと清掃前後の写真付きです。",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "ここで発行した請求書、検索で見つかった請求書、取り込んだ XML がこの一覧に表示されます。",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "分割回はここに表示されます。それぞれに証明書類（写真、PDF、PIXのスクリーンショット）を添付してください。",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "今後12か月の分割回はすでに My Planner に入っています。",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "未払いの分割回は、契約の現在の金額・利率・期間で計算し直されます。支払い済みの回は変わりません。",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "この書類のページはスキャンしたデバイスにあります。そちらで開くか、Drive または OneDrive に保存したコピーを使ってください。",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "ページが軽い画像になります。スキャンした PDF に最適です。テキストは検索できなくなります（必要なら後で OCR を使ってください）。",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "ページはあなたが選んだ AI にだけ、あなたのキーで送られます。",
 "As receitas do cardápio já têm tudo na despensa.": "献立のレシピの材料はすべてストックにあります。",
 "As senhas novas não conferem.": "新しいパスワードが一致しません。",
 "As senhas não conferem.": "パスワードが一致しません。",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "タスクは My Planner に残ります。Google カレンダーから取り込んだものも削除しますか？",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "この部屋のタスクは部屋なしでマイホームに残ります。",
 "As tarefas vinculadas continuam no My Planner.": "リンクされたタスクはMy Plannerに残ります。",
 "Aspirar e passar pano": "掃除機と拭き掃除",
 "Assinada": "購入済み",
 "Assinar": "署名",
 "Assinar (simulação de teste)": "契約する（テスト用シミュレーション）",
 "Assinar o documento": "書類に署名",
 "Assinatura": "署名",
 "Assinatura do profissional": "担当者の署名",
 "Assinatura e segurança": "署名とセキュリティ",
 "Assinaturas (simulação de teste)": "サブスクリプション（テスト用シミュレーション）",
 "Assine a aba em Ajustes para enviar anotações para ela.": "このタブにメモを送るには、設定でタブを契約してください。",
 "Assine a aba em Ajustes para vincular.": "リンクするには、設定でタブを契約してください。",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "このタブにメモを送るには、設定 › 購入 でタブを契約してください。",
 "Assine a aba em Ajustes › Compras para vincular.": "リンクするには、設定 › 購入 でタブを契約してください。",
 "Assine a aba para abrir o vínculo.": "リンクを開くにはタブを契約してください。",
 "Assisti mais uma aula": "講義を1本見た",
 "Assistido": "視聴済み",
 "Assistindo": "視聴中",
 "Assistência técnica (nome)": "修理窓口（名前）",
 "Assistência: {nome}": "修理窓口：{nome}",
 "Assunto": "件名",
 "Assunto (ex.: Reunião semanal)": "件名（例：週次ミーティング）",
 "Atender": "応答",
 "Atendimento": "診療",
 "Atendimentos": "診療",
 "Ativar avisos": "通知をオン",
 "Ativar monitor": "モニターを有効にする",
 "Ativas": "有効",
 "Atividade": "作業",
 "Atividade do roteiro": "旅程のアクティビティ",
 "Atividade hoje": "今日のアクティビティ",
 "Atividade: {blocos}": "作業時間：{blocos}",
 "Atividades": "アクティビティ",
 "Atividades de hoje": "今日のアクティビティ",
 "Atividades e materiais": "アクティビティと教材",
 "Atividades físicas e saúde": "運動と健康",
 "Atrasada": "期限切れ",
 "Atrasada há {n} dia(s)": "{n}日遅れ",
 "Atrasadas": "期限切れ",
 "Atrasados": "期限切れ",
 "Atuais": "保有中",
 "Atualidades": "時事",
 "Atualizar": "更新",
 "Atualizar agora": "今すぐ更新",
 "Atualizar alarmes no My Planner": "My Planner のアラームを更新",
 "Atualizar rega e adubo na agenda": "予定の水やり・肥料を更新",
 "Atualização automática disponível no app instalado (APK).": "インストール版アプリ（APK）では自動更新が利用できます。",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "アップデートをダウンロードしました。アプリを開き直すか、通知をタップすると反映されます。",
 "Atualização pronta": "アップデートの準備完了",
 "Atualizações": "アップデート",
 "Até": "終了日",
 "Audiência": "期日",
 "Aula dada": "授業済み",
 "Aula {a} de {n} ({p}%)": "{n} 回中 {a} 回目（{p}%）",
 "Aulas assistidas": "視聴済みの講義",
 "Autoajuda": "自己啓発",
 "Autor": "著者",
 "Avaliação": "評価",
 "Avaliações e notas": "評価と成績",
 "Avançado": "詳細",
 "Aveia": "オートミール",
 "Avisar a hora de sair": "出発時刻を通知",
 "Avisar antes de vencer": "期限前に通知",
 "Avisar no celular quando alguém incluir algo": "誰かが何かを追加したらスマホに通知する",
 "Aviso": "お知らせ",
 "Aviso com as tarefas do dia": "その日のタスクのお知らせ",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "サーバーからテスト通知を送信しました。数秒で届きます。アプリを閉じて通知バーで確認してください。",
 "Aviso enviado": "通知を送信しました",
 "Aviso {dias} dia(s) antes e no dia": "{dias}日前と当日にお知らせ",
 "Avisos no celular": "スマホの通知",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "スマートフォンへの通知は Expo、Google、Apple のサービスを経由します。",
 "Ação": "アクション",
 "Ações": "株式",
 "BOLETO E DOCUMENTOS": "BOLETOと書類",
 "Backup importado.": "バックアップを読み込みました。",
 "Bairro": "地区",
 "Baixa": "低",
 "Baixando atualização...": "アップデートをダウンロード中...",
 "Baixar": "ダウンロード",
 "Baixar a versão {v}": "バージョン {v} をダウンロード",
 "Baixar agora": "今すぐダウンロード",
 "Baixar o My Planner para Android": "Android 版 My Planner をダウンロード",
 "Baixar o My Planner para Android (versão {v})": "Android 版 My Planner をダウンロード（バージョン {v}）",
 "Baixar o My Planner para iPhone": "iPhone 版 My Planner をダウンロード",
 "Baixar o PDF da nota (DANFSe)": "請求書の PDF をダウンロード（DANFSe）",
 "Baixar o PDF?": "PDF をダウンロードしますか？",
 "Baixar o XML completo (dá ciência na SEFAZ)": "完全な XML をダウンロード（SEFAZ に確認を送信）",
 "Baixe a versão mais recente para Android: {apk}": "最新の Android 版をダウンロード：{apk}",
 "Baixe aqui a versão mais recente: {link}": "最新版はこちらからダウンロード：{link}",
 "Balança": "ゆらゆら",
 "Balanço e relatórios": "決算書・レポート",
 "Banana": "バナナ",
 "Banco": "銀行",
 "Banco, financeira ou pessoa": "銀行・金融会社・個人",
 "Bandeiras": "旗",
 "Banheiro": "浴室",
 "Banho": "シャンプー",
 "Banho e tosa": "シャンプーとトリミング",
 "Barra": "バー",
 "Bateria": "バッテリー",
 "Batimentos (média)": "心拍数（平均）",
 "Batizado": "洗礼式",
 "Bebida": "ドリンク",
 "Bebê": "赤ちゃん",
 "Beijo": "チュッ",
 "Bem": "資産",
 "Bem clara": "ごく薄い",
 "Bem-Estar": "ウェルネス",
 "Bem-Estar · Cronograma alimentar": "ウェルネス · 食事プラン",
 "Bens": "資産",
 "Bichos e diversão": "動物と遊び",
 "Bicicleta": "自転車",
 "Bicicleta ergométrica": "エアロバイク",
 "Biografia": "伝記",
 "Biologia": "生物",
 "Biometria (digital ou rosto)": "生体認証（指紋または顔）",
 "Biometria ({tipos})": "生体認証（{tipos}）",
 "Biometria não confirmada.": "生体認証が確認できませんでした。",
 "Bloqueado": "ブロック中",
 "Bloquear": "ブロック",
 "Bloquear agora": "今すぐロック",
 "Bloqueio": "ブロック",
 "Blusas de frio": "防寒着",
 "Boa noite": "おやすみ",
 "Boa sorte!": "がんばって！",
 "Boas-vindas ao My Planner": "My Planner へようこそ",
 "Boas-vindas pelo WhatsApp": "WhatsAppでウェルカムメッセージ",
 "Boleto": "Boleto（振込用紙）",
 "Boleto anexado": "Boletoを添付しました",
 "Boleto do banco {b}": "{b}銀行のBoleto",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boletoと書類（写真・PDF・ファイル）",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boletoまたは請求書（写真・PDF・ファイル）",
 "Boleto por foto": "写真でBoleto",
 "Bolinha": "丸",
 "Bom dia": "おはよう",
 "Bom dia!": "おはよう！",
 "Bom dia! Seu dia no My Planner": "おはようございます！My Plannerの今日の予定",
 "Booking": "Booking",
 "Bora!": "行こう！",
 "Borboleta": "蝶",
 "Borracha": "消しゴム",
 "Botas para neve": "スノーブーツ",
 "Brasil": "ブラジル",
 "Braços acima da cabeça": "両腕を頭の上に伸ばす",
 "Brilho": "キラキラ",
 "Brinquedo ou livro para a viagem": "移動中のおもちゃや本",
 "Busca de notas": "請求書の検索",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Querido Diário（Open Knowledge Brasil）が収集した市町村の官報から名前を検索します。すべての市町村が含まれているわけではなく、官報は DJEN には含まれません。",
 "Buscando...": "検索中...",
 "Buscar": "検索",
 "Buscar GIF (ex.: parabéns, bom dia)": "GIFを検索（例：おめでとう、おはよう）",
 "Buscar cidade, país ou GMT": "都市・国・GMT で検索",
 "Buscar conversa": "トークを検索",
 "Buscar documento, titular ou órgão": "書類・名義人・発行機関を検索",
 "Buscar em {nome}": "{nome}を検索",
 "Buscar emoji (ex.: coração, risada)": "絵文字を検索（例：ハート、笑い）",
 "Buscar figurinha": "スタンプを検索",
 "Buscar notas": "請求書を検索",
 "Buscar ou digitar um alimento": "食品を検索または入力",
 "Buscar país": "国を検索",
 "Buscar pelo nome ou pelo texto": "名前やテキストで検索",
 "Buscar produto, loja ou observação": "商品名、店舗、メモで検索",
 "Buscar tarefas": "タスクを検索",
 "Buscar: processo, parte, tribunal, palavra...": "検索：訴訟、当事者、裁判所、キーワード...",
 "CAIXA {n}": "箱 {n}",
 "CARDS DE ANOTAÇÕES": "メモカード",
 "CARTÕES": "カード",
 "CEP": "CEP（郵便番号）",
 "CID (se o paciente pedir na declaração)": "CID（患者が証明書に希望する場合）",
 "CID: {c}": "CID：{c}",
 "CNH": "CNH（ブラジルの運転免許証）",
 "CNPJ (se tiver)": "CNPJ（ある場合）",
 "CNPJ ou CPF": "CNPJ または CPF",
 "COMPROVANTE DE PAGAMENTO": "支払いの控え",
 "COMPROVANTE DE RECEBIMENTO": "受取の控え",
 "COMPROVANTES ANTERIORES": "過去の控え",
 "CONTAS DO MÊS": "今月の支払い",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF（ブラジル）",
 "CPF de quem paga": "支払う人の CPF",
 "CPF do paciente": "患者の CPF",
 "CPF do pagador": "支払者の CPF",
 "CPF inválido": "CPFが正しくありません",
 "CPF ou CNPJ de quem recebeu": "受取人の CPF または CNPJ",
 "CPF ou senha incorretos.": "CPFまたはパスワードが正しくありません。",
 "CRIAR CÔMODO": "部屋を作成",
 "CRIAR UM GRUPO": "グループを作成",
 "CRONOGRAMA ALIMENTAR": "食事スケジュール",
 "CUIDADOS PESSOAIS": "セルフケア",
 "Cabeleireiro": "美容師",
 "Cabelo": "ヘア",
 "Cachorro": "犬",
 "Cactos e suculentas": "サボテン・多肉植物",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "追加タブごとに {n} 日間無料、その後は年 {preco}。",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "完成したファイルは {nome} に保存されます。開いた PDF はこの端末の下の一覧にも残ります。",
 "Cada dia da semana": "曜日ごと",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "新しい書類は、閉じたときに {nome} に保存されます。ページの写真はこのデバイスにのみ残ります。",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "チームの各メンバーの受信に会議が届き、ワンタップで通知付きで Planner に追加できます。",
 "Cada pessoa do grupo recebe e decide se aceita.": "グループの各メンバーが受け取り、承認するかを決めます。",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "各ページに要約、授業、章などを保存します。終わったら復習済みにしましょう。",
 "Cada página vira uma imagem JPG.": "各ページが JPG 画像になります。",
 "Cada refeição se repete nos dias dela": "各食事は設定した曜日に繰り返されます",
 "Cadastrar": "登録",
 "Cadastrar cartão de crédito": "クレジットカードを登録",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "写真から登録（講座のページ、修了証、チラシ）",
 "Cadastrar pela foto da capa": "表紙の写真から登録",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "「自分の情報」を登録すると、領収書にあなたの名前、所属団体、登録番号が入ります。",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "身分証、運転免許証、パスポート、契約書、証明書を登録しましょう。期限前にお知らせし、ワンタップで書類を送信できます。",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "会社（または個人事業者としてのあなた）を CNPJ または CPF、市区町村、税制区分で登録します。次に A1 証明書を接続すると、Padrão Nacional で NFS-e を発行し、発行済み・受領済みの請求書を検索できます。",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "工事を登録し、その中に予算付きの工程、写真付きの日誌、職人、資材の納品を追加します。",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "旅行を登録し、その中に日ごとの旅程、予約、荷物を追加します。旅行中は旅程が My Planner に表示されます。",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "ご自身の氏名とOAB番号のみを登録してください。",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "子どもを登録します：テスト、面談、受診、予防接種はそれぞれの中にまとまります。",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "ペットごとに登録します：ワクチン手帳、駆虫薬、薬、ペットショップはその中にまとまります。",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "植物ごとに日当たり、土、水やりと肥料の間隔を登録します。アプリが予定にカレンダーを作ります。",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "車両ごとに登録します。その中に整備（距離と日付でお知らせ）と、IPVA・ライセンス更新・保険の期限がまとまります。",
 "Cadastre digital ou rosto no aparelho para usar.": "使用するには、端末に指紋または顔を登録してください。",
 "Cadastre o cartão primeiro": "先にカードを登録してください",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "ローンや融資を金額、利率、回数とともに登録してください。アプリが各回の金額と残債を計算し、期日をお知らせします。",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "貸し出す物件全体、または部屋ごとに登録してください。それぞれの中に予約、清掃、経費がまとまります。",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "本の総ページ数と1日の目標を登録します。⋮ をタップして読んだページを追加します。",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "薬と服用時刻を登録し、⋮ をタップするとアラーム付きでタイムラインに入ります。",
 "Cadastre os alunos da turma na aba Alunos.": "「生徒」タブでクラスの生徒を登録してください。",
 "Cadastre os clientes para separar as horas.": "時間を分けて記録するため、クライアントを登録してください。",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "請求書を受け取る依頼主を登録します。住所は任意です（入力する場合は CEP、IBGE コード、通り、番号、地区を入力してください）。",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "よく発行するサービスを国の課税コードとともに登録します。発行時はタップするだけです。",
 "Cadastre primeiro em {nome}.": "先に{nome}で登録してください。",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "名前、所属団体、登録番号を登録してください。領収書と証明書に記載されます。",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "会社の「依頼主」タブで依頼主を登録すると、ここで選べます。",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "書類に記載するため、「自分の情報」で職業情報（名前、所属団体、番号）を登録してください。",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "領収書に記載するため、「自分の情報」で職業情報（名前、所属団体、番号）を登録してください。",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "患者を登録してください。それぞれの中に、経過記録、処方、支払い、領収書、保険用の証明書付きの診療がまとまります。",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "あなたと家族一人ひとりを登録します。その中に受診、検査、予防接種、薬がまとまります。機密データは暗号化された金庫に入ります。",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "登録は承認待ちです：Supabaseで「Confirm email」をオフにしてください（COMO RODARを参照）。",
 "Cadastro recebido": "登録を受け付けました",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "登録情報：名前、CPF またはメールアドレス、パスワード（保護された形式でのみ保存）、連絡先メールアドレス。",
 "Cadastros": "登録",
 "Cadastros e comprovantes": "登録と控え",
 "Cadeira extensora": "レッグエクステンション",
 "Café": "コーヒー",
 "Café da manhã": "朝食",
 "Café ou bar": "カフェ・バー",
 "Café?": "コーヒー？",
 "Cafés": "カフェ",
 "Caixa": "箱",
 "Caixa arquivada": "アーカイブしたボックス",
 "Caixa com checklist, lista ou texto livre": "チェックリスト・リスト・自由テキストのボックス",
 "Caixa {n}": "箱 {n}",
 "Caixas": "箱",
 "Caixas e cronograma da mudança.": "段ボールと引っ越しのスケジュール。",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "部屋ごとのラベル付きの箱、電気・水道・ネットの手続き、立ち会い検査、日ごとのスケジュール。",
 "Calculadora": "電卓",
 "Calculando...": "計算中...",
 "Calendário": "カレンダー",
 "Calendário da planta": "植物のカレンダー",
 "Calendário do imposto": "税金カレンダー",
 "Calendários": "カレンダー",
 "Calorias em atividade": "アクティブカロリー",
 "Calorias gastas em atividade (kcal)": "アクティビティで消費したカロリー（kcal）",
 "Calça térmica (segunda pele)": "保温タイツ（インナー）",
 "Calças ou bermudas": "ズボンまたは短パン",
 "Cama": "ベッド",
 "Caminhada": "ウォーキング",
 "Caminhão": "トラック",
 "Camisetas": "Tシャツ",
 "Campo Grande": "カンポ・グランデ",
 "Campo Grande (MS)": "カンポ・グランデ（MS）",
 "Campos de formulário": "フォームフィールド",
 "Cancelada": "キャンセル",
 "Canceladas": "キャンセル済み",
 "Cancelar": "キャンセル",
 "Cancelar a NFS-e": "NFS-e を取り消す",
 "Cancelar a NFS-e {n}?": "NFS-e {n} を取り消しますか？",
 "Cancelar a nota": "請求書を取り消す",
 "Cancelar a reunião \"{nome}\"?": "会議「{nome}」をキャンセルしますか？",
 "Cancelar reunião": "会議をキャンセル",
 "Caneta": "ペン",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "サーバーの自動取得：2時間ごと、08:00〜20:00",
 "Captura automática: todos os dias às 08h e 12h": "自動取得：毎日 08:00 と 12:00",
 "Card": "カード",
 "Cardápio": "献立",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "週の献立、レシピ、自動の買い物リスト、ストックの賞味期限。",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "この日だけの献立です。ほかの日は週の献立のままです。",
 "Carga (kg)": "重量（kg）",
 "Carimbo": "スタンプ",
 "Carnaval": "カーニバル",
 "Carne magra": "赤身肉",
 "Carregando feriados...": "祝日を読み込み中...",
 "Carregando...": "読み込み中...",
 "Carro": "車",
 "Carta": "レター",
 "Carteira": "財布",
 "Carteira de trabalho": "労働手帳",
 "Carteira profissional (OAB, CRC, CREA...)": "資格証（OAB、CRC、CREA...）",
 "Cartão": "カード",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "メッセージの連絡先カード：ご自身で選んで設定する写真、電話番号、メールアドレス、ひとことです。あなたとチャットしている人、友だち、アプリのグループを共有している人だけが見られます。",
 "Cartão de crédito": "クレジットカード",
 "Cartão de débito": "デビットカード",
 "Cartão parcelado": "カード分割払い",
 "Cartões": "カード",
 "Cartões de visita": "名刺",
 "Cartões e dinheiro": "カードと現金",
 "Casa": "家",
 "Casa e rotina": "家と暮らし",
 "Casa, família e veículos": "家・家族・車",
 "Casaco leve": "薄手の上着",
 "Casaco pesado": "厚手のコート",
 "Casamento": "結婚式",
 "Castanhas": "ナッツ",
 "Categoria": "カテゴリー",
 "Categoria de \"{d}\"": "「{d}」のカテゴリー",
 "Categorias": "カテゴリー",
 "Caução": "保証金",
 "Ceia": "夜食",
 "Celular": "スマートフォン",
 "Celular confirmado": "携帯番号を確認済み",
 "Celular e carregador": "スマートフォンと充電器",
 "Certidão": "証明書",
 "Certificado digital": "電子証明書",
 "Certificado digital A1": "電子証明書 A1",
 "Certificado ligado": "証明書を接続済み",
 "Chamada": "出欠",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "この日の出欠はまだです。欠席者をタップするか、全員出席を確認してください。",
 "Chamada, notas, planos de aula e materiais.": "出欠、成績、授業計画、教材。",
 "Chamadas": "通話",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "音声通話とビデオ通話は通話中のみ LiveKit のサーバーを経由し、録音はされません。",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "音声通話とビデオ通話は、通話中に限り LiveKit のサーバーを経由します。録画が行われるのはオフィスの会議で管理者が録画する場合のみで、ファイルはアプリのストレージに直接保存されます。",
 "Chamando...": "呼び出し中...",
 "Chapéu ou boné": "帽子",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "この端末に AI キーが登録されていません（設定 › 人工知能）。",
 "Chave de acesso": "アクセスキー",
 "Check-in": "チェックイン",
 "Check-in: {d} a partir das {h}": "チェックイン：{d} {h}以降",
 "Check-in: {h} · {e}": "チェックイン：{h} · {e}",
 "Check-out": "チェックアウト",
 "Check-out: {d} até as {h}": "チェックアウト：{d} {h}まで",
 "Check-out: {h} · {e}": "チェックアウト：{h} · {e}",
 "Checklist": "チェックリスト",
 "Chinelo": "サンダル",
 "Chá de bebê": "ベビーシャワー",
 "Cidade": "市区町村",
 "Cidade (para a data dos recibos)": "市区町村（領収書の日付欄用）",
 "Cidade de {nome}": "{nome}市",
 "Cidades": "市",
 "Cifrão": "通貨記号",
 "Cinza": "グレー",
 "Cirurgia": "手術",
 "Ciências": "理科",
 "Clara": "薄い",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "スキャンした PDF を明るくします：白、グレー、白黒の背景。",
 "Claro": "ライト",
 "Classificar categorias com IA": "AIでカテゴリーを分類",
 "Claude, ChatGPT ou Gemini": "Claude、ChatGPT、Gemini",
 "Cliente": "クライアント",
 "Clientes": "クライアント",
 "Clima esperado": "予想される気候",
 "Co-anfitrião": "共同ホスト",
 "Cobrança": "請求",
 "Cobranças": "請求",
 "Coelho": "ウサギ",
 "Cofre (criptografia de ponta a ponta)": "金庫（エンドツーエンド暗号化）",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "金庫は開いています（使わないと5分で自動的に閉じます）",
 "Cofre ainda não criado": "金庫はまだ作成されていません",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "身分証、運転免許証、パスポート、契約書、証明書を入れる暗号化金庫。期限までのカウントダウンとワンタップ送信つき。",
 "Cofre fechado": "金庫は閉じています",
 "Cofrinho": "貯金箱",
 "Cole aqui a chave ({ini}...)": "ここにキーを貼り付け（{ini}...）",
 "Cole o link (https://...)": "リンクを貼り付け（https://...）",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "コード欄にバーコード番号（またはPixコピー＆ペースト）を貼り付けるか入力してください。金額と期日はアプリが自動で計算します。AIをオンにすると、写真からすべて読み取ります。",
 "Coloca arquivos dentro do PDF.": "PDF の中にファイルを入れます。",
 "Colocar na agenda": "予定に入れる",
 "Colocar na linha do tempo com alarme": "アラーム付きでタイムラインに入れる",
 "Colocar no My Planner": "My Planner に入れる",
 "Colocar rega e adubo na agenda": "水やりと肥料を予定に入れる",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "月謝の金額をクラス（編集）または生徒に入力してください。今月すでにある請求は重複しません。",
 "Coluna": "列",
 "Colágeno": "コラーゲン",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "生体認証をオンにすると、最初に表示されます。失敗した場合は、パターンまたはパスワードを使ってください。",
 "Com convênio": "保険あり",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "国番号と市外局番を含めてください。例：+55 41 99999-0000",
 "Com outras pessoas": "貸し出し中",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "期限を決めると、毎月いくら貯めればよいかアプリが計算します。貯めたお金はその月の「貯蓄」として計上されます。",
 "Com quem": "相手",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "支払い済みの各診療の支払者、患者、日付、金額が入っています。個人の場合は Receita Federal アプリ › Receita Saúde で一件ずつ登録し、CNPJ がある場合はサービス請求書を発行してください。",
 "Com valor a receber": "受取予定あり",
 "Com vencimento": "期限あり",
 "Combinado": "了解",
 "Combinado 👍": "了解です 👍",
 "Combustível": "燃料",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "まずは毎月の固定費（家賃、電気代、ネット）とカードを登録しましょう。期日の前にお知らせします。",
 "Comecei em": "開始日",
 "Comentários": "コメント",
 "Começa amanhã": "明日から",
 "Começa às {hora} (em {m} min)": "{hora}に開始（{m}分後）",
 "Começar": "開始",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "テンプレートから始める：朝食、間食、昼食、間食、夕食",
 "Começar em": "開始番号",
 "Começar o teste grátis": "無料トライアルを開始",
 "Comi outros alimentos ou quantidades": "別の食品・量を食べた",
 "Comida": "食べ物",
 "Comidas e bebidas": "食べ物と飲み物",
 "Comido": "食べた量",
 "Comido / alterações": "食べた量 / 変更",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "「食べた量」は今日までに完了（または変更あり）とした食事を集計します。",
 "Comigo": "借りているもの",
 "Comissão da plataforma": "プラットフォーム手数料",
 "Como apagar a sua conta e os seus dados": "アカウントとデータを削除する方法",
 "Como chegar": "行き方",
 "Como ela está": "状態",
 "Como estou comparado ao mês passado?": "先月と比べてどうですか？",
 "Como funciona": "使い方",
 "Como planejado": "予定どおり",
 "Compartilhado no grupo": "グループで共有",
 "Compartilhado no grupo · só leitura": "グループで共有 · 閲覧のみ",
 "Compartilhamento indisponível neste dispositivo.": "この端末では共有できません。",
 "Compartilhar": "共有",
 "Compartilhar PDF": "PDF を共有",
 "Compartilhar a limpeza": "清掃を共有",
 "Compartilhar os dados": "データを共有",
 "Compartilhar os dados com a equipe": "チームとデータを共有",
 "Compartilhar os dados com o grupo?": "グループとデータを共有しますか？",
 "Compartilhar texto": "テキストを共有",
 "Competência (mês de referência)": "対象月（基準月）",
 "Competência {d}": "対象月 {d}",
 "Complemento": "建物名・部屋番号",
 "Complete seus dados": "情報を入力してください",
 "Compra": "購入",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "不動産・車・株式の売買、控除対象の領収書、税金カレンダー。",
 "Compra feita": "購入済み",
 "Compra no cartão": "カードでの購入",
 "Compras": "購入",
 "Compras da semana": "今週の買い物",
 "Comprimir": "圧縮",
 "Compromisso": "予定",
 "Compromisso da escola": "学校の予定",
 "Comprovante": "証憑",
 "Comprovante guardado": "控えを保存しました",
 "Comprovantes": "控え",
 "Computador": "パソコン",
 "Comédia": "コメディ",
 "Concedi": "貸した",
 "Concluir": "完了",
 "Concluir (esquerda)": "完了（左）",
 "Concluída": "完了",
 "Concluído": "完了",
 "Concluído (%)": "進捗（%）",
 "Concluído!": "完了しました！",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "氏名、CPF、メールアドレスはアカウントの識別のみに使用され、タスクとメモはアカウントに保存されることに同意します。アカウントとすべてのデータは、設定 › セキュリティ からいつでも削除できます。",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "氏名、CPF、メールアドレスがアカウントの識別のみに使われること、またタスクとメモがアカウントに保存されることに同意します。アカウントとすべてのデータは、設定からいつでも削除できます。",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "氏名・身分証番号・メールアドレスはアカウントの識別にのみ使用され、タスクとメモはアカウントに保存されることに同意します。設定 › セキュリティ でいつでもアカウントとすべてのデータを削除できます。",
 "Concursos": "公務員試験",
 "Condicionador": "コンディショナー",
 "Condomínio": "管理費",
 "Condomínio e IPTU": "管理費・固定資産税",
 "Conectado": "接続済み",
 "Conectando...": "接続中...",
 "Conectar": "接続",
 "Conectar navegador": "ブラウザを接続",
 "Conectar o {nome}": "{nome} に接続",
 "Conectar relógio ou app de saúde": "時計またはヘルスケアアプリを接続",
 "Conectar {nome}": "{nome} に接続",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "設定 › Google Drive と OneDrive で {nome} に接続してください。",
 "Conferindo...": "確認中...",
 "Conferir controles, chaves e Wi-Fi": "リモコン、鍵、Wi-Fi を確認",
 "Conferir o prazo no sistema oficial": "公式システムで期限を確認",
 "Confete": "紙吹雪",
 "Configuração geral": "一般設定",
 "Confira a senha da sua conta e tente de novo.": "アカウントのパスワードを確認して、もう一度お試しください。",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "公式の日程はブラジル連邦歳入庁（Receita Federal）のサイトで確認し、必要なら調整してください。",
 "Confira o código. Ele tem 6 letras e números.": "コードを確認してください。英数字6文字です。",
 "Confira o e-mail ou deixe em branco.": "メールアドレスを確認するか、空欄にしてください。",
 "Confira o e-mail.": "メールアドレスを確認してください。",
 "Confira o prazo no sistema oficial.": "公式システムで期限を確認してください。",
 "Confira os 11 números.": "11桁の番号を確認してください。",
 "Confira os campos antes de salvar.": "保存する前に各項目を確認してください。",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "スマートフォンに Google アカウントが追加され、カレンダーが同期されているか確認してください。",
 "Confirmada": "確定",
 "Confirmado": "出席予定",
 "Confirmar": "確認",
 "Confirme a declaração sobre a empresa.": "会社に関する宣言を確認してください。",
 "Confirme o seu celular": "携帯番号を確認してください",
 "Confirme para ativar a biometria": "確認して生体認証を有効にする",
 "Confirme para excluir": "削除を確認",
 "Confirme sua senha para sincronizar": "同期するにはパスワードを確認してください",
 "Confraternização": "懇親会",
 "Confraternização Universal": "元日",
 "Conselho": "所属団体",
 "Consignado": "給与天引きローン",
 "Consulta": "受診",
 "Consulta ou vacina": "受診または予防接種",
 "Consultas": "受診",
 "Consultório": "クリニック",
 "Consumo médio: {v} km/L": "平均燃費：{v} km/L",
 "Conta": "アカウント",
 "Conta a pagar": "支払い予定",
 "Conta a receber": "入金予定",
 "Conta de consumo ou tributo": "公共料金・税金",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "各項目の予定日数（曜日の設定による）と、完了にした日数を数えます。",
 "Conta paga": "支払い済み",
 "Conta recebida": "受取済み",
 "Conta vence hoje": "支払期日は今日です",
 "Conta vencendo": "期日が近い支払い",
 "Contabilidade": "会計",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "同伴者を含みます。招待客のステータスをタップすると変更できます。",
 "Contando: {cliente}": "計測中：{cliente}",
 "Contas": "支払い",
 "Contas a pagar": "支払予定",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "支払いと入金の管理、今月の支出、期日のお知らせ、MEI の管理（Mestre Achado）。",
 "Contas a receber": "受取予定",
 "Contas fixas": "固定費",
 "Contato": "連絡先",
 "Contato de emergência": "緊急連絡先",
 "Contato do encarregado de dados:": "データ保護責任者の連絡先：",
 "Conte a sua ideia para o app ficar melhor.": "アプリをより良くするためのアイデアをお聞かせください。",
 "Conte o que está difícil ou não funciona como deveria.": "使いにくい点や、正しく動かない点をお知らせください。",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "何をしたか、何を期待したか、何が表示されたかを書いてください。エラーメッセージがあれば、ここにコピーしてください。",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "問題、エラー、改善のアイデアをお知らせください。メッセージは My Planner チームに直接届きます。",
 "Conteúdo": "内容",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "あなたが作成するコンテンツ：タスク、メモ、家計、書類、写真、添付ファイル、各タブのデータ。",
 "Conteúdo, matéria, tarefa de casa...": "内容、科目、宿題など",
 "Continuar": "続ける",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "年 {preco} で My Planner とメモを引き続きご利用いただけます。データはそのまま保存されています。",
 "Contratado": "契約済み",
 "Contratado: {v}": "契約済み：{v}",
 "Contrato": "契約書",
 "Conversa": "トーク",
 "Conversa do grupo": "グループトーク",
 "Conversar": "トーク",
 "Conversar com o Mestre (precisa da sua IA)": "マスターと話す（あなたのAIが必要）",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "友だちやグループとトークし、音声通話やビデオ通話ができます。",
 "Converter de PDF": "PDF から変換",
 "Converter para PDF": "PDF に変換",
 "Convidado": "招待客",
 "Convidados": "招待客",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "出欠確認つきの招待客、業者、当日のタイムスケジュール。",
 "Convidados e cronograma do dia, sem os valores.": "ゲストと当日のスケジュール。金額は除きます。",
 "Convidar": "招待",
 "Convidar pelo WhatsApp": "WhatsAppで招待",
 "Convite": "招待",
 "Convite copiado. Cole onde quiser enviar.": "招待をコピーしました。送りたい場所に貼り付けてください。",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "招待が無効か、管理者により変更されました。新しいリンクを依頼してください。",
 "Convite para o My Planner": "My Planner への招待",
 "Convênio": "保険",
 "Copiar": "コピー",
 "Copiar a lista para uma tarefa": "リストをタスクにコピー",
 "Copiar o código": "コードをコピー",
 "Copiar para hoje": "今日にコピー",
 "Copo de outro tamanho": "別のサイズのコップ",
 "Copo {n}": "コップ {n}",
 "Cor": "色",
 "Cor do fichário": "バインダーの色",
 "Cor do tema": "テーマカラー",
 "Cor do tema de cada aba": "各タブのテーマカラー",
 "Coração": "ハート",
 "Corações": "ハート",
 "Cores das abas": "タブの色",
 "Cores das conversas": "トークの色",
 "Cores e opções desta aba": "このタブの色とオプション",
 "Corpo": "体",
 "Corporativo": "企業イベント",
 "Corpus Christi": "聖体祭",
 "Corredor": "廊下",
 "Correia dentada": "タイミングベルト",
 "Corrida": "ランニング",
 "Corta as bordas em branco ou partes da página.": "余白やページの一部を切り取ります。",
 "Cortesia": "無料",
 "Coxa e sobrecoxa": "鶏もも肉（骨付き）",
 "Cozinha": "キッチン",
 "Creatina": "クレアチン",
 "Criada em {data}": "{data} に作成",
 "Criado com": "作成アプリ",
 "Criado em": "作成日",
 "Criança": "子ども",
 "Crianças": "子ども",
 "Criar": "作成",
 "Criar animada": "アニメで作成",
 "Criar conta": "アカウントを作成",
 "Criar do zero": "最初から作成",
 "Criar documento, planilha ou apresentação": "ドキュメント、スプレッドシート、プレゼンを作成",
 "Criar em outro app": "別のアプリで作成",
 "Criar escritório": "オフィスを作成",
 "Criar fichário": "バインダーを作成",
 "Criar figurinha": "スタンプを作成",
 "Criar grupo": "グループを作成",
 "Criar grupo e convidar pessoas": "グループを作成して招待",
 "Criar minha chave de API": "API キーを作成",
 "Criar o cofre": "金庫を作成",
 "Criar o grupo e convidar": "グループを作成して招待",
 "Criar os prazos do IR de {ano}": "{ano}年の確定申告の期限を作成",
 "Criar uma meta (viagem, reserva, carro...)": "目標を作成（旅行、貯金、車...）",
 "Criar uma senha nova": "新しいパスワードを作成",
 "Criar {n} tarefa(s)": "{n} 件のタスクを作成",
 "Criação do Estado de MS": "マット・グロッソ・ド・スル州創設記念日",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "引っ越しを作成すると、アプリが手続きリスト（電気、水道、ネット…）を自動で作ります。そのあと部屋ごとの箱、立ち会い検査、日ごとのスケジュールを登録します。",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "クライアントごとのフォルダを作成し、リンクで招待します（クライアントは自分のフォルダだけを見られます）。請求書、納付書、給与明細、取引明細、契約書を双方向でやり取りできます。",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "クラス（またはメンタリング、トレーニング、講座のグループ）を作成し、その中に生徒、出欠、成績、授業計画、教材、請求を追加します。",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "クラスを作成し、その中に生徒、出欠、成績付きの評価、授業計画を追加します。",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "家事（浴室掃除、シーツ交換...）を頻度つきで作成しましょう。期限が過ぎるとアプリがお知らせします。My Planner がいっぱいになることはありません。",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "この科目用にチェックリスト、リスト、自由テキスト、手書きのカードを作れます。右にスワイプで削除、左でアーカイブ。",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "オフィスを作成してチームを招待し（アプリの友だち、またはリンクで招待）、メッセージや書類をやり取りしたり、会議を予定したり、ビデオ会議をしたりできます。管理者のあなたは会議を録画できます。",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "イベントを作成し、その中に出欠確認つきの招待客リスト、業者、当日のスケジュールを追加します。",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "グループを作成してリンクを送りましょう。参加した人は日時、場所、お知らせ、あなたが送るすべてを受け取り、承諾・編集・辞退ができます。",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "グループを作成してリンクを送りましょう。参加した人は、あなたが選んだ役割に応じて閲覧・参加できます。メンバーの追加・削除は管理者だけができます。",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "グループを作成してリンクを送りましょう。参加した人はここにあるすべてを見て参加できます（追加、編集、写真の投稿）。メンバーの追加・削除は管理者だけができます。",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "アカウントを作成しましょう。データはクラウドとこの端末に保存されます。",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "バインダー（例：博士課程、英語、資格試験）を作り、その中に科目とページを作成します。",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "グループ（クラス、患者、チーム、ゲスト、顧客）を作り、招待リンクを送って、予定・資料・お知らせを配信しましょう。各メンバーは受け取った内容を承認・編集・却下できます。",
 "Crie um perfil com nome e, se for advogado, a OAB.": "名前と、弁護士の場合はOAB番号でプロフィールを作成してください。",
 "Criptografado no cofre, só neste dispositivo": "金庫で暗号化済み、この端末のみ",
 "Criptomoedas": "暗号資産",
 "Cronograma": "スケジュール",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "食事スケジュール、ステップ付きのセルフケア、今日の水分補給。",
 "Cronograma do dia": "当日のスケジュール",
 "Cronograma físico-financeiro": "工程・資金計画表",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "工程ごとの工程・資金計画、ビフォー・アフター付きの工事日誌、職人、納品。",
 "Cronômetro de horas": "作業時間タイマー",
 "Crédito empresarial": "事業融資",
 "Créditos": "クレジット",
 "Cuida das reservas, da limpeza e das despesas.": "予約、清掃、経費を担当します。",
 "Cuidado": "ケア",
 "Cuidado pessoal": "セルフケア",
 "Cuidados": "お手入れ",
 "Cupom do mercado": "スーパーのレシート",
 "Cupom do mercado (foto)": "スーパーのレシート（写真）",
 "Cupom lançado": "レシートを記録しました",
 "Curitiba": "クリチバ",
 "Curitiba (PR)": "クリチバ（PR）",
 "Curso": "コース",
 "Cursos": "コース",
 "Cursos livres e certificações": "一般講座・資格",
 "Cuscuz": "コーンクスクス",
 "CÓDIGO PARA PAGAR": "支払い用コード",
 "CÔMODOS": "部屋",
 "Câmera": "カメラ",
 "Câmera e galeria": "カメラとギャラリー",
 "Câmera não liberada": "カメラが許可されていません",
 "Código IBGE do município": "市区町村の IBGE コード",
 "Código IBGE do município (7 números)": "市区町村の IBGE コード（7 桁）",
 "Código NBS (9 números, opcional)": "NBS コード（9 桁、任意）",
 "Código copiado": "コードをコピーしました",
 "Código da reserva (localizador)": "予約番号",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "バーコード、デジタル番号またはPixコピー＆ペースト（任意）",
 "Código de indicação": "紹介コード",
 "Código de indicação (opcional)": "紹介コード（任意）",
 "Código de quem convidou você": "招待した人のコード",
 "Código de tributação nacional (6 números)": "国の課税コード（6 桁）",
 "Código de tributação nacional (6 números, ex.: 171901)": "国の課税コード（6 桁、例: 171901）",
 "Código do amigo": "友だちのコード",
 "Código do convite": "招待コード",
 "Código do procedimento (TUSS ou do plano)": "処置コード（TUSS または保険独自）",
 "Código errado. Confira e tente de novo.": "コードが違います。確認してもう一度お試しください。",
 "Código não encontrado. Confira as letras e os números.": "コードが見つかりません。英字と数字を確認してください。",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "コードを認識できません。数字を確認してください（Boleto：47桁または48桁）。",
 "Código: {c}": "番号：{c}",
 "Cópia automática toda semana": "毎週自動でバックアップ",
 "Cópia criada.": "コピーを作成しました。",
 "Cópia de segurança": "バックアップ",
 "Cópia feita": "バックアップしました",
 "Cópia restaurada.": "バックアップを復元しました。",
 "Cômodo": "部屋",
 "Cômodo ou quarto": "部屋単位",
 "Cômodos da casa e as tarefas de cada um.": "家の部屋と、それぞれのタスク。",
 "DAS de {mes} pago": "{mes}の DAS 支払い済み",
 "DAS de {mes}: vence dia {dia}": "{mes}の DAS：{dia}日が期日",
 "DAS do MEI": "MEI の DAS",
 "DECLARAÇÃO DE ATENDIMENTO": "診療証明書",
 "DICA DO MESTRE ACHADO": "Mestre Achado のヒント",
 "DPS nº {n}, série {s}": "DPS 番号 {n}、シリーズ {s}",
 "Da galeria ou dos arquivos": "ギャラリーまたはファイルから",
 "Da meta de passos": "歩数目標に対して",
 "Dados compartilhados": "共有データ",
 "Dados compartilhados com o grupo": "グループと共有中のデータ",
 "Dados compartilhados · seu papel: {p}": "共有データ · あなたの役割: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "あなた自身が記録した健康データは、あなたの同意に基づき、あなたと共有相手のためだけに取り扱います（art. 11, I）。",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "端末データ：言語、国、タイムゾーン（日付、祝日、通貨のため）、端末の機種、スマートフォン通知用のコード。",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "時計と健康のデータは広告に使われることも、第三者に提供されることもありません。いつでも接続を解除し、許可を取り消せます。",
 "Dança": "ダンス",
 "Dar ciência": "確認を送信",
 "Dar ciência da operação?": "取引の確認を SEFAZ に送信しますか？",
 "Data": "日付",
 "Data (embarque ou check-in)": "日付（出発またはチェックイン）",
 "Data agendada": "予定日",
 "Data da aplicação": "接種日",
 "Data da compra": "購入日",
 "Data da entrega": "納品日",
 "Data da venda": "売却日",
 "Data de nascimento": "生年月日",
 "Data do empréstimo": "貸し借りした日",
 "Data do pagamento": "支払日",
 "Data em que foi feita": "実施日",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "営業日 2 日分の余裕をもたせた推奨日です。公式システムで確認してください。",
 "De": "開始",
 "De uma foto": "写真から",
 "De {de} para {para} ({p}% menor).": "{de} から {para} へ（{p}% 削減）。",
 "Declaração": "申告書",
 "Declaração de atendimento": "診療証明書",
 "Declaração para reembolso (PDF)": "払い戻し用証明書（PDF）",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "この会社は自分のもの、または追跡を許可した顧客のものであることを宣言します。",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "患者 {nome}{cpf}{cart}が{data}{hora}に{tipo}として私の診療を受けたことを、{conv}払い戻しのために証明します。",
 "Defina a meta de aulas por dia ou por semana em Editar.": "「編集」で1日または1週間の授業目標を設定してください。",
 "Defina a meta de páginas por dia em Editar.": "「編集」で1日のページ目標を設定してください。",
 "Defina um horário": "時刻を設定してください",
 "Defina um horário para usar pausas.": "休憩を使うには時刻を設定してください。",
 "Demaquilante ou água micelar": "メイク落としまたはミセラーウォーター",
 "Demolição": "解体",
 "Demonstração": "デモ",
 "Dentista": "歯科",
 "Dependentes": "扶養家族",
 "Depois": "アフター",
 "Depois da aula": "授業の後",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "削除したタスクは元に戻せません。確認のため、アカウントのパスワードを入力してください。",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "ダウンロード後、ファイルを開いて「インストール」をタップしてください。確認が表示されたら、この提供元からのアプリのインストールを許可してください。",
 "Depois de criar": "作成したら",
 "Depois de {nome}. Toque para pular.": "{nome} のあと。タップでスキップ。",
 "Depois é só ajustar horários e o que comer em cada um.": "あとは時間と食べるものを調整するだけです。",
 "Desarquivar": "アーカイブ解除",
 "Desbloquear": "ロック解除",
 "Desbloquear com": "ロック解除の方法",
 "Desbloquear com biometria": "生体認証でロック解除",
 "Desbloquear o My Planner": "My Plannerのロックを解除",
 "Desbloqueio do app": "アプリのロック解除",
 "Descanso": "休憩",
 "Descartadas": "破棄済み",
 "Descartar": "破棄",
 "Descartar este tempo?": "この時間を破棄しますか？",
 "Descobrir lugares em {d}": "{d}の見どころを探す",
 "Desconectar": "接続を解除",
 "Desconectar o {nome}?": "{nome} の接続を解除しますか？",
 "Desconto": "割引",
 "Desconto de {v}": "{v}の割引",
 "Descontos obtidos": "受けた割引",
 "Descrição": "説明",
 "Descrição (cliente, nota fiscal...)": "説明（顧客、請求書...）",
 "Descrição do serviço (sai na nota)": "サービスの説明（請求書に記載）",
 "Descrição que sai na nota": "請求書に記載される説明",
 "Desenhar a assinatura": "署名を描く",
 "Desenhar com caneta ou dedo": "ペンや指で描く",
 "Desenhe a assinatura e escolha a página e o lugar.": "署名を描いて、ページと位置を選んでください。",
 "Desenhe a assinatura primeiro.": "先に署名を描いてください。",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "指またはペン（S Pen、Apple Pencil、タブレット用ペン）で描いてください。",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "指またはペンで描きます。ボードをスクロールするには「移動」をタップします。",
 "Desenhe de novo para confirmar.": "確認のため、もう一度描いてください。",
 "Desenhe o seu padrão": "パターンを描いてください",
 "Desenhe pelo menos uma tarja.": "黒塗りを 1 つ以上描いてください。",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "4つ以上の点をつないでパターンを描いてください。",
 "Desenho": "手描き",
 "Desenho com caneta ou dedo": "ペンや指で手描き",
 "Desenho incorreto": "パターンが違います",
 "Desenho padrão": "パターン",
 "Desenho padrão salvo.": "パターンを保存しました。",
 "Desenvolvimento": "ショルダープレス",
 "Desfazer": "元に戻す",
 "Desfazer amizade": "友だちを解除",
 "Desligar": "オフにする",
 "Desligar a sincronização?": "同期をオフにしますか？",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "左右にスワイプしてほかの日を表示します（最大60日先まで）。食事をタップすると、その日だけの献立を計画できます。右にドラッグで削除。",
 "Desmarcado": "キャンセル",
 "Desmarcar como recebida": "受取済みを取り消す",
 "Desmarcar feita hoje": "今日の完了を取り消す",
 "Desmarcar grupo": "グループの選択を解除",
 "Desmarcar pagamento": "支払い済みを解除",
 "Desodorante": "デオドラント",
 "Despensa": "パントリー",
 "Despesa": "経費",
 "Despesas": "経費",
 "Destino": "行き先",
 "Detalhes": "詳細",
 "Devolver até": "返却期限",
 "Devolver: {i} ({p})": "返却：{i}（{p}）",
 "Devolvido": "返却済み",
 "Devolvidos": "返却済み",
 "Dia": "日",
 "Dia a dia": "毎日の暮らし",
 "Dia da mudança": "引っ越し当日",
 "Dia de vencimento do DAS": "DAS の期日",
 "Dia do Trabalho": "メーデー",
 "Dia do vencimento": "支払日",
 "Dia em que a fatura fecha": "請求の締め日",
 "Dia planejado": "予定日",
 "Dia {d} de {total}": "{total}日中{d}日目",
 "Diagnóstico": "診断",
 "Dias e horários": "曜日と時間",
 "Dias específicos": "特定の曜日",
 "Dias úteis": "平日",
 "Dias: {dias}": "曜日：{dias}",
 "Dicas e observações": "ヒント・メモ",
 "Diesel": "ディーゼル",
 "Diferença": "差額",
 "Digitado": "手動",
 "Digitar": "入力",
 "Digitar à mão": "手動で入力",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "金庫のパスワードを入力してください。使わないと5分で自動的に閉じます。",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "分（90）または時間と分（1:30 または 01:30）で入力し、「OK」をタップしてください。",
 "Digite no formato HH:MM, por exemplo 13:30.": "HH:MM の形式で入力してください（例：13:30）。",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "コードを入力すると、すべてのタブが10日間使えます。お持ちでなければ空欄のままにしてください。",
 "Digite o nome da tarefa.": "タスク名を入力してください。",
 "Dinheiro": "お金",
 "Dinheiro e documentos": "お金と書類",
 "Direita": "右",
 "Direito": "法律",
 "Direito Administrativo": "行政法",
 "Direito Civil": "民法",
 "Direito Constitucional": "憲法",
 "Direito Empresarial": "商法",
 "Direito Penal": "刑法",
 "Direito Tributário": "税法",
 "Direito do Trabalho": "労働法",
 "Direto": "直接",
 "Disciplina": "教科",
 "Dispensar": "閉じる",
 "Dispensar o aviso": "通知を閉じる",
 "Dispensar todas": "すべて閉じる",
 "Disponibilizada em": "公開日",
 "Disponível no app novo": "新しいアプリで利用できます",
 "Distância": "距離",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "コースを科目やモジュールに分けましょう。それぞれで止まった回を記録し、メモカードを作れます。",
 "Dividir": "分割",
 "Dividir entre (nenhum marcado = todos)": "割り勘する人（未選択 = 全員）",
 "Divisão das despesas": "費用の割り勘",
 "Diária": "1泊料金",
 "Diária padrão": "標準1泊料金",
 "Diário": "日誌",
 "Diários municipais": "市町村の官報",
 "Do celular, do Google Drive ou do OneDrive": "スマホ、Google Drive、OneDrive から",
 "Do cliente": "クライアントから",
 "Do escritório": "事務所から",
 "Doações": "寄付",
 "Docs": "書類",
 "Documento": "書類",
 "Documento (fundo branco)": "文書（白背景）",
 "Documento do veículo (CRLV)": "車両書類（CRLV）",
 "Documento pessoal": "個人書類",
 "Documento vence hoje": "書類の期限は今日です",
 "Documento vencendo": "書類の期限が近づいています",
 "Documento: {o}": "書類: {o}",
 "Documentos": "書類",
 "Documentos (contrato, nota, recibo...)": "書類（契約書、請求書、領収書...）",
 "Documentos (passaporte, identidade, carteira de motorista)": "書類（パスポート、身分証、運転免許証）",
 "Documentos e autorização das crianças": "子どもの書類と同意書",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "保護された書類、検査、病歴など 🔒 の付いた項目は、金庫のパスワードでこの端末上で暗号化されます（AES-256）。サポートでも読めません。パスワードがないと、これらのデータは復元できません。",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "書類、レシート、ノート、ホワイトボード（複数ページ対応）",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "書類、会議、録画は全員から削除されます。チャットはメッセージに残ります。",
 "Documentário": "ドキュメンタリー",
 "Doenças, cirurgias e observações": "病気、手術、メモ",
 "Dois dedos ou toque duplo para ampliar": "ピンチまたはダブルタップで拡大",
 "Domingo": "日曜日",
 "Dono da obra": "施主",
 "Dose": "用量",
 "Dose (ex.: 1 cápsula, 5 g)": "用量（例：1カプセル、5 g）",
 "Dose única": "1回のみ",
 "Drama": "ドラマ",
 "Duplicar": "複製",
 "Duplicar tarefa": "タスクを複製",
 "Duração": "所要時間",
 "Duração de cada sessão": "各セッションの長さ",
 "Duração {dur}": "所要時間 {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "3,000の買い物を10回払いにできますか？",
 "Débito automático": "口座振替",
 "Débito, Pix ou dinheiro": "デビット、Pix、現金",
 "Dê um nome ao cartão.": "カードに名前を付けてください。",
 "Dê um nome ao cuidado.": "ケアに名前を付けてください。",
 "Dê um nome ao cômodo.": "部屋に名前を付けてください。",
 "Dê um nome ao fichário.": "バインダーに名前を付けてください。",
 "Dê um nome ao grupo.": "グループ名を入力してください。",
 "Dê um nome ao suplemento.": "サプリメントの名前を入力してください。",
 "Dê um nome ao treino.": "トレーニングの名前を入力してください。",
 "Dê um nome à conta.": "支払いに名前を付けてください。",
 "Dê um nome à matéria.": "科目に名前を付けてください。",
 "Dê um nome à meta.": "目標に名前を付けてください。",
 "Dê um nome à refeição.": "食事に名前を付けてください。",
 "Dê um nome à tarefa.": "タスクに名前を付けてください。",
 "E-MAIL (OPCIONAL)": "メールアドレス（任意）",
 "E-mail": "メールアドレス",
 "E-mail (recebe a nota)": "メール（請求書の送付先）",
 "E-mail de contato": "連絡用メールアドレス",
 "E-mail do responsável": "保護者のメール",
 "E-mail inválido": "メールアドレスが正しくありません",
 "E-mail inválido.": "メールアドレスが正しくありません。",
 "E-mail ou WhatsApp para resposta (opcional)": "返信用のメールアドレスまたは WhatsApp（任意）",
 "E-mail para contato (opcional)": "連絡用メールアドレス（任意）",
 "E-mail salvo.": "メールアドレスを保存しました。",
 "EM ATRASO": "期限切れ",
 "ENTRAR COM UM CÓDIGO": "コードで参加",
 "ENVIADOS": "送信済み",
 "ESCOLHA AS ATIVIDADES": "アクティビティを選択",
 "ESTA SEMANA": "今週",
 "EXERCÍCIO FÍSICO": "運動",
 "Economia": "経済",
 "Edita tudo": "すべて編集",
 "Edita tudo: etapas, orçamento, diário e entregas.": "すべて編集: 工程、予算、日誌、納品。",
 "Editar": "編集",
 "Editar cartão": "カードを編集",
 "Editar compra": "購入を編集",
 "Editar cômodo": "部屋を編集",
 "Editar desenho": "描画を編集",
 "Editar documento": "書類を編集",
 "Editar fichário": "バインダーを編集",
 "Editar garantia": "保証を編集",
 "Editar matéria": "科目を編集",
 "Editar meta": "目標を編集",
 "Editar perfil": "プロフィールを編集",
 "Editar tarefa": "タスクを編集",
 "Editar {nome}": "{nome}を編集",
 "Educação": "教育",
 "Educação Física": "体育",
 "Efeito de scanner": "スキャン風効果",
 "Ela sai da lista e dos Recebidos da equipe.": "一覧とチームの受信から削除されます。",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "\"マイスタンプ\"にも保存されるので、また送れます。",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "「ローン・融資」タブから来ています。ここで支払い済みにするか、タブを開いて契約を確認してください。",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "「請求書（NF）」タブから来ています。入金されたら受取済みにしてください。",
 "Eleitorais": "選挙裁判所",
 "Eletrodoméstico": "家電",
 "Eletrodomésticos": "家電",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "家電、電子機器、家具：領収書、修理窓口、保証終了の15日前にお知らせ。",
 "Eletrônico": "電子機器",
 "Elétrica": "電気工事",
 "Elétrico": "電気自動車",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "「編集」に掲載物件のカレンダーリンク（iCal）を貼り付けてください。Airbnb：カレンダー › 予約可能状況 › カレンダーを接続 › カレンダーをエクスポート。Booking：料金と空室状況 › カレンダーを同期。",
 "Em aberto": "未完了",
 "Em alta": "トレンド",
 "Em andamento": "進行中",
 "Em atraso": "延滞",
 "Em branco": "白紙",
 "Em casa": "自宅",
 "Em cima": "上",
 "Em construção": "準備中",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "最新です。改善はアプリを開くと自動で届きます。",
 "Em limpeza": "清掃中",
 "Em quais páginas": "対象ページ",
 "Em qual agenda criar os eventos:": "予定を作成するカレンダー：",
 "Em qual página e onde": "どのページのどこに",
 "Em tratamento": "治療中",
 "Em um horário específico": "指定した時刻に",
 "Em uso: {ia}": "使用中：{ia}",
 "Em {n} dia(s)": "{n}日後",
 "Embaixo": "下",
 "Embaixo à esquerda": "左下",
 "Emissão": "発行日",
 "Emissão +": "発行日 +",
 "Emissão: {data}": "発行日：{data}",
 "Emitida": "発行済み",
 "Emitida em {data}": "{data}発行",
 "Emitida ou recebida": "発行または受領",
 "Emitidas": "発行済み",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "発行: {v} · 受領: {r} · {n} 件",
 "Emitir": "発行",
 "Emitir NFS-e": "NFS-e を発行",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "A1 証明書を使って Padrão Nacional で NFS-e を発行し、発行済み・受領済みの請求書を検索して、XML、スプレッドシート、PDF に書き出します。",
 "Emitir a nota de verdade?": "本番の請求書を発行しますか？",
 "Emitir no ambiente de teste?": "テスト環境で発行しますか？",
 "Emojis": "絵文字",
 "Emojis animados": "アニメ絵文字",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "アニメ絵文字：Google の Noto (CC BY 4.0)。",
 "Emojis, GIFs e figurinhas": "絵文字・GIF・スタンプ",
 "Empresa": "会社",
 "Empresa de mudança": "引っ越し業者",
 "Empresa ou pessoa": "会社または個人",
 "Empresa, hotel ou voo": "会社、ホテル、またはフライト",
 "Empresas": "会社",
 "Emprestei": "貸した",
 "Empréstimo": "貸し借り",
 "Empréstimo entre pessoas": "個人間の貸し借り",
 "Empréstimo pessoal": "個人ローン",
 "Empréstimos": "貸し借り",
 "Empréstimos & Financiamentos": "ローン・融資",
 "Encaminhada para {nome}.": "{nome}さんに転送しました。",
 "Encaminhar": "転送",
 "Encaminhar para": "転送先",
 "Encerrar e salvar": "終了して保存",
 "Encontrada para {perfil}": "{perfil}で見つかりました",
 "Endereço": "住所",
 "Endereço (opcional)": "住所（任意）",
 "Endereço (se for presencial)": "住所（対面の場合）",
 "Endereço atual": "現住所",
 "Endereço da escola": "学校の住所",
 "Endereço da oficina": "整備工場の住所",
 "Endereço de quem está com o item": "物を持っている人の住所",
 "Endereço do consultório": "クリニックの住所",
 "Endereço do imóvel": "物件の住所",
 "Endereço do laboratório": "検査機関の住所",
 "Endereço do veterinário": "動物病院の住所",
 "Endereço no trabalho e na escola": "勤務先と学校の住所",
 "Endereço nos Correios e entregas": "郵便と配送の住所",
 "Endereço nos bancos e cartões": "銀行とカードの住所",
 "Endereço novo": "新しい住所",
 "Endereço ou nome do lugar": "住所または場所の名前",
 "Endereço ou terminal": "住所またはターミナル",
 "Energia": "エネルギー",
 "Enfermeiro": "看護師",
 "Engenharia": "工学",
 "Engenheiro ou arquiteto": "エンジニアまたは建築士",
 "Enquadre o documento e toque no botão": "書類を枠に合わせてボタンをタップしてください",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "顔を枠に合わせてボタンをタップしてください。🔄 でカメラを切り替えます。",
 "Ensino Fundamental": "小・中学校",
 "Ensino Médio e ENEM": "高校・ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "内容を理解し、この条件でモニターを使用することに同意します。",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "時間、曜日、項目リストとともに Planner に直接追加されます。その時間がすでに埋まっている場合は、置き換える・両方残す・キャンセルから選べます。",
 "Entrada": "収入",
 "Entrada (imóvel novo)": "入居（新居）",
 "Entrada de dinheiro": "入金",
 "Entrando...": "ログイン中...",
 "Entrar": "ログイン",
 "Entrar com CPF e senha": "CPFとパスワードでログイン",
 "Entrar com outra conta": "別のアカウントでログイン",
 "Entrar de novo": "再ログイン",
 "Entrar na chamada": "通話に参加",
 "Entrar na reunião": "会議に参加",
 "Entrar na sala online": "オンラインルームに入る",
 "Entrar no grupo": "グループに参加",
 "Entrar no navegador?": "ブラウザでログインしますか？",
 "Entre com seu CPF e sua senha.": "CPFとパスワードでログインしてください。",
 "Entre com seu e-mail e sua senha.": "メールアドレスとパスワードでログインしてください。",
 "Entre na sua conta de novo.": "もう一度ログインしてください。",
 "Entre na sua conta para usar as notas fiscais.": "請求書機能を使うにはアカウントにログインしてください。",
 "Entre no app com o seu e-mail e a senha nova.": "メールアドレスと新しいパスワードでアプリにログインしてください。",
 "Entrega de material": "資材の納品",
 "Entrega prevista": "納品予定",
 "Entregas": "納品",
 "Entregue": "提出済み",
 "Entrou": "入金",
 "Entrou no total da semana.": "週の合計に加算されました。",
 "Enviada": "送信しました",
 "Enviado": "送信しました",
 "Enviado para o Planner": "Planner に送信しました",
 "Enviado pelo cliente": "クライアントが送信",
 "Enviado pelo escritório": "事務所が送信",
 "Enviado por {quem} no grupo {g}": "{quem} がグループ {g} で送信",
 "Enviando {f} de {n}...": "アップロード中 {f}/{n}...",
 "Enviando...": "送信中...",
 "Enviar": "送信",
 "Enviar \"{nome}\"": "「{nome}」を送信",
 "Enviar \"{nome}\" para…": "「{nome}」の送信先…",
 "Enviar \"{titulo}\" para": "「{titulo}」の送信先",
 "Enviar ao grupo": "グループに送信",
 "Enviar convite": "招待を送る",
 "Enviar convite para {nome}": "{nome}に招待状を送る",
 "Enviar convite pelo WhatsApp": "WhatsApp で招待を送る",
 "Enviar documento": "書類を送信",
 "Enviar instruções ao hóspede": "ゲストに案内を送る",
 "Enviar o convite": "招待状を送る",
 "Enviar ou copiar o código": "コードを送信・コピー",
 "Enviar ou imprimir a etiqueta": "ラベルを送信または印刷",
 "Enviar para Estudos": "勉強に送る",
 "Enviar para My Planner": "My Planner に送る",
 "Enviar para a equipe": "チームに送信",
 "Enviar para o My Planner": "My Planner に送る",
 "Enviar para o Planner": "Planner に送る",
 "Enviar para o grupo": "グループに送る",
 "Enviar para o grupo de estudos": "勉強グループに送信",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "この端末の {n} 件のファイルを {nome} にアップロード",
 "Enviar para um grupo": "グループに送る",
 "Enviar para {g}": "{g} に送る",
 "Enviar para…": "送信先…",
 "Enviar por e-mail": "メールで送信",
 "Enviar relatório": "レポートを送信",
 "Enviar relatório para a equipe": "チームにレポートを送信",
 "Enviar também as tarefas que já existem (de hoje em diante)": "既存のタスクも送信する（今日以降）",
 "Enviar tarefas do My Planner para a agenda": "My Planner のタスクをカレンダーに送信",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "納付書、請求書、レポートをクライアントに送ったり、クライアントから届いたものを確認したりできます。各書類には写真、PDF、リンクを添付できます。",
 "Enxaguante": "マウスウォッシュ",
 "Episódio": "エピソード",
 "Equipe": "チーム",
 "Equipe ({n})": "チーム（{n}）",
 "Equipe de limpeza": "清掃スタッフ",
 "Equipe do consultório": "クリニックのスタッフ",
 "Equipe do imóvel (limpeza e co-anfitrião)": "物件のスタッフ（清掃・共同ホスト）",
 "Erro": "エラー",
 "Erro na emissão": "発行エラー",
 "Erro: {erro}": "エラー：{erro}",
 "Erros registrados neste dispositivo ({n})": "この端末で記録されたエラー（{n}）",
 "Escanear documento": "書類をスキャン",
 "Escanear o verso": "裏面をスキャン",
 "Escanear para PDF": "スキャンして PDF に",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "書類、レシート、ノート、ホワイトボードをスキャン：端や影を補正、複数ページ、身分証の表裏、署名に対応し、PDF はスマートフォン、Google Drive、OneDrive に保存できます。",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "スキャンして画像を見やすくし、フォルダーで整理して、PDF を WhatsApp、メール、Drive で送れます。AI をオンにすると、アプリがテキストを読み取り、要約し、書類についての質問に答えます。",
 "Escola": "学校",
 "Escolha a aba:": "タブを選択：",
 "Escolha a data do compromisso.": "予定の日付を選んでください。",
 "Escolha a imagem.": "画像を選んでください。",
 "Escolha a matéria": "科目を選択",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "スマートフォンのフォルダーを選んでください（例：Documents）。アプリが自動でそこに保存します。",
 "Escolha a página": "ページを選択",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "裁判所を 1 つ以上選ぶか、「すべての裁判所」にチェックを入れてください。",
 "Escolha ao menos uma agenda.": "カレンダーを1つ以上選択してください。",
 "Escolha o PDF": "PDF を選択",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "会社の A1 証明書ファイル（.pfx または .p12）を選んでパスワードを入力してください。証明書は金庫に暗号化して保存されます。",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "NFS-e、NF-e、CT-e の .xml ファイルを選んでください。",
 "Escolha o fichário": "バインダーを選択",
 "Escolha o grupo para enviar: {t}": "送信先のグループを選択：{t}",
 "Escolha os PDFs": "PDF を選択（複数）",
 "Escolha os arquivos.": "ファイルを選んでください。",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Planner と 🎉 祝日 ボタンに表示する祝日を選んでください。",
 "Escolha para quem enviar.": "送信先を選んでください。",
 "Escolha pelo menos um dia.": "少なくとも1日を選んでください。",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "PDF に存在するページを 1 つ以上選んでください（例：1-3, 5）。",
 "Escolha quem participa:": "参加者を選んでください：",
 "Escolher": "選択",
 "Escolher a imagem": "画像を選ぶ",
 "Escolher a pasta": "フォルダーを選択",
 "Escolher agendas": "カレンダーを選択",
 "Escolher alimento": "食品を選ぶ",
 "Escolher arquivo": "ファイルを選択",
 "Escolher arquivos": "ファイルを選ぶ",
 "Escolher arquivos do Drive ou do OneDrive": "Drive または OneDrive からファイルを選ぶ",
 "Escolher as imagens e criar o PDF": "画像を選んで PDF を作成",
 "Escolher da galeria": "ギャラリーから選ぶ",
 "Escolher da galeria ou arquivo (foto ou PDF)": "ギャラリーまたはファイルから選ぶ（写真または PDF）",
 "Escolher data": "日付を選択",
 "Escolher fuso": "タイムゾーンを選択",
 "Escolher hora": "時刻を選択",
 "Escolher horário": "時刻を選択",
 "Escolher o certificado": "証明書を選ぶ",
 "Escolher outro": "別のものを選ぶ",
 "Escolher pessoas": "メンバーを選ぶ",
 "Escolher tribunais": "裁判所を選択",
 "Escolher ícone": "アイコンを選択",
 "Esconder da equipe (só administradores)": "チームに非表示（管理者のみ）",
 "Esconder detalhes": "詳細を隠す",
 "Esconder o texto completo": "全文を閉じる",
 "Escondido de {n} pessoa(s)": "{n} 人に非表示",
 "Escondido de: {n}": "非表示：{n}",
 "Escondidos no Planner.": "Planner では非表示です。",
 "Escova e pasta de dente": "歯ブラシと歯みがき粉",
 "Escovar os dentes": "歯を磨く",
 "Escreva aqui": "ここに入力",
 "Escreva e dê Enter (ex.: lavar a máquina)": "入力してEnter（例：洗濯機を洗う）",
 "Escreva em uma ou em todas as páginas.": "1 ページまたは全ページに書き込みます。",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "請求書の詳細の「取消理由」に理由を書いて（15 文字以上）、もう一度ここをタップしてください。",
 "Escreva o resumo, tópicos, dúvidas...": "要約、トピック、疑問点などを書く...",
 "Escreva o texto da marca d'água.": "透かしの文字を入力してください。",
 "Escreva o texto.": "テキストを入力してください。",
 "Escreva o título.": "タイトルを入力してください。",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "テキストを入力または貼り付けてください。\"# \" で始まる行は見出しになります。",
 "Escreva ou cole um texto e gere o PDF.": "テキストを入力または貼り付けて PDF を作成します。",
 "Escritório": "オフィス",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "オフィス：チームのドキュメントと会議。会議を録画できるのはオフィスの管理者のみで、録画中は参加者全員に「録画中」の表示が出ます。録画はオフィスのドキュメントに保存され、管理者がチームに公開するまでは管理者のみが閲覧できます。",
 "Escuro": "ダーク",
 "Espanhol": "スペイン語",
 "Espaço": "物件",
 "Espaço livre, dados de cada aba e anexos": "空き容量、各タブのデータ、添付ファイル",
 "Especialidade": "診療科",
 "Espécie": "種類",
 "Esquadro": "直角定規",
 "Esqueci a senha": "パスワードを忘れた",
 "Esquerda": "左",
 "Esse código é o seu.": "これはあなたのコードです。",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "これはあなた自身のコードです。アプリを紹介してくれた人のコードを使ってください。",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "このアドレスは請求書サーバーとして応答しませんでした。確認してもう一度お試しください。",
 "Esta aba ainda não está no seu plano.": "このタブはまだプランに含まれていません。",
 "Esta e todas as futuras": "これ以降すべて",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "このツールには PDF のページ表示が必要で、新しいアプリ（バージョン 0.50）で対応します。ブラウザを使うか、新しい APK をインストールしてください。",
 "Esta imagem foi guardada em outro dispositivo.": "この画像は別の端末に保存されています。",
 "Esta janela pode ser fechada.": "このウィンドウは閉じてかまいません。",
 "Esta pessoa ainda não preencheu o cartão de contato.": "この人はまだ連絡先カードを入力していません。",
 "Esta semana: {a} de {m} aulas ({p}%)": "今週：{m} 回中 {a} 回（{p}%）",
 "Esta senha é de outra conta.": "このパスワードは別のアカウントのものです。",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "このタスクには時刻がありません。「開始時」と「開始前」は使えません。「指定した時刻に」を使ってください。",
 "Esta tarefa se repete. O que excluir?": "このタスクは繰り返します。どれを削除しますか？",
 "Esta tela teve um problema": "この画面で問題が発生しました",
 "Estado (UF) do registro": "登録した州（UF）",
 "Estado de Mato Grosso do Sul": "マット・グロッソ・ド・スル州",
 "Estado de São Paulo": "サンパウロ州",
 "Estado do Paraná": "パラナ州",
 "Estados": "州",
 "Estaduais": "州裁判所",
 "Estadual": "州",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "これらのタブは、この順番で下のバーに表示されます。My Planner、タブ、設定は常に表示されます。ほかのタブはこのタブ画面に残ります。",
 "Estatística": "統計",
 "Este CPF já tem cadastro. Use \"Entrar\".": "このCPFは登録済みです。「ログイン」を使ってください。",
 "Este PDF está no dispositivo onde foi aberto.": "この PDF は開いた端末に保存されています。",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "この PDF は開いた端末に保存されています。その端末で開くか、Drive または OneDrive に保存したコピーを開き直してください。",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "この PDF はパスワードで保護されています。作成したソフトでパスワードを外してから、もう一度お試しください。",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "この PDF にはフォームフィールドがありません。\"テキストを追加\" で書き込んでください。",
 "Este ano": "今年",
 "Este dispositivo": "この端末",
 "Este dispositivo não consegue abrir o arquivo.": "この端末ではファイルを開けません。",
 "Este dispositivo não consegue compartilhar arquivos.": "この端末はファイルを共有できません。",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "このデバイスには健康データがありません。手動で入力できます。",
 "Este arquivo foi guardado em outro dispositivo.": "このファイルは別の端末に保存されています。",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "このファイルはスマホに保存されています。スマホのアプリで開いてください。",
 "Este arquivo não é um backup do My Planner.": "このファイルはMy Plannerのバックアップではありません。",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "このスマホはアプリを閉じた状態ではまだ通知を受け取れません。アプリ {v} 以降（サーバー通知対応の APK）をインストールしてください。アプリを開いている間は通知が届きます。",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "この証明書は {doc} のもので、会社の CNPJ/CPF（{emp}）と異なります。",
 "Este fichário ainda não tem matérias.": "このバインダーにはまだ科目がありません。",
 "Este grupo já está cheio.": "このグループは満員です。",
 "Este mês": "今月",
 "Este mês: emitidas {e} · recebidas {r}": "今月: 発行 {e} · 受領 {r}",
 "Este mês: {h}": "今月：{h}",
 "Este navegador": "このブラウザ",
 "Este país só tem feriados nacionais.": "この国には国民の祝日しかありません。",
 "Esteira": "トレッドミル",
 "Esteticista": "エステティシャン",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "My Planner で予定や家計などを管理しています。アプリをダウンロードして、アカウント作成時に私のコード {codigo} を使うと、すべてのタブが10日間使えます。",
 "Estratégia": "指導法",
 "Estrela": "星",
 "Estudando": "勉強中",
 "Estudar agora": "今すぐ勉強",
 "Estudar {nome}": "{nome}を勉強",
 "Estudar: {c}": "勉強：{c}",
 "Estudo": "研究",
 "Estudos": "勉強",
 "Estudos e exatas": "勉強と理系",
 "Estudos, lazer e viagens": "勉強・レジャー・旅行",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "「資産＆所得税 › 控除対象の領収書」にあります。そこで領収書の写真と、受け取った人のCPFまたはCNPJを添付してください。",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "ページ「{titulo}」と「ファイルを見る」にあります。",
 "Etanol": "エタノール",
 "Etapa": "工程",
 "Etapa do cronograma": "スケジュールの工程",
 "Etapas": "工程",
 "Evento": "イベント",
 "Eventos": "イベント",
 "Eventos & Celebrações": "イベント＆お祝い",
 "Evolução (no cofre)": "経過記録（金庫内）",
 "Ex.: 08:00 e 20:00": "例：08:00 と 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "例：08:00、14:00、20:00",
 "Ex.: 09/2026": "例: 09/2026",
 "Ex.: 1 comprimido": "例：1錠",
 "Ex.: 1-3, 4-10, 11-": "例：1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "例：1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "例: 171901（コンサルティング）、010101（プログラミング）",
 "Ex.: 40 sacos de cimento": "例：セメント40袋",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "例: 4106902（Curitiba）、5002704（Campo Grande）、3550308（São Paulo）",
 "Ex.: 8º ano B": "例：中学2年B組",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "例：腰のストレッチ、1,800 kcal の食事",
 "Ex.: Aniversário de 30 anos da Ana": "例：アナの30歳の誕生日",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "例：ビーチのマンション、スイート1、離れ",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "例：X通りのマンション、PETR4 100株",
 "Ex.: Aula de revisão, Consulta de retorno": "例：復習授業、再診",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "例：ケータリング、DJ、装飾、カメラマン",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "例：社外秘、コピー、下書き",
 "Ex.: Cardiologista": "例：循環器内科",
 "Ex.: Consultoria mensal": "例: 月次コンサルティング",
 "Ex.: Costela-de-adão da sala": "例：リビングのモンステラ",
 "Ex.: DAS de setembro, Extrato do Itaú": "例: 9 月の DAS、Itaú の取引明細",
 "Ex.: Desmontar os móveis do quarto": "例：寝室の家具を分解する",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "例：対応可能 · 18時まで授業中 · 旅行に行こう！",
 "Ex.: Eletricista, loja de material": "例：電気工事士、建材店",
 "Ex.: Entrada dos noivos": "例：新郎新婦入場",
 "Ex.: Financiamento do carro": "例：車のローン",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "例：理学療法士、栄養士、循環器内科医",
 "Ex.: Furadeira, livro, R$ 200": "例：ドリル、本、R$ 200",
 "Ex.: Hemograma": "例：血液検査",
 "Ex.: IPVA 2027, parcela 1": "例：IPVA 2027 第1回",
 "Ex.: Lisboa, Portugal": "例：ポルトガル、リスボン",
 "Ex.: Mala da Ana": "例：アナのスーツケース",
 "Ex.: Mensalidade de outubro, material": "例：10月の月謝、教材費",
 "Ex.: Netflix, cinema": "例：Netflix、映画館",
 "Ex.: Notas de compra de setembro": "例: 9 月の仕入れ請求書",
 "Ex.: Onix 2022": "例：Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "例：テスト1、グループ課題",
 "Ex.: Prova de matemática": "例：数学のテスト",
 "Ex.: Pôr do sol no Tejo": "例：テージョ川の夕日",
 "Ex.: Reforma da cozinha": "例：キッチンのリフォーム",
 "Ex.: TAP TP 108": "例：TAP TP 108",
 "Ex.: Torre de Belém": "例：ベレンの塔",
 "Ex.: Troca da fiação da sala": "例：リビングの配線交換",
 "Ex.: V10, antirrábica": "例：V10、狂犬病ワクチン",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "例：ジェロニモス修道院の見学",
 "Ex.: cerâmica 30 cm": "例：30cm のタイル",
 "Ex.: kg, pacotes, latas": "例：kg、袋、缶",
 "Ex.: seg e qua, 07:30": "例：月・水 07:30",
 "Ex.: troquei o arroz por batata doce": "例：ご飯をさつまいもに替えた",
 "Ex.: varanda, sala": "例：ベランダ、リビング",
 "Exame": "検査",
 "Exame da OAB": "OAB 弁護士試験",
 "Exames": "検査",
 "Excel": "Excel",
 "Excluir": "削除",
 "Excluir \"{nome}\"?": "「{nome}」を削除しますか？",
 "Excluir \"{titulo}\"?": "「{titulo}」を削除しますか？",
 "Excluir a caixa?": "ボックスを削除しますか？",
 "Excluir a compra": "購入を削除",
 "Excluir a compra?": "購入を削除しますか？",
 "Excluir a meta \"{m}\"?": "目標「{m}」を削除しますか？",
 "Excluir cartão": "カードを削除",
 "Excluir conta": "請求を削除",
 "Excluir cuidado": "ケアを削除",
 "Excluir cômodo": "部屋を削除",
 "Excluir esta página?": "このページを削除しますか？",
 "Excluir fichário": "バインダーを削除",
 "Excluir matéria": "科目を削除",
 "Excluir o cartão \"{c}\"?": "カード「{c}」を削除しますか？",
 "Excluir o documento": "書類を削除",
 "Excluir o fichário {nome}": "バインダー {nome} を削除",
 "Excluir página": "ページを削除",
 "Excluir refeição": "食事を削除",
 "Excluir suplemento": "サプリメントを削除",
 "Excluir tarefa": "タスクを削除",
 "Excluir tarefa repetida": "繰り返しタスクを削除",
 "Excluir tarefa?": "タスクを削除しますか？",
 "Excluir treino": "トレーニングを削除",
 "Excluir {nome}?": "{nome}を削除しますか？",
 "Excluídas em definitivo 30 dias depois do descarte.": "破棄してから 30 日後に完全に削除されます。",
 "Executivo e profissional": "ビジネスと仕事",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "契約の履行（art. 7º, V）：サービス提供のため。同意（art. 7º, I）：カメラ、ギャラリー、マイク、位置情報のため。法的義務の遵守（art. 7º, II）。正当な利益（art. 7º, IX）：セキュリティと不正防止のため。",
 "Exemplos: 13:30, 1330, 9:05": "例：13:30、1330、9:05",
 "Exercício": "エクササイズ",
 "Exercício físico": "運動",
 "Experimente grátis por {n} dias": "{n} 日間無料でお試し",
 "Explique o motivo (para cancelar)": "理由を入力（取消用）",
 "Exportar arquivo": "ファイルをエクスポート",
 "Exportar para o contador": "会計士向けに書き出す",
 "Extrair páginas": "ページを抽出",
 "Extras (pet, check-in tardio...)": "追加料金（ペット、遅いチェックインなど）",
 "Extrato": "明細",
 "Extrato bancário": "銀行取引明細",
 "Extrato do banco (foto ou PDF)": "銀行の明細（写真またはPDF）",
 "Extrato importado": "明細を取り込みました",
 "Extrato por foto": "写真で明細",
 "FRASE": "ひとこと",
 "FRÁGIL": "割れ物",
 "Fabricante ou estendida: {n} meses": "メーカー保証または延長保証：{n}か月",
 "Facultativo": "任意",
 "Falar com a limpeza": "清掃担当に連絡",
 "Fale conosco": "お問い合わせ",
 "Falta": "欠席",
 "Falta XML": "XML なし",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "請求書サーバーが未接続です。パソコンで 13-LIGAR-NOTAS.bat をダブルクリックし、表示されたアドレスをここに貼り付けてください。",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect がありません。時計や健康アプリのデータをまとめる Google のアプリです。",
 "Faltam": "未訪問",
 "Faltam {ml} ({n} copo(s))": "あと {ml}（{n}杯）",
 "Faltam {n} dia(s) do seu período grátis": "無料期間は残り {n} 日です",
 "Faltam {n} dias": "あと{n}日",
 "Faltou": "欠席",
 "Família": "家族",
 "Fantasia": "ファンタジー",
 "Fatura": "請求",
 "Fatura com vencimento em {d}.": "支払期日が{d}の請求です。",
 "Fatura de {mes}": "{mes}の請求",
 "Fatura de {mes}: vence {data}": "{mes}の請求：期日 {data}",
 "Fatura do cartão (foto ou PDF)": "カードの請求（写真またはPDF）",
 "Fatura importada": "請求を取り込みました",
 "Fatura paga (toque para desfazer)": "支払い済み（タップで取り消し）",
 "Fatura {c}": "{c}の請求",
 "Faturamento em {ano}: {v} de {lim}": "{ano}年の売上：{v} / {lim}",
 "Faturas dos cartões": "カードの請求",
 "Fazer agora, passo a passo": "今すぐステップごとに実行",
 "Fazer com este PDF": "この PDF でできること",
 "Fazer cópia agora": "今すぐバックアップ",
 "Fecha dia {f} · vence dia {v}": "締め日 {f}日 · 支払日 {v}日",
 "Fecha {f} · vence {v}": "締め {f} · 期日 {v}",
 "Fechar": "閉じる",
 "Fechar o cofre": "金庫を閉じる",
 "Feche e abra o app de novo": "アプリを閉じて開き直してください",
 "Federais": "連邦裁判所",
 "Feijão": "煮豆",
 "Feita em {data}": "{data} に完了",
 "Feita hoje": "今日完了",
 "Feitas": "完了",
 "Feitas (não se repetem) · {n}": "完了（繰り返しなし）· {n}",
 "Feito": "完了",
 "Feito!": "完了！",
 "Feliz aniversário": "誕生日おめでとう",
 "Feminino": "女性",
 "Feminino e suave": "フェミニン＆ソフト",
 "Feriado escolar": "学校の休日",
 "Feriado estadual": "州の祝日",
 "Feriado estadual: {nome}": "州の祝日：{nome}",
 "Feriado municipal": "市の祝日",
 "Feriado municipal: {nome}": "市の祝日：{nome}",
 "Feriado nacional": "国民の祝日",
 "Feriado nacional: {nome}": "国民の祝日：{nome}",
 "Feriado regional": "地域の祝日",
 "Feriado regional: {nome}": "地域の祝日：{nome}",
 "Feriados": "祝日",
 "Feriados nacionais": "国民の祝日",
 "Feriados no planner": "プランナーに祝日を表示",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "祝日、為替レート、AI の提案、支払伝票や領収書の自動読み取りには誤りがある場合があります。使う前に確認してください。",
 "Ferramenta": "工具",
 "Ferramentas": "道具",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "植物ごとの記録、植え替え、予定に入る水やりと肥料のカレンダー。",
 "Ficha preenchida": "入力が完了しました",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "バインダー、科目、ページ、勉強タイマー、週ごとの目標。",
 "Ficção": "フィクション",
 "Figurinha": "スタンプ",
 "Figurinhas": "スタンプ",
 "Filme": "映画",
 "Filme ou série": "映画またはドラマ",
 "Filmes e séries": "映画とドラマ",
 "Filosofia": "哲学",
 "Filtros": "フィルター",
 "Fim": "終了",
 "Fim (vazio = uso contínuo)": "終了日（空欄 = 継続服用）",
 "Fim da garantia": "保証終了",
 "Fim da garantia:": "保証終了日：",
 "Fim da pausa. Continue: {tarefa}": "休憩終了。続けましょう：{tarefa}",
 "Fim de semana": "週末",
 "Fim previsto": "完了予定",
 "Fina": "細",
 "Finados": "死者の日",
 "Finalizador": "仕上げ剤",
 "Financeiro": "家計",
 "Financeiro: {gasto} de {orcado} ({p}%)": "費用：{orcado}中{gasto}（{p}%）",
 "Financiamento": "ローン",
 "Financiamento de veículo": "自動車ローン",
 "Financiamento imobiliário": "住宅ローン",
 "Financiamentos": "融資",
 "Financiamentos e empréstimos": "ローンと融資",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "分割回、利息、残債、証明書類付きのローンと融資。貸し借りした物は写真と返却リマインダー付き。",
 "Finanças": "ファイナンス",
 "Finanças {p}": "ファイナンス {p}",
 "Finanças · {p}": "ファイナンス · {p}",
 "Fins de semana": "週末",
 "Fio dental": "デンタルフロス",
 "Flex": "フレックス燃料",
 "Flexão de braço": "腕立て伏せ",
 "Flor": "花",
 "Flutua": "ふわふわ",
 "Foguete": "ロケット",
 "Fogão": "コンロ",
 "Foi no cartão de crédito? Lançar como compra no cartão": "クレジットカードで払いましたか？カードの購入として記録",
 "Foi para {destino}.": "{destino}に送信しました。",
 "Foi para {destino}. Quer tirar daqui?": "{destino}に送信しました。ここから削除しますか？",
 "Folha de pagamento": "給与明細",
 "Fone": "受話口",
 "Fone de ouvido": "イヤホン",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "出典：ブラジルは連邦の祝日告示と各州の法律をもとにアプリ内で計算。その他の国は公開データベース Nager.Date (date.nager.at) をインターネットからダウンロードし、端末に保存しています。",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "出典：ブラジルは、連邦の祝日告示、各州の法律、各州都の公式カレンダーをもとにアプリ内で計算しています。その他の国：公開データベース Nager.Date（date.nager.at）をインターネットからダウンロードし、端末に保存しています。",
 "Forma": "支払方法",
 "Forma das parcelas": "返済方式",
 "Forma de pagamento": "支払方法",
 "Forma de pagamento: {f}.": "支払方法：{f}。",
 "Formas": "図形",
 "Formato": "形式",
 "Formatos": "図形",
 "Formatura": "卒業式",
 "Fornecedor": "業者",
 "Fornecedores": "業者",
 "Forte": "濃い",
 "Foto": "写真",
 "Foto da galeria": "ギャラリーから選択",
 "Foto do contato": "連絡先の写真",
 "Foto inteira": "写真全体",
 "Foto ou PDF (lido pela sua IA)": "写真またはPDF（あなたのAIが読み取ります）",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "退去時と入居時の立ち会い検査で、各部屋を写真に撮っておきましょう。物件を返すときに写真があなたを守ります。",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "医師、歯科、学校、年金の領収書は支払ったらすぐ写真に撮りましょう。年末にはすべてそろっています。",
 "Fotos": "写真",
 "Fotos JPG, PNG e outras viram um PDF.": "JPG、PNG などの写真を PDF にします。",
 "Fotos de {d}": "{d} の写真",
 "Fotos do espaço pronto": "清掃後の写真",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "このカードの写真とファイルもグループのフォルダに保存され、参加者が開けます。",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "写真とファイルはこの端末にのみ保存されます。書類のデータは保護された状態でアカウントに保存されます。",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "写真とファイルはこの端末に保存されます（設定で連携していれば、Drive や OneDrive にも保存されます）。",
 "Fotos e notas": "写真とメモ",
 "Fotos e vídeos": "写真と動画",
 "Fotos, arquivos e links": "写真、ファイル、リンク",
 "Fraldas e lenços": "おむつとおしりふき",
 "Francês": "フランス語",
 "Frango com osso": "骨付き鶏肉",
 "Frango sem osso": "骨なし鶏肉",
 "Frase (opcional, ex.: Bom dia!)": "フレーズ（任意、例：おはよう！）",
 "Freelancer & Projetos": "フリーランス＆プロジェクト",
 "Freezer": "冷凍庫",
 "Freios": "ブレーキ",
 "Frente": "表面",
 "Frente do documento": "書類の表面",
 "Frente e verso na mesma folha": "表と裏を 1 枚に",
 "Frente pronta": "表面完了",
 "Frequência": "頻度",
 "Frio": "寒い",
 "Fruta": "果物",
 "Frágil": "割れ物",
 "Fundação e estrutura": "基礎と構造",
 "Fundo": "背景",
 "Fundos e renda fixa": "投資信託・債券",
 "Fuso": "タイムゾーン",
 "Fuso horário": "タイムゾーン",
 "Fuso horário do destino": "行き先のタイムゾーン",
 "Futebol": "サッカー",
 "Física": "物理",
 "Físico (obra pronta): {p}%": "工事の進捗：{p}%",
 "GASTOS POR CATEGORIA": "カテゴリー別の支出",
 "GIF guardado nos seus GIFs.": "GIFをマイGIFに保存しました。",
 "Garagem": "ガレージ",
 "Garantia": "保証",
 "Garantia até {data}.": "{data}まで保証。",
 "Garantia legal": "法定保証",
 "Garantia vencendo": "保証期限が近い",
 "Garantias": "保証",
 "Garrafa de água": "水筒",
 "Gasolina": "ガソリン",
 "Gasto": "支出",
 "Gasto até agora": "これまでの支出",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "{v}の支出を記録しました。買い物リスト用に{n}件の価格を保存しました。",
 "Gasto neste mês: {v}": "今月の支出：{v}",
 "Gasto: {v}": "支出：{v}",
 "Gastos": "支出",
 "Gastos por categoria": "カテゴリー別の支出",
 "Gato": "猫",
 "Geladeira": "冷蔵庫",
 "Geografia": "地理",
 "Gerado por": "生成アプリ",
 "Gerando QR Code...": "QRコードを生成中...",
 "Gerar PDF": "PDF を作成",
 "Gerar as cobranças do mês": "今月の請求を作成",
 "Gerar as parcelas": "分割回を作成",
 "Gerar lista da mala": "荷物リストを作成",
 "Gerar pelo cardápio e pela despensa": "献立とストックから作成",
 "Gesso e forro": "石膏ボードと天井",
 "Gira todas as páginas ou só as escolhidas.": "全ページまたは選んだページを回転します。",
 "Girar": "回転",
 "Google Drive e OneDrive": "Google Drive と OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google ドライブ、OneDrive、Google カレンダー：接続した場合のみ、ファイルと予定の保存のためだけに使います。",
 "Gorro, cachecol e luvas": "ニット帽、マフラー、手袋",
 "Gota": "しずく",
 "Graduação e Pós": "大学・大学院",
 "Grande": "大",
 "Gravando": "録画中",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "必要なときに音声でリマインダーやメモを録音します。マイクはタップしたときだけオンになります。",
 "Gravar reunião": "会議を録画",
 "Gravação de áudio": "音声録音",
 "Gravações das reuniões": "会議の録画",
 "Grossa": "太",
 "Grupo": "グループ",
 "Grupo com convite (turma, equipe, convidados)": "招待制グループ（クラス、チーム、ゲスト）",
 "Grupo criado": "グループを作成しました",
 "Grupo da família": "家族グループ",
 "Grupo da mudança (família e ajudantes)": "引っ越しグループ（家族・手伝い）",
 "Grupo da obra (equipe)": "工事グループ（チーム）",
 "Grupo da turma (convidar alunos)": "クラスグループ（生徒を招待）",
 "Grupo da viagem (convidar quem vai)": "旅行グループ（同行者を招待）",
 "Grupo de cuidado (família ou profissional)": "ケアグループ（家族・専門家）",
 "Grupo de estudos (convidar colegas)": "勉強グループ（仲間を招待）",
 "Grupo de leitura (convidar)": "読書グループ（招待）",
 "Grupo do cliente": "クライアントグループ",
 "Grupo do evento (convidar)": "イベントグループ（招待）",
 "Grupos": "グループ",
 "Grupos de estudo": "勉強グループ",
 "Grupos de {aba}": "{aba} のグループ",
 "Grupos desta aba: {n}": "このタブのグループ: {n}",
 "Grupos e convites": "グループと招待",
 "Grátis no lançamento": "リリース期間は無料",
 "Guarda-chuva": "傘",
 "Guardada nas suas figurinhas.": "マイスタンプに保存しました。",
 "Guardado": "貯蓄額",
 "Guardado até agora: {v}": "これまでの貯蓄：{v}",
 "Guardado em outro dispositivo": "別の端末に保存",
 "Guardado na pasta \"{pasta}\" do celular.": "スマホの \"{pasta}\" フォルダに保存しました。",
 "Guardado no cofre, com criptografia de ponta a ponta.": "エンドツーエンド暗号化で金庫に保管済み。",
 "Guardado no {nome}.": "{nome} に保存しました。",
 "Guardado {onde} em {quando}": "{onde} に保存済み（{quando}）",
 "Guardando...": "保存中...",
 "Guardar": "貯める",
 "Guardar como recibo do IR": "IR（所得税）の領収書として保存",
 "Guardar dinheiro": "お金を貯める",
 "Guardar e enviar": "保存して送信",
 "Guardar na meta": "目標に貯める",
 "Guardar nas minhas figurinhas": "マイスタンプに保存",
 "Guardar nos meus GIFs": "マイGIFに保存",
 "Guardar o PDF {onde}": "PDF を {onde} に保存",
 "Guardar os PDFs em": "PDF の保存先",
 "Guardar os arquivos prontos em": "完成ファイルの保存先",
 "Guardar sozinho cada arquivo pronto": "完成したファイルを自動で保存",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "よく使う処方や指導内容を保存しておきましょう。診療で ⋮ › テンプレートを使う をタップします。",
 "Guarde seus documentos num lugar só": "書類をひとつの場所にまとめましょう",
 "Guarde {v} por mês até {d}": "{d}まで毎月{v}を貯めましょう",
 "Guardou": "貯蓄",
 "Guia de imposto": "税の納付書",
 "Gás": "ガス",
 "Gênero ou categoria": "ジャンル・カテゴリ",
 "HISTÓRICO DOS DADOS": "データの履歴",
 "HOJE": "今日",
 "Hall de entrada": "玄関",
 "Halteres": "ダンベル",
 "Hexágono": "六角形",
 "Hidratante": "保湿剤",
 "Hidratante labial": "リップクリーム",
 "Hidráulica": "水道設備",
 "Higiene bucal": "口腔ケア",
 "Higienizar": "クリーンアップ",
 "História": "歴史",
 "Histórico": "病歴",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "家族の病歴、保護された検査、予防接種、受診、タイムライン上の服薬アラーム。",
 "Hmm...": "うーん...",
 "Hoje": "今日",
 "Hoje: {a} de {m} aulas ({p}%)": "今日：{m} 回中 {a} 回（{p}%）",
 "Hoje: {n} página(s)": "今日：{n} ページ",
 "Hora": "時刻",
 "Hora da pausa": "休憩時間",
 "Hora de voltar": "戻る時間",
 "Hora de voltar!": "戻る時間です！",
 "Hora do check-in": "チェックイン時刻",
 "Hora do check-out": "チェックアウト時刻",
 "Horas": "時間",
 "Horas de sono": "睡眠時間",
 "Horário": "時刻",
 "Horário de check-in": "チェックイン時間",
 "Horário de check-out": "チェックアウト時間",
 "Horário do lembrete": "リマインダーの時刻",
 "Horário inválido": "無効な時刻です",
 "Horário ocupado": "時間が重複しています",
 "Horários": "時刻",
 "Horários (remédio diário)": "時刻（毎日の薬）",
 "Hospedados agora": "滞在中",
 "Hospedagem": "宿泊",
 "Hospital ou pronto-socorro de referência": "かかりつけの病院・救急外来",
 "Hotel": "ホテル",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "My Planner Web の新しいバージョンがあります。再読み込みしてご利用ください。",
 "Híbrido": "ハイブリッド",
 "Hóspede": "ゲスト",
 "Hóspede ({c})": "ゲスト（{c}）",
 "Hóspedes (máximo)": "最大宿泊人数",
 "IA ligada": "AI オン",
 "IA não ligada": "AI オフ",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "AI がオフです。設定 › 人工知能 でオンにしてください。",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "依頼主による ISS 源泉徴収",
 "Ida": "出発",
 "Identidade": "身分証",
 "Idioma": "言語",
 "Idiomas": "語学",
 "Ilimitados": "無制限",
 "Imagem": "画像",
 "Imagem escolhida (trocar)": "画像を選択済み（変更）",
 "Imagem guardada no {nome}. Toque para abrir.": "画像を {nome} に保存しました。タップして開きます。",
 "Imagens para PDF": "画像を PDF に",
 "Imagens {data}": "画像 {data}",
 "Imperdíveis": "必見",
 "Imperdível": "必見",
 "Importar": "取り込む",
 "Importar XML de nota": "請求書の XML を取り込む",
 "Importar arquivo": "ファイルをインポート",
 "Importar backup?": "バックアップをインポートしますか？",
 "Importar extrato": "明細を取り込む",
 "Importar extrato do banco (OFX ou CSV)": "銀行の明細を取り込む（OFX または CSV）",
 "Importar fatura": "請求を取り込む",
 "Importar fotos": "写真を取り込む",
 "Importar reservas do Airbnb, Booking...": "Airbnb、Booking などから予約を取り込む",
 "Importar {n} lançamento(s)": "{n}件を取り込む",
 "Imóveis e espaços": "物件・スペース",
 "Imóvel": "不動産",
 "Imóvel inteiro": "物件全体",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "物件全体でも部屋単位でも：Airbnb、Booking、直接の予約、チェックアウト後の清掃、経費、稼働率、月の利益。",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "「請求書（NF）」タブで発行した請求書の{v}を含みます。",
 "Independência do Brasil": "ブラジル独立記念日",
 "Indicação": "紹介",
 "Indique e ganhe": "紹介特典",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "My Planner を友人や家族に紹介しましょう。あなたのコードでアカウントを作成した人は、すべてのタブが10日間使えます。",
 "Infantil": "児童書",
 "Informações do PDF": "PDF の情報",
 "Informe a descrição e o valor.": "説明と金額を入力してください。",
 "Informe de quantos em quantos dias regar ou adubar.": "水やりまたは肥料の間隔（日数）を入力してください。",
 "Informe o nome do produto.": "商品名を入力してください。",
 "Informe o rótulo e o nome.": "ラベルと名前を入力してください。",
 "Informe o total de aulas da matéria em Editar.": "「編集」で科目の総授業数を入力してください。",
 "Informe o valor.": "金額を入力してください。",
 "Informe os horários": "時刻を入力してください",
 "Informe quanto quer juntar.": "貯めたい金額を入力してください。",
 "Informe seu nome.": "お名前を入力してください。",
 "Informática": "情報",
 "Inglês": "英語",
 "Ingredientes (um por linha)": "材料（1行に1つ）",
 "Inscrição municipal (se tiver)": "市の登録番号（ある場合）",
 "Inspeção": "車検",
 "Instalar ou atualizar o Health Connect": "Health Connect をインストールまたは更新",
 "Instruções, receita, observações...": "手順、レシピ、メモ...",
 "Insumos (papel, sabonete, café)": "消耗品（紙類、石けん、コーヒー）",
 "Inteligência artificial": "人工知能",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "AI（Claude、ChatGPT、Gemini）：オンにした場合のみ、あなた自身のキーで使います。キーは端末内にだけ保存されます。質問の文章は選んだサービスに直接送られます。",
 "Intensidade": "強さ",
 "Internação": "入院",
 "Internet": "インターネット",
 "Intimação": "送達通知",
 "Intimação com prazo": "期限付きの送達通知",
 "Investimento": "投資",
 "Investimentos": "投資",
 "Início": "開始",
 "Início {ini} · Fim {fim} · Duração {dur}": "開始 {ini} · 終了 {fim} · 所要時間 {dur}",
 "Iogurte": "ヨーグルト",
 "Ir para Ajustes (exportar meus dados)": "設定へ（データをエクスポート）",
 "Ir para hoje": "今日へ移動",
 "Ir para o My Planner Web": "My Planner Web へ移動",
 "Italiano": "イタリア語",
 "Item": "項目",
 "Item da despensa": "ストックの品目",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "保護された項目：写真とファイルは金庫で暗号化され、この端末にのみ保存されます（Drive や OneDrive には送られません）。",
 "Itens": "品目",
 "Itens de higiene (xampu, sabonete)": "洗面用品（シャンプー、石けん）",
 "Jantar": "夕食",
 "Japonês": "日本語",
 "Jaqueta impermeável": "防水ジャケット",
 "Jogo": "ゲーム",
 "Jovem e divertido": "若々しく楽しい",
 "Juntar PDFs": "PDF を結合",
 "Juros": "利息",
 "Juros ainda por vir: {v}": "今後の利息：{v}",
 "Juros ao mês": "月利",
 "JÁ RESPONDIDOS": "回答済み",
 "Já aberta na casa nova": "新居で開封済み",
 "Já enviado para a turma": "クラスに送信済み",
 "Já está compacto": "すでに軽量です",
 "Já está no Planner": "すでに Planner にあります",
 "Já está pago": "支払い済み",
 "Já há horários deste item no My Planner": "この項目の時間はすでに My Planner にあります",
 "Já pago: {v}": "支払い済み：{v}",
 "Já tenho o app: abrir nele": "アプリをお持ちの方：アプリで開く",
 "Já tenho o app: abrir o convite nele": "アプリを持っています：アプリで招待を開く",
 "Já visitei": "訪問済み",
 "Kit de primeiros socorros": "救急セット",
 "Kkkk": "www",
 "Kkkkk": "爆笑",
 "Km de hoje no painel": "今日のメーター距離",
 "Km no dia": "当日の距離",
 "Km no painel": "メーター距離",
 "LANÇAMENTOS": "入出金の記録",
 "LINHA DO TEMPO": "タイムライン",
 "Laboratório": "検査機関",
 "Lanche": "軽食",
 "Lanche da manhã": "午前の間食",
 "Lanche da tarde": "午後の間食",
 "Lanches e água": "おやつと水",
 "Lançamentos": "取引",
 "Lavanderia": "ランドリー",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "クリーニング、消耗品、修繕、光熱費、手数料など。月の利益に反映されます。",
 "Lavar o rosto com sabonete facial": "洗顔料で顔を洗う",
 "Lazer": "レジャー",
 "Leg press": "レッグプレス",
 "Legenda": "キャプション",
 "Legislação Específica": "個別法令",
 "Legumes": "野菜",
 "Leia hoje para começar uma sequência": "今日読んで連続記録を始めましょう",
 "Leite": "牛乳",
 "Leitura": "読書",
 "Leitura automática do texto": "テキストの自動読み取り",
 "Leitura da IA": "AI の読み取り",
 "Leitura, Cursos & Mídia": "読書・講座・メディア",
 "Lembrete": "リマインダー",
 "Lembrete de hoje": "今日のリマインダー",
 "Lembrete de renovação no Planner": "Planner に更新リマインダーを追加",
 "Lembrete no Planner": "Planner にリマインダー",
 "Lembrete no planner": "プランナーでリマインド",
 "Lembrete pelo WhatsApp": "WhatsApp でリマインド",
 "Lembrete: começa às {hora}": "リマインダー：{hora} に開始します",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "すべてのメッセージに目を通しています。必要に応じてメールで返信します。",
 "Lendo": "読書中",
 "Lendo a fatura...": "請求を読み取り中...",
 "Lendo a página": "ページを読み取り中",
 "Lendo o boleto...": "Boletoを読み取り中...",
 "Lendo o cupom...": "レシートを読み取り中...",
 "Lendo o documento...": "書類を読み取っています...",
 "Lendo o extrato...": "明細を読み取り中...",
 "Lendo o relógio...": "時計を読み取り中...",
 "Lendo o texto": "テキストを読み取り中",
 "Ler a fatura": "請求を読み取る",
 "Ler a publicação inteira": "公告全文を読む",
 "Ler com a minha IA": "自分の AI で読み取る",
 "Ler de novo": "再読み取り",
 "Ler de novo agora": "今すぐ再読み込み",
 "Ler o texto": "テキストを読み取る",
 "Ler o texto completo": "全文を読む",
 "Ler publicação inteira": "公告全文を読む",
 "Ler sozinho as publicações novas": "新しい公告を自動で読み取る",
 "Leve": "軽い",
 "Leve (sem perder qualidade)": "軽め（画質そのまま）",
 "Li e aceito os termos e a política de privacidade": "規約とプライバシーポリシーを読み、同意します",
 "Li mais {n} páginas": "さらに{n}ページ読んだ",
 "Liberada pelo suporte": "サポートにより開放",
 "Liberar para a equipe": "チームに公開",
 "Liberar para a turma em": "クラスへの公開日",
 "Liberar para o grupo": "グループに公開",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "開放とクレジットはCPFに紐づいています。同期すると更新されます。",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "QRコードを読み取るには、スマートフォンの設定でMy Plannerのカメラを許可してください。",
 "Libere a câmera para o My Planner nas configurações do celular.": "スマートフォンの設定で My Planner のカメラへのアクセスを許可してください。",
 "Libere outras abas em Ajustes › Compras.": "設定 › 購入 でほかのタブを解除してください。",
 "Licenciamento": "ライセンス更新",
 "Lidas hoje": "今日読んだ",
 "Lido": "読了",
 "Ligando. Toque para atender.": "着信中。タップして応答。",
 "Ligar": "電話する",
 "Ligar certificado": "証明書を接続",
 "Ligar para a assistência": "修理窓口に電話",
 "Ligar para {nome}": "{nome}に電話",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "このツールを使うには、設定 › 人工知能 で AI（Claude、ChatGPT、Gemini）を有効にしてください。",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "テキストの読み取り、要約、書類への質問をするには、設定 › 人工知能 で AI をオンにしてください。",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "設定 › 人工知能 でご自分の AI をオンにしてください。",
 "Ligue o certificado A1 da empresa primeiro.": "先に会社の A1 証明書を接続してください。",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Google Drive または OneDrive に接続すると、写真やファイルを保存でき（どの端末からでも開けます）、完全なバックアップも取れます。",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "オンにすると、グループが同じデータ（工事、旅行、クラス、物件、診療所）で作業でき、各自に役割が付きます。",
 "Ligue pelo menos 4 pontos.": "4つ以上の点をつないでください。",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "年間上限は 設定 › タブ › ファイナンスタブ で変更できます。必ず会計士にご確認ください。",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "検索回数の上限に達しました。1分後にもう一度お試しください。",
 "Limite de energia por dia": "1日のエネルギー上限",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "MEI の年間売上上限（現行の金額は会計士にご確認ください）。",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "本日のメッセージ送信上限に達しました。明日もう一度お試しください。",
 "Limite diário": "1日の上限",
 "Limite livre: {v} de {l}": "利用可能枠：{v} / {l}",
 "Limite total (opcional)": "総利用枠（任意）",
 "Limpar": "消去",
 "Limpar a agenda": "予定を整理",
 "Limpar banheiro": "浴室の掃除",
 "Limpar cozinha e louça": "キッチンと食器の掃除",
 "Limpar feitos": "完了済みを消去",
 "Limpeza": "清掃",
 "Limpeza após {h}": "{h}の後の清掃",
 "Limpeza final": "最終清掃",
 "Limpeza · {e}": "清掃 · {e}",
 "Limpeza: {e}": "清掃：{e}",
 "Limpezas": "清掃",
 "Linha do tempo, tarefas, energia e alertas.": "タイムライン、タスク、エネルギー、アラート。",
 "Link": "リンク",
 "Link (Drive, OneDrive, Dropbox)": "リンク（Drive、OneDrive、Dropbox）",
 "Link copiado. Cole onde quiser enviar.": "リンクをコピーしました。送りたい場所に貼り付けてください。",
 "Link da aula ou reunião online (opcional)": "授業またはオンライン会議のリンク（任意）",
 "Link da nota fiscal (Drive ou OneDrive)": "領収書のリンク（DriveまたはOneDrive）",
 "Link da pasta no Drive ou OneDrive (opcional)": "Drive または OneDrive のフォルダのリンク（任意）",
 "Link da reserva": "予約リンク",
 "Link da sala online (Meet, Zoom...)": "オンラインルームのリンク（Meet、Zoom など）",
 "Link de outro calendário (iCal)": "その他のカレンダーのリンク（iCal）",
 "Link do calendário do Airbnb (iCal)": "Airbnb のカレンダーリンク（iCal）",
 "Link do calendário do Booking (iCal)": "Booking のカレンダーリンク（iCal）",
 "Link inválido": "リンクが正しくありません",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "資料のリンク（Drive、動画、PDF）、1 行に 1 つ",
 "Links: {n}": "リンク：{n}",
 "Lista": "リスト",
 "Lista da mala": "荷物リスト",
 "Lista de compras": "買い物リスト",
 "Lista de exercícios": "問題集",
 "Lista rápida": "クイックリスト",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "クイックリストと、タスクにしたり他のタブに送れるボックス。",
 "Literatura": "文学",
 "Litros": "リットル",
 "Livre": "空室",
 "Livro": "本",
 "Livros": "本",
 "Local": "場所",
 "Local ou endereço": "場所または住所",
 "Local: {l}": "場所：{l}",
 "Localização (país e fuso horário)": "位置情報（国とタイムゾーン）",
 "Logo, foto ou rubrica nas páginas.": "ロゴ、写真、イニシャルをページに入れます。",
 "Loja (opcional)": "店舗（任意）",
 "Lote": "ロット",
 "Lua": "月",
 "Lugar": "場所",
 "Lugar para visitar": "行きたい場所",
 "Lugares": "場所",
 "Luz": "電気",
 "Luz indireta": "明るい日陰",
 "Luz, água, gás e internet": "電気・水道・ガス・ネット",
 "Lápis": "鉛筆",
 "Língua Portuguesa": "ポルトガル語",
 "MAIS ADIANTE": "その先",
 "MAIS USADOS": "よく使う",
 "ME ou EPP do Simples": "Simples の ME または EPP",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI：{ano}年の売上は{v}（上限 {l}）。",
 "MEMBROS ({n})": "メンバー（{n}）",
 "METAS": "目標",
 "MS": "MS",
 "Mais": "その他",
 "Mais abas": "ほかのタブ",
 "Mais cidades entram nas próximas versões.": "今後のバージョンで都市を追加します。",
 "Mais emojis": "その他の絵文字",
 "Mais ferramentas": "その他のツール",
 "Mais figurinhas animadas (KLIPY)": "アニメスタンプをもっと見る (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "このタブのその他のオプションは今後のバージョンで追加されます。",
 "Mais uma": "もう 1 枚",
 "Mala": "荷物",
 "Mala ({clima}, {n} dias)": "荷物（{clima}、{n}日）",
 "Mamadeiras e leite": "哺乳瓶とミルク",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "{tel} のWhatsAppに6桁のコードを送信しました。",
 "Mandar as orientações pelo WhatsApp": "WhatsAppで指導内容を送る",
 "Mandar de novo": "再送信",
 "Mandar e-mail": "メールを送る",
 "Mandar lembrete": "リマインダーを送る",
 "Mandar meu código": "自分のコードを送る",
 "Mandar o acerto para o grupo": "精算をグループに送る",
 "Mandar para quem limpa (WhatsApp)": "清掃担当に送る（WhatsApp）",
 "Mandarim": "中国語",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "アカウントの ID 番号を添えて、削除を依頼するメールを送ってください。15 日以内に返信します。",
 "Manter": "残す",
 "Manter ambas": "両方残す",
 "Manter ambos": "両方残す",
 "Manter aqui também": "ここにも残す",
 "Manter tarefas": "タスクを残す",
 "Manutenção": "整備",
 "Manutenções": "整備",
 "Mapas (Apple)": "Apple マップ",
 "Marca d'água": "透かし",
 "Marca-texto": "蛍光ペン",
 "Marcado": "チェック済み",
 "Marcado como feito hoje.": "今日は完了済みにしました。",
 "Marcar como concluída ({dia})": "完了にする（{dia}）",
 "Marcar como devolvido": "返却済みにする",
 "Marcar como feita hoje": "今日完了にする",
 "Marcar como lido": "既読にする",
 "Marcar como paga": "支払い済みにする",
 "Marcar como pago": "支払い済みにする",
 "Marcar como quitado": "完済にする",
 "Marcar como recebida": "入金済みにする",
 "Marcar como recebida?": "受取済みにしますか？",
 "Marcar como recebido": "受取済みにする",
 "Marcar como visto": "確認済みにする",
 "Marcar e avisar a equipe": "予定してチームに通知",
 "Marcar esta conta como paga?": "この請求を支払い済みにしますか？",
 "Marcar fatura como paga": "請求を支払い済みにする",
 "Marcar grupo": "グループを選択",
 "Marcar reunião": "会議を予定",
 "Marcenaria": "木工・建具",
 "Margem": "余白",
 "Marketing": "マーケティング",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "日誌の写真をビフォーまたはアフターに設定するとギャラリーができます。",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "勉強する曜日と各曜日の時間を選んでください。各曜日はこの項目に紐づいた毎週繰り返すタスクになります。",
 "Marque um ou mais estados.": "州を1つ以上選んでください。",
 "Martelo": "ハンマー",
 "Masculino": "男性",
 "Masculino e minimalista": "メンズ＆ミニマル",
 "Matemática": "数学",
 "Materiais": "教材",
 "Material": "資材",
 "Matrícula, placa, código ou CNPJ": "登録番号、ナンバー、コード、または CNPJ",
 "Matéria ou material": "科目・資料",
 "Matéria ou módulo": "科目・モジュール",
 "Matérias": "科目",
 "Meia-sombra": "半日陰",
 "Melhorando a imagem...": "画像を補正中...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "新しい改善がダウンロード済みです。数秒で完了し、データはそのまま残ります。",
 "Membros": "メンバー",
 "Menos de 1 minuto": "1分未満",
 "Mensagem": "メッセージ",
 "Mensagem apagada": "メッセージは削除されました",
 "Mensagem enviada. Obrigado!": "メッセージを送信しました。ありがとうございます！",
 "Mensagem ou observações": "メッセージ・備考",
 "Mensagens": "メッセージ",
 "Mensagens que você envia em Fale conosco.": "お問い合わせから送信したメッセージ。",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "メッセージ：友だちリスト、トーク、送信した写真やファイルは、他の端末に届けるためサーバーに保存されます。音声通話とビデオ通話は録音されません。",
 "Mensalidade de {m}": "{m}の月謝",
 "Mensalidade ou valor por aluno": "月謝または生徒1人あたりの金額",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "月謝、単発レッスン、教材費。クラスの ⋮ で「今月の請求を作成」を選ぶと、生徒ごとに1件作成されます。",
 "Mercado": "食料品",
 "Mesa flexora": "レッグカール",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "現場監督",
 "Meta": "目標",
 "Meta 100% batida": "目標 100% 達成",
 "Meta atingida": "目標達成",
 "Meta atingida!": "目標達成！",
 "Meta da semana: {dur}": "今週の目標：{dur}",
 "Meta de aulas": "授業の目標",
 "Meta de aulas batida": "授業の目標を達成",
 "Meta de copos por dia": "1日の目標杯数",
 "Meta de páginas por dia": "1日の目標ページ数",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "ページ目標、進捗、本・見たい映画やドラマの感想、講座の授業。",
 "Meta diária": "1日の目標",
 "Meta por dia": "1日の目標",
 "Meta por semana:": "週の目標：",
 "Meta {meta} · copo de {copo} · {n} copos": "目標 {meta} · コップ {copo} · {n}杯",
 "Metas": "目標",
 "Metodologia Científica": "研究方法論",
 "Meu caderno": "マイノート",
 "Meu cartão de contato": "自分の連絡先カード",
 "Meu plano": "マイプラン",
 "Meus GIFs ({n})": "マイGIF ({n})",
 "Meus PDFs": "マイ PDF",
 "Meus dados": "自分の情報",
 "Meus dados profissionais": "自分の職業情報",
 "Microchip": "マイクロチップ",
 "Microfone": "マイク",
 "Microscópio": "顕微鏡",
 "Militares estaduais": "州軍事裁判所",
 "Minha Casa": "マイホーム",
 "Minha conta": "マイアカウント",
 "Minhas anotações do livro": "本のメモ",
 "Minhas figurinhas": "マイスタンプ",
 "Minutos": "分",
 "Minutos de exercício": "エクササイズ時間（分）",
 "Mirante": "展望スポット",
 "Mirantes": "展望台",
 "Modelo": "モデル",
 "Modelo de prescrição": "処方テンプレート",
 "Modelos": "テンプレート",
 "Modificado em": "更新日",
 "Modo": "モード",
 "Modo de preparo": "作り方",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "セーフモード：アプリを開き直すまで自動処理はオフです",
 "Moeda": "通貨",
 "Moeda: {m}": "通貨：{m}",
 "Moedas": "コイン",
 "Momento do evento": "イベントの場面",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "氏名とOAB番号で電子司法公報（DJEN）をモニタリング。",
 "Monitor ou co-professor": "TAまたは共同講師",
 "Montando o PDF: página {n} de {total}...": "PDF を作成中：{n} / {total} ページ...",
 "Montar a mala pelo clima ({n} dias)": "気候に合わせて荷物を作る（{n}日）",
 "Monte o cronograma alimentar para ver o relatório.": "レポートを見るには食事スケジュールを作成してください。",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "日ごとの旅程を作ります。旅行期間中は My Planner のタイムラインに表示されます。",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "下で食事スケジュールとセルフケアを作成しましょう。今日の分がここに表示され、チェックできます。",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "下で食事スケジュール、お手入れ、トレーニング、サプリメントを設定しましょう。今日の分はここに表示され、チェックできます。",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "用意されたアクティビティでトレーニングを作成：ジムのマシン、自宅トレーニング、ウォーキング、ランニング、ヨガ、ピラティス...",
 "Mostrando as 120 mais recentes.": "最新の120件を表示しています。",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "旅程のみ表示中。この日のタスク{n}件を非表示にしています。",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "現在地に合った日付、時刻、通貨、祝日を表示するため。GPS は使いません。",
 "Mostrar menos": "表示を減らす",
 "Mostrar só o roteiro durante a viagem": "旅行中は旅程だけを表示",
 "Motivo do cancelamento": "取消理由",
 "Moto": "バイク",
 "Mover": "移動",
 "Mover para hoje": "今日に移動",
 "Mudança": "引っ越し",
 "Mudança: {para}": "引っ越し：{para}",
 "Mudanças": "引っ越し",
 "Mudar e-mail": "メールアドレスを変更",
 "Mudar o nome": "名前を変更",
 "Mudar senha": "パスワードを変更",
 "Mudo": "ミュート",
 "Muitas tentativas": "試行回数が多すぎます",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "間違いが多すぎます。{s} 秒後にもう一度お試しください。",
 "Muitas tentativas. Aguarde alguns minutos.": "試行回数が多すぎます。数分お待ちください。",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "いいですね：今月はもう{v}貯めました。大きな額より続けることが大切です。",
 "Multa": "罰金",
 "Multa e juros": "延滞金・利息",
 "Multa e juros de {v}": "延滞金・利息 {v}",
 "Multa e juros estimados: {v}": "延滞金と利息の見込み：{v}",
 "Multas e juros pagos": "支払った延滞金・利息",
 "Mundo": "世界",
 "Municipal": "市町村",
 "Município da prestação (IBGE), se for outro": "サービス提供地の市区町村（IBGE）、異なる場合",
 "Município da prestação (código IBGE, 7 números)": "サービス提供地の市区町村（IBGE コード、7 桁）",
 "Mural": "お知らせ",
 "Museu": "博物館・美術館",
 "Museus": "博物館",
 "My Planner (vira tarefa)": "My Planner（タスクにする）",
 "My Planner bloqueado": "My Plannerはロックされています",
 "Máxima": "最大",
 "Média": "中",
 "Média para aprovação": "合格に必要な平均点",
 "Média · repouso {n}": "平均 · 安静時 {n}",
 "Médico": "医師",
 "Médico ou clínica": "医師またはクリニック",
 "Médio": "中",
 "Mês": "月",
 "Mês a mês": "月ごと",
 "Mês atual": "今月",
 "Mês passado": "先月",
 "Móveis e enxoval": "家具・リネン類",
 "Móvel": "家具",
 "Música": "音楽",
 "NAS ABAS": "タブ内",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: SEFAZ では検索の間隔を 1 時間空ける必要があります。次回は {h} 以降です。",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: 商品の請求書を検索するには会社の州（UF）を入力してください。",
 "NFS-e emitida": "NFS-e を発行しました",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "曜日（任意）：",
 "Na agenda": "予定済み",
 "Na agenda em {data}": "{data}に予定済み",
 "Na barra": "バーに表示中",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "デモには請求書サーバーがありません。ご自分のアカウントでアプリを使ってください。",
 "Na hora": "すぐに",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "休憩時間になると、カウントダウン付きの大きな通知が画面に表示されます。",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "タイムラインでタイマーをタップしても、このページが開きます。",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "スマホの \"{pasta}\" フォルダ。完成したファイルはそこに保存されます。",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "スマートフォンの \"{pasta}\" フォルダー。新しい書類は、閉じたときにそこへ保存されます。",
 "Na prévia de demonstração não há chamadas de verdade.": "デモ版では実際の通話はできません。",
 "Na prévia de demonstração não há gravação de verdade.": "デモプレビューでは実際の録画はありません。",
 "Na prévia de demonstração os arquivos não abrem.": "デモプレビューではファイルを開けません。",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "ストア版では、Google Play または App Store で購入します。現在はテスト用にスイッチで契約をシミュレーションしています。",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "ストア版では、このボタンでGoogle PlayまたはApp Storeの購入画面が開きます。",
 "Nacional": "全国",
 "Nada a gerar": "作成するものはありません",
 "Nada encontrado.": "見つかりませんでした。",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "許可なく誰かの予定に入ることはありません。各メンバーが承認・編集・却下します。",
 "Nada foi registrado.": "何も記録されていません。",
 "Nada lançado neste mês.": "今月の記録はありません。",
 "Nada no mês": "今月はありません",
 "Nada no roteiro deste dia.": "この日の旅程はありません。",
 "Nada para apagar com esse filtro.": "この条件で削除するものはありません。",
 "Nada para comprar": "買うものはありません",
 "Nada para enviar.": "送信するものがありません。",
 "Nada planejado para este dia": "この日の予定はありません",
 "Nada planejado para hoje. Bom dia!": "今日の予定はありません。おはようございます！",
 "Nada por aqui.": "ここには何もありません。",
 "Nada recebido ainda.": "まだ何も届いていません。",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "トークでは、参加者全員にあなたの名前と送信内容が表示されます。メッセージを全員から削除したり、グループを退出したり、相手をブロックしたりできます。",
 "Nascimento": "誕生",
 "Natal": "クリスマス",
 "Natação": "水泳",
 "Navegador conectado": "ブラウザ接続済み",
 "Negrito": "太字",
 "Negócios": "ビジネス",
 "Nenhum": "なし",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "この期間の XML はありません（または別の端末に保存されています）。",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "追加できる友だちがいません。WhatsAppで招待するか、メッセージで友だちを追加してください（友だちのコード）。",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "この科目のページにはファイル、画像、リンクがありません。",
 "Nenhum arquivo.": "ファイルはありません。",
 "Nenhum atendimento pago neste mês.": "今月の支払い済みの診療はありません。",
 "Nenhum cartão": "カードがありません",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "保存された控えはまだありません。支払い後、請求をタップして控えの写真、PDF、またはスクリーンショットを添付してください。",
 "Nenhum cômodo ainda": "まだ部屋がありません",
 "Nenhum dia": "曜日なし",
 "Nenhum documento ainda.": "書類はまだありません。",
 "Nenhum documento neste filtro.": "このフィルターに該当する書類はありません。",
 "Nenhum e-mail cadastrado": "メールアドレスが登録されていません",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "エラーの記録はありません。アプリが勝手に閉じたり画面に問題が起きたりすると、ここに表示されチームに送れます。",
 "Nenhum feriado neste ano.": "今年は祝日がありません。",
 "Nenhum fichário ainda": "まだバインダーがありません",
 "Nenhum grupo ainda.": "まだグループがありません。",
 "Nenhum item em {nome}": "{nome}に項目がありません",
 "Nenhum lançamento encontrado": "記録が見つかりません",
 "Nenhum país encontrado.": "国が見つかりません。",
 "Nenhum selecionado": "未選択",
 "Nenhuma (plano gratuito)": "なし（無料プラン）",
 "Nenhuma aba encontrada.": "タブが見つかりません。",
 "Nenhuma aba fixada além do My Planner.": "My Planner 以外に固定されたタブはありません。",
 "Nenhuma aba liberada para receber": "受け取れる解除済みのタブがありません",
 "Nenhuma agenda encontrada": "カレンダーが見つかりません",
 "Nenhuma agenda para trazer": "取り込めるカレンダーがありません",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "この公告に期日や期限は見つかりませんでした。",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "アーカイブしたボックスはありません。ボックスを左にスワイプするとアーカイブできます。",
 "Nenhuma compra encontrada": "購入が見つかりません",
 "Nenhuma compra nesta fatura.": "この請求には購入がありません。",
 "Nenhuma conta a pagar cadastrada.": "支払予定の請求はありません。",
 "Nenhuma conta a receber cadastrada.": "受取予定の請求はありません。",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "今月の支払いはありません。+ をタップして登録（家賃、電気代、カード...）。",
 "Nenhuma cópia de segurança ainda.": "バックアップはまだありません。",
 "Nenhuma cópia encontrada.": "バックアップが見つかりません。",
 "Nenhuma garantia ativa. Cadastre com o +.": "有効な保証はありません。+で登録してください。",
 "Nenhuma garantia vencida.": "期限切れの保証はありません。",
 "Nenhuma mensagem ainda. Diga oi! 👋": "まだメッセージはありません。あいさつしましょう！👋",
 "Nenhuma nota neste período.": "この期間の請求書はありません。",
 "Nenhuma opção ainda.": "まだ選択肢がありません。",
 "Nenhuma publicação nova.": "新しい公告はありません。",
 "Nenhuma refeição neste dia.": "この日の食事はありません。",
 "Nenhuma reunião marcada.": "予定された会議はありません。",
 "Nesse ritmo, termina em {d}": "このペースなら {d} に終わります",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "リリース期間中は、すべてのタブが無料で使えます。",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "テスト期間中は、パスワードはサポートが再設定します。CPF またはメールアドレスを添えて {email} までご連絡ください。",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "テスト期間中は、パスワードはサポートが再設定します。CPFを添えて{email}までご連絡ください。",
 "Neve": "雪",
 "Ninguém deve nada a ninguém.": "誰も誰にも借りはありません。",
 "Ninguém entrou ainda. Envie o convite.": "まだ誰も参加していません。招待を送りましょう。",
 "Ninguém usou o seu código ainda.": "まだ誰もあなたのコードを使っていません。",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Android では、アプリは選んだファイルへのショートカットだけを保存します。ファイルは元の場所（Drive、OneDrive、ダウンロード）にあり、スマホのアプリで開きます。何もコピーされません。この設定はカメラで撮った写真に適用されます。",
 "No Google Drive ou OneDrive: {n}": "Google Drive または OneDrive 内：{n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "Google Drive では、アプリは自身が My Planner フォルダに作成したファイルのみを参照できます。Google API から受け取った情報の使用は、限定使用の要件を含め、Google API サービスのユーザーデータに関するポリシーに従います。お客様の許可がある場合または法令上の義務がある場合を除き、情報が販売されたり、広告に使用されたり、人によって閲覧されたりすることはありません。",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "時計のアプリ（Samsung Health、Garmin Connect、Mi Fitness、Zepp、Fitbit、Amazfit、Google Fit...）で、\"Health Connect\" または \"Health Connect と同期\" をオンにしてください。",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "新しいアプリ（バージョン 0.49）では、スマートフォンが用紙の端を自動で見つけます。このバージョンでは、4 隅を指で調整してください。",
 "No centro": "中央",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "パソコンで{url}を開き、上のボタンをタップして、画面のQRコードにカメラを向けてください。",
 "No dia (opcional):": "日付（任意）：",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "iPhone では \"ファイルに保存\" が開き、保存先のフォルダーを選べます（iCloud Drive も可）。",
 "No início": "開始時",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "セーフモードでは自動処理（通知、Google カレンダー、公告、メッセージ、時計）なしで開きます。データは変わらず、次に開いたときに元どおりになります。",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "ブラウザでは、このページを開いている間だけページが保持されます。",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "ブラウザでは、Drive、OneDrive、Dropbox のファイルのリンクを貼り付けてください（「勉強」または「書類」の「リンク」から）。スマホでは、ファイルボタンに Drive と OneDrive が表示されます。",
 "No navegador, o PDF é baixado para o computador.": "ブラウザでは、PDF はパソコンにダウンロードされます。",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "ブラウザでは小さな画像（200 KB まで）しか保存できません。その他のファイルは Drive、OneDrive、Dropbox のリンクを追加するか、スマホのアプリを使ってください。",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "別のアプリでファイルのリンクをコピーし（共有 › リンクをコピー）、このページに追加されたリンクブロックに貼り付けてください。",
 "No ritmo atual, o ano fecha em {v}.": "このペースだと年間で {v} になります。",
 "No seu fuso: {hora}{dia}": "あなたのタイムゾーン：{hora}{dia}",
 "Nome": "名前",
 "Nome (cliente ou fornecedor)": "名前（クライアントまたは仕入先）",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "名前（例：2年B組、クリニックの患者、アナの誕生日）",
 "Nome (ex.: Almoço)": "名前（例：昼食）",
 "Nome (ex.: Aluguel recebido, Cliente X)": "名前（例：家賃収入、顧客 X）",
 "Nome (ex.: Aluguel, Luz, Internet)": "名前（例：家賃、電気代、インターネット）",
 "Nome (ex.: Doutorado UFPR)": "名前（例：UFPR博士課程）",
 "Nome (ex.: Nubank, Itaú Visa)": "名前（例：Nubank、Itaú Visa）",
 "Nome (ex.: Skincare da noite)": "名前（例：夜のスキンケア）",
 "Nome (ex.: Treino A)": "名前（例：トレーニングA）",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "名前（例：夏休みの旅行、緊急資金）",
 "Nome (ex.: Vitamina C)": "名前（例：ビタミンC）",
 "Nome (opcional)": "名前（任意）",
 "Nome (opcional, ex.: CNH do Walter)": "名前（任意、例：Walter の CNH）",
 "Nome (pode editar, ex.: \"Suco de uva\")": "名前（編集可、例：「ぶどうジュース」）",
 "Nome completo": "氏名",
 "Nome curto": "略称",
 "Nome da lista": "リスト名",
 "Nome da matéria": "科目名",
 "Nome da obra": "工事名",
 "Nome da pasta (ex.: Recibos, Contratos)": "フォルダー名（例：レシート、契約書）",
 "Nome da tarefa": "タスク名",
 "Nome da tarefa (ex.: Academia)": "タスク名（例：ジム）",
 "Nome da tarefa (ex.: Limpar o banheiro)": "タスク名（例：浴室掃除）",
 "Nome do PDF (opcional)": "PDF の名前（任意）",
 "Nome do conselho": "所属団体名",
 "Nome do cômodo": "部屋の名前",
 "Nome do documento": "書類名",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "オフィス名（例：Ravasco Contabilidade）",
 "Nome do evento": "イベント名",
 "Nome do grupo (ex.: Família)": "グループ名（例：家族）",
 "Nome do modelo": "テンプレート名",
 "Nome ou modelo": "名前またはモデル",
 "Nome ou razão social": "氏名または会社名",
 "Nome, subtarefa ou anotação": "名前、サブタスク、メモ",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "グループでは、各自が自分の追加した内容に責任を持ちます。グループの管理者が参加者を決めます。",
 "Nossa Senhora Aparecida": "ノッサ・セニョーラ・アパレシーダの日",
 "Nossa Senhora da Luz dos Pinhais": "ノッサ・セニョーラ・ダ・ルス・ドス・ピニャイスの日",
 "Nota cancelada": "取り消された請求書",
 "Nota fiscal": "請求書",
 "Nota fiscal emitida": "発行済みの請求書",
 "Nota fiscal, certificado de garantia e fotos": "領収書、保証書、写真",
 "Nota importada": "取り込んだ請求書",
 "Notas": "請求書",
 "Notas Fiscais": "請求書（NF）",
 "Notebook e carregador": "ノートパソコンと充電器",
 "Nova avaliação": "新しい評価",
 "Nova caixa (ex.: Compras, Ideias)": "新しいボックス（例：買い物、アイデア）",
 "Nova conversa": "新しいトーク",
 "Nova garantia": "新しい保証",
 "Nova matéria": "新しい科目",
 "Nova meta": "新しい目標",
 "Nova pasta": "新しいフォルダー",
 "Nova página": "新しいページ",
 "Nova página com esta caixa": "このボックスで新しいページ",
 "Nova refeição": "新しい食事",
 "Nova tarefa": "新しいタスク",
 "Nova tarefa da casa": "新しい家事",
 "Nova tarefa neste cômodo": "この部屋に新しいタスク",
 "Novas": "新着",
 "Novo": "新規",
 "Novo alerta:": "新しいアラート：",
 "Novo cartão": "新しいカード",
 "Novo cartão de crédito": "新しいクレジットカード",
 "Novo cuidado": "新しいケア",
 "Novo documento": "新しい書類",
 "Novo e-mail": "新しいメールアドレス",
 "Novo fichário": "新しいバインダー",
 "Novo grupo": "新しいグループ",
 "Novo item": "新しい品目",
 "Novo perfil": "新しいプロフィール",
 "Novo suplemento": "新しいサプリメント",
 "Novo treino": "新しいトレーニング",
 "Novo: {nome}": "新規：{nome}",
 "Novos": "新着",
 "Num período": "期間で",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "箱に番号を付け、部屋と中身を書きましょう。検索で何がどこにあるか探せます。",
 "Nº": "No.",
 "Não": "いいえ",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "レシートに合計が見つかりませんでした。もっと鮮明な写真でお試しください。",
 "Não consegue entrar?": "ログインできませんか？",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "\"{nome}\" を開けませんでした。\"PDF を修復\" ツールをお試しください。",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "通話に接続できませんでした。インターネット接続を確認して、もう一度お試しください。",
 "Não deu certo: {msg}": "うまくいきませんでした：{msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "この PDF はこれ以上小さくできませんでした（{tam}）。",
 "Não dá para tirar todas as páginas.": "すべてのページは削除できません。",
 "Não encontrei texto neste PDF.": "この PDF にテキストが見つかりませんでした。",
 "Não encontrei texto neste documento.": "この書類にテキストは見つかりませんでした。",
 "Não foi possível": "できませんでした",
 "Não foi possível abrir": "開けませんでした",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "保存した証明書を開けませんでした。証明書をもう一度接続してください。",
 "Não foi possível abrir.": "開けませんでした。",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "この国の祝日をダウンロードできませんでした。インターネット接続を確認してください。",
 "Não foi possível conectar": "接続できませんでした",
 "Não foi possível conectar o {nome}": "{nome} に接続できませんでした",
 "Não foi possível consultar o DJEN agora.": "現在DJENに照会できません。",
 "Não foi possível continuar": "続行できませんでした",
 "Não foi possível criar um evento na agenda: {msg}": "カレンダーに予定を作成できませんでした：{msg}",
 "Não foi possível entrar.": "ログインできませんでした。",
 "Não foi possível enviar": "送信できませんでした",
 "Não foi possível enviar.": "送信できませんでした。",
 "Não foi possível guardar: {erro}": "保存できませんでした：{erro}",
 "Não foi possível ler o arquivo.": "ファイルを読み込めませんでした。",
 "Não foi possível ler o calendário. Confira o link em Editar.": "カレンダーを読み込めませんでした。「編集」でリンクを確認してください。",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "現在検索できません。後で自動的に再試行します。",
 "Não foi possível reiniciar sozinho.": "自動で再起動できませんでした。",
 "Não foi possível sincronizar com a agenda: {msg}": "カレンダーと同期できませんでした：{msg}",
 "Não foi possível trocar a foto": "写真を変更できませんでした",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "アプリを閉じている間は通知が届く保証はありません。確認はアプリを開いたとき（6時間ごと）または「今すぐ確認」で行われます。",
 "Não identificado": "不明",
 "Não marcada como feita": "未完了",
 "Não optante pelo Simples": "Simples 非適用",
 "Não se repete": "繰り返さない",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "違法な活動、許可のない第三者のコンテンツの保存、他人のデータへのアクセスの試みにアプリを使わないでください。",
 "Não vai": "欠席",
 "Não vence": "期限なし",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "あなたのデータを販売したり、コンテンツを広告に使ったりすることはありません。",
 "Não é possível adicionar esta pessoa.": "この人は追加できません。",
 "Não é um XML de nota fiscal": "請求書の XML ではありません",
 "Número": "番号",
 "Número (opcional)": "番号（任意）",
 "Número da OAB": "OAB番号",
 "Número da caixa": "箱の番号",
 "Número da carteirinha": "会員証番号",
 "Número da guia do convênio": "保険の請求番号",
 "Número da parcela": "回数",
 "Número de hóspedes": "宿泊人数",
 "Número de parcelas": "支払回数",
 "Número do contrato": "契約番号",
 "Número do registro": "登録番号",
 "Número na chamada": "出席番号",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "番号 {n}。XML は請求書に保存されました。タップすると PDF を表示できます。",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "番号、発行機関、メモは、クラウドに送る前に端末上で暗号化されます（AES-256）。",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "番号、発行機関、メモ、写真、PDF は端末上で暗号化されます（AES-256）。保護されたファイルはこの端末にのみ保存されます。",
 "Número: {n}": "番号：{n}",
 "Números de página": "ページ番号",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ここではChatGPTはPDFを読めません。ページの写真かスクリーンショットを撮るか、設定 › 人工知能 でClaudeまたはGeminiを使ってください。",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "DAS の期日は {dia}日です。ファイナンスで支払い済みにしてください。",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "サーバーでオフィス機能がまだ有効になっていません。パソコンで 29-SERVIDOR-0.45.bat を実行してください（1回のみ）。",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achadoがあなたのお金を管理します：支払い、カードと請求、カテゴリー別予算、目標、写真での明細とレシート、レポート、MEI。",
 "O Mestre está pensando...": "マスターが考えています...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner は Drive に「My Planner」フォルダを作成し、自分で保存したものだけを参照します。",
 "O My Planner já abriu no computador, com os seus dados.": "My Plannerがパソコンで、あなたのデータとともに開きました。",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner は {fonte} を通じて時計のデータを読み取ります。時計や健康・運動アプリのデータはすべてそこに保存されています。",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner は、予定、タスク、家計、書類など、生活のさまざまな分野を整理するアプリです。提供者は Walter Ravasco da Costa で、アプリで取り扱う個人データの管理者です。",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner は OneDrive の アプリ › My Planner フォルダだけを使用します。",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "PDF と画像はこのデバイスとクラウドから削除されます。",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "PDF が 15 MB を超えました。WhatsApp やメールで送れない場合は \"ファイルを小さく\" をオンにしてください。",
 "O QUE COMER": "食べるもの",
 "O QUE OS MEMBROS PODEM": "メンバーができること",
 "O QUE VOCÊ MANDA": "送信するメッセージ",
 "O QUE VOCÊ RECEBE": "受信するメッセージ",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "ログインは引き続き CPF で行います。メールアドレスはサポートからの連絡に使います。",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "グループの管理者は予定・資料・お知らせを送れます。あなたが承認しない限り、予定には何も入りません。",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "服用済みにするまで、アラームは2分ごとに再び鳴ります（最大4回）。",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "アプリは整理を手助けしますが、医師、弁護士、会計士などの専門家の助言に代わるものではありません。重要な期限、金額、日付は必ず確認してください。",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "期日の 3 日前と当日の 9 時にお知らせします。",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "アプリは、登録した氏名とOAB番号でCNJの公共サービス（DJEN）に照会します。これらのデータは確認のたびにそのサービスへ送信されます。",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "My Planner のアプリとサーバーは、登録された名前と OAB 番号で CNJ の公共サービス（DJEN）に照会し、チェックを入れた場合は Querido Diário（市町村の官報）にも照会します。これらのデータは確認のたびに各サービスへ送信されます。",
 "O app fechou sozinho {n} vezes seguidas": "アプリが {n} 回続けて勝手に閉じました",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "この端末にインストールされているアプリはバージョン {v} です。音声・ビデオ通話をするには、アプリ 0.35 以降（新しい APK）をインストールしてください。メッセージはすでに使えます。",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "アプリは閉じておらず、データも保存されています。もう一度試すか、レポートを送ってチームに修正を依頼してください。",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "アプリを開いたときとバックグラウンドから戻ったときに、ロック解除を求めます。",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "アプリを開くとロック解除を求めます。アプリや画面をすばやく切り替えた場合は再度求めません。スマートフォンがロックされたり、アプリが下の設定時間より長く画面外にあったりすると求めます。",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "アプリは読み取るだけ（歩数、距離、カロリー、エクササイズ、心拍数、睡眠）で、健康データを変更することはありません。毎日の合計はアカウントに保存され、Webサイトやもう一台のスマホにも表示されます。",
 "O app volta a pedir a senha para desbloquear.": "アプリのロック解除にはまたパスワードが必要になります。",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "本アプリは18歳以上を対象としています。子どものデータは、親または保護者のみが登録できます。",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "ファイルはこの端末にのみ保存されました。{nome} に保存できませんでした：{erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "ファイルはもうその場所にありません（削除または移動されました）。",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "ファイルはもうその場所にありません（削除、移動、またはアプリが権限を外しました）。もう一度添付してください。",
 "O arquivo passa de 15 MB.": "ファイルが 15 MB を超えています。",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "ファイルが 15 MB を超えています。\"ファイルを小さく\" をオンにして、もう一度お試しください。",
 "O arquivo passa de 25 MB.": "ファイルが 25 MB を超えています。",
 "O arquivo passa de 50 MB.": "ファイルが 50 MB を超えています。",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "ファイルはこのスマホから削除されます。Drive や OneDrive に保存したコピーや送ったものは残ります。",
 "O arquivo sai do escritório para todos.": "このファイルは全員のオフィスから削除されます。",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "通知は 9 時に届き、期限当日にもう一度届きます。",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "データベースがまだ準備されていません。Supabaseでsupabase/schema.sqlファイルを実行してください。",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "カード{c}は利用枠の{p}%を使っています。しばらくは新しい分割払いを避けましょう。",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "スマートフォンは画面のロックをアプリに知らせないため、アプリは画面外にあった時間を数えます。1分に設定すると、スマートフォンをロックしてから戻ったときは生体認証を求めますが、短いメッセージに返信しただけなら求めません。",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "携帯番号はアカウントがご本人のものであることの確認にのみ使います（登録時と番号変更時にWhatsAppでコードを送信）。1アカウントにつき1番号です。",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "サーバーで共有がまだオンになっていません。パソコンで C:\\MyPlanner フォルダを開き、12-LIGAR-COMPARTILHAMENTO.bat をダブルクリックしてください（1回だけ）。",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "パソコンがあなたのアカウントでMy Plannerを開きます。信頼できるパソコンでのみ行ってください。",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "招待にはアプリと最新 APK のリンクが含まれます。リンクから参加した人はそのままオフィスに入ります。",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "紹介コードはアカウント作成後30日以内のみ有効です。",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "パターンはこの端末内にのみ安全に保存されます。パターンを忘れた場合もパスワードは使えます。",
 "O dinheiro gasto está à frente do andamento da obra.": "支出が工事の進捗を上回っています。",
 "O documento não tem páginas.": "書類にページがありません。",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "明細はこの端末上で読み取られます。金額が同じで日付が近い支払い予定は自動的に支払い済みになります。",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "明細はこの端末内で読み取ります。金額が同じで日付が近い支払予定は自動的に消し込まれます。カード請求の支払いは二重に計上されません。",
 "O governo recusou a nota": "政府が請求書を拒否しました",
 "O governo recusou a nota.": "政府が請求書を拒否しました。",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "言語設定はこの端末にのみ適用されます。入力したデータは翻訳されません。",
 "O item vinculado foi apagado ou movido.": "リンク先の項目は削除または移動されました。",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "リンク先の項目は削除または移動されました。タスクを編集して別の項目を選んでください。",
 "O link antigo deixa de funcionar.": "古いリンクは使えなくなります。",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "古いリンクは使えなくなります。すでに参加している人はそのままです。",
 "O link deve começar com https://": "リンクは https:// で始まる必要があります",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "ブラウザではプラットフォームのカレンダーを読み込めません。スマホのアプリから取り込んでください。",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "ベーシックプランと各タブの試用期間は 設定 > 購入 に表示されるルールに従います。紹介特典は1アカウントにつき1回限りです。",
 "O que acontece": "内容",
 "O que apagar": "削除する対象",
 "O que comprou": "購入したもの",
 "O que fazer": "やること",
 "O que foi comido:": "食べたもの：",
 "O que foi feito": "行った作業",
 "O que foi visto": "扱った内容",
 "O que funcionou, o que ajustar, metodologias, resumos...": "うまくいったこと、改善点、指導法、まとめ...",
 "O que já foi guardado continua nos lançamentos como investimento.": "これまで貯めた分は、投資として取引に残ります。",
 "O que levar ou estudar": "持ち物・勉強すること",
 "O que o app pode usar": "アプリが使えるもの",
 "O que o médico disse": "医師の説明",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "グループから届いたもの。承認した予定は My Planner に、資料とお知らせは メモ に入ります。",
 "O que precisa": "必要なもの",
 "O que tem dentro": "中身",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "貸したもの・借りたもの：写真、だれが持っているか、返却のお知らせ。",
 "O que é apagado": "削除されるもの",
 "O quê": "内容",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "スマホに Google Drive、OneDrive、Dropbox が入っていれば選択画面に表示されます。アプリはショートカットだけを保存し、ファイルは元の場所のままスマホのアプリで開きます。",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "スマホに Google Drive、OneDrive、Dropbox がインストールされていれば、選択画面に表示されます。選んだファイルはこの端末に保存されます。",
 "O servidor ainda não buscou para os seus perfis.": "サーバーはまだあなたのプロフィールを検索していません。",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "サーバーでメッセージ機能の準備ができていません。17-LIGAR-MENSAGENS.bat を実行してください。",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "サーバーはまだ紹介機能に対応していません。しばらくしてからもう一度お試しください。",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "サーバーはまだ連絡先カードに対応していません。19-LIGAR-CONTATO.bat を実行してください。",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "サーバーはまだ共有データ用に準備されていません。パソコンで C:\\MyPlanner フォルダを開き、15-LIGAR-GRUPOS-COLABORATIVOS.bat をダブルクリックしてください（1回だけ）。",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "サーバーがまだ Drive と OneDrive に対応していません（COMO RODAR のバージョン 0.14 を参照）。",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "サーバーはまだWebアクセスの準備ができていません（supabase/migracao-0.6.sqlを実行してください）。",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "サーバーにまだ「qr-login」機能がありません。COMO RODARのバージョン0.6の手順を参照してください。",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "通話サーバーが LiveKit のキーを拒否しました。管理者のパソコンで 30-CONSERTAR-CHAMADAS.bat を実行してください。",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "請求書サーバーから予期しない応答がありました（HTTP {s}）。アドレスを確認してください。",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "サーバーはアプリを閉じていても、08:00〜20:00（ブラジリア時間）の間、2時間ごとに自動取得します。取得した公告はアプリを開くと表示されます。「今すぐ確認」も使えます。",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "サーバーは、アプリを閉じていても毎日 08:00 と 12:00（ブラジリア時間）に自動取得を行います。取得した公告はアプリを開くと表示されます。「今すぐ確認」も使えます。",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "サーバーがアクセスを拒否しました：Supabase の「nuvem」関数で「Verify JWT」をオフにしてください（32-LIGAR-DRIVE-ONEDRIVE.bat で自動的に行われます）。",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "サーバーがアクセスを拒否しました。Supabase の「nuvem」関数で「Verify JWT」をオフにしてください（9-LIGAR-DRIVE-ONEDRIVE.bat が自動で行います）。",
 "O seu papel no grupo não permite incluir aqui.": "グループでのあなたの役割では、ここに追加できません。",
 "O site deve começar com https://": "サイトはhttps://で始まる必要があります",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "コップの標準サイズ（{copo}）は、水分カードの「調整」で変更できます。",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "テーマを変えるとタブの色が変わります（アイコンはそのまま）。ライトモードとダークモードの両方に適用されます。あとで 設定 > タブ から個別のタブの色も変更できます。",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "タイマーはタスクの時間が進むにつれて色で満たされます。タップするとタスクのリンク先が開きます。",
 "O teste grátis terminou": "無料トライアルが終了しました",
 "O texto": "テキスト",
 "O texto do PDF num arquivo .docx para editar.": "PDF のテキストを編集できる .docx ファイルにします。",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "テキストは PDF 内にも埋め込まれます：PDF リーダーで検索やコピーができます。",
 "O tom escolhido fica para os próximos emojis.": "選んだ肌の色は次回以降の絵文字にも使われます。",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "合計はMy Plannerの上部に表示されます。上限を超えると稲妻が赤くなります。「リラックス」タスクは0です。",
 "OAB (opcional, para advogados)": "OAB（任意、弁護士向け）",
 "OBS": "メモ",
 "OCR: texto pesquisável": "OCR：検索可能なテキスト",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "または部屋を選択…",
 "Objetivos": "目標",
 "Objeto": "物",
 "Objetos": "もの",
 "Objetos e valores": "物とお金",
 "Obra": "工事",
 "Obras": "工事",
 "Obras & Reformas": "工事＆リフォーム",
 "Obrigado": "ありがとう",
 "Obrigado!": "ありがとう！",
 "Observações": "メモ",
 "Observações (alergias, ração...)": "メモ（アレルギー、フード…）",
 "Observações (chave Pix, conta para depósito...)": "メモ（Pixキー、振込先口座...）",
 "Observações (código de barras, chave Pix...)": "メモ（バーコード、Pix キー...）",
 "Observações (dados bancários, PIX...)": "メモ（口座情報、PIX など）",
 "Observações (estado do item...)": "メモ（品物の状態…）",
 "Observações (garantia, seguro, CET...)": "メモ（担保、保険、実質年率など）",
 "Observações (nº de série, modelo...)": "メモ（シリアル番号、型番...）",
 "Observações (onde está o original, categoria da CNH...)": "メモ（原本の保管場所、免許の種類など...）",
 "Observações (recibo de entrega, número...)": "メモ（受領書、番号…）",
 "Observações (restrição alimentar...)": "メモ（食事制限…）",
 "Ocultar texto (tarja)": "テキストを隠す（黒塗り）",
 "Ocupado": "使用中",
 "Oficina": "整備工場",
 "Ofício": "リーガル",
 "Oi!": "やあ！",
 "Oi! Tudo certo para sábado?": "こんにちは！土曜日の準備は大丈夫？",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "{pessoa}さん、こんにちは！貸してもらった{coisa}、まだ私が持っています。いつ返すのが都合いいですか？",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "{pessoa}さん、こんにちは！お元気ですか？{data}にお貸しした{coisa}の件でご連絡しました。{quando}に返してもらえますか？",
 "Oi?!": "え？！",
 "Olá!": "こんにちは！",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "こんにちは！Mestre Achadoです。支出、支払い、カード、目標について聞いてください。あなたの数字で答えます。",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "こんにちは！{ref}（{v}）のお支払い期限が{d}ですので、お知らせします。よろしくお願いします！",
 "Olá! Preciso de assistência técnica para: {item}": "こんにちは！修理サポートをお願いします：{item}",
 "Olá, {nome}!": "{nome}さん、こんにちは！",
 "Olá, {nome}! Seja bem-vindo(a).": "こんにちは、{nome}さん！ようこそ。",
 "Ombros: girar para trás": "肩：後ろに回す",
 "Omelete": "オムレツ",
 "Onde": "場所",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "AI が役立つ場所：公告（期日と期限）、書類（写真から入力）、メモ（ボックスをタスクに変換）。",
 "Onde assistir": "視聴方法",
 "Onde eu mais gastei este mês?": "今月いちばんお金を使ったのは何ですか？",
 "Onde fica": "場所",
 "Onde guardar fotos e arquivos novos": "新しい写真とファイルの保存先",
 "Onde na página": "ページ上の位置",
 "Ontem": "昨日",
 "Organizar": "整理",
 "Organizar barra": "バーを整理",
 "Organizar com IA": "AI で整理",
 "Organizar com IA (vira tarefas)": "AI で整理（タスクに変換）",
 "Organizar páginas": "ページを整理",
 "Orgulho e vibrante": "プライド＆ビビッド",
 "Origem": "出所",
 "Origem da reserva": "予約元",
 "Original": "オリジナル",
 "Orquídeas": "ラン",
 "Orçado": "見積額",
 "Orçamento": "予算",
 "Orçamento do mês": "今月の予算",
 "Orçamento por categoria": "カテゴリー別予算",
 "Orçamento total": "総予算",
 "Orçamento: {v}": "予算：{v}",
 "Os alertas precisam de um horário.": "アラートには時刻が必要です。",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "この端末にだけある添付ファイルは他の端末には表示されず、スマホを買い替えると失われます。コピーを保存するには「設定」で Google Drive または OneDrive に接続してください。",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "すでに保存されているファイルとバックアップはそのまま残ります。My Planner が新しく保存しなくなるだけです。",
 "Os arquivos guardados neste dispositivo também serão apagados.": "この端末に保存されたファイルも削除されます。",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "Google Drive、OneDrive、スマホにあるファイルはそのまま残ります。法律で保存が義務付けられた記録（アクセス記録など）は法定期間保存された後に削除されます。",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "グループの通知はまだサーバーで有効になっていません。パソコンで 15-LIGAR-GRUPOS-COLABORATIVOS.bat をダブルクリックしてください（1回だけ）。",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "My Planner の通知がオフになっています。「設定を開く」をタップして通知をオンにしてください。",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "スマホの通知はインストール版アプリ（Android または iPhone）で使えます。",
 "Os campos do formulário viram parte da página.": "フォームの入力欄がページの一部になります。",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "現在のデータは、この端末とクラウドの両方でファイルの内容に置き換えられます。",
 "Os dados continuam salvos na nuvem.": "データはクラウドに保存されたままです。",
 "Os dados da aba ainda são só seus": "このタブのデータはまだあなただけのものです",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "タブ「{aba}」のデータがチームに表示されるようになります。各自の表示内容はあなたが選ぶ役割に応じて決まります。",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "このグループのデータはまだ利用可能になっていません。グループを作成した人に最新版の My Planner を開いてもらってください。アプリが自動で利用可能にします。",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "このグループのデータはまだ公開されていません。グループを作成した人に My Planner を更新してグループを開くよう頼んでください。そこに公開ボタンが表示されます。",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "金庫のデータは、クラウドに送る前にこの端末上で暗号化されます（AES-256）。サポートでも読めません。金庫のパスワードを忘れると、データは復元できません。",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "データはアカウントがある限り保存されます。アカウントを削除するとデータも削除されます。ただし、法律で保存が義務づけられているものを除きます。",
 "Os desenhos não conferem. Comece de novo.": "パターンが一致しません。最初からやり直してください。",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "締め日と期日は銀行のアプリか請求に載っています。締め日以降の購入は次の請求に入ります。",
 "Os emojis que você usar aparecem aqui.": "使った絵文字がここに表示されます。",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "グループはまだサーバーで有効になっていません。パソコンで C:\\MyPlanner フォルダを開き、11-LIGAR-GRUPOS.bat をダブルクリックしてください（1回だけ）。",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "サーバーでグループがまだ有効になっていません。Supabase で supabase\\migracao-0.21.sql を実行してください（COMO RODAR を参照）。",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "場所は「設定」で選んだ Google Maps、Waze、またはマップで開きます。",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "メンバーは常に管理者を見ることができ、自分宛ての内容だけを受け取ります。",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "他のメンバーはデータを見られなくなります（各自の端末からコピーが消えます）。データはすべてあなたの手元に残ります。",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "プロフィールと結果はMy Plannerのアカウントに保存されます。",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "プロフィール、OAB、裁判所は 公告 タブ内で設定します。自動検索はサーバー上で 8:00 と 12:00（ブラジリア時間）に実行されます。",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "価格は保存され、「食事＆食品ストック」タブの買い物リストに前回の購入価格として表示されます。",
 "Os resultados deste perfil também serão apagados.": "このプロフィールの結果も削除されます。",
 "Os termos foram atualizados": "規約が更新されました",
 "Ou digite (ex.: 2 ovos mexidos)": "または入力（例：スクランブルエッグ卵2個）",
 "Ou escreva o prato": "または料理名を入力",
 "Ou escreva o seu": "または自分で入力",
 "Outra": "その他",
 "Outra aba…": "ほかのタブ…",
 "Outra atividade (digite e dê Enter)": "その他のアクティビティ（入力してEnter）",
 "Outro": "その他",
 "Outro (ml)": "その他（ml）",
 "Outro valor": "別の金額",
 "Outros": "その他",
 "Outros países": "その他の国",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "その他の時計（Garmin、Samsung、Xiaomi、Amazfit...）：時計のアプリで、データを「ヘルスケア」App（Apple ヘルスケア）に送信するオプションをオンにしてください。",
 "Ovo": "卵",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "支払済、受領済、社外秘、承認済、または自由な文字を日付付きで。",
 "PARA ACERTAR": "精算",
 "PARA QUEM": "送信先",
 "PARA {refeicao}": "{refeicao}用",
 "PASSO A PASSO": "ステップ",
 "PASSO {n}": "ステップ {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "デジタルテキストの PDF：ブラウザですぐ完了。スキャンした PDF（写真）：AI が各ページを読み取ります。",
 "PDF grande": "大きな PDF",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF をスマートフォンの \"{pasta}\" フォルダーに保存しました。",
 "PDF guardado no {nome}.": "PDF を {nome} に保存しました。",
 "PDF numa página só": "PDF を 1 ページに",
 "PDF para Word": "PDF を Word に",
 "PDF para imagens": "PDF を画像に",
 "PDF para texto": "PDF をテキストに",
 "PDFs arquivados ({n})": "アーカイブ済みのPDF ({n})",
 "PDFs juntados {data}": "結合した PDF {data}",
 "PEDIDOS RECEBIDOS": "受け取ったリクエスト",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIXコピー＆ペースト",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "今後の請求（確定済み）",
 "Paciente": "患者",
 "Paciente ou aluno": "患者または生徒",
 "Pacientes": "患者",
 "Padrão": "標準",
 "Padrão da aba": "タブの標準",
 "Paga": "支払い済み",
 "Paga (toque para desfazer)": "支払い済み（タップで取り消し）",
 "Pagador": "支払者",
 "Pagamento já contado": "計上済みの支払い",
 "Pagar": "支払い",
 "Pagar parcela {n}/{t} · {c}": "支払い {n}/{t}回目 · {c}",
 "Pagas": "支払い済み",
 "Pago": "支払い済み",
 "Pago com": "支払い方法",
 "Pago: {p} · Falta pagar: {f}": "支払い済み：{p} · 未払い：{f}",
 "Pagos": "支払い済み",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "{v}を支払いましたか？割引や延滞金・利息があった場合は、実際の支払額を入力してください。今すぐ証憑を保存しますか？",
 "Paguei outro valor (desconto, multa ou juros)": "別の金額を支払った（割引・延滞金・利息）",
 "Paixão de Cristo": "聖金曜日",
 "Palavras-chave (separe com vírgula)": "キーワード（カンマ区切り）",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "目標「{m}」を期限までに達成するには、毎月{v}が必要です。期限を延ばすか、少ない額から始めてみましょう。",
 "Para clareza, firmo o presente.": "以上、相違ないことを証明します。",
 "Para comprar": "購入できるもの",
 "Para continuar, digite a senha do app.": "続けるには、アプリのパスワードを入力してください。",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "会話するには、設定 › 人工知能 であなたのAI（Claude、ChatGPT、Gemini）をオンにしてください。",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "費用を割り勘するには、「参加者」に名前をカンマ区切りで入力してください（旅行を編集）。",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "請求書の発行と検索には、請求書サーバーを一度接続してください。パソコンで 13-LIGAR-NOTAS.bat をダブルクリックし、表示されたアドレス（.netlify.app で終わる）をここに貼り付けます。",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "権利を行使するには、アプリのお問い合わせを使うか、下記のメールアドレスにご連絡ください。15日以内に回答します。",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "音声通話とビデオ通話を使うには、アプリの新しいバージョン（0.35）をインストールしてください。メッセージはすでに使えます。",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "アプリを動かすため：端末間でのデータの保存と同期、アラートの送信、選んだグループとの共有、サポートの提供。",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "PDF を {nome} に保存するには、設定 › Google Drive と OneDrive でアカウントを接続してください。",
 "Para hoje": "今日へ",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "写真やPDFを読むには、設定 › 人工知能 であなたのAI（Claude、ChatGPT、Gemini）をオンにしてください。OFXやCSVの明細はAIなしで使えます。",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "時計を自動で読み取るには、アプリの新しいバージョン（0.33）をインストールしてください。それまでは手動で入力できます。",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "時計を読み取るには、スマホのアプリから接続してください。数値はここにも表示されます。",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "時計を読み取るには、My Planner にアクティビティデータへのアクセスを許可してください。",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "テキストの読み取り、要約、質問をするには、設定 › 人工知能 で AI をオンにしてください（Claude、ChatGPT、Gemini）。",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "オンにするには、スマートフォンのアプリを使用してください（設定 > Google カレンダー）。その後、すべてここにも表示されます。",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "オンにするには、スマートフォンのアプリを使用してください（設定 › 一般設定 › Google カレンダー）。その後、すべてここにも表示されます。",
 "Para monitorar a OAB, informe o número e a UF.": "OABをモニタリングするには、番号と州（UF）を入力してください。",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "今後確認しない場合は、設定 › 一般設定 でアプリを選んでください。",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "医療従事者向け：患者、金庫に保管する経過記録、テンプレート付き処方、会計、領収書、払い戻し用証明書（PDF）。",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "医療従事者向け：患者、経過記録、テンプレート付き処方、保険対応の会計、領収書、払い戻し用証明書。",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "アカウント保護のため、WhatsAppのコードで携帯番号を一度だけ確認します。番号を変更した場合のみ、再度求められます。",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "物件や部屋を短期で貸す人向け（Airbnb、Booking、直接）：予約、清掃、経費、毎月の利益。",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "イベントの予定、場所、お知らせをスマホで受け取るには、グループに参加してください: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "同期するには、スマートフォンの設定で My Planner にカレンダーへのアクセスを許可してください。",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "システムに与えた許可（カメラ、写真、マイク）を取り消すには、スマートフォンの設定も使ってください。",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "より詳しく読み取るには、設定 › 人工知能 でご自分の AI をオンにしてください。",
 "Parabéns": "おめでとう",
 "Parabéns!": "おめでとう！",
 "Parada": "静止",
 "Parar": "停止",
 "Parar de compartilhar?": "共有を停止しますか？",
 "Parar e salvar": "停止して保存",
 "Parar gravação": "録画を停止",
 "Parcela": "支払回",
 "Parcela de financiamento": "ローンの返済",
 "Parcela {n}/{t}": "{n}/{t}回目",
 "Parcela {n}/{t} · {c}": "{n}/{t}回目 · {c}",
 "Parcelas": "分割回",
 "Parcelas a pagar nos próximos meses": "今後数か月の支払予定",
 "Parcelas recalculadas": "分割回を再計算しました",
 "Parece que foi impresso e escaneado.": "印刷してスキャンしたように見せます。",
 "Parei": "中断",
 "Parei na aula": "止まった回",
 "Parei na aula...": "止まった回は…",
 "Pares de meia": "靴下（足）",
 "Parque ou natureza": "公園・自然",
 "Parques": "公園",
 "Parte": "当事者",
 "Partes": "当事者",
 "Participa": "参加者",
 "Participantes": "参加者",
 "Participação em empresa": "会社への出資",
 "Passa do limite do MEI: fale com seu contador.": "MEI の上限を超えます。会計士にご相談ください。",
 "Passaporte": "パスポート",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "絵の上を指でなぞると、その部分だけ消せます。",
 "Passeio": "校外学習",
 "Passeios": "観光",
 "Passo a passo": "ステップごと",
 "Passos": "歩数",
 "Passos, exercício, calorias, batimentos e sono": "歩数、エクササイズ、カロリー、心拍数、睡眠",
 "Passou do orçamento": "予算オーバー",
 "Passou do orçamento em {v}": "予算を{v}超過",
 "Pasta": "フォルダー",
 "Patrimônio": "資産",
 "Patrimônio & Imposto de Renda": "資産＆所得税",
 "Patrimônio pelo valor de compra: {v}": "取得価額での資産：{v}",
 "Pausa (s)": "休憩（秒）",
 "Pausa de {m} min": "{m}分の休憩",
 "Pausado": "一時停止中",
 "Pausar": "一時停止",
 "Pausas": "休憩",
 "Pausas de estudo": "勉強の休憩",
 "Pauta (opcional)": "議題（任意）",
 "Paz": "平和",
 "Pediatra": "小児科",
 "Pedido": "依頼",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "{nome} さんにリクエストを送りました。承認されるとトークできます。",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "リクエストを送りました。相手が承認するとトークできます。",
 "Pedidos de documentos": "書類の依頼",
 "Pedir de novo depois de": "再度求めるまでの時間",
 "Peguei emprestado": "借りた",
 "Peito de frango": "鶏むね肉",
 "Peixe": "魚",
 "Pela última compra: cerca de {v}": "前回の購入では約{v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "今月まだ期日が来る支払いを考えると、{v}足りなくなります。新しい出費の前に、延期や削減できるものを確認しましょう。",
 "Pendente": "未回答",
 "Pensão alimentícia": "養育費",
 "Pequena": "小",
 "Pequeno": "小",
 "Percentual de tributos do Simples (para sair na nota)": "Simples の税率（請求書に記載）",
 "Perguntar ao Mestre": "マスターに聞く",
 "Perguntar sempre": "毎回確認する",
 "Pergunte ao Mestre...": "マスターに聞く...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "書類について質問（例：期限はいつ？）",
 "Permissões": "権限",
 "Personalizado": "カスタム",
 "Perto do limite do orçamento": "予算の上限が近い",
 "Período": "期間",
 "Período da meta": "目標の期間",
 "Pescoço: inclinar para os lados": "首：左右に傾ける",
 "Peso": "体重",
 "Peso na média": "平均点での重み",
 "Pesquisar no mapa": "地図で検索",
 "Pessoa": "個人",
 "Pessoa de contato": "担当者",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "グループのメンバーには、グループで共有されたものだけが表示されます。",
 "Pet": "ペット",
 "Pet & Família": "ペット＆家族",
 "Pet shop": "ペットショップ",
 "Pet shop ou clínica": "ペットショップまたは動物病院",
 "Pets": "ペット",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "期限付きでクライアントに書類を依頼します。クライアントは受け取り、添付して、提出済みにします。",
 "Pijamas": "パジャマ",
 "Pilates": "ピラティス",
 "Pintura": "塗装",
 "Pix copia e cola": "Pixコピー＆ペースト",
 "Placa": "ナンバー",
 "Planejado": "予定",
 "Planejado e comido": "予定と実際",
 "Planilha": "スプレッドシート",
 "Planilha (Excel)": "スプレッドシート（Excel）",
 "Planilha do mês para o Receita Saúde": "Receita Saúde 用の月次表",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "ベーシックプラン：My Planner + メモ",
 "Plano de aula": "授業計画",
 "Plano de saúde": "健康保険",
 "Planos de aula": "授業計画",
 "Planta": "植物",
 "Plantas": "植物",
 "Plantas & Jardim": "植物＆ガーデン",
 "Plataforma ou escola": "プラットフォームまたはスクール",
 "Pneus novos": "新しいタイヤ",
 "Podcast": "ポッドキャスト",
 "Pode confirmar sua presença respondendo esta mensagem?": "このメッセージへの返信で出欠をお知らせいただけますか？",
 "Polichinelo": "ジャンピングジャック",
 "Polo ativo": "原告側",
 "Polo passivo": "被告側",
 "Política de privacidade (LGPD)": "プライバシーポリシー（LGPD）",
 "Política de privacidade, LGPD e permissões": "プライバシーポリシー、LGPD、権限",
 "Política de privacidade, LGPD e termos": "プライバシーポリシー、LGPD、規約",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "旅行の写真と動画をここに追加しましょう。グループでは全員が見られて、全員が自分の写真を追加できます。",
 "Ponte de glúteos": "ヒップリフト",
 "Ponto facultativo": "任意休日",
 "Ponto facultativo: {nome}": "任意休日：{nome}",
 "Ponto turístico": "観光スポット",
 "Pontos turísticos": "観光スポット",
 "Por dia": "日単位",
 "Por faixas": "範囲ごと",
 "Por mês": "月単位",
 "Por nome": "名前で",
 "Por semana": "週単位",
 "Portal": "ポータル",
 "Portal do Cliente": "顧客ポータル",
 "Portal do cliente (convidar o cliente)": "顧客ポータル（クライアントを招待）",
 "Português": "ポルトガル語",
 "Porão": "地下室",
 "Porções": "人前",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "空き容量が少なくなっています。新しい写真や添付ファイルが保存されない可能性があります。容量を空けるか、添付ファイルを Google Drive または OneDrive に保存してください。",
 "Praia": "ビーチ",
 "Prancha": "プランク",
 "Prato do cardápio": "献立の料理",
 "Prato principal": "主菜",
 "Prazo": "期限",
 "Prazo (pagamento ou entrega)": "期限（支払いまたは納品）",
 "Prazo até {fim} · fazer em {dia}": "期限 {fim} · {dia} に対応",
 "Prazo final: {fim}": "最終期限：{fim}",
 "Prazo: {d}": "期限：{d}",
 "Prazo: {t}": "期限：{t}",
 "Prazos criados": "期限を作成しました",
 "Precisa da sua IA": "あなたのAIが必要",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "説明、国の課税コード（6 桁）、金額を入力してください。",
 "Preenche os campos do PDF e, se quiser, trava.": "PDF の入力欄に記入し、必要ならロックします。",
 "Preencher formulário": "フォームに記入",
 "Preencher pela foto com a minha IA": "自分の AI で写真から入力",
 "Preencher pela nota fiscal com a minha IA": "自分のAIで領収書から入力",
 "Preparando a conversa da equipe...": "チームのチャットを準備しています...",
 "Preparando a página {n} de {total}...": "{n} / {total} ページを準備中...",
 "Preparando o arquivo": "ファイルを準備中",
 "Prescrição, conduta e orientações": "処方・方針・指導",
 "Presente": "出席",
 "Presença": "出欠",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "コードを長押ししてコピーするか、送信をタップして「コピー」を選んでください。",
 "Pressione e segure o código para copiar.": "コードを長押しするとコピーできます。",
 "Pressione e segure um lançamento para apagar.": "記録を長押しすると削除できます。",
 "Pressione e segure um perfil para removê-lo.": "プロフィールを長押しすると削除できます。",
 "Preto e branco": "白黒",
 "Previdência privada": "個人年金",
 "Preço ou ingresso": "料金・チケット",
 "Price": "Price（元利均等）",
 "Primeira": "最初",
 "Primeira cota ou cota única do IR": "所得税の第1回または一括納付",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "初回の支払いは{mes}の請求で、期日は{data}です。",
 "Prioridade": "優先度",
 "Privacidade": "プライバシー",
 "Privacidade e termos": "プライバシーと規約",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "プライバシー：分析するテキストや画像は、あなたのキーを使ってこの端末から選んだ AI の会社へ直接送られます。My Planner はコピーを保存しません。",
 "Problema": "問題",
 "Problemas, erros e sugestões": "問題、エラー、提案",
 "Procedimento": "処置",
 "Procedimento: {c}": "処置：{c}",
 "Processo": "訴訟",
 "Processo Civil": "民事訴訟法",
 "Processo Penal": "刑事訴訟法",
 "Processo do Trabalho": "労働訴訟法",
 "Processo não informado": "事件番号なし",
 "Proclamação da República": "共和国宣言記念日",
 "Procurando a folha...": "用紙を探しています...",
 "Procurando atualização...": "アップデートを確認中...",
 "Procurar aba": "タブを検索",
 "Procurar atualização agora": "今すぐアップデートを確認",
 "Procurar documento": "書類を検索",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "ツールを検索（例：結合、署名、圧縮）",
 "Produto": "商品",
 "Produto (ex.: Geladeira)": "商品（例：冷蔵庫）",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "商品、領収書、修理窓口、期限前のお知らせ。",
 "Produção (vale de verdade)": "本番（正式に有効）",
 "Produção restrita (teste)": "制限付き本番（テスト）",
 "Produção restrita (teste, não vale)": "制限付き本番（テスト、無効）",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "制限付き本番: 政府のテスト環境です。請求書は無効です。本番に切り替える前に（「編集」から）ここですべてテストしてください。",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "本番: 発行した請求書は正式に有効となり、市役所と連邦歳入庁に送られます。",
 "Produção: vale de verdade": "本番: 正式に有効",
 "Professor": "先生",
 "Professor & Mentoria": "先生・メンタリング",
 "Professor(a)": "先生",
 "Profissionais": "職人",
 "Profissional": "職人",
 "Profissional assistente": "アシスタント",
 "Profissional ou fornecedor": "職人または業者",
 "Profissional ou local": "医療者または場所",
 "Profissão ou especialidade": "職種・専門",
 "Profissões": "職業",
 "Programação": "プログラミング",
 "Progresso geral": "全体の進み具合",
 "Projeto e licenças": "設計と許可",
 "Projetos": "プロジェクト",
 "Prontas": "定番",
 "Pronto": "完了",
 "Pronto! Todas as abas estão liberadas até {data}.": "完了！すべてのタブが {data} まで使えます。",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "完了しました。画面をロックして1分お待ちください：通知が音付きで表示されるはずです。",
 "Prontuário, evolução e prescrições, sem o financeiro.": "カルテ、経過、処方。会計は除きます。",
 "Protegendo a chave...": "鍵を保護しています...",
 "Proteger no cofre": "金庫で保護",
 "Protegido": "保護",
 "Protegido no cofre": "金庫で保護済み",
 "Protegidos pelo cofre: {n}": "金庫で保護：{n}",
 "Protetor solar": "日焼け止め",
 "Protocolo": "受付番号",
 "Prova": "テスト",
 "Próxima": "次回",
 "Próxima até a data": "次回の期限日",
 "Próxima com quantos km": "次回の距離",
 "Próxima dose": "次回の接種",
 "Próxima: {data}": "次回：{data}",
 "Próxima: {d} · {v}": "次回：{d} · {v}",
 "Próximas": "今後",
 "Próximo": "次へ",
 "Próximo ano": "翌年",
 "Próximo número da DPS": "次の DPS 番号",
 "Próximos 7 dias": "今後7日間",
 "Próximos vencimentos ({n})": "今後の期限（{n}）",
 "Publicação": "公告",
 "Publicações": "公告",
 "Pula": "ジャンプ",
 "Pulsa": "ドキドキ",
 "Punho": "こぶし",
 "Puxada frontal": "ラットプルダウン",
 "PÁGINAS": "ページ",
 "PÔR NA BARRA": "バーに表示",
 "Pág. {n}": "{n} ページ",
 "Página": "ページ",
 "Página 1": "ページ 1",
 "Página 1 de 10": "ページ 1 / 10",
 "Página em branco no fim": "最後に白紙ページ",
 "Página em que estou": "今読んでいるページ",
 "Página escaneada": "ページをスキャンしました",
 "Página inteira": "ページ全体",
 "Página {a} de {n}": "{n} ページ中 {a} ページ",
 "Página {n}": "{n}ページ",
 "Página {n} de {total}": "{n} / {total} ページ",
 "Página: {titulo}": "ページ：{titulo}",
 "Páginas": "ページ",
 "Páginas, tamanho, autor, datas e campos.": "ページ数、サイズ、作成者、日付、フィールド。",
 "Pássaro": "鳥",
 "Pão francês": "ブラジル風ロールパン",
 "Pão integral": "全粒粉パン",
 "Pôr a data de hoje": "今日の日付を入れる",
 "Pôr as parcelas no My Planner": "分割回を My Planner に追加",
 "Pôr na barra": "バーに表示",
 "Pôr no roteiro da viagem": "旅程に追加",
 "Pôr uma foto": "写真を設定",
 "Quadro": "ボード",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Kanban ボード、クライアント別の作業時間タイマー、My Planner の期限。",
 "Quais contas vencem nos próximos dias?": "近日中に期日が来る支払いは？",
 "Quais páginas ficam no PDF novo": "新しい PDF に残すページ",
 "Quais páginas sair": "削除するページ",
 "Qual IA": "使用する AI",
 "Qualidade alta": "高画質",
 "Qualidade boa (menor)": "良好な画質（小さめ）",
 "Quantidade": "数量",
 "Quanto cortar de cada lado (% da página)": "各辺から切り取る量（ページの %）",
 "Quanto já tem guardado (opcional)": "すでに貯めた額（任意）",
 "Quanto paga por limpeza": "清掃1回の支払額",
 "Quanto preciso guardar por mês para as minhas metas?": "目標のために毎月いくら貯めればいいですか？",
 "Quanto quer juntar": "貯めたい金額",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "各カテゴリーで毎月使ってよい上限額です。空欄にすると管理しません。",
 "Quarta": "水曜日",
 "Quarta-feira de Cinzas (até 14h)": "灰の水曜日（14時まで）",
 "Quarto": "寝室",
 "Quarto das crianças": "子ども部屋",
 "Quarto de casal": "主寝室",
 "Quarto de hóspedes": "客間",
 "Quarto infantil": "子ども部屋",
 "Queijo": "チーズ",
 "Queixa principal": "主訴",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "リンクを開いた人は My Planner をダウンロード（またはブラウザで利用）し、ログインしてグループに参加します。",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "あなたのコードでアカウントを作成した人は、申請なしでここで友だちになります。",
 "Quem enviou": "送信者",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "アプリ内で同じグループ（クラス、家族、旅行など）にいる人とは、友だちでなくてもトークできます。友だちを長押しすると解除やブロックができます。",
 "Quem faz a limpeza": "清掃担当者",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "支払者（患者本人以外の場合：母、父、保護者）",
 "Quem pagou": "支払った人",
 "Quem recebeu (médico, escola...)": "受取人（医師、学校…）",
 "Quem vai": "参加者",
 "Quem vai limpar": "清掃する人",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "表示される相手：あなたとチャットしている人、友だち、アプリのグループであなたと一緒の人だけです。表示したくない項目は空欄のままにしてください。",
 "Quente": "暑い",
 "Quer escanear mais uma página?": "もう 1 ページスキャンしますか？",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "今すぐ控えを保存しますか？写真、PDF、またはPixのスクリーンショット。",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "スクリーンショットを送りたい場合は、メールで送信して画像を添付してください。",
 "Quer trocar pelos novos ou manter os dois?": "新しいものに置き換えますか、それとも両方残しますか？",
 "Quero assistir": "見たい",
 "Quero ir": "行きたい",
 "Quero ler": "読みたい",
 "Quero ver": "見たい",
 "Quilometragem atual": "現在の走行距離",
 "Quilometragem: {km}": "走行距離：{km}",
 "Quinta": "木曜日",
 "Quintal": "庭",
 "Quitado": "完済",
 "Quitados": "完済",
 "Química": "化学",
 "RECIBO": "領収書",
 "RG / Carteira de identidade": "RG / 身分証明書",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "身分証、運転免許証、パスポート、契約書、証明書を期限前に通知し、ワンタップで送信。",
 "Raciocínio Lógico": "論理的思考",
 "Razão social ou nome": "会社名または氏名",
 "Razão social ou nome do consultório": "法人名またはクリニック名",
 "Razão social ou nome fantasia": "商号または屋号",
 "Raça": "品種",
 "Realizado": "実施済み",
 "Recado": "メッセージ",
 "Recalcular": "再計算",
 "Recalcular as parcelas em aberto": "未払いの分割回を再計算",
 "Recalcular as parcelas?": "分割回を再計算しますか？",
 "Receber": "受け取り",
 "Receber de volta: {i} ({p})": "返してもらう：{i}（{p}）",
 "Receber o código no WhatsApp": "WhatsAppでコードを受け取る",
 "Receber parcela {n}/{t} · {c}": "受取 {n}/{t}回目 · {c}",
 "Recebeu um convite?": "招待を受け取りましたか？",
 "Recebeu um código?": "コードを受け取りましたか？",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "{pagador}{doc}より、{data}に実施した{tipo}{paciente}の代金として、{valor}{extenso}を受領しました。",
 "Recebi outro valor": "別の金額を受け取った",
 "Recebida": "受領",
 "Recebida (toque para desfazer)": "受取済み（タップで取り消し）",
 "Recebidas": "受取済み",
 "Recebido": "受取済み",
 "Recebido: {v}": "受取済み：{v}",
 "Recebidos": "受信",
 "Recebidos dos grupos": "グループからの受信",
 "Recebimento": "受取",
 "Receita": "レシピ",
 "Receitas": "レシピ",
 "Recibo": "領収書",
 "Recibo em PDF": "領収書（PDF）",
 "Recibo emitido": "領収書発行済み",
 "Recibo guardado": "領収書を保存しました",
 "Recibos dedutíveis": "控除対象の領収書",
 "Recomendada": "おすすめ",
 "Recomeçar": "リセット",
 "Recortar": "切り抜き",
 "Recortar margens": "余白をトリミング",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "切り抜き、回転、フィルターは新しいアプリ（バージョン 0.49）で使えます。",
 "Recusada": "却下済み",
 "Recusado": "却下",
 "Recusar": "却下",
 "Redação": "作文",
 "Refazer": "やり直す",
 "Refeição": "食事",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "今日予定の食事、運動、お手入れ、サプリメント",
 "Referente a": "内容",
 "Referência": "参考資料",
 "Reforço": "追加接種",
 "Regar a cada quantos dias": "何日ごとに水やり",
 "Regar hoje": "今日水やり",
 "Regar: {p}": "水やり：{p}",
 "Regional": "地域",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "日誌、工程、納品を記録します。金額は表示されません。",
 "Registrar venda/serviço do MEI": "MEI の売上・サービスを記録",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "診療ごとに記録しましょう。経過記録は暗号化されて金庫に保管されます。処方はテンプレートから入力できます。",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "不動産、車、投資の売買を証憑と一緒に記録しましょう。税金の申告でとても役立ちます。",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "スケジュールと違ったこと（食品を替えた、食事を変えた）を記録します。週間レポートに反映されます。",
 "Registro": "記録",
 "Registro clínico": "診療記録",
 "Registro de horas": "作業時間の記録",
 "Registro do diário": "日誌の記録",
 "Regiões com feriado próprio (marque as suas):": "独自の祝日がある地域（該当する地域を選択）：",
 "Regras da casa": "ハウスルール",
 "Regras da casa:": "ハウスルール：",
 "Reguei": "水やりした",
 "Reguei hoje": "今日水やりした",
 "Reiniciar": "再起動",
 "Reiniciar o app": "アプリを再起動",
 "Relatório": "レポート",
 "Relatório da semana": "週間レポート",
 "Relatório em PDF ou Excel": "PDFまたはExcelのレポート",
 "Relatório enviado. Obrigado!": "レポートを送信しました。ありがとうございます！",
 "Relatórios": "レポート",
 "Relatórios do Bem-Estar": "ウェルネスのレポート",
 "Relatórios gerados ({n})": "作成したレポート（{n}）",
 "Relaxar": "リラックス",
 "Religião": "宗教",
 "Relógio": "時計",
 "Relógio e apps de saúde": "時計と健康アプリ",
 "Remada baixa": "シーテッドロー",
 "Remover": "削除",
 "Remover \"{nome}\"?": "「{nome}」を削除しますか？",
 "Remover anotações": "注釈を削除",
 "Remover este bloco?": "このブロックを削除しますか？",
 "Remover páginas": "ページを削除",
 "Remover vínculo": "リンクを解除",
 "Remover {nome}?": "{nome} を削除しますか？",
 "Remédio": "薬",
 "Remédio contínuo": "継続服用の薬",
 "Remédio na linha do tempo": "タイムライン上の薬",
 "Remédios": "薬",
 "Remédios de uso contínuo": "継続服用の薬",
 "Renavam ou chassi": "Renavam または車台番号",
 "Renegociado": "条件変更済み",
 "Renomear": "名前を変更",
 "Renomear com IA": "AI で名前を変更",
 "Renomear ou trocar ícone": "名前またはアイコンを変更",
 "Renomear pasta": "フォルダー名を変更",
 "Renomear, ícone ou cor": "名前、アイコン、色",
 "Renovar: {nome}": "更新：{nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "ファイル内部を整理します。写真の多い PDF にはあまり効果がありません。",
 "Reparar PDF": "PDF を修復",
 "Repelente": "虫よけ",
 "Repete": "繰り返し",
 "Repetir a cada quantos dias": "何日ごとに繰り返す",
 "Repetições": "回数",
 "Repita a senha": "パスワードを再入力",
 "Repita a senha do cofre": "金庫のパスワードをもう一度入力",
 "Repita a senha nova": "新しいパスワード（確認）",
 "Replantio": "植え替え",
 "Replantios": "植え替え",
 "Repor papel higiênico, sabonete e café": "トイレットペーパー、石けん、コーヒーを補充",
 "Representatividade": "多様性",
 "Reserva": "予約",
 "Reservas": "予約",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "予約、清掃、収入、経費は「賃貸・民泊」タブで",
 "Respirar fundo 5 vezes": "深呼吸を5回",
 "Respondendo a {nome}": "{nome} に返信中",
 "Responder": "返信",
 "Responsável": "担当者",
 "Responsável (imobiliária, vistoriador)": "担当者（不動産会社、検査員）",
 "Resposta da SEFAZ": "SEFAZ の応答",
 "Resta {tempo}": "残り{tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "残り {ml} = {copo} のコップ {n} 杯",
 "Restaurante": "レストラン",
 "Restaurantes": "レストラン",
 "Restaurar": "復元",
 "Restaurar esta cópia?": "このバックアップを復元しますか？",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "復元すると、この端末とアカウントの現在のデータがすべてバックアップの内容に置き換わります。",
 "Restaurar uma cópia": "バックアップを復元",
 "Resultado": "結果",
 "Resultado nas vendas: {v}": "売却損益：{v}",
 "Resumir": "要約",
 "Resumir e perguntar": "要約と質問",
 "Resumo": "概要",
 "Resumo (falta o XML completo)": "概要（完全な XML なし）",
 "Resumo da manhã": "朝のまとめ",
 "Resumo da pasta": "フォルダの概要",
 "Resumo e opinião": "あらすじと感想",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "概要、カテゴリー別支出、支払い、請求、目標、すべての取引。税理士に送ったり、IR（所得税）用に保管したりするのに便利です。",
 "Retirar": "引き出す",
 "Retirar da meta": "目標から引き出す",
 "Retorno": "再診",
 "Reunião": "面談",
 "Reunião agora": "今すぐ会議",
 "Reunião de equipe": "チーム会議",
 "Reuniões": "会議",
 "Revestimento e pisos": "仕上げ材と床",
 "Revisão": "点検",
 "Revolução Constitucionalista": "護憲革命記念日",
 "Rico em matéria orgânica": "有機物が豊富",
 "Rodízio de pneus": "タイヤローテーション",
 "Roedor": "げっ歯類",
 "Romance": "ロマンス",
 "Rosca direta": "バーベルカール",
 "Rota": "ルート",
 "Rota passando pelos {n} lugares que faltam": "残り {n} か所を回るルート",
 "Rotas e mapas": "ルートと地図",
 "Roteiro": "旅程",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "旅行中はタイムラインに入る日ごとの旅程、気候に合わせた荷物、予約、タイムゾーン。",
 "Rotina": "ルーティン",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "ステップ付きのルーティン：スキンケア、ストレッチ、ヘアなど。「+ ケア」をタップしてテンプレートを選ぶか、自分で作成しましょう。",
 "Roupa": "服",
 "Roupa social": "フォーマルウェア",
 "Roupas de banho": "水着",
 "Roupas extras das crianças": "子どもの着替え",
 "Roupas íntimas": "下着",
 "Rua": "通り",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "番地、地区、市区町村（または場所の名前）",
 "Régua": "定規",
 "Réptil": "爬虫類",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "ラベル（例：自分の名前、顧客の会社）",
 "SAC": "SAC（元金均等）",
 "SEM HORÁRIO": "時刻なし",
 "SEU MÊS EM NÚMEROS": "今月の数字",
 "SEU TREINO": "あなたのトレーニング",
 "SEUS GRUPOS DO APP": "アプリのグループ",
 "SP": "SP",
 "SUBTAREFA": "サブタスク",
 "SUBTAREFAS": "サブタスク",
 "SUPLEMENTAÇÃO": "サプリメント",
 "Sabonete facial": "洗顔料",
 "Sabão para lavar roupa": "洗濯洗剤",
 "Sacada": "バルコニー",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "このアプリの一覧から外すだけです。Drive、OneDrive、スマホのフォルダに保存したコピーは残ります。",
 "Sai só da lista. O arquivo continua onde foi salvo.": "リストから外すだけです。ファイルは保存先に残ります。",
 "Sair": "ログアウト",
 "Sair da conta?": "ログアウトしますか？",
 "Sair do escritório": "オフィスを退出",
 "Sair do escritório?": "オフィスを退出しますか？",
 "Sair do grupo": "グループを退出",
 "Sair do grupo?": "グループを退出しますか？",
 "Sair sem baixar": "ダウンロードせずに終了",
 "Saiu": "出金",
 "Sala": "教室",
 "Sala de estar": "リビング",
 "Sala de jantar": "ダイニング",
 "Sala virtual": "オンライン会議室",
 "Salada": "サラダ",
 "Saldo": "残高",
 "Saldo depois desta parcela": "この回の後の残債",
 "Saldo devedor: {v}": "残債：{v}",
 "Saldo do mês": "今月の収支",
 "Salvar": "保存",
 "Salvar backup do My Planner": "My Plannerのバックアップを保存",
 "Salvar cuidado": "ケアを保存",
 "Salvar cômodo": "部屋を保存",
 "Salvar e colocar no My Planner": "保存して My Planner に入れる",
 "Salvar e sincronizar": "保存して同期",
 "Salvar e testar": "保存してテスト",
 "Salvar endereço": "住所を保存",
 "Salvar no My Planner": "My Planner に保存",
 "Salvar refeição": "食事を保存",
 "Salvar suplemento": "サプリメントを保存",
 "Salvar tarefa": "タスクを保存",
 "Salvar treino": "トレーニングを保存",
 "Sanduíche natural": "ヘルシーサンド",
 "Santo Antônio": "聖アントニオの日",
 "Sapato confortável": "歩きやすい靴",
 "Saudade": "会いたい",
 "Saída (imóvel antigo)": "退去（旧居）",
 "Saída de praia": "ビーチ用の羽織り",
 "Saúde": "健康",
 "Saúde & Prontuário": "健康＆カルテ",
 "Saúde (médicos, dentistas, exames, plano)": "医療（医師、歯科、検査、保険）",
 "Saúde e bem-estar": "健康とウェルネス",
 "Scanner": "スキャナー",
 "Scanner PDF": "PDF スキャナー",
 "Sci-Fi": "SF",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "反応しないところがあれば、アプリを再起動してください。データは保存されています。",
 "Se der tempo": "時間があれば",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "本ポリシーに重要な変更があった場合は、アプリでお知らせし、改めて同意をお願いします。",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "この通知が表示されたら、予定の通知は正常に動作しています。",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "{email} のアカウントが存在する場合、新しいパスワードを作成するためのリンクを送信しました。迷惑メールフォルダもご確認ください。",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "通知が遅れる・表示されない場合：アプリの設定で通知をオンにし、バッテリーを「制限なし」にして、「アラームとリマインダー」を許可してください。",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "時計が接続されている場合、データがあれば時計の数値が手動入力の数値より優先されます。",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "時計を接続した場合：Health Connect（Android）または「ヘルスケア」App（iPhone）から読み取った、歩数、距離、カロリー、エクササイズ、心拍数、睡眠の毎日の合計。アプリは読み取るだけで、これらのデータを変更することはありません。",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "このタブを使ったことがある場合も、何も削除されていません。契約すると元どおりに戻ります。",
 "Secretária ou recepção": "受付・秘書",
 "Seg a sex": "月〜金",
 "Seguir": "次へ",
 "Segunda": "月曜日",
 "Segurança": "セキュリティ",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "長押ししてドラッグで並べ替え。↻ 回転、⧉ 複製、✕ ページを削除。",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "トークでGIFを長押しして\"保存\"をタップすると、ここに表示されます。",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "部屋を長押しすると並べ替えできます。部屋を開いた状態でタスクを長押しし、別の部屋で離すと移動できます。",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "バインダー・科目・ページを長押しすると並べ替えできます。科目を別のバインダーで離すとそこへ移動します。",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "トークを長押しするとミュートやアーカイブができます。アーカイブしても送受信はできますが、通知は届きません。",
 "Seguro": "保険",
 "Seguro da casa": "住宅保険",
 "Seguro viagem": "旅行保険",
 "Selecionar": "選択",
 "Sem": "なし",
 "Sem alerta": "アラートなし",
 "Sem categoria": "カテゴリーなし",
 "Sem comprovante": "証明書類なし",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "請求書サーバーに接続できません。インターネットとサーバーのアドレスを確認してください。",
 "Sem conexão com o servidor. Confira a internet.": "サーバーに接続できません。インターネットを確認してください。",
 "Sem conexão com os GIFs agora.": "現在GIFに接続できません。",
 "Sem cômodo": "部屋なし",
 "Sem data de fim": "終了日なし",
 "Sem exercícios": "運動なし",
 "Sem fatura em {mes}": "{mes}は請求なし",
 "Sem fim": "終了なし",
 "Sem horário": "時刻なし",
 "Sem internet ou servidor ainda não preparado.": "インターネットに接続されていないか、サーバーの準備ができていません。",
 "Sem internet. Envia quando voltar.": "インターネットに接続していません。接続が戻ったら送信します。",
 "Sem internet. Tente de novo.": "インターネットに接続されていません。もう一度お試しください。",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "これがないと黒塗りは上に重なるだけで、下のテキストはファイルに残りコピーできます。",
 "Sem itens": "項目なし",
 "Sem juros": "無利息",
 "Sem limite": "上限なし",
 "Sem link de calendário": "カレンダーリンクなし",
 "Sem margem": "余白なし",
 "Sem nome": "名前なし",
 "Sem número na primeira página (capa)": "最初のページ（表紙）に番号を付けない",
 "Sem pasta": "フォルダーなし",
 "Sem pausas": "休憩なし",
 "Sem permissão": "許可がありません",
 "Sem prazo": "期限なし",
 "Sem recibo": "領収書なし",
 "Sem tarefas": "タスクなし",
 "Sem texto.": "テキストなし。",
 "Sem tomador identificado": "依頼主不明",
 "Sem título": "無題",
 "Sem validade": "期限なし",
 "Semana": "週",
 "Semana completa": "1週間すべて",
 "Semana de {de} a {ate}": "{de}〜{ate} の週",
 "Semanal": "毎週",
 "Semanal · dias úteis": "毎週 · 平日",
 "Semanal · todos os dias": "毎週 · 毎日",
 "Semanal · {dias}": "毎週 · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "常に表示されます。任意休日（カーニバル、灰の水曜日、聖体祭）も一緒に表示されます。",
 "Senha": "パスワード",
 "Senha (8 caracteres ou mais)": "パスワード（8文字以上）",
 "Senha alterada.": "パスワードを変更しました。",
 "Senha atual": "現在のパスワード",
 "Senha atual do cofre": "現在の金庫のパスワード",
 "Senha da conta": "アカウントのパスワード",
 "Senha do certificado": "証明書のパスワード",
 "Senha do cofre": "金庫のパスワード",
 "Senha do cofre alterada.": "金庫のパスワードを変更しました。",
 "Senha do cofre incorreta.": "金庫のパスワードが正しくありません。",
 "Senha incorreta": "パスワードが違います",
 "Senha incorreta.": "パスワードが正しくありません。",
 "Senha nova (8 caracteres ou mais)": "新しいパスワード（8文字以上）",
 "Senha nova do cofre (6 caracteres ou mais)": "新しい金庫のパスワード（6文字以上）",
 "Senha, biometria, bloqueio e privacidade": "パスワード、生体認証、ロック、プライバシー",
 "Senha, e-mail e formas de desbloquear": "パスワード、メールアドレス、ロック解除の方法",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "収入証明をまとめる（銀行、勤務先、証券会社）",
 "Servidor de notas": "請求書サーバー",
 "Servidor não configurado (lib/config.ts).": "サーバーが設定されていません（lib/config.ts）。",
 "Servidor não configurado.": "サーバーが設定されていません。",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "サーバーが設定されていません：lib/config.tsにSupabaseの情報がありません。",
 "Serviço": "サービス",
 "Serviço não prestado": "サービス未提供",
 "Serviços": "サービス",
 "Será excluída em 1 dia": "1 日後に削除されます",
 "Será excluída em {n} dias": "{n} 日後に削除されます",
 "Será excluída hoje": "今日削除されます",
 "Sessão": "セッション",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "アクセスはまだ承認されていません。しばらくしてからログインしてください。",
 "Seu código": "あなたのコード",
 "Seu código de amigo": "あなたの友だちコード",
 "Seu código para amigos ganharem 10 dias com todas as abas": "友だちがすべてのタブを10日間使えるあなたのコード",
 "Seu nome": "お名前",
 "Seu papel: {p}": "あなたの役割: {p}",
 "Seu papel: {p}. {d}": "あなたの役割: {p}。{d}",
 "Seu scanner de bolso": "ポケットにスキャナーを",
 "Seus dados continuam salvos na nuvem.": "データはクラウドに保存されたままです。",
 "Seus dados na nuvem do My Planner": "My Planner のクラウド上のあなたのデータ",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "あなたのデータはあなたのものです。販売も広告への利用もしません。いつでもすべてをエクスポートまたは削除できます。",
 "Seus {n} meses grátis terminaram": "{n} か月の無料期間が終了しました",
 "Sexta": "金曜日",
 "Sextou": "花金",
 "Sextou!": "花金だ！",
 "Shampoo": "シャンプー",
 "Show ou passeio": "ショー・ツアー",
 "Silenciar avisos": "通知をオフ",
 "Sim": "はい",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "{data}に同期",
 "Sincronizando pelo dispositivo {nome}": "端末 {nome} で同期中",
 "Sincronizando...": "同期中...",
 "Sincronizar agora": "今すぐ同期",
 "Sincronização parada: confirme sua senha. Nada se perde.": "同期が停止中です: パスワードを確認してください。データは失われません。",
 "Site da assistência": "修理窓口のサイト",
 "Site da assistência (https://...)": "修理窓口のサイト（https://...）",
 "Site ou ingresso online": "サイト・オンラインチケット",
 "Situação": "ステータス",
 "Situação agora": "現在の状況",
 "Skincare da manhã": "朝のスキンケア",
 "Skincare da noite": "夜のスキンケア",
 "Slides": "スライド",
 "Smileys e pessoas": "スマイリーと人",
 "Sobremesa": "デザート",
 "Sobrou no mês": "今月の残り",
 "Sociologia": "社会学",
 "Sofá": "ソファ",
 "Sol": "太陽",
 "Sol pleno": "日なた",
 "Solo ou substrato": "土または用土",
 "Solte numa matéria para mover a página para lá:": "科目の上で離すとページをそこへ移動します：",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "法定保証とメーカー保証を合算します。保証書で確認してください。15日前と3日前にお知らせします。",
 "Sombra": "日陰",
 "Somente esta tarefa": "このタスクのみ",
 "Sono": "睡眠",
 "Sono da noite": "昨夜の睡眠",
 "Sopa": "スープ",
 "Sou MEI": "MEI です",
 "Status": "ステータス",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "クラウドとの接続の有効期限が切れました（アプリを長期間開かなかった場合や、別の端末でパスワードが変更された場合に起こります）。データは失われません: 確認するとすぐに、ここにある内容が送信されます。",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "チームをひとつの場所に：チャット、書類、録画できるビデオ会議、リンクでの招待。",
 "Sua rotina em um só lugar": "毎日の予定をひとつの場所に",
 "Sua senha": "あなたのパスワード",
 "Suas abas": "あなたのタブ",
 "Substituir": "置き換える",
 "Substrato usado": "使った用土",
 "Subtarefa {n}": "サブタスク {n}",
 "Suco": "ジュース",
 "Sugerir nome": "名前を提案",
 "Sugestão": "提案",
 "Sugestões de {categoria}": "{categoria}のおすすめ",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase：処理者として、アカウントと同期データを保存します。サーバーはブラジル国外にある場合があり、LGPD art. 33の保護措置が適用されます。",
 "Superiores": "上級裁判所",
 "Supino reto": "ベンチプレス",
 "Suplemento": "サプリメント",
 "Suspense": "サスペンス",
 "Suíte": "主寝室（バス付き）",
 "Sábado": "土曜日",
 "São Paulo": "サンパウロ",
 "São Paulo (SP)": "サンパウロ（SP）",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "60 ファイルを超えます。\"N ページごと\" を使ってください。",
 "Série": "ドラマ",
 "Série da DPS": "DPS のシリーズ",
 "Série e turma": "学年とクラス",
 "Séries": "セット",
 "Sérum": "美容液",
 "Símbolos": "記号",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "オフィスのチームだけが見られます。1ファイル 50 MB まで。",
 "Só acompanha": "閲覧のみ",
 "Só acompanha, sem valores": "閲覧のみ（金額なし）",
 "Só administradores": "管理者のみ",
 "Só em {data}": "{data} のみ",
 "Só leitura": "閲覧のみ",
 "Só mandar para a aba Estudos (sem escolher página)": "勉強タブに送るだけ（ページを選ばない）",
 "Só neste dispositivo": "この端末のみ",
 "Só neste dispositivo: {n}": "この端末のみ：{n}",
 "Só o código": "コードのみ",
 "Só o dia {data}": "{data} の日のみ",
 "Só os dados (texto)": "データのみ（テキスト）",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "あなたのAIに送られるのはファイナンスの合計だけです。投資の推奨ではありません。",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "あなた専用：研究、指導法、各授業でうまくいったこと・いかなかったこと。生徒には表示されません。",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "カレンダーと同期できるのは1台のスマートフォンだけです。この端末に切り替えるには、下をタップしてください。",
 "Só uma vez": "1 回のみ",
 "Só uma vez (abrir a ficha da tarefa)": "1回だけ（タスクカードを開く）",
 "Só áudio": "音声のみ",
 "Sótão": "屋根裏",
 "TAREFAS DA CASA": "家事",
 "TELEFONE (OPCIONAL)": "電話番号（任意）",
 "TRAZER PARA O MY PLANNER": "MY PLANNER に取り込む",
 "TV por assinatura": "有料テレビ",
 "Tabela": "表",
 "Talvez": "未定",
 "Tamanho": "サイズ",
 "Tamanho da foto": "写真のサイズ",
 "Tamanho da página": "ページサイズ",
 "Tamanho das páginas": "ページのサイズ",
 "Tamanho do arquivo": "ファイルサイズ",
 "Tamanho do copo": "コップのサイズ",
 "Também procurar nos Diários Oficiais dos municípios": "市町村の官報も検索する",
 "Também serão excluídos {n} item(ns) dentro dele.": "中にある{n}件の項目も削除されます。",
 "Tapioca": "タピオカクレープ",
 "Tarefa": "タスク",
 "Tarefa da casa": "家事",
 "Tarefa de casa": "宿題",
 "Tarefa duplicada": "タスクを複製しました",
 "Tarefa ou entrega": "タスクまたは納品物",
 "Tarefa para {nome}": "{nome}のタスク",
 "Tarefas da casa": "家事",
 "Tarefas e itens de todas as abas": "すべてのタブのタスクと項目",
 "Tarefas novas do My Planner vão para: {agenda}": "My Planner の新しいタスクの追加先：{agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "期間を超えて繰り返すタスクは他の日に残ります。選んだ日だけが削除されます。",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "CPF、金額、名前を黒塗りします。完全に消去します。",
 "Tartaruga": "カメ",
 "Taxa de limpeza": "清掃料金",
 "Taxa de limpeza cobrada do hóspede": "ゲストから受け取る清掃料金",
 "Taxas e anúncios": "手数料・掲載費",
 "Te amo": "大好き",
 "Tecnologia": "テクノロジー",
 "Tela cheia": "全画面",
 "Teleconsulta": "オンライン診療",
 "Telefone": "電話",
 "Telefone da assistência": "修理窓口の電話番号",
 "Telefone da empresa": "会社の電話",
 "Telefone da escola": "学校の電話",
 "Telefone da limpeza": "清掃担当の電話番号",
 "Telefone de emergência": "緊急時の電話",
 "Telefone do veterinário": "動物病院の電話",
 "Telhado": "屋根",
 "Tem anexos": "添付ファイル",
 "Tem certeza?": "本当によろしいですか？",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "延滞中の支払いが{n}件、合計{v}あります。カードや当座貸越など、金利の高いものから先に払いましょう。",
 "Tema": "テーマ",
 "Tempo de preparo": "調理時間",
 "Temporada": "シーズン",
 "Temporizador (direita)": "タイマー（右）",
 "Tenta consertar um PDF que não abre direito.": "正しく開かない PDF の修復を試みます。",
 "Tentar de novo": "再試行",
 "Tente uma foto mais nítida, com a página inteira.": "ページ全体が入った、もっと鮮明な写真でお試しください。",
 "Termina às {hora}": "{hora}に終了",
 "Terminar até": "完了期限",
 "Terminei em": "読了日",
 "Terminou": "終了",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "{data} に終了しました。何も削除されていません。購入すればすべて元どおりになります。",
 "Termos de uso": "利用規約",
 "Termos de uso e privacidade": "利用規約とプライバシー",
 "Terror": "ホラー",
 "Terça": "火曜日",
 "Testando...": "テスト中...",
 "Testar alerta (1 minuto)": "通知をテスト（1分）",
 "Testar aviso": "通知をテスト",
 "Teste de alerta do Planner": "Planner の通知テスト",
 "Teste grátis até {data} ({n} dia(s))": "{data} まで無料トライアル（{n} 日）",
 "Teste grátis: {n} dia(s)": "無料トライアル：{n} 日",
 "Teste terminado": "トライアル終了",
 "Teste terminou em {data}": "トライアルは {data} に終了",
 "Teste: aviso feito pelo próprio celular.": "テスト：このスマホ自体が作成した通知です。",
 "Texto": "テキスト",
 "Texto completo": "全文",
 "Texto copiado. Cole onde quiser enviar.": "テキストをコピーしました。送りたい場所に貼り付けてください。",
 "Texto do documento": "書類のテキスト",
 "Texto extra do convite (traje, presentes...)": "招待状の追記（服装、プレゼント…）",
 "Texto livre": "自由テキスト",
 "Texto ou recado": "テキストまたはお知らせ",
 "Texto para PDF": "テキストを PDF に",
 "Texto {data}": "テキスト {data}",
 "Tipo": "種類",
 "Tipo sanguíneo": "血液型",
 "Tira as páginas que você não quer.": "不要なページを削除します。",
 "Tira autor, programas, comandos escondidos e anexos.": "作成者、ソフト情報、隠れたコマンド、添付ファイルを削除します。",
 "Tira comentários, destaques e desenhos de outros programas.": "他のソフトで付けたコメント、ハイライト、描画を削除します。",
 "Tira o texto do PDF (arquivo .txt).": "PDF からテキストを取り出します（.txt ファイル）。",
 "Tiradentes": "チラデンテスの日",
 "Tirar": "削除",
 "Tirar a assinatura": "署名を外す",
 "Tirar a foto": "写真を削除",
 "Tirar a foto agora": "今すぐ写真を撮る",
 "Tirar admin": "管理者を解除",
 "Tirar alarmes do My Planner": "My Planner からアラームを外す",
 "Tirar arquivos anexados": "添付ファイルを削除",
 "Tirar comentários, destaques e links": "コメント、ハイライト、リンクを削除",
 "Tirar da agenda": "予定から外す",
 "Tirar da barra": "バーから外す",
 "Tirar daqui": "ここから削除",
 "Tirar das minhas figurinhas?": "マイスタンプから削除しますか？",
 "Tirar de administrador": "管理者から外す",
 "Tirar do escritório": "オフィスから外す",
 "Tirar dos meus GIFs?": "マイGIFから削除しますか？",
 "Tirar este copo": "このコップを削除",
 "Tirar foto": "写真を撮る",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "支払伝票、レシート、書類を撮影し、ギャラリーから写真や動画を選ぶため。",
 "Tirar o desenho padrão?": "パターンを削除しますか？",
 "Tirar o lixo": "ゴミ出し",
 "Tire a foto e a sua IA preenche a ficha": "写真を撮ると AI がフォームに入力します",
 "Titular (de quem é o documento)": "名義人（書類の持ち主）",
 "Titular: {nome}": "名義人：{nome}",
 "Toalha de praia": "ビーチタオル",
 "Tocar os pés": "つま先に触れる",
 "Toda a agenda": "予定全体",
 "Toda semana": "毎週",
 "Todas": "すべて",
 "Todas (passadas, esta e futuras)": "すべて（過去・この回・今後）",
 "Todas ({n})": "すべて（{n}）",
 "Todas as abas liberadas até {data}.": "すべてのタブが {data} まで使えます。",
 "Todas as capitais. Marque uma ou mais cidades.": "すべての州都。1つ以上の都市を選んでください。",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "PDF ツールが勢ぞろい：結合、分割、整理、署名、スタンプ、黒塗り、ページ番号、フォーム、圧縮、変換、OCR、AI。スマホ、Google Drive、OneDrive に保存できます。",
 "Todas as ferramentas ficam na tela da aba.": "すべてのツールはこのタブの画面にあります。",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "旅行の写真はすべてここにあります。アルバムに追加したものと、旅程・場所・予約の写真です。",
 "Todas as plantas estão regadas.": "すべての植物に水やり済みです。",
 "Todas as páginas, uma embaixo da outra.": "全ページを縦につなげます。",
 "Todo ano": "毎年",
 "Todo dia": "毎日",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "毎日指定した時刻に：その日のタスク数、最初のタスク、エネルギーの合計。",
 "Todo mês": "毎月",
 "Todo mês · dia {d}": "毎月 · {d}日",
 "Todo o histórico": "履歴すべて",
 "Todos": "すべて",
 "Todos ({n})": "すべて（{n}）",
 "Todos do grupo": "グループ全員",
 "Todos do grupo veem": "グループ全員に表示",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "会議の参加者全員に「録画中」の表示が出ます。ファイルはオフィスの書類に保存され、チームに公開するまではあなただけが見られます。",
 "Todos os cuidados": "すべてのお手入れ",
 "Todos os dias": "毎日",
 "Todos os suplementos": "すべてのサプリメント",
 "Todos os treinos": "すべてのトレーニング",
 "Todos os tribunais": "すべての裁判所",
 "Todos presentes": "全員出席",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "全員がグループから退出します。各自が承認済みの内容は予定に残ります。",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "全員が同じデータで作業し、各自の役割に応じて操作できます。変更するには、メンバーで各自の役割をタップしてください。",
 "Tomador": "依頼主",
 "Tomador (quem contratou)": "依頼主（契約した人）",
 "Tomadores": "依頼主",
 "Tomei": "借りた",
 "Toque aqui ou no + para criar uma tarefa": "ここか+をタップしてタスクを作成",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "「アカウントとすべてのデータを削除」をタップして確認します。",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "+ › 新しいクレジットカード をタップし、締め日と期日を入力してください。",
 "Toque em Ajustes e depois em Segurança.": "「設定」から「セキュリティ」をタップします。",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "「接続」をタップし、Apple の画面で My Planner が読み取れる項目をオンにしてください。",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "「接続」をタップし、Health Connect の画面で My Planner にデータの読み取りを許可してください。",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "このカード（とその中身）を見せたくない人をタップしてください。例：サプライズのプレゼント。",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "タブをタップすると開きます。ロック中のタブには購読方法が表示されます。",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "タブをタップして開きます。追加タブはそれぞれ 10 日間無料でお試しいただけます。",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "タブをタップすると開きます。📌 をタップすると、タブを下のバーに表示したり外したりできます。追加タブはそれぞれ10日間無料で試せます。",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "エリアをタップして開きます。ロック中のエリアには契約方法が表示されます。",
 "Toque no desenho para continuar desenhando.": "手描きをタップすると続きを描けます。",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "このグループで共有するものをタップしてください。中身（旅程、写真、予約…）もすべて一緒に共有され、全員が参加できます。",
 "Toque nos PDFs na ordem em que devem ficar.": "並べたい順に PDF をタップしてください。",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "コップをタップして量を変更。+ を長押しすると別のサイズのコップを追加できます。",
 "Toque num feriado para adicioná-lo ao Planner.": "祝日をタップすると Planner に追加できます。",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "取引をタップすると、カテゴリーの変更、IRの領収書として保存、削除ができます。",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "記録をタップするとカテゴリーを変更できます。長押しで削除します。",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "プロフィールをタップすると編集できます。長押しすると削除できます。",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "テキスト、絵、チェックリストをタップして、シートの好きな場所へドラッグします。",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "ページをタップすると切り抜き、回転、フィルター変更ができます。長押ししてドラッグすると順番を変えられます。",
 "Toque numa tarefa para copiar ou mover para hoje.": "タスクをタップすると、今日にコピーまたは移動できます。",
 "Toque onde quer a checklist.": "チェックリストを置く場所をタップしてください。",
 "Toque onde quer escrever.": "書きたい場所をタップしてください。",
 "Toque para abrir": "タップして開く",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "タップしてスマホのアプリで開きます。右にスワイプでリストから外します。",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "タップで開き、長押しで名前を変更します。左にスワイプでアーカイブ、右にスワイプで削除します。",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "タップで開きます。右にスワイプすると一覧から外せます。",
 "Toque para aceitar ou recusar.": "タップして承認または拒否します。",
 "Toque para aceitar, editar ou recusar.": "タップして承認・編集・却下。",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "タップすると今すぐ適用します。アプリを開き直しても自動で反映されます。",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "タップしてダウンロードし、上書きインストールします。データはそのまま残ります。",
 "Toque para conversar": "タップしてトーク",
 "Toque para enviar o emoji animado": "タップしてアニメ絵文字を送信",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "タップで送信。長押しで保存または削除します。",
 "Toque para escolher": "タップして選択",
 "Toque para fechar": "タップして閉じる",
 "Toque para gerar um novo QR Code": "タップして新しいQRコードを生成",
 "Tornar admin": "管理者にする",
 "Tornar administrador": "管理者にする",
 "Tosa": "トリミング",
 "Totais por alimento": "食品別の合計",
 "Total": "合計",
 "Total bruto": "総額",
 "Total das reservas: {v}": "予約の合計：{v}",
 "Total de aulas": "授業の総数",
 "Total de capítulos": "総章数",
 "Total de módulos": "総モジュール数",
 "Total de páginas": "総ページ数",
 "Total de recibos: {v}": "領収書の合計：{v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "合計：{n}。各タブのテキストは最大{lim}までです（写真やファイルは含まれません。端末またはあなたの Drive に保存されます）。",
 "Total: {v}": "合計：{v}",
 "Trabalhando...": "処理中...",
 "Trabalho": "労働裁判所",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Google カレンダーの予定を My Planner に取り込んで、ここで編集できます。変更はカレンダーにも反映されます。",
 "Trans": "トランスジェンダー",
 "Transferir: {s}": "手続き：{s}",
 "Transferência": "手続き",
 "Transferências": "手続き",
 "Transporte": "交通",
 "Tratamento": "治療",
 "Travar depois de preencher": "記入後にロック",
 "Trazer todas para hoje": "すべて今日に移動",
 "Trazer tudo para hoje?": "すべて今日に移動しますか？",
 "Trecho ou ideia": "抜粋やアイデア",
 "Treino": "トレーニング",
 "Trem ou ônibus": "電車またはバス",
 "Treme": "ぷるぷる",
 "Tribunais": "裁判所",
 "Trilha": "ハイキング",
 "Triste": "悲しい",
 "Triângulo": "三角形",
 "Troca de óleo": "オイル交換",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "オイル交換、タイヤローテーション、距離ごとの点検、IPVA、ライセンス更新、保険。",
 "Trocador portátil": "携帯用おむつ替えシート",
 "Trocar": "変更",
 "Trocar a categoria": "カテゴリーを変更",
 "Trocar a foto": "写真を変更",
 "Trocar a pasta": "フォルダーを変更",
 "Trocar a senha do cofre": "金庫のパスワードを変更",
 "Trocar número": "番号を変更",
 "Trocar o certificado": "証明書を変更",
 "Trocar o código": "コードを変更",
 "Trocar o código?": "コードを変更しますか？",
 "Trocar o desenho": "パターンを変更",
 "Trocar o emoji": "絵文字を変更",
 "Trocar o modelo": "モデルを変更",
 "Trocar o número": "番号を変更",
 "Trocar o número do celular": "携帯番号を変更",
 "Trocar por:": "変更先：",
 "Trocar roupa de cama e toalhas": "シーツとタオルを交換",
 "Tríceps na polia": "トライセプスプレスダウン",
 "Tubo de ensaio": "試験管",
 "Tudo": "すべて",
 "Tudo certo": "問題なし",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "ここはすべて順調です。日々の支出を記録すれば、お金の行き先が私にも見えるようになります。",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "すべてアカウントに保存済みです。ファイルは好きな場所に保管できる追加のコピーです。",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "\"{nome}\" 内のすべてがグループに表示されるようになります。各自の表示内容はあなたが選ぶ役割に応じて決まります（新しく参加した人は最も制限された役割から始まります）。",
 "Tudo! Já comprei os ingressos.": "バッチリ！チケットはもう買ったよ。",
 "Turma": "クラス",
 "Turma (opcional)": "クラス（任意）",
 "Turmas": "クラス",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "クラスとグループ（授業、メンタリング、トレーニング）：生徒、出欠、成績、計画、教材、請求、あなたのノート。",
 "Turmas, alunos, chamada, notas e planos de aula.": "クラス、生徒、出欠、成績、授業計画。",
 "Turmas, pacientes, equipes e convidados": "クラス、患者、チーム、ゲスト",
 "Técnico": "技術書",
 "Título": "タイトル",
 "Título (ex.: Capítulo 3)": "タイトル（例：第3章）",
 "Título (opcional)": "タイトル（任意）",
 "Título da caixa": "ボックスのタイトル",
 "Título de eleitor": "選挙人証",
 "Título, autor, assunto e palavras-chave.": "タイトル、作成者、件名、キーワード。",
 "Tô chegando": "今向かってます",
 "Tônico": "化粧水",
 "UF": "UF",
 "Uau": "すごい",
 "Uhuul!": "やったー！",
 "Um PDF novo só com as páginas escolhidas.": "選んだページだけの新しい PDF。",
 "Um texto clarinho na diagonal de todas as páginas.": "全ページに斜めの薄い文字を入れます。",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "クライアントごとに 1 つのフォルダ: 書類を双方向でやり取りでき、各クライアントは自分のフォルダだけを見られます。",
 "Uma página por arquivo": "1 ページずつ別ファイル",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "1 ページずつ、N ページごと、または範囲ごとに分けます。",
 "Unicórnio": "ユニコーン",
 "Unidade": "単位",
 "Universal": "培養土",
 "União": "連帯",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "スマートフォンにある Google アカウントを使用します。My Planner が Google のパスワードを求めることはありません。",
 "Usado: {u} · livre: {v} · limite {l}": "利用：{u} · 空き：{v} · 上限 {l}",
 "Usar": "使用",
 "Usar \"{nome}\"": "「{nome}」を使う",
 "Usar biometria": "生体認証を使う",
 "Usar desenho padrão": "パターンを使う",
 "Usar este celular": "このスマートフォンを使用",
 "Usar este nome": "この名前を使う",
 "Usar modelo: {m}": "テンプレートを使う：{m}",
 "Usar no navegador (My Planner Web)": "ブラウザで使う（My Planner Web）",
 "Usar o arquivo já anexado ({nome})": "添付済みのファイルを使う（{nome}）",
 "Usar o código": "コードを使う",
 "Usar senha": "パスワードを使う",
 "Usar {ia}": "{ia} を使う",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "次回ログイン時から、ここでも My Planner Web でも新しいパスワードを使ってください。",
 "Use a senha para desbloquear.": "パスワードでロック解除してください。",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "ご自分の AI で公告・書類・メモを読み取り、予定を提案します。Planner に追加する前に必ずあなたが確認します。",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "アカウント作成時にこのコードを入力すると、すべてのタブが 10 日間使えます。",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "銀行のアプリやサイトからダウンロードした OFX（おすすめ）または CSV の明細を使ってください。",
 "Use o seu planner no computador, sincronizado com o celular.": "スマートフォンと同期して、パソコンでもプランナーを使えます。",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Google Drive、Google Docs、OneDrive、SharePointのhttpsリンクを使ってください。",
 "Uso": "使い方",
 "Uso próprio": "自己使用",
 "VRBO": "VRBO",
 "Vacina": "ワクチン",
 "Vacina {nome}: {pet}": "{nome}ワクチン：{pet}",
 "Vacina: {nome}": "ワクチン：{nome}",
 "Vacinas": "ワクチン",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "ペットのワクチンと薬、ペットショップ、子どもの学校と健康の予定。",
 "Vai na viagem": "旅行に参加",
 "Vale até {d}": "有効期限 {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "「勉強」と「書類」に適用されます。クラウドに保存すると、どの端末からでも、また My Planner Web でもファイルを開けます（1 ファイル 15 MB まで）。",
 "Vale quantos pontos": "配点",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "あなたにだけ適用されます。同じ人が複数追加しても、通知は1人につき3分に最大1回です。",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "アカウント作成後30日以内に1回だけ使えます。",
 "Validade": "有効期限",
 "Validade do certificado A1": "A1 証明書の有効期限",
 "Validade: {data}": "有効期限：{data}",
 "Valor": "金額",
 "Valor ({m})": "金額（{m}）",
 "Valor a pagar": "支払額",
 "Valor combinado": "取り決めた金額",
 "Valor combinado por atendimento": "1回あたりの取り決め金額",
 "Valor da hora": "時給",
 "Valor da parcela (1ª)": "1回目の支払額",
 "Valor da venda": "売却額",
 "Valor de costume": "通常の金額",
 "Valor do atendimento: {v}{pago}.": "診療費：{v}{pago}。",
 "Valor emprestado ou financiado": "借入額・融資額",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "最終価格は Google Play または App Store が決定し、お住まいの国の通貨で表示されます。",
 "Valor maior que o guardado nesta meta.": "この目標に貯めた額を超えています。",
 "Valor padrão da consulta ou sessão": "診察・セッションの標準料金",
 "Valor pago": "支払額",
 "Valor pago (com multa ou desconto)": "支払額（延滞金・割引込み）",
 "Valor pago (opcional)": "支払額（任意）",
 "Valor pago: {v}": "支払額：{v}",
 "Valor que este aluno paga (se for diferente)": "この生徒の支払額（異なる場合）",
 "Valor recebido": "受取額",
 "Valor recebido: {v}": "受取額：{v}",
 "Valor total da compra": "購入の合計金額",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "金額と診療データは、役割で許可された人にだけ表示されます。いつでもオフにできます。データはあなたの手元に残ります。",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "税理士と確認するための金額です。控除のルールは毎年変わります。",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "My Planner でトークしませんか？コード {codigo} で友だちに追加してください（メッセージタブ > 友だち）。",
 "Vaso": "鉢",
 "Veja os planos em Ajustes › Compras.": "プランは 設定 › 購入 でご確認ください。",
 "Vem da aba Empréstimos & Financiamentos": "「ローン・融資」タブから",
 "Vence em {data}.": "{data} に期限切れになります。",
 "Vence em {fim} (data informada na publicação).": "期限は {fim}（公告に記載の日付）。",
 "Vence em {n} dia(s)": "あと{n}日で期限切れ",
 "Vence hoje": "今日が期限",
 "Vence {data}": "期日 {data}",
 "Vencendo": "期限間近",
 "Venceu há {n} dia(s)": "{n}日前に期限切れ",
 "Vencidas": "期限切れ",
 "Vencidos": "期限切れ",
 "Vencimento": "期日",
 "Vencimento (guias e boletos)": "支払期限（納付書・ボレート）",
 "Vencimento da 1ª parcela": "1回目の支払期日",
 "Vencimentos": "期限",
 "Venda": "売上",
 "Venda/serviço do MEI": "MEI の売上・サービス",
 "Vendidos": "売却済み",
 "Ver": "見る",
 "Ver a lista de membros": "メンバー一覧を見る",
 "Ver a rota": "ルートを見る",
 "Ver arquivos": "ファイルを見る",
 "Ver detalhes do erro": "エラーの詳細を見る",
 "Ver e editar": "表示と編集",
 "Ver em Compras": "購入で見る",
 "Ver mais": "もっと見る",
 "Ver mais páginas": "さらにページを表示",
 "Ver no My Planner": "My Planner で見る",
 "Ver o dia": "その日を表示",
 "Ver os feriados do ano": "1年間の祝日を見る",
 "Ver participantes": "参加者を見る",
 "Ver páginas": "ページを見る",
 "Ver todos": "すべて表示",
 "Ver todos ({n})": "すべて表示 ({n})",
 "Ver {nome}": "{nome} を表示",
 "Verificar agora": "今すぐ確認",
 "Vermífugo": "駆虫薬",
 "Vermífugo ou remédio": "駆虫薬または薬",
 "Vermífugos e remédios": "駆虫薬と薬",
 "Verso": "裏面",
 "Verso do documento": "書類の裏面",
 "Versão do PDF": "PDF バージョン",
 "Versão instalada": "インストール済みのバージョン",
 "Versão {versao} disponível": "バージョン{versao}が利用可能",
 "Versão {v}": "バージョン {v}",
 "Veterinário": "獣医",
 "Veterinário ou clínica": "獣医または動物病院",
 "Veículo": "車両",
 "Veículo e acessórios": "車両とアクセサリー",
 "Veículos": "車両",
 "Veículos & Manutenção": "車両＆整備",
 "Vi mais um episódio": "1話見た",
 "Viagem": "旅行",
 "Viagens": "旅行",
 "Viagens & Lazer": "旅行＆レジャー",
 "Viagens e lugares": "旅行と場所",
 "Vida noturna": "ナイトライフ",
 "Vidros e esquadrias": "ガラスとサッシ",
 "Vigente": "有効",
 "Vigentes": "有効",
 "Virar": "切替",
 "Virar a câmera": "カメラを切り替え",
 "Virar tarefa (levar à assistência)": "タスクにする（修理に出す）",
 "Visita domiciliar": "訪問診療",
 "Visitados": "訪問済み",
 "Visto": "視聴済み",
 "Vistoria": "立ち会い検査",
 "Vistoria: {i}": "立ち会い検査：{i}",
 "Vistorias": "立ち会い検査",
 "Visualizar feriados": "祝日を表示",
 "Vitamina": "ビタミン",
 "Vitamina D": "ビタミンD",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "ビタミン、ホエイ、クレアチン...それぞれの頻度を設定。今日の分は「今日」に表示され、チェックできます。",
 "Você": "あなた",
 "Você aceitou os termos em {data}.": "{data} に規約に同意しました。",
 "Você ainda não tem amigos no app. Adicione pelo código.": "アプリにはまだ友だちがいません。コードで追加しましょう。",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "まだバインダーがありません。勉強タブで作成してください。",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "チャット、書類、会議が見られなくなります。",
 "Você deve: {v}": "あなたの支払分：{v}",
 "Você entrou no grupo": "グループに参加しました",
 "Você entrou no grupo \"{nome}\".": "グループ「{nome}」に参加しました。",
 "Você está convidado(a) para: {evento}": "{evento}にご招待します",
 "Você foi convidado para o My Planner": "My Planner に招待されました",
 "Você foi convidado para o grupo": "グループに招待されました",
 "Você juntou {v} para \"{m}\".": "「{m}」のために{v}貯めました。",
 "Você já tem todas as abas.": "すべてのタブをお持ちです。",
 "Você já usou um código de indicação nesta conta.": "このアカウントではすでに紹介コードを使用しています。",
 "Você ligou": "発信しました",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "アカウントはいつでも、スマホのアプリまたはウェブサイトから削除できます：",
 "Você não tem permissão para isso neste grupo.": "このグループではその操作の権限がありません。",
 "Você não vê os outros membros deste grupo.": "このグループの他のメンバーは表示されません。",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "アカウントは 設定 > セキュリティ からいつでも削除できます。クラウドと端末のデータが完全に削除されます。",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "あなたは次のことができます：データ取り扱いの有無の確認、アクセス、訂正、データポータビリティの請求（設定 > 一般設定 でファイルをエクスポート）、削除の請求、共有先の確認、同意の撤回、ANPD への申し立て。",
 "Você recebe (líquido)": "受取額（手取り）",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "パスワードとアカウントで行われることについては、あなたが責任を負います。登録には正しい情報を使ってください。",
 "Volta": "帰り",
 "Volta ou check-out": "帰りまたはチェックアウト",
 "Volta às {hora}": "{hora}に再開",
 "Voltar": "戻る",
 "Voltar ao cardápio da semana neste dia": "この日を週の献立に戻す",
 "Voltar ao cálculo": "計算に戻る",
 "Voltar ao foco": "集中に戻る",
 "Voltar ao padrão": "初期設定に戻す",
 "Voltar ao planejado": "予定に戻す",
 "Voltar para Anotações": "メモに戻る",
 "Voltar para as cores do My Planner": "My Planner の色に戻す",
 "Voltar para novas": "新着に戻る",
 "Voltar para o QR Code": "QRコードに戻る",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "スマホの My Planner アプリに戻ってください。「設定」画面は自動で更新されます。",
 "Voo": "フライト",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "フライト、ホテル、車、観光を番号と証明書つきで1か所にまとめます。",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "設定で「ブラウザを接続」をタップしてください。",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "設定 › 一般設定 で「ブラウザを接続」をタップしてください。",
 "Várias páginas por folha": "1 枚に複数ページ",
 "Vários PDFs num só, na ordem que você escolher.": "複数の PDF を好きな順番で 1 つにまとめます。",
 "Vê as aulas e os materiais liberados.": "公開された授業と教材を閲覧します。",
 "Vê as etapas e registra o diário.": "工程を閲覧し、日誌に記録します。",
 "Vê e altera tudo, inclusive os valores.": "金額を含め、すべてを閲覧・編集します。",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "自分のフォルダの書類を閲覧・送信し、依頼に回答します。",
 "Vê o andamento, sem os valores e sem alterar.": "進捗を閲覧します。金額は表示されず、編集もできません。",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "チェックイン・チェックアウトを確認し、清掃完了を記録します。金額は表示されません。",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "すべてを閲覧し、費用、スポット、旅程、持ち物を記録します。",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "すべて閲覧し、追加、編集、コメント、写真の投稿ができます。グループへのメンバーの追加・削除だけはできません。",
 "Vê tudo, inclusive os valores, sem alterar.": "金額を含めすべてを閲覧します。編集はできません。",
 "Vídeo": "動画",
 "Vínculo": "リンク",
 "Vínculo perdido": "リンク切れ",
 "WhatsApp da assistência": "サポートの WhatsApp",
 "Whey": "ホエイプロテイン",
 "Wi-Fi (rede e senha)": "Wi-Fi（ネットワーク名とパスワード）",
 "Yoga": "ヨガ",
 "Zumbi e Consciência Negra": "ズンビと黒人意識の日",
 "Zzz": "Zzz",
 "a cada {n} dias": "{n}日ごと",
 "a pagar": "支払予定",
 "a receber": "受取予定",
 "a receber {v}": "受取予定 {v}",
 "a reserva": "予約",
 "a última execução falhou; avise o suporte": "前回の実行に失敗しました。サポートにご連絡ください",
 "abr": "4月",
 "abril": "4月",
 "acabou": "在庫切れ",
 "achatado": "フラット化",
 "administra": "管理者",
 "ago": "8月",
 "agosto": "8月",
 "ajustado": "調整済み",
 "algo novo": "新しい項目",
 "alterou": "が変更しました",
 "amanhã": "明日",
 "anual": "毎年",
 "apagou": "が削除しました",
 "aplicada em {d}": "{d}に接種",
 "app {v} · atualização {p} de {data}": "アプリ {v} · アップデート {p}（{data}）",
 "assinado": "署名済み",
 "atrasada": "期限切れ",
 "atrasada há {n} dia(s)": "{n}日遅れ",
 "até": "〜",
 "até {data}": "{data}まで",
 "até {d}": "{d}まで",
 "aula {a} de {n}": "{n} 回中 {a} 回目",
 "avisos silenciados": "通知オフ",
 "caixa": "ボックス",
 "colher(es)": "さじ",
 "coluna": "列",
 "com anexos": "添付付き",
 "com imagem": "画像付き",
 "com tarjas": "黒塗り済み",
 "com texto": "テキスト付き",
 "com {p}": "{p}が所持",
 "como planejado": "予定どおり",
 "comprado em {data}": "{data}購入",
 "comprado em {d} por {v}": "{d}に{v}で購入",
 "comprimido": "圧縮済み",
 "comprovante": "証明書類",
 "concha(s)": "お玉",
 "confirmados": "出席予定",
 "consulta recusada": "照会が拒否されました",
 "contratado": "契約済み",
 "contínuo": "継続",
 "copo(s)": "杯",
 "corridos": "暦日",
 "criou o grupo": "グループを作成しました",
 "de": "/",
 "de Anotações": "メモから",
 "de {meta} passos": "目標 {meta} 歩",
 "de {n}": "/ {n}",
 "de {p}": "{p}から",
 "dentro / fora do planejado": "予定どおり / 予定外",
 "desconto {v}": "割引 {v}",
 "desfazer": "元に戻す",
 "destino": "目的地",
 "deve {v}": "支払分 {v}",
 "devolvido em {d}": "{d}に返却",
 "dez": "12月",
 "dezembro": "12月",
 "dia": "日",
 "dias": "日",
 "dias com a meta batida": "目標達成日数",
 "dias com a meta de passos": "歩数目標の達成日数",
 "digital": "指紋",
 "diária média": "平均1泊料金",
 "do cliente": "クライアントから",
 "do escritório": "事務所から",
 "dom": "日",
 "domingo": "日曜日",
 "e mais {n}": "ほか {n} 件",
 "em aberto": "未決済",
 "em atraso": "延滞",
 "em {n} dias": "{n}日後",
 "emitida": "発行済み",
 "entregue": "提出済み",
 "entrou no escritório": "がオフィスに参加しました",
 "enviado": "送信済み",
 "escaneado": "スキャン風",
 "escolha": "選択",
 "este": "この端末",
 "este dispositivo": "この端末",
 "este item": "この項目",
 "exercícios concluídos": "完了した種目",
 "falta {v}": "残り {v}",
 "faltam {km}": "残り{km}",
 "fatia(s)": "枚",
 "faturamento": "売上",
 "feita em {d}": "{d}に実施",
 "feito {dur}": "{dur}達成",
 "fev": "2月",
 "fevereiro": "2月",
 "frequência {p}%": "出席率 {p}%",
 "gasto {v}": "支出 {v}",
 "girado": "回転済み",
 "guardado": "保存済み",
 "higienizado": "クリーン",
 "hoje": "今日",
 "hora fixa no dia": "当日の固定時刻",
 "há {n} dias": "{n}日前",
 "iPhone ou computador: {link}": "iPhone またはパソコン：{link}",
 "incluiu": "が追加しました",
 "jan": "1月",
 "janeiro": "1月",
 "jul": "7月",
 "julho": "7月",
 "jun": "6月",
 "junho": "6月",
 "já importado": "取り込み済み",
 "liberar em {d}": "{d}に公開",
 "ligou o compartilhamento": "が共有をオンにしました",
 "linha": "行",
 "lucro líquido": "純利益",
 "mai": "5月",
 "maio": "5月",
 "mar": "3月",
 "marca d'água": "透かし",
 "marcada por {nome}": "{nome} が予定",
 "março": "3月",
 "menos de 1 ano": "1年未満",
 "mensalidade": "月謝",
 "meta batida!": "目標達成！",
 "metadados": "メタデータ",
 "min": "分",
 "min antes": "分前",
 "min antes do início": "分（開始前）",
 "min · {de} às {ate}": "分 · {de}〜{ate}",
 "multa e juros {v}": "延滞金・利息 {v}",
 "média {m}": "平均 {m}",
 "mês(es)": "か月",
 "na nuvem": "クラウド",
 "na pasta \"{pasta}\"": "\"{pasta}\" フォルダー",
 "na pasta escolhida": "選んだフォルダ",
 "neste dispositivo": "このデバイス",
 "neste celular": "このスマホ",
 "no Planner": "Planner に登録済み",
 "no {nome}": "{nome}",
 "nos próximos dias": "近日中",
 "nov": "11月",
 "novembro": "11月",
 "numerado": "番号付き",
 "nunca verificado": "未確認",
 "não vão": "欠席",
 "o documento mudou depois disso: guarde de novo": "その後書類が変更されました：もう一度保存してください",
 "ocupação": "稼働率",
 "ontem": "昨日",
 "organizado": "整理済み",
 "orçando": "見積中",
 "out": "10月",
 "outubro": "10月",
 "paga": "支払い済み",
 "paga em {d}": "{d}に支払い済み",
 "pago": "支払い済み",
 "pago em {d}": "{d}に支払い済み",
 "pago por {p}": "{p}が支払い",
 "pagou {v}": "{v}支払い済み",
 "parcela {a} de {n}": "{n}回中{a}回目",
 "parece já lançado": "記録済みの可能性",
 "parte {n}": "パート {n}",
 "passos por dia (média)": "1日の平均歩数",
 "passou {km}": "{km}超過",
 "pausa {p}": "休憩 {p}",
 "pausado": "一時停止中",
 "peso {n}": "重み {n}",
 "pesquisável": "検索可能",
 "por dia": "1日あたり",
 "por dia (média)": "1日平均",
 "por dia disponível": "利用可能日あたり",
 "por semana": "1週間あたり",
 "por {p}": "{p} が追加",
 "porção(ões)": "人前",
 "preenchido": "記入済み",
 "primeira às {hora}: {tarefa}": "最初は{hora}：{tarefa}",
 "produção": "本番",
 "próxima em {data}": "次回 {data}",
 "próxima rega {d}": "次の水やり {d}",
 "publicação": "公告",
 "página de estudo": "学習ページ",
 "página única": "単一ページ",
 "páginas": "ページ",
 "páginas {p}": "ページ {p}",
 "qua": "水",
 "quarta": "水曜",
 "quarta-feira": "水曜日",
 "qui": "木",
 "quinta": "木曜",
 "quinta-feira": "木曜日",
 "quitada": "完済",
 "recebe {v}": "受取 {v}",
 "recebida": "受領",
 "reconhecimento facial": "顔認証",
 "recortado": "トリミング済み",
 "refeições feitas": "食べた食事",
 "rega a cada {n} dias": "{n}日ごとに水やり",
 "regar hoje": "今日水やり",
 "reparado": "修復済み",
 "retorno {d}": "再診 {d}",
 "saldo {v}": "残高 {v}",
 "seg": "月",
 "segunda": "月曜",
 "segunda-feira": "月曜日",
 "sem anotações": "注釈なし",
 "sem as páginas {p}": "ページ {p} を除く",
 "sem cliente": "クライアントなし",
 "sem dias previstos": "予定日なし",
 "sem horário": "時刻なし",
 "sem meta": "目標なし",
 "sem resposta": "未回答",
 "sem tempo": "時間なし",
 "semana(s)": "週間",
 "set": "9月",
 "setembro": "9月",
 "seu@email.com": "you@email.com",
 "sex": "金",
 "sexta": "金曜",
 "sexta-feira": "金曜日",
 "sáb": "土",
 "sábado": "土曜日",
 "talvez": "未定",
 "tarefa da casa": "家事タスク",
 "tarefa: {t}": "タスク：{t}",
 "taxas e despesas": "手数料と経費",
 "ter": "火",
 "termina em {d}": "{d}に終了",
 "terça": "火曜",
 "terça-feira": "火曜日",
 "teste": "テスト",
 "todas": "すべて",
 "todo ano em {d}": "毎年 {d}",
 "todo dia {d}": "毎月 {d}日",
 "todos": "全員",
 "toque para abrir": "タップして開く",
 "toque para pausar": "タップして一時停止",
 "toque para ver o contato": "タップして連絡先を表示",
 "toque para voltar a hoje": "タップで今日に戻る",
 "treinos concluídos": "完了したトレーニング",
 "uma vez em {d}": "1回のみ {d}",
 "unidade(s)": "個",
 "vale {n}": "配点 {n}",
 "vence em {n} dias": "あと {n} 日で期限",
 "vence {d}": "期限 {d}",
 "venceu em {data}": "{data}に期限切れ",
 "vencido": "期限切れ",
 "vendido com ganho de {v}": "{v}の利益で売却",
 "vendido com perda de {v}": "{v}の損失で売却",
 "verificado {quando}": "{quando}に確認",
 "você": "あなた",
 "você administra": "あなたが管理者",
 "xícara(s)": "カップ",
 "{aba} bloqueada": "{aba}はロック中",
 "{aba} está bloqueada": "{aba}はロックされています",
 "{aba}, em \"Anotações recebidas\"": "{aba}の「受け取ったメモ」",
 "{a} aula(s) feita(s)": "{a} 回受講済み",
 "{a} de {n} aulas": "{n} 回中 {a} 回",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c}は予算の{p}%に達しました（{g} / {l}）。",
 "{c} confirmados de {n} convidados": "招待客{n}人中{c}人が出席",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c}は今月の予算の{p}%です。月末まであと{dias}日あります。",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c}はすでに先月全体より{v}多くなっています。普段と違う出費がないか確認してください。",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c}はすでに予算を超えています：{g} / {l}。月が変わるまでこの出費は控えましょう。",
 "{c} passou do orçamento: {g} de {l}.": "{c}が予算を超えました：{g} / {l}。",
 "{de} paga {v} para {para}": "{de} → {para}：{v} を支払う",
 "{de} às {ate}": "{de}〜{ate}",
 "{dia}, {d} de {mes} de {a}": "{a}年{mes}{d}日（{dia}）",
 "{dia}, {d} {mes}": "{mes}{d}日（{dia}）",
 "{dia}, {d}/{m}": "{m}/{d}（{dia}）",
 "{dur} na semana": "今週 {dur}",
 "{dur} registrados": "{dur}を記録",
 "{d}/{n} notas": "成績 {d}/{n}",
 "{feito} de {meta}": "{feito} / {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{n}件中{f}件完了",
 "{f}/{n} transferências feitas": "手続き {f}/{n} 件完了",
 "{hora} em {fuso}": "{fuso}の {hora}",
 "{h} este mês": "今月 {h}",
 "{h} h": "{h}時間",
 "{h} h {m} min": "{h}時間{m}分",
 "{h} no seu relógio": "あなたの時刻で{h}",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} に接続しました。アカウントで {n} 個のモデルが利用できます。",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}：API キーが無効か、権限がありません。",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}：利用上限に達しました。API アカウントの残高または上限を確認してください。",
 "{item}: em {n} dias ({data}).": "{item}：{n}日後（{data}）。",
 "{item}: hoje ({data}).": "{item}：今日（{data}）。",
 "{item}: termina em {n} dias ({data}).": "{item}：{n}日後（{data}）に終了します。",
 "{item}: vence em {n} dias ({data}).": "{item}：あと {n} 日で期限です（{data}）。",
 "{item}: vence hoje ({data}).": "{item}：今日が期限です（{data}）。",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}：期限は{data}でしたが、まだ完了になっていません。",
 "{livre} livres de {total}": "{total}中{livre}空き",
 "{m} min": "{m}分",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} さんと友だちになりました。トークできます。",
 "{nome} conectado!": "{nome} に接続しました！",
 "{nome} ligou": "{nome} さんが発信しました",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "新規 {novas}件、更新 {atualizadas}件、送信 {enviadas}件、削除 {removidas}件",
 "{n} ITEM(NS)": "{n}品目",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "プランのタブ {n} 件 · それぞれの色とオプション",
 "{n} aba(s) para comprar": "購入できるタブ {n} 件",
 "{n} adicionada(s)": "{n}人を追加しました",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "今後数日間、この端末で {n} 件の通知を予約済みです。",
 "{n} aluno(s)": "生徒{n}人",
 "{n} anexo(s)": "添付ファイル{n}件",
 "{n} ano(s)": "{n} 年",
 "{n} arquivo(s)": "{n} 件のファイル",
 "{n} atendimento(s)": "{n}件の診療",
 "{n} atrasada(s)": "{n}件期限切れ",
 "{n} atrasado(s)": "期限切れ{n}件",
 "{n} caixa(s)": "箱{n}個",
 "{n} caixa(s) frágil(eis)": "割れ物の箱{n}個",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "箱{n}個 · 新居で開封済み{a}個",
 "{n} cancelada(s).": "{n} 件を取り消しました。",
 "{n} cartão(ões) abertos": "未完了のカード{n}枚",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{d}期限の請求を{n}件作成しました。",
 "{n} com vencimento": "期限あり {n} 件",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "カード{c}で{n}件の購入。今後の分割分は次回以降の請求に表示されます。",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n}件の支払いを自動的に支払い済みにしました。",
 "{n} copo(s), {ml} de {meta}": "{n}杯、{ml} / {meta}",
 "{n} de {meta} copos": "{n} / {meta}杯",
 "{n} de {total}": "{n} / {total}",
 "{n} de {total} dias": "{total} 日中 {n} 日",
 "{n} de {total} hoje": "今日 {n}/{total}",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "ファイナンスで読み取ったレシートのうち、価格のある品目：{t}件中{n}件。",
 "{n} dia(s)": "{n} 日",
 "{n} dia(s) seguido(s) lendo": "{n} 日連続で読書中",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "繰り返しタスクから {n} 日分を削除",
 "{n} dias": "{n}日",
 "{n} dias grátis": "{n} 日間無料",
 "{n} dias grátis para testar": "{n} 日間無料でお試し",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} 日（{tipo}）：{pub} 公告、{ini} から起算、{fim} 満了。",
 "{n} documento(s)": "書類 {n} 件",
 "{n} em atraso": "{n}件延滞",
 "{n} etapa(s) atrasada(s)": "遅れている工程{n}件",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n}件の削除がスマートフォンの同期を待っています。",
 "{n} falta(s)": "欠席{n}回",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "グループ内のカード: {n} 件。メンバーで各自の役割を選んでください。",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "グループ全員による旅行の写真と動画 {n} 件。旅程・場所・予約の写真もここに表示されます。",
 "{n} item(ns) adicionado(s).": "{n}件の品目を追加しました。",
 "{n} item(ns) com outras pessoas": "貸し出し中の品物{n}件",
 "{n} item(ns) no Planner.": "{n} 件を Planner に追加しました。",
 "{n} lançamento(s) encontrado(s)": "{n}件の記録が見つかりました",
 "{n} lançamento(s) novo(s).": "新しい記録 {n}件。",
 "{n} lembrete(s) colocado(s) no My Planner.": "My Planner にリマインダーを{n}件追加しました。",
 "{n} livro(s) lido(s) este ano": "今年読んだ本 {n}冊",
 "{n} marcado(s)": "{n} 件選択",
 "{n} matéria(s)": "{n}科目",
 "{n} membro(s) · abrir a conversa do grupo": "メンバー {n} 人 · グループトークを開く",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "アカウント作成から {n} か月無料、その後は年 {preco}。",
 "{n} min": "{n}分",
 "{n} min antes": "{n} 分前",
 "{n} módulo(s)": "{n} モジュール",
 "{n} noite(s)": "{n}泊",
 "{n} nota(s) nova(s).": "新しい請求書 {n} 件。",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "この端末に XML がない請求書 {n} 件は除外されました。",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} 件 · 発行 {e} · 受領 {r}",
 "{n} nova(s)": "新着 {n} 件",
 "{n} novo(s) do cliente": "クライアントからの新着 {n} 件",
 "{n} novo(s) para aceitar, editar ou recusar.": "新着 {n} 件：承認・編集・却下してください。",
 "{n} parcela(s) colocada(s) no My Planner.": "{n}回分を My Planner に追加しました。",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "未払いの{n}回分を再計算しました。支払い済みの回はそのままです。",
 "{n} parcela(s) em atraso": "{n}回分が延滞",
 "{n} parcela(s) em atraso: {v}": "{n}回分が延滞：{v}",
 "{n} participantes · toque para ver": "参加者 {n} 人 · タップして表示",
 "{n} passo(s)": "{n}ステップ",
 "{n} pausa(s)": "休憩{n}回",
 "{n} pedido(s) de amizade": "友だちリクエスト {n} 件",
 "{n} pedido(s) em aberto": "未完了の依頼 {n} 件",
 "{n} pessoa(s)": "{n} 人",
 "{n} pessoa(s) já entraram com o seu código.": "{n} 人があなたのコードで登録しました。",
 "{n} pessoas": "{n} 人",
 "{n} por folha": "1 枚に {n} ページ",
 "{n} porções": "{n}人前",
 "{n} publicação(ões) nova(s).": "新しい公告が{n}件あります。",
 "{n} publicações novas": "新しい公告 {n} 件",
 "{n} página(s)": "{n}ページ",
 "{n} página(s) · {r} revisada(s)": "{n}ページ · {r}ページ復習済み",
 "{n} páginas": "{n} ページ",
 "{n} recebido(s) dos seus grupos": "グループからの受信 {n} 件",
 "{n} recebido(s) para responder": "未回答の受信 {n} 件",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} 食（その日の献立で）",
 "{n} reserva(s) nova(s) ou alterada(s).": "新規または変更された予約：{n}件",
 "{n} resultado(s) em todas as publicações": "すべての公告で {n} 件",
 "{n} selecionado(s): {lista}": "{n} 件選択中：{lista}",
 "{n} tarefa(s)": "{n}件のタスク",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} 件のタスクを完全に削除",
 "{n} tarefa(s) criada(s)": "{n} 件のタスクを作成しました",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n}件の家事が My Planner から外れ、マイホームだけに残っています。Planner に戻すには、タスクを開いて「My Planner に送る」をタップしてください。",
 "{n} tarefa(s) de ontem sem concluir": "昨日の未完了タスク：{n}件",
 "{n} tarefa(s) dos últimos dias sem concluir": "ここ数日の未完了タスク：{n}件",
 "{n} tarefa(s) hoje": "今日のタスク{n}件",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "未完了のタスク{n}件を今日のリストに移動します。",
 "{n} tarjas no documento": "文書内の黒塗り {n} か所",
 "{n} treino(s), cada um nos dias dele": "{n} 件のトレーニング（各曜日に）",
 "{n} tribunais": "{n} 件の裁判所",
 "{n}x de {v}": "{n}回 × {v}",
 "{n}º alerta": "アラート{n}",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} 件アップロード、{falhas} 件エラー。後でもう一度お試しください。",
 "{ok} enviado(s).": "{ok} 件アップロードしました。",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{d}泊中{o}泊が稼働。月をまたぐ予約は泊数で按分されます。",
 "{preco} por ano": "年 {preco}",
 "{p} de {t} parcelas pagas ({pct}%)": "{t}回中{p}回支払い済み（{pct}%）",
 "{p} presentes · {f} faltas": "出席 {p} · 欠席 {f}",
 "{p}% da meta de {m} páginas": "目標 {m} ページの {p}%",
 "{p}% feito": "{p}%完了",
 "{p}% ocupado no mês": "今月の稼働率 {p}%",
 "{p}% pronta": "{p}%完成",
 "{p}/{t} pagas": "{p}/{t}回支払い済み",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} さんが My Planner のグループ「{grupo}」にあなたを招待しました。リンクをタップして参加してください（アプリは無料で始められます）：{link}\n招待コード：{codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} さんたちがグループに {n} 件追加しました。",
 "{quem} incluiu {item} no grupo.": "{quem} さんがグループに「{item}」を追加しました。",
 "{servico} do veículo": "車両の{servico}",
 "{s} de {a}": "{s} / {a}",
 "{tarefa}: volte às {hora}": "{tarefa}：{hora}に戻りましょう",
 "{tipo}: {p}": "{tipo}：{p}",
 "{titulo} (cópia)": "{titulo}（コピー）",
 "{uso} usados de {total} reservados para o site": "サイト用に確保した{total}のうち{uso}使用中",
 "{v} · atualização de {data}": "{v} · {data}のアップデート",
 "{v}/hora": "{v}/時間",
 "À direita": "右",
 "À vista": "一括払い",
 "Às": "時刻",
 "Às {hora}": "{hora} に",
 "ÁGUA": "水分",
 "Ácido": "酸性",
 "Água": "水分",
 "Água hoje": "今日の水分",
 "Área externa": "屋外",
 "Áreas": "エリア",
 "Áudio": "音声",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "これは補助ツールであり、公式チャネルでの送達通知の確認に代わるものではありません。期限は公式システムで確認してください。",
 "Ética Profissional": "職業倫理",
 "Ícone e aba": "アイコンとタブ",
 "Óculos de sol": "サングラス",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "発行機関（例：DETRAN-MS、連邦警察）",
 "Órgão emissor: {nome}": "発行機関：{nome}",
 "Ômega 3": "オメガ3",
 "Última": "最後",
 "Última adubação": "最後の肥料",
 "Última aplicação": "前回の接種",
 "Última busca do servidor para você: {quando}": "サーバーによる最終検索：{quando}",
 "Última cópia de segurança: {data}": "前回のバックアップ：{data}",
 "Última rega": "最後の水やり",
 "Última sincronização: {quando}": "最終同期：{quando}",
 "Última: {data}": "前回：{data}",
 "Último dia para entregar a declaração do IR": "確定申告の最終日",
 "Último erro: {m}": "直近のエラー：{m}",
 "Últimos 30 dias": "過去30日間",
 "Últimos 7 dias": "過去7日間",
 "íris": "虹彩",
 "última vez em {data}": "前回 {data}",
 "último em {d}": "最終：{d}",
 "úteis": "営業日",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ は My Planner の色です。この設定はこの端末とあなたのアカウントのすべてのトークに適用されます。",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} さんから着信（ビデオ）",
 "📆 Conectar a agenda deste celular": "📆 このスマートフォンのカレンダーを接続",
 "📞 {nome} está ligando (áudio)": "📞 {nome} さんから着信（音声）",
 "Link bloqueado por segurança.": "安全のためリンクをブロックしました。",
 "Este arquivo não é uma imagem válida.": "このファイルは有効な画像ではありません。",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "サーバーの自動検索は最初の5つのプロフィールを対象にします。ほかは「今すぐ確認」をタップしたときに確認されます。",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "この画面には、日付が決まっているアクティビティと場所が旅行のタイムラインとして表示されます。場所の詳しい情報を追加・編集するには「場所」タブを使ってください。",
 "Para a viagem {d}": "旅行 {d} 用",
 "sem nome": "名前なし",
 "Foi para a viagem {d}.": "旅行 {d} に移動しました。",
 "Orçamento total (se não for detalhar)": "予算合計（内訳を入れない場合）",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "旅程を1日ずつ組み立てましょう。日付が決まっている場所は自動でここに入ります。旅行期間中は、旅程が My Planner のタイムラインに表示されます。",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "場所に日付と時刻を設定すると、自動で「旅程」に表示されます。",
 "No roteiro": "旅程に追加済み",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "「{nome}」は {data} の旅程に入っています。日付や時刻を変えるには場所を編集してください。",
 "Para o roteiro desta viagem": "この旅行の旅程用",
 "Orçamento e gastos": "予算と支出",
 "Parada (cidade)": "立ち寄り先（都市）",
 "Item da categoria": "カテゴリの項目",
 "Orçamento da viagem inteira": "旅行全体の予算",
 "Orçamento geral da viagem": "旅行の総合予算",
 "Previsto {p} · gasto {g}": "予定 {p}・支出 {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "立ち寄り先に属さない旅行の費用（例：航空券、保険）はここに入ります。立ち寄り先ごとに予算があります。",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "各カテゴリでいくら使う予定かを入力してください。支出を記録すると、使った金額がアプリに表示されます。",
 "Orçamento por parada": "立ち寄り先ごとの予算",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "複数の都市を回りますか？立ち寄り先を登録しましょう（「立ち寄り先」タブ）。それぞれに予算があり、その期間の支出は自動で振り分けられます。",
 "Coloque o valor do gasto.": "支出の金額を入力してください。",
 "Orçamento de {c}": "{c} の予算",
 "Lançar um gasto nesta parada": "この立ち寄り先の支出を記録",
 "Lançar gasto": "支出を記録",
 "Orçamento e gastos da parada": "立ち寄り先の予算と支出",
 "Gastos lançados ({n})": "記録した支出（{n}）",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "支出を修正・削除するには、旅行の「予算と支出」タブを使ってください。",
 "Paradas": "立ち寄り先",
 "Cidade ou lugar": "都市または場所",
 "Ex.: Porto": "例：ポルト",
 "Chegada": "到着",
 "Saída": "出発",
 "Onde vai ficar": "宿泊先",
 "gasto {g} de {p}": "支出 {g} / {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "複数の都市を回りますか？立ち寄り先を日付とともに登録しましょう。それぞれに予算（宿泊、食事、交通など）があり、その期間の支出は自動で振り分けられます。",
 "Café da tarde": "午後のお茶",
 "Outros / Lanches": "その他・軽食",
 "Gasto {v}": "支出 {v}",
 "Gasto {g} de {p} · {a} acima": "支出 {g} / {p}・{a} 超過",
 "Gasto {g} de {p}": "支出 {g} / {p}",
 "Tirar \"{nome}\" do orçamento?": "「{nome}」を予算から外しますか？",
 "Os gastos já lançados nela continuam na lista de gastos.": "すでに記録した支出は支出リストに残ります。",
 "Previsto para {nome}": "{nome} の予定額",
 "Tirar {nome}": "{nome} を外す",
 "Nome do item (ex.: Jantar especial)": "項目名（例：特別なディナー）",
 "Adicionar item": "項目を追加",
 "Detalhar em itens": "項目に分けて入力",
 "Nova categoria (ex.: Seguro, Presentes)": "新しいカテゴリ（例：保険、お土産）",
 "Voltar às categorias sugeridas?": "おすすめのカテゴリに戻しますか？",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "このリストの予定額は消去されます。記録した支出はそのまま残ります。",
 "Voltar às categorias sugeridas": "おすすめのカテゴリに戻す",
 "Previsto": "予定",
 "Ainda pode gastar": "残り使える金額",
 "Passou do previsto": "予定を超過",
 "Não foi possível buscar o câmbio": "為替レートを取得できませんでした",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "インターネットに接続されていないか、{m} が一覧にありません。旅行を編集してレートを手入力してください。",
 "Câmbio de {m} ainda não definido": "{m} の為替レートは未設定です",
 "Câmbio de hoje": "今日のレート",
 "Atualizado em {d}": "{d} に更新",
 "Valor em {m}": "{m} での金額",
 "Moeda do destino": "目的地の通貨",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "為替レート：目的地の通貨1単位があなたの通貨でいくらか",
 "Sem dia marcado": "日付なし",
 "Valor na moeda do destino": "目的地の通貨での金額",
 "Tirar só desta lista ou excluir de vez?": "このリストから外すだけにしますか、それとも完全に削除しますか？",
 "Excluir de vez": "完全に削除",
 "Relatório da viagem (PDF)": "旅行レポート（PDF）",
 "Planilha da viagem (Excel)": "旅行の表（Excel）",
 "Geral da viagem": "旅行全体",
 "Viagem {d}": "旅行 {d}",
 "Quem vai: {p}": "参加者：{p}",
 "Outros gastos": "その他の支出",
 "Orçamento · {n}": "予算 · {n}",
 "Código": "コード",
 "Pagou": "支払った人",
 "Permissão internacional para dirigir": "国際運転免許証",
 "Vacina (certificado)": "ワクチン（証明書）",
 "Autorização de viagem de menor": "未成年者の渡航同意書",
 "Vence antes da volta": "帰国前に期限切れ",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "帰国後6か月未満で期限切れ（多くの国で入国不可）",
 "A lista básica já está aqui.": "基本リストはすでにあります。",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "旅行に支障が出るおそれのある有効期限の書類：{n}件",
 "Lista básica: passaporte de cada um e seguro viagem": "基本リスト：各自のパスポートと旅行保険",
 "Lista básica: identidade de cada um": "基本リスト：各自の身分証明書",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "各書類の有効期限を入力してください。期限切れの前にお知らせし、パスポートが帰国後6か月有効かも確認します。書類の写真は金庫で保護されます。",
 "De quem": "所有者",
 "Número (protegido no cofre)": "番号（金庫で保護）",
 "Está em mãos": "手元にある",
 "Válido até {d}": "{d}まで有効",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "パスポート、ビザ、旅行保険、ワクチン、未成年者の同意書など。有効期限と写真付き。手元に用意できたらチェックしてください。",
 "acerto entre os viajantes (não entra no orçamento)": "旅行者間の精算（予算に含まない）",
 "Só gastos": "支出のみ",
 "Acertos": "精算",
 "Marcar como pago?": "支払い済みにしますか？",
 "{de} já pagou {v} para {para}?": "{de} は {para} に {v} を支払いましたか？",
 "Já pagou": "支払い済み",
 "Acerto: {de} pagou {para}": "精算：{de} が {para} に支払い",
 "Conferir minhas assinaturas": "サブスクリプションを確認",
 "Gerenciar ou cancelar assinaturas na loja": "ストアでサブスクリプションを管理・解約",
 "Restaurar compras": "購入を復元",
 "Procurando...": "検索中...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} 件のサブスクリプションが見つかり、解放されました。",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "年間サブスクリプションで自動更新されます。更新の24時間前までストアのサブスクリプションからいつでも解約できます。",
 "Assinaturas da loja": "ストアのサブスクリプション",
 "Gerenciar assinaturas (App Store)": "サブスクリプションを管理（App Store）",
 "Gerenciar assinaturas (Google Play)": "サブスクリプションを管理（Google Play）",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "サブスクリプションはスマホのアプリ（Google Play または App Store）で行い、このサイトでも有効です。",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "このサブスクリプションはまだストアで利用できません。後でもう一度お試しください。",
 "Assinatura feita": "購読しました",
 "Já assinei no celular: conferir": "スマホで購読済み：確認する",
 "Nenhuma assinatura encontrada nesta conta da loja.": "このストアアカウントにサブスクリプションは見つかりませんでした。",
 "Confira a internet e tente de novo. Nada foi cobrado.": "インターネット接続を確認して再試行してください。請求は発生していません。",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} が解放されました。他の端末やサイトでも有効です。",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "購読するには、Google Play または App Store で My Planner を更新してください。",
 "Assinada, renova em {data}": "購読中、{data} に更新",
 "Não deu para assinar agora": "今は購読できませんでした",
 "Assinar por {preco} por ano": "年額 {preco} で購読",
 "\"{nome}\" foi para o Mural, em Conquistas.": "「{nome}」はボードの「達成」に移動しました。",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "「{nome}」はもう習慣になりました。ボードの「達成」に移動しました。",
 "\"{nome}\" voltou para o lugar.": "「{nome}」を元の場所に戻しました。",
 "1 ano": "1年",
 "1 mês": "1か月",
 "A IA não achou o valor no comprovante.": "AIは領収書から金額を見つけられませんでした。",
 "A cada {n} dias": "{n}日ごと",
 "A carta está vazia": "手紙が空です",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "手紙は{d}までロックされます。それまでは読み返すことも編集することもできません。変更したい場合は、新しい手紙を書いてください。",
 "A lixeira está vazia.": "ゴミ箱は空です。",
 "A mesma do app e do celular": "アプリと端末と同じ",
 "A mesma forma de desbloqueio do app e do celular": "アプリと端末と同じロック解除方法",
 "A senha do diário precisa ter 6 caracteres ou mais.": "日記のパスワードは6文字以上にしてください。",
 "A senha precisa ter 6 caracteres ou mais.": "パスワードは6文字以上にしてください。",
 "A turma ainda não tem grupo": "このクラスにはまだグループがありません",
 "AS 4 BOLINHAS DE COR": "4つの色の丸",
 "Aberta em {d}": "{d}に開封",
 "Abra a aba para poder restaurar": "復元するにはタブを開いてください",
 "Abra o diário primeiro": "先に日記を開いてください",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "生体認証、顔認証、またはアプリのパスワードで開きます。日記のパスワードは各端末で初回のみ求められます。",
 "Abre em {d}": "{d}に開封",
 "Abrir carta para o futuro": "未来への手紙を開く",
 "Abrir em {aba}": "{aba}で開く",
 "Abrir o Diário": "日記を開く",
 "Abrir o diário": "日記を開く",
 "Abrir {aba}": "{aba}を開く",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "物件、予約、稼働率、経費、利益を確認できます。変更はできません。",
 "Adicionar foto": "写真を追加",
 "Apaga tudo o que está no quadro desta página.": "このページのボードに描いたものをすべて消します。",
 "Apagar o desenho?": "絵を消しますか？",
 "Apagar o diário": "日記を削除",
 "Apagar para todos?": "全員に対して削除しますか？",
 "Aplicar a todas as páginas desta matéria": "この科目のすべてのページに適用",
 "Aplicar a todas as páginas desta pasta": "このフォルダーのすべてのページに適用",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "テキスト、問題集、スライド、動画、リンク、お知らせ。⋮ › クラスに送信 で、各生徒のアプリに届きます。",
 "Aquarela": "水彩",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "グループがあなたと共有したものは、ここに無料で表示されます。自分のデータでこのタブを使うには、タブを契約してください。",
 "Arquivados": "アーカイブ済み",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "右にスワイプで削除、左にスワイプでアーカイブ。",
 "As cobranças desta aula extra já existem.": "この補講の請求はすでにあります。",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "成績は各生徒本人にだけ送られます。そのためには、グループ内の名前が登録された生徒または保護者の名前と同じである必要があります。",
 "Atestado": "診断書",
 "Atestados": "診断書",
 "Até quando (opcional)": "終了日（任意）",
 "Até {d}": "{d}まで",
 "Aula extra": "補講",
 "Aula extra (fora dos dias de aula)": "補講（授業日以外）",
 "Aula extra de {d}": "{d}の補講",
 "Avaliação de {d}": "{d}の評価",
 "Avaliação salva": "評価を保存しました",
 "Avançar": "次へ",
 "Aviso da revisão do mês": "月のふりかえりの通知",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "月末日に通知：「今月をふりかえってみませんか？✨」",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "日記の内容を含まない通知：「今日はどんな一日だった？✍️」",
 "Avulsa": "単発",
 "Avulsas": "単発",
 "Azul": "青",
 "Baixar na App Store": "App Store からダウンロード",
 "Baixar na Google Play": "Google Play で手に入れよう",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "ストアで My Planner をダウンロード：Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "生体認証、顔認証、またはアプリのパスワード。日記のパスワードは各端末での初回用に保存されます。",
 "Branco": "白",
 "Buscando o clima…": "天気を取得中…",
 "Básicas": "ベーシック",
 "COMO ESTOU": "今の気分",
 "COMO O DIÁRIO ABRE": "日記の開き方",
 "COR DA FOLHA": "用紙の色",
 "Caixinha no My Planner": "My Planner の貯金箱",
 "Caixinha {m}": "貯金箱 {m}",
 "Carta de {d}": "{d}の手紙",
 "Carta guardada": "手紙を保管しました",
 "Carta para o futuro": "未来への手紙",
 "Carta trancada": "ロック中の手紙",
 "Cartas abertas podem ser lidas, mas não editadas.": "開封済みの手紙は読めますが、編集はできません。",
 "Cartas para o Futuro": "未来への手紙",
 "Cartões arquivados": "アーカイブしたカード",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "{tempo}前の{nome}から手紙が届きました 💌",
 "Chegou! Toque para abrir 💌": "届きました！タップして開く 💌",
 "Cinza-escuro": "ダークグレー",
 "Clara (segue o tema)": "ライト（テーマに合わせる）",
 "Claras e pastel (boas para folha escura)": "明るい色・パステル（暗い用紙向け）",
 "Clima (toque para preencher)": "天気（タップして入力）",
 "Clima automático": "天気を自動入力",
 "Clima do dia": "今日の天気",
 "Cobrar a aula extra": "補講の請求をする",
 "Cobrar a aula extra dos presentes": "出席者に補講の請求をする",
 "Cobrar a turma toda": "クラス全員に請求",
 "Cole um link que comece com https://": "https:// で始まるリンクを貼り付けてください",
 "Coloque o valor da aula extra na turma (Editar).": "クラスの「編集」で補講の金額を入力してください。",
 "Coloque o valor.": "金額を入力してください。",
 "Colunas": "列",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "AI をオンにすると（設定 › 人工知能）、アプリが写真から金額、日付、説明を読み取ります。",
 "Como cuidei de mim hoje?": "今日、自分をどう大切にした？",
 "Como foi o seu dia? ✍️": "今日はどんな一日だった？✍️",
 "Compartilhar este projeto (convidar)": "このプロジェクトを共有（招待）",
 "Compartilhar o texto": "テキストを共有",
 "Completa": "詳細",
 "Comprovante (foto, PDF ou print)": "領収書（写真、PDF、スクリーンショット）",
 "Comprovante anexado": "領収書を添付しました",
 "Comprovante de pagamento (foto ou PDF)": "支払いの領収書（写真または PDF）",
 "Concluído: hábito formado": "完了：習慣が身についた",
 "Concluídos": "完了",
 "Configurar o Diário": "日記の設定",
 "Confirmar pagamento": "支払いを確認",
 "Confirmar recebimento": "受け取りを確認",
 "Conquistas": "達成",
 "Contas arquivadas": "アーカイブした支払い",
 "Continuar escrevendo": "続きを書く",
 "Copiado ✓": "コピーしました ✓",
 "Copiar código": "コードをコピー",
 "Copiar link": "リンクをコピー",
 "Cor atual": "現在の色",
 "Cor {n}": "色 {n}",
 "Creme": "クリーム",
 "Criada em {d}": "{d}に作成",
 "Criar as cobranças": "請求を作成",
 "Criar o grupo da turma": "クラスのグループを作成",
 "Criar o meu diário": "自分の日記を作る",
 "Crie a senha do diário (6 ou mais)": "日記のパスワードを作成（6文字以上）",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "クラスのグループを作って生徒に招待を送りましょう。その後は、生徒に直接送信されます。",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "下の + ボタンで最初の目標、目的、夢を作りましょう。",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "プロジェクトを作り、参加者を招待してステップを分担しましょう。各自が終わったものにチェックします。",
 "Crie uma senha nova para começar.": "始めるには新しいパスワードを作成してください。",
 "Cuidados arquivados": "アーカイブしたお手入れ",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "今日のセルフケア完了（ウェルネス）",
 "Curto prazo": "短期",
 "Custos": "費用",
 "Céu estrelado": "星空",
 "Círculo": "円",
 "Cômodos arquivados": "アーカイブした部屋",
 "DIAS CUMPRIDOS": "達成した日",
 "Data (opcional)": "日付（任意）",
 "De {d}": "{d}から",
 "Desafixar do topo": "上部への固定を解除",
 "Desenho mais fraco ou mais forte": "描画を薄く・濃く",
 "Desfazer \"Concluído\" ({d})": "「完了」を取り消す（{d}）",
 "Desligado": "オフ",
 "Desmarcar": "チェックを外す",
 "Desmarcar como paga?": "支払い済みを取り消しますか？",
 "Desmarcar como recebida?": "受け取り済みを取り消しますか？",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "使わないものはチェックを外すと画面から消え、タブがシンプルになります。あとで 設定 › タブ › {aba} › このタブの項目 で変更できます。",
 "Dias da semana": "曜日",
 "Dias de aula": "授業日",
 "Dias de aula: {d}": "授業日：{d}",
 "Dias escritos": "書いた日",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "ヒント：形を手で描き、線の終わりで指を押したままにするときれいな形になります。",
 "Ditado": "音声入力",
 "Ditar (falar para escrever)": "音声入力（話して書く）",
 "Diário apagado": "日記を削除しました",
 "Diário protegido": "保護された日記",
 "Dom": "日",
 "Dê um nome a ele na pasta Hábitos.": "「習慣」フォルダーで名前を付けてください。",
 "EVOLUÇÃO": "推移",
 "Editada em {d}": "{d}に編集",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "開封は{d}（{n}日後）です。それまでは読み返すことも編集することもできません。",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "開封は{d}です。その日に通知が届きます。",
 "Ela fica guardada com a data de hoje para comparar depois.": "あとで比べられるよう、今日の日付で保存されます。",
 "Enorme": "特大",
 "Enviado ao paciente": "患者に送信済み",
 "Enviado em": "送信日",
 "Enviar \"{t}\" para todos do grupo {g}?": "「{t}」をグループ{g}の全員に送りますか？",
 "Enviar a nota para cada aluno": "各生徒に成績を送る",
 "Enviar as notas": "成績を送る",
 "Enviar o arquivo: {nome}": "ファイルを送る：{nome}",
 "Enviar o recado para a turma": "クラスにお知らせを送る",
 "Enviar o título para outra aba": "タイトルを別のタブに送る",
 "Enviar para a turma": "クラスに送信",
 "Enviar para outra aba": "別のタブに送る",
 "Escolha a cor desta bolinha": "この丸の色を選んでください",
 "Escolha uma data no futuro": "未来の日付を選んでください",
 "Escolher qualquer cor": "好きな色を選ぶ",
 "Esconder a barra": "バーを隠す",
 "Escreva a frase": "フレーズを書く",
 "Escreva a que se refere a cobrança.": "何の請求か書いてください。",
 "Escreva alguma coisa antes de guardar.": "保管する前に何か書いてください。",
 "Escreva alguma coisa antes de salvar.": "保存する前に何か書いてください。",
 "Escreva hoje, abra no futuro": "今日書いて、未来に開く",
 "Escreva o que você quer mudar a partir de hoje": "今日から変えたいことを書く",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "未来の自分へ書きましょう。手紙は開封日までロックされます。",
 "Escrever uma carta": "手紙を書く",
 "Escrita em {e} · abre em {a}": "{e}に書いた · {a}に開封",
 "Escuras (boas para folha clara)": "暗い色（明るい用紙向け）",
 "Esperado": "予定",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "予定：{e} · 実施：{f} · 未実施：{fa}",
 "Esqueceu a senha do diário?": "日記のパスワードを忘れましたか？",
 "Esqueci a senha do diário": "日記のパスワードを忘れた",
 "Esta semana": "今週",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "この取引はアプリの別の場所から来ているため、ここでは削除できません。",
 "Estudo: {h}": "勉強：{h}",
 "Esvaziar": "空にする",
 "Esvaziar a lixeira": "ゴミ箱を空にする",
 "Esvaziar a lixeira?": "ゴミ箱を空にしますか？",
 "Ex.: Comer uma fruta por dia": "例：1日1つ果物を食べる",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "例：宿題、2日間の診断書",
 "Ex.: Reservar a pousada": "例：宿を予約する",
 "Ex.: Viagem em família, juntar para a festa": "例：家族旅行、パーティーのために貯める",
 "Excluir de vez?": "完全に削除しますか？",
 "Excluir esta avaliação?": "この評価を削除しますか？",
 "Excluir este bloco?": "このブロックを削除しますか？",
 "Excluir este desenho?": "この絵を削除しますか？",
 "Excluir este item?": "この項目を削除しますか？",
 "Excluir {n} item(ns)?": "{n}件の項目を削除しますか？",
 "Exportar como imagem": "画像としてエクスポート",
 "Exportar em PDF": "PDF でエクスポート",
 "FOTOS": "写真",
 "FRASE DO DIA": "今日のフレーズ",
 "FREQUÊNCIA": "頻度",
 "Falta o valor": "金額が未入力です",
 "Feriado": "祝日",
 "Feriado: {f}": "祝日：{f}",
 "Fica 30 dias na lixeira.": "ゴミ箱に30日間残ります。",
 "Ficam 30 dias na lixeira.": "ゴミ箱に30日間残ります。",
 "Fichários arquivados": "アーカイブしたバインダー",
 "Fixar no topo": "上部に固定",
 "Floral": "花柄",
 "Folha": "用紙",
 "Folha, tema e cores das páginas com escrita": "手書きページの用紙、テーマ、色",
 "Folhas e plantas": "葉と植物",
 "Foto adicionada": "写真を追加しました",
 "Foto do sonho": "夢の写真",
 "Fotos do dia": "今日の写真",
 "Frase": "フレーズ",
 "Frase do dia (aparece no topo do Meu Dia)": "今日のフレーズ（「マイデイ」の上部に表示）",
 "Frases, textos, vídeos e fotos que motivam": "やる気が出るフレーズ、文章、動画、写真",
 "Geométrico": "幾何学",
 "Gerar": "生成",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "必要なときに音声でリマインダーやメモを録音し、文章を音声入力（🎤）します。マイクはタップしたときだけオンになり、音声入力の音声は保存されません。",
 "Guardar e trancar": "保管してロック",
 "Guardar e trancar?": "保管してロックしますか？",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "やる気が出るものをここに保管しましょう：フレーズ、自分の文章、動画、写真。",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "このパスワードは大切に保管してください。パスワードがないと日記は復元できません。",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "今日は祝日です：{f}。それでも記録しますか？",
 "Humor do mês": "今月の気分",
 "Humor do período": "期間中の気分",
 "HÁBITOS LIGADOS": "リンクした習慣",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "選択に大きな項目があります。大きな項目は確認とパスワードを入れて1件ずつしか削除できません。",
 "Há um ano": "1年前",
 "Há um mês": "1か月前",
 "Hábito": "習慣",
 "Hábito criado": "習慣を作成しました",
 "Hábitos": "習慣",
 "Hábitos cumpridos": "達成した習慣",
 "Hábitos cumpridos: {f} de {n}": "達成した習慣：{n}中{f}",
 "Hábitos formados": "身についた習慣",
 "INSPIRAÇÃO": "インスピレーション",
 "Imagem adicionada": "画像を追加しました",
 "Imagem não encontrada": "画像が見つかりません",
 "Incrível": "最高",
 "Informação nutricional": "栄養成分",
 "Inserir": "挿入",
 "Inspiração": "インスピレーション",
 "Item para o paciente": "患者向けの項目",
 "Itens grandes só se excluem um por um.": "大きな項目は1件ずつしか削除できません。",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "実現したいことの写真を集めましょう。長押しして動かすと並べ替えられます。",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "人生プロジェクトの夢にリンク（任意）",
 "LIGAR A UMA META (OPCIONAL)": "目標にリンク（任意）",
 "LINKS DE VÍDEO": "動画のリンク",
 "Lance as notas antes de enviar.": "送信する前に成績を入力してください。",
 "Lançamentos arquivados": "アーカイブした取引",
 "Legenda (opcional)": "キャプション（任意）",
 "Lembrete diário": "毎日のリマインダー",
 "Lendo o comprovante...": "領収書を読み取り中...",
 "Ler o comprovante com a minha IA": "自分の AI で領収書を読み取る",
 "Ligado": "オン",
 "Ligar um texto de motivação (Inspiração)": "やる気の出るテキストをリンク（インスピレーション）",
 "Lilás": "ライラック",
 "Limpar a folha inteira?": "用紙全体を消しますか？",
 "Linha reta": "直線",
 "Linhas": "罫線",
 "Link do vídeo (YouTube, Instagram...)": "動画のリンク（YouTube、Instagram...）",
 "Lisa": "無地",
 "Liste os passos do projeto e diga quem faz cada um.": "プロジェクトのステップを書き出し、それぞれの担当者を決めましょう。",
 "Lixeira": "ゴミ箱",
 "Longo prazo": "長期",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "ウェルネスから自動でチェック（任意）",
 "META OU SONHO LIGADO (OPCIONAL)": "リンクした目標・夢（任意）",
 "Mais opções": "その他のオプション",
 "Mal": "よくない",
 "Mandar ao paciente pelo WhatsApp": "WhatsApp で患者に送る",
 "Marque o que fez em cada dia": "毎日やったことにチェック",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "出欠にその日だけ表示されるよう、クラスの「編集」で授業日にチェックしてください。",
 "Matérias arquivadas": "アーカイブした科目",
 "Mensalidade": "月謝",
 "Meta de água do Bem-Estar": "ウェルネスの水分目標",
 "Metas arquivadas": "アーカイブした目標",
 "Metas e sonhos concluídos": "達成した目標と夢",
 "Metas em andamento": "進行中の目標",
 "Metas que avançaram": "前進した目標",
 "Metas, objetivos e sonhos, com passos e prazos": "ステップと期限つきの目標、目的、夢",
 "Meu Dia": "マイデイ",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "自由ページ付きのマイデイ、人生プロジェクト、習慣、夢ボード、人生の輪、未来への手紙、達成。パスワードで保護。",
 "Minimalista": "ミニマル",
 "Mostrar as contas antes do vencimento": "期日前に支払いを表示",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "現在地に合った日付、時刻、通貨、祝日を表示します。端末のおおよその位置情報は、日記で今日の天気を求めたときだけ使われ、保存されません。",
 "Muito bem": "とてもいい",
 "Muito mal": "とても悪い",
 "Mural de fotos dos seus sonhos": "夢の写真ボード",
 "Mural, relatório e revisão do mês": "ボード、レポート、月のふりかえり",
 "Médio prazo": "中期",
 "N dias cumpridos no mês": "今月 N 日達成",
 "N dias seguidos": "N 日連続",
 "NESTE DIA": "この日",
 "Nada a enviar": "送るものがありません",
 "Nenhum estudo registrado nesta semana.": "今週の勉強記録はありません。",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "まだ習慣がありません。例：「1日1つ果物を食べる」「水を2 L飲む」「朝食を抜かない」。",
 "Nenhum no período.": "この期間にはありません。",
 "Nenhuma": "なし",
 "Nenhuma carta ainda.": "まだ手紙はありません。",
 "Nenhuma foto ainda.": "まだ写真はありません。",
 "Neutras e opacas": "ニュートラル・マット",
 "Ninguém encontrado no grupo": "グループに該当者がいません",
 "No computador: {link}": "パソコンでは：{link}",
 "No navegador, a senha do diário é pedida sempre.": "ブラウザでは、日記のパスワードを毎回求められます。",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "月末日に：「今月をふりかえってみませんか？✨」",
 "Nome da página (opcional)": "ページ名（任意）",
 "Nome de quem faz este passo": "このステップの担当者の名前",
 "Nome do vídeo (opcional)": "動画の名前（任意）",
 "Normal": "標準",
 "Nota de 0 a 10 para cada área da vida": "人生の各分野を0〜10で評価",
 "Nota: {a}": "評価：{a}",
 "Nova caixa": "新しいボックス",
 "Nova carta": "新しい手紙",
 "Nova meta, objetivo ou sonho": "新しい目標・目的・夢",
 "Nova senha (6 caracteres ou mais)": "新しいパスワード（6文字以上）",
 "Nova área (ex.: Espiritualidade)": "新しい分野（例：スピリチュアリティ）",
 "Novo cômodo": "新しい部屋",
 "Novo hábito": "新しい習慣",
 "Não dá para excluir em grupo": "まとめて削除はできません",
 "Não enviados": "未送信",
 "Não estão no grupo (ou com outro nome): {l}": "グループにいない（または別の名前の）人：{l}",
 "Não foi possível exportar": "エクスポートできませんでした",
 "Não foi possível ouvir agora ({erro}).": "今は聞き取れません（{erro}）。",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "日記のパスワードは求められません。共有できる唯一の部分です。",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "このクラスの授業日ではありません。出欠は振替または補講として記録されます。",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "期日の{n}日前と当日の9時にお知らせします。設定 › タブ › ファイナンス で変更できます。",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "天気の自動入力は端末の位置情報を使います。許可がない場合は、ここで入力してください。",
 "O conteúdo desta carta não foi encontrado.": "この手紙の内容が見つかりません。",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "音声入力はアプリの新しいバージョンで使えるようになります。マイクを使うには、ストアで My Planner をアップデート（または新しい APK をインストール）してください。",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "アプリのロックを解除していても、日記に入るたびにパスワードを求めます。",
 "O diário só abre com essa senha, sempre.": "日記はこのパスワードでしか開きません。いつでもです。",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "日記は暗号化されています。パスワードがなければ、サポートも含め誰も開けません。必要なら日記を削除して新しく始められます（グループプロジェクトはそのまま残ります）。",
 "O que aprendi hoje?": "今日学んだことは？",
 "O que este mês te ensinou? O que quer levar para o próximo?": "今月から何を学んだ？来月に持っていきたいことは？",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "チェックを外したものは画面から消えます。データは保存されたままです。",
 "O que foi bom hoje?": "今日よかったことは？",
 "O que foi excluído nos últimos 30 dias": "過去30日間に削除したもの",
 "O que quero melhorar amanhã?": "明日もっとよくしたいことは？",
 "O que quero mudar agora": "今変えたいこと",
 "O que você escreveu nesta carta vai se perder.": "この手紙に書いた内容は失われます。",
 "O que você quer fazer com o arquivo?": "ファイルをどうしますか？",
 "Objetivo": "目的",
 "Oculta": "非表示",
 "Orientação": "指導",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "患者に渡す指導、処方箋、診断書、資料をファイル付きで。送られるのはここにあるものだけで、カルテがこのフォルダーから出ることはありません。",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "書いたページがある日には印が付きます。日付をタップすると開きます。",
 "Os itens saem de vez e não podem mais ser restaurados.": "項目は完全に削除され、復元できなくなります。",
 "Outra data": "別の日付",
 "Outras moedas": "その他の通貨",
 "Ouvindo…": "聞き取り中…",
 "PASSOS": "ステップ",
 "PDF com seus dados e assinatura": "あなたの情報と署名入りの PDF",
 "POR DIA": "日別",
 "POR MATÉRIA": "科目別",
 "PROGRESSO": "進捗",
 "Paciente: {nome}": "患者：{nome}",
 "Para o paciente": "患者向け",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "開き方を変えるには、日記のパスワードで日記に入ってから、ここに戻ってください。",
 "Para {nome} de {tempo} depois": "{tempo}後の{nome}へ",
 "Parar o ditado": "音声入力を停止",
 "Parcelado": "分割払い",
 "Partes desta aba": "このタブの項目",
 "Passo": "ステップ",
 "Pastas arquivadas": "アーカイブしたフォルダー",
 "Pastas arquivadas ({n})": "アーカイブしたフォルダー（{n}）",
 "Pautada": "罫線",
 "Pautada com margem": "余白付き罫線",
 "Pedido de exame": "検査依頼",
 "Pelo que sou grata hoje?": "今日感謝していることは？",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "端末の設定で、My Planner にマイクと音声認識を許可してください。",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "カスタマイズ：このタブだけの用紙の種類、色、テーマ、丸の色",
 "Pontilhada": "ドット",
 "Posto": "ガソリンスタンド",
 "Preenche o clima do Meu Dia pela localização do celular.": "端末の位置情報から「マイデイ」の天気を入力します。",
 "Preencher pela foto do comprovante": "領収書の写真から入力",
 "Primeira vez neste aparelho: digite a senha do diário.": "この端末では初めてです：日記のパスワードを入力してください。",
 "Projeto": "プロジェクト",
 "Projeto de Vida": "人生プロジェクト",
 "Projetos com amigos e família (compartilhados)": "友だちや家族とのプロジェクト（共有）",
 "Projetos em Grupo": "グループプロジェクト",
 "Proprietário / Locador": "オーナー／貸主",
 "Páginas arquivadas": "アーカイブしたページ",
 "Páginas desta aba": "このタブのページ",
 "QUANDO ELA ABRE": "開封日",
 "Qua": "水",
 "Quadriculada": "方眼",
 "Quadro dos Sonhos": "夢ボード",
 "Quais partes você vai usar?": "どの項目を使いますか？",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "目標を達成したり習慣が身についたりすると、ここに表示されてお祝いします。🎉",
 "Quanto você pagou?": "いくら払いましたか？",
 "Quanto você recebeu?": "いくら受け取りましたか？",
 "Que tal revisar o seu mês? ✨": "今月をふりかえってみませんか？✨",
 "Quem faz": "担当",
 "Quem fez o meu dia melhor?": "今日を素敵にしてくれたのは誰？",
 "Quer guardar o comprovante agora?": "今、領収書を保存しますか？",
 "Qui": "木",
 "REFLEXÃO DO MÊS": "今月のふりかえり",
 "Recebeu {v} a mais": "{v}多く受け取りました",
 "Recebeu {v} a menos": "{v}少なく受け取りました",
 "Receita médica": "処方箋",
 "Receitas médicas": "処方箋",
 "Recolher": "たたむ",
 "Refeições arquivadas": "アーカイブした食事",
 "Refeições do cronograma feitas (Bem-Estar)": "食事プランの食事完了（ウェルネス）",
 "Referente a (ex.: material, passeio, inscrição)": "内容（例：教材、遠足、登録料）",
 "Registrar": "記録",
 "Relacionamentos": "人間関係",
 "Relatório de estudos": "勉強レポート",
 "Relatório de realizações": "達成レポート",
 "Relatório em PDF": "PDF レポート",
 "Renomear, adicionar ou tirar áreas": "分野の名前変更・追加・削除",
 "Reposição": "振替",
 "Restaurado": "復元しました",
 "Resumida": "簡易",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "簡易：合計を1行だけ表示。詳細：その日の項目を表示。非表示：表示しません。このタブのものが自動でタスクになることはありません。",
 "Resumo de {nome}": "{nome}のまとめ",
 "Resumo do dia": "今日のまとめ",
 "Retângulo": "四角形",
 "Revisar antes": "先に確認",
 "Revisão do mês": "月のふりかえり",
 "Roda da Vida": "人生の輪",
 "Rosa": "ピンク",
 "Sair sem guardar?": "保存せずに終了しますか？",
 "Salvar avaliação de hoje": "今日の評価を保存",
 "Salvar ou enviar": "保存または送信",
 "Seg": "月",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "フォルダーを長押しして動かすと順番を変えられます。左にスワイプでアーカイブ。",
 "Sem chamada neste dia: cobra todos os alunos.": "この日は出欠がないため、全生徒に請求します。",
 "Sem ideia do que escrever? Toque numa pergunta:": "何を書けばいいか迷ったら、質問をタップ：",
 "Sem registros de humor.": "気分の記録はありません。",
 "Sem tema": "テーマなし",
 "Semana de {d}": "{d}の週",
 "Senha atual do diário": "現在の日記のパスワード",
 "Senha do diário": "日記のパスワード",
 "Senha do diário incorreta.": "日記のパスワードが違います。",
 "Senha do diário trocada": "日記のパスワードを変更しました",
 "Senha própria só do diário": "日記専用のパスワード",
 "Sequência dos hábitos": "習慣の連続記録",
 "Seta": "矢印",
 "Seu diário, só seu": "あなただけの日記",
 "Seu texto de motivação": "あなたのやる気の出るテキスト",
 "Sex": "金",
 "Sonho": "夢",
 "Suplementos arquivados": "アーカイブしたサプリメント",
 "Sáb": "土",
 "Só abre com a senha do diário.": "日記のパスワードでのみ開きます。",
 "TEMA DECORATIVO": "デコレーションテーマ",
 "TIPO DE FOLHA": "用紙の種類",
 "Tarefas arquivadas": "アーカイブしたタスク",
 "Ter": "火",
 "Texto para o paciente": "患者向けテキスト",
 "Tipo, cor e tema da folha": "用紙の種類、色、テーマ",
 "Tirar a área \"{a}\"?": "分野「{a}」を削除しますか？",
 "Tirar da frase do dia": "今日のフレーズから外す",
 "Tirar do arquivo": "アーカイブから戻す",
 "Tirar esta foto do quadro?": "この写真をボードから外しますか？",
 "Tirar esta pergunta?": "この質問を外しますか？",
 "Tirar este vídeo?": "この動画を外しますか？",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "毎日{h}に：「今日はどんな一日だった？✍️」",
 "Todos os alunos já têm uma cobrança com esta referência.": "全生徒にこの内容の請求がすでにあります。",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "もう一度タップで「その他」（免除、診断書など）：欠席にも授業にも数えません。",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "丸をタップして今日やったことにチェック。習慣は自動では My Planner に送られません。⋮ メニューの「送信」を使ってください。",
 "Toque num dia para marcar ou desmarcar.": "日付をタップしてチェック・解除。",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "丸をタップすると色を変えられます。ページ上で丸を長押ししても同じです。",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "タップして開く。左にスワイプでアーカイブまたは複製、右にスワイプで削除。",
 "Treino do dia feito (Bem-Estar)": "今日のトレーニング完了（ウェルネス）",
 "Treinos arquivados": "アーカイブしたトレーニング",
 "Trocar a senha do diário": "日記のパスワードを変更",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "日記に書いたことはすべて、アカウントに送られる前にこの端末で暗号化されます。サポートを含め、ほかの誰も読めません。",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "削除したものはここに30日間残ります。その後、完全に削除されます。",
 "Título (ex.: Ter uma boa alimentação)": "タイトル（例：バランスのよい食事をとる）",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "{n}人の生徒それぞれに単発の請求を作成します。1人だけに請求するには + をタップ。",
 "Uma senha própria, só do diário": "日記専用のパスワード",
 "Usar a senha do diário": "日記のパスワードを使う",
 "Usar como frase do dia": "今日のフレーズにする",
 "Usar este valor": "この金額を使う",
 "Usar o padrão do app": "アプリの標準を使う",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "すべてのタブの金額に適用されます（ファイナンス、家賃、月謝など）。",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "手書きのすべてのページに適用されます（勉強、メモ、日記、書類など）。各タブは 設定 › タブ で独自の標準を設定でき、各ページは ⋮ › 用紙 で用紙を変えられます。",
 "Valor da aula extra (por aluno)": "補講の金額（生徒1人あたり）",
 "Valor por aluno": "生徒1人あたりの金額",
 "Valor previsto: {v}": "予定金額：{v}",
 "Vencimento: {d}": "期日：{d}",
 "Ver o comprovante": "領収書を見る",
 "Verde": "緑",
 "Visualizar": "プレビュー",
 "Você está como convidado": "ゲストとして参加中",
 "Voltar a acompanhar este hábito": "この習慣の記録を再開",
 "Voltar ao início da folha": "用紙の先頭に戻る",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "初期設定に戻す（罫線用紙。黒、青、赤、緑）",
 "Voltar para a nova avaliação": "新しい評価に戻る",
 "Vídeos": "動画",
 "X vezes por semana": "週 X 回",
 "abre em {n} dias": "あと{n}日で開封",
 "agradável": "快適",
 "arquivo": "ファイル",
 "aula extra": "補講",
 "calor": "暑い",
 "chuva": "雨",
 "concluído": "完了",
 "céu limpo": "快晴",
 "de {n} planejados": "予定{n}のうち",
 "dentro de {p}": "{p}以内",
 "enviado em {d}": "{d}に送信",
 "estudados na semana": "今週の勉強",
 "excluído em {d}": "{d}に削除",
 "falta 1 dia": "あと1日",
 "faltam {n} dias": "あと{n}日",
 "feito {dur} na semana": "今週{dur}実施",
 "fresco": "涼しい",
 "frio": "寒い",
 "garoa": "霧雨",
 "hoje não está planejado": "今日は予定なし",
 "hábito formado ✨": "習慣が身についた ✨",
 "incorreta": "不正解",
 "neblina": "霧",
 "neve": "雪",
 "nublado": "くもり",
 "não enviado": "未送信",
 "parcela {k}/{n}": "{k}/{n}回目",
 "passou há {n} dias": "{n}日経過",
 "pelo Bem-Estar": "ウェルネスから",
 "poucas nuvens": "晴れ時々くもり",
 "reposição": "振替",
 "sai de vez em {n} dia(s)": "{n}日後に完全に削除",
 "sem registros": "記録なし",
 "tempestade": "雷雨",
 "tracejado: {d}": "破線：{d}",
 "ver mais": "もっと見る",
 "ver menos": "閉じる",
 "{aluno}: {n} de {max}": "{aluno}：{max}中{n}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d}は祝日です：{f}。それでも記録しますか？",
 "{f} de {n} passos feitos": "{n}ステップ中{f}完了",
 "{f}/{n} passos": "{f}/{n}ステップ",
 "{nome} daqui a 1 ano": "1年後の{nome}",
 "{nome} daqui a 10 anos": "10年後の{nome}",
 "{nome} daqui a 6 meses": "6か月後の{nome}",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n}人の生徒には「{a}」の本人の成績だけが届きます。",
 "{n} aluno(s) receberam a nota.": "{n}人の生徒に成績が届きました。",
 "{n} aluno(s) · {v} cada": "生徒{n}人 · 1人{v}",
 "{n} anos": "{n}年",
 "{n} dia(s) antes": "{n}日前",
 "{n} dia(s) cumprido(s) no mês": "今月{n}日達成",
 "{n} dia(s) registrado(s) · média {e}": "{n}日記録 · 平均{e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n}日記録、平均{m}／6",
 "{n} dia(s) seguido(s)": "{n}日連続",
 "{n} dispensada(s) hoje": "今日は{n}件免除",
 "{n} meses": "{n}か月",
 "{n} outro(s)": "ほか{n}件",
 "{n} selecionado(s)": "{n}件選択中",
 "{n} tarefa(s) concluída(s) no My Planner": "My Planner で{n}件のタスクを完了",
 "{n} vez(es) por semana": "週{n}回",
 "{n}x": "{n}回",
 "Água: {a} de {m} ml": "水分：{m} ml中{a}",
 "ÚLTIMAS 8 SEMANAS": "過去8週間",
 "Última parcela em {d}": "最終回は{d}",
 "é hoje!": "今日です！",
 "A mesma do app": "アプリと同じ",
 "Abrir com o código": "コードで開く",
 "Ainda não criado": "未作成",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "作成時に、保管用の復元コードが表示されます。",
 "Apagar o diário e começar de novo": "日記を削除して最初からやり直す",
 "Biometria ou código do dispositivo": "生体認証または端末のパスコード",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "生体認証、端末の PIN、またはアプリのパスワード。別のパスワードを作る必要はありません。",
 "Bloquear o app": "アプリをロック",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "使用するには、端末に指紋、顔、または画面ロックのパスコードを登録してください。",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "生体認証をオンにすると、最初に表示されます。失敗した場合は、同じ画面で端末のパスコード/PIN/パターンを使えます。アプリのパスワードも引き続き使えます。",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "パスワードを忘れたり端末を変えたりしても、これで日記を復元できます。",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "パスワードを忘れたり端末を変えたりしても、このコードで日記を復元できます。安全な場所に保管し、誰にも見せないでください。",
 "Como funciona a Roda da Vida": "人生の輪の使い方",
 "Como o diário abre": "日記の開き方",
 "Crie a senha que vai abrir o diário.": "日記を開くパスワードを作成してください。",
 "Crie o PIN do diário (4 a 6 números)": "日記の PIN を作成（4〜6桁の数字）",
 "Crie o diário de novo para começar.": "始めるには、日記をもう一度作成してください。",
 "Código aceito. Crie uma senha nova para o diário.": "コードを確認しました。日記の新しいパスワードを作成してください。",
 "Código de recuperação": "復元コード",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "復元コード（例：ABCD-EFGH-...）",
 "Código de recuperação incorreto.": "復元コードが正しくありません。",
 "Cômodos": "部屋",
 "Depois de 1 minuto": "1分後",
 "Depois de {n} minutos": "{n}分後",
 "Desenhe o padrão do diário": "日記のパターンを描いてください",
 "Dias no mês": "月の日数",
 "Dias seguidos": "連続日数",
 "Digite o seu PIN": "PIN を入力してください",
 "Diário ainda não criado": "日記はまだ作成されていません",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "生活の各分野について、今日の気分を0〜10で評価してください。図を見ると、生活のバランスが取れている所と注意が必要な所がわかります。評価を保存し、定期的に（たとえば毎月）繰り返して、比較しながら変化を確認しましょう。分野の名前変更、追加、削除もできます。",
 "Entre na aba Diário para criar o seu diário.": "「日記」タブで日記を作成してください。",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "日記に入って（日記のパスワードまたはアプリのロック解除で）、ここに戻ってください。",
 "Esconder a senha": "パスワードを隠す",
 "Gerar novo código": "新しいコードを生成",
 "Gerar um código de recuperação novo?": "新しい復元コードを生成しますか？",
 "Guarde este código": "このコードを保管してください",
 "Já guardei": "保管しました",
 "Ligar um hábito que já existe": "既存の習慣をリンク",
 "Mostrar a senha": "パスワードを表示",
 "Mudar como o diário abre": "日記の開き方を変更",
 "My Planner · Código de recuperação do Diário": "My Planner · 日記の復元コード",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "この端末のキーで開けませんでした。日記のパスワードまたは復元コードを使ってください。",
 "O Caps Lock parece estar ligado.": "Caps Lock がオンになっているようです。",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "PIN はこの端末にのみ保護された状態で保存されます。PIN を忘れても、パスワードは引き続き使えます。",
 "O PIN precisa ter de 4 a 6 números.": "PIN は4〜6桁の数字にしてください。",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "以前のコードは無効になります。安全のため、コードはアプリに保存されず、生成時にしか表示されません。",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "コードはサポートが見られる場所には一切保存されません。パスワードとコードがないと、日記は復元できません。",
 "O diário agora abre só com a senha dele.": "日記は今後、日記のパスワードでのみ開きます。",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "この端末の顔認証はアプリでは使えません。指紋または端末のパスコード/PIN を使ってください。",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "時間は、アプリが画面から離れた時点（別のアプリ、ホーム画面、画面オフ）から数えます。通知を引き出す、生体認証の画面、権限の確認、写真やファイルの選択は含まれません。",
 "Os PINs não conferem.": "PIN が一致しません。",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN（4〜6桁の数字）",
 "PIN (só números, 4 a 6)": "PIN（数字のみ、4〜6桁）",
 "PIN do diário": "日記の PIN",
 "PIN incorreto": "PIN が正しくありません",
 "PIN salvo.": "PIN を保存しました。",
 "Padrão do app": "アプリの標準",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "削除するには、アプリのパスワード、生体認証、または端末の PIN で確認してください。日記のマイデイ、目標、習慣、手紙、写真が削除されます。グループプロジェクトは残ります。",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "続けるには、アプリのパスワードを入力するか、生体認証/端末のパスコードを使ってください。",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "パスワードを忘れたり端末を変えたりしたときに、日記を復元するためのものです。",
 "Pastas": "フォルダー",
 "Pedir a senha de novo": "もう一度パスワードを求める",
 "Personalizada": "カスタム",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "この端末では初めてです：日記のパスワードを入力するか、復元コードを使ってください。",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "この端末では初めてです：日記の復元コードを入力してください。",
 "Reconhecimento de rosto": "顔認証",
 "Repita o PIN": "PIN をもう一度入力",
 "Salvar a senha nova": "新しいパスワードを保存",
 "Salvar em arquivo / no Drive": "ファイル / ドライブに保存",
 "Salvar o código de recuperação": "復元コードを保存",
 "Senha (letras e números)": "パスワード（英字と数字）",
 "Senha do app": "アプリのパスワード",
 "Senha nova do diário": "日記の新しいパスワード",
 "Senha própria": "専用パスワード",
 "Senha própria do diário": "日記専用のパスワード",
 "Tarefas": "タスク",
 "Trocar o PIN": "PIN を変更",
 "Usar a senha": "パスワードを使う",
 "Usar o PIN": "PIN を使う",
 "Usar o código de recuperação": "復元コードを使う",
 "Usar o desbloqueio do app": "アプリのロック解除を使う",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "生体認証または端末のパスコード/PIN/パターンを使ってください。",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "日記を作成したときに表示された復元コードを使ってください。パスワードとコードがなければ、サポートを含め誰も日記を開けません。",
 "Voltar a usar só a senha?": "パスワードのみに戻しますか？",
 "incorreto": "正しくありません",
 "1 h": "1時間",
 "12 horas (2:30 PM)": "12時間表示（2:30 PM）",
 "15 min": "15分",
 "24 horas (14:30)": "24時間表示（14:30）",
 "30 min": "30分",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "ゴミ箱に大きな項目があります。アプリのパスワード、生体認証、または端末のパスコードで確認してください。",
 "A semana começa na": "週の始まり",
 "Abra o Diário primeiro": "先に日誌を開いてください",
 "Abrir configurações do celular": "スマートフォンの設定を開く",
 "Agenda e mapas": "カレンダーと地図",
 "Agora: {m}": "現在：{m}",
 "Ajuda e sobre": "ヘルプと情報",
 "Alarme (som)": "アラーム（音）",
 "Alarme ou vibração das pausas": "休憩のアラームまたはバイブ",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "アカウントと、クラウドおよびこの端末上のすべてのデータを完全に削除します。削除前にパスワードを確認します。",
 "Apagar todas ({n})": "すべて削除（{n}）",
 "Apagar {n} selecionada(s)": "選択した{n}件を削除",
 "Aparência": "外観",
 "App das rotas": "ルートアプリ",
 "Ardósia": "スレート",
 "Arrastar para a direita": "右にスワイプ",
 "Arrastar para a esquerda": "左にスワイプ",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "ファイナンスの支払いが、この日数前から My Planner に表示されます。",
 "Atualizações e sobre": "アップデートと情報",
 "Avisar antes do vencimento": "期限前に通知",
 "Aviso marcado": "リマインダーを設定しました",
 "Aviso no começo e no fim de cada pausa": "各休憩の開始時と終了時に通知",
 "Avisos desta aba": "このタブの通知",
 "Avisos e alarmes": "通知とアラーム",
 "Avisos silenciosos": "サイレント通知",
 "Avisos: som e vibração": "通知：音とバイブ",
 "Avisos: só som": "通知：音のみ",
 "Avisos: só vibração": "通知：バイブのみ",
 "Azul elétrico": "エレクトリックブルー",
 "Azul-aço": "スチールブルー",
 "Azul-bebê": "ベビーブルー",
 "Azul-marinho": "ネイビー",
 "Baixar meus dados": "自分のデータをダウンロード",
 "Baixar todos os meus dados": "自分のデータをすべてダウンロード",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "自分のデータをすべてダウンロードしてアカウントを削除（LGPD）",
 "Biometria": "生体認証",
 "Bissexual": "バイセクシュアル",
 "Brilhante": "ブライト",
 "Buscar abas": "タブを検索",
 "Buscar nos ajustes": "設定を検索",
 "Cancelar aviso": "リマインダーをキャンセル",
 "Cinza-chumbo": "チャコールグレー",
 "Cofre": "金庫",
 "Coloque pelo menos uma matéria.": "科目を1つ以上追加してください。",
 "Como usar": "使い方",
 "Conexões": "連携",
 "Cor da aba": "タブの色",
 "Cor de destaque": "アクセントカラー",
 "Crie uma matéria primeiro": "先に科目を作成してください",
 "Cítrico": "シトラス",
 "Cópia de segurança em arquivo": "ファイルにバックアップ",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "患者データとカルテです。アプリのパスワード、生体認証、または端末のパスコードで確認してください。",
 "Desligadas": "オフ",
 "Digite a senha da sua conta para confirmar.": "確認のため、アカウントのパスワードを入力してください。",
 "Duração padrão de uma tarefa nova": "新しいタスクの標準の長さ",
 "Editar sessão": "セッションを編集",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "終了日なしで繰り返します：{data}までの回が表示されています。すべてにチェックすると、タスク全体が削除されます。",
 "Em atividade": "実施中",
 "Em pausa": "休憩中",
 "Emoji da pausa": "休憩の絵文字",
 "Encerrar": "終了",
 "Encerrar a sessão?": "セッションを終了しますか？",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "選択モードに入り、複数の項目をまとめて選べます。",
 "Escolha um horário no futuro.": "未来の時刻を選んでください。",
 "Escolher a matéria": "科目を選ぶ",
 "Esconde os valores em dinheiro (R$ •••)": "金額を非表示にします（R$ •••）",
 "Esconder o CPF": "CPF を隠す",
 "Esconder os valores": "金額を隠す",
 "Esta e as próximas": "この回以降",
 "Esta tarefa se repete. Onde aplicar a mudança?": "このタスクは繰り返します。変更をどこに適用しますか？",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "この項目には多くの内容が含まれています。アプリのパスワード、生体認証、または端末のパスコードで確認してください。",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "項目を削除します（確認あり）。あとで元に戻すか、ゴミ箱から復元できます。",
 "Excluir minha conta": "アカウントを削除",
 "Ficha protegida": "保護されたカード",
 "Formato da hora": "時刻の形式",
 "Foto do Quadro dos Sonhos": "夢ボードの写真",
 "Geral": "一般",
 "Gestos": "ジェスチャー",
 "Google Drive, OneDrive e arquivo de cópia": "Google ドライブ、OneDrive、バックアップファイル",
 "Grafite": "グラファイト",
 "Guardar em": "保存先",
 "Hábito do Diário": "日誌の習慣",
 "Idioma e moeda": "言語と通貨",
 "Inspiração do Diário": "日誌のインスピレーション",
 "Intenso": "インテンス",
 "Item arquivado": "項目をアーカイブしました",
 "Item excluído": "項目を削除しました",
 "Lavanda": "ラベンダー",
 "Ligadas": "オン",
 "Limite de energia": "エネルギー上限",
 "Lésbica": "レズビアン",
 "Marque as vezes que vão ser apagadas.": "削除する回にチェックを入れてください。",
 "Matéria": "科目",
 "Me avise em…": "通知のタイミング…",
 "Menta": "ミント",
 "Menu ⋮": "メニュー ⋮",
 "Meta do Diário": "日誌の目標",
 "Modo discreto": "シークレットモード",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "セッションを一度組み立てれば（科目、各科目の時間、休憩）、ほかの日は「開始」をタップするだけで繰り返せます。勉強した時間は自動で目標に加算されます。",
 "Mostra Arquivar e Duplicar.": "「アーカイブ」と「複製」を表示します。",
 "Mostrar feriados no topo": "上部に祝日を表示",
 "Mostrar os valores": "金額を表示",
 "Muda a ordem dos itens.": "項目の順番を変更します。",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "My Planner の色だけを変更します。アプリのアクセントカラーは 設定 > 外観 にあります。各タスクはカードで個別の色を設定できます。",
 "Nada encontrado nos ajustes.": "設定に該当する項目はありません。",
 "Nenhuma sessão salva ainda.": "保存されたセッションはまだありません。",
 "Neon": "ネオン",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "この時間帯はアプリが鳴ったり振動したりしません。通知は引き続き無音で届きます。",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "各項目のメニュー ⋮ から：My Planner にタスクを作らずに、選んだ時刻にスマートフォンが通知します。",
 "Nome (ex.: Sessão do mestrado)": "名前（例：修士の勉強セッション）",
 "Nova sessão": "新しいセッション",
 "Nuvem e cópias de segurança": "クラウドとバックアップ",
 "Não perturbe": "おやすみモード",
 "Não perturbe {de}–{ate}": "おやすみモード {de}–{ate}",
 "Não-binário": "ノンバイナリー",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "My Planner 上部の 🎉 祝日ボタン。国と祝日リストは 設定 > 祝日 にあります。",
 "O celular avisa às {h}.": "{h}にスマートフォンが通知します。",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "日誌から削除したものは暗号化されたままゴミ箱に入ります。日誌に入ってから、ここに戻って復元してください。",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "削除したものは30日間ゴミ箱に残ります。確認のため、アカウントのパスワードを入力してください。",
 "O que saiu fica na Lixeira por 30 dias.": "削除したものは30日間ゴミ箱に残ります。",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "テーマは、ライト／ダークの両モードでタブの色、アクセントカラー、背景のほのかな色合いを変更します。1つのタブだけ色を変えるには、設定 > タブ へ。",
 "O tempo estudado até agora entra na meta.": "これまでの勉強時間が目標に加算されます。",
 "Oliva": "オリーブ",
 "Orgulho": "プライド",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "通知は、通知をオンにしたインストール済みアプリで動作します。",
 "Os gestos do app": "アプリのジェスチャー",
 "Outro (escolher a hora)": "その他（時刻を選ぶ）",
 "Pansexual": "パンセクシュアル",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "オンにするには、スマートフォンのアプリを使ってください（設定 › カレンダーと地図 › Google カレンダー）。その後、ここにもすべて表示されます。",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "今後確認しないようにするには、設定 › カレンダーと地図 でアプリを選んでください。",
 "Pausa": "休憩",
 "Petróleo": "ペトロール",
 "Pink elétrico": "エレクトリックピンク",
 "Preto total": "ピュアブラック",
 "Progresso": "進捗",
 "Pêssego": "ピーチ",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "支払いを何日前から表示するかは 設定 > 通知とアラーム で設定します。",
 "Rosa-chá": "ティーローズ",
 "Roxo-profundo": "ディープパープル",
 "Segurança e dados": "セキュリティとデータ",
 "Segurar e arrastar": "長押ししてドラッグ",
 "Segurar e soltar": "長押しして離す",
 "Selecionar todas": "すべて選択",
 "Semana começa na {dia}": "週の始まり：{dia}",
 "Sessão de estudo": "勉強セッション",
 "Sessão encerrada": "セッションを終了しました",
 "Sessão pausada": "セッションを一時停止しました",
 "Som e vibração": "音とバイブ",
 "Suave": "ソフト",
 "Só esta semana": "今週のみ",
 "Só hoje": "今日のみ",
 "Só neste dia ({data})": "この日のみ（{data}）",
 "Tamanho das caixas": "マスの大きさ",
 "Tamanho do texto": "文字の大きさ",
 "Tarefa nova": "新しいタスク",
 "Tela inicial": "ホーム画面",
 "Tema e cor de destaque": "テーマとアクセントカラー",
 "Testar alerta": "アラートをテスト",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "アラートのテスト、「おやすみモード」、スマートフォンの設定は 設定 > 通知とアラーム にあります。",
 "Testar e conferir": "テストと確認",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "項目のすべてのオプション：編集、移動、共有、アーカイブ、削除など",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "テーマ「{tema}」の色をタップすると、ボタン、＋ボタン、選択中の項目に使われます。",
 "Total: {dur}": "合計：{dur}",
 "Tropical": "トロピカル",
 "Turquesa": "ターコイズ",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "My Planner のすべてのデータをまとめたファイルです。保管や別の場所への移行に使えます（データポータビリティ、LGPD）。",
 "Usar no computador, pelo navegador": "パソコンのブラウザで使う",
 "Usar o padrão": "標準を使う",
 "Usar o padrão ({emoji})": "標準を使う（{emoji}）",
 "Use o app no celular para baixar o arquivo.": "ファイルをダウンロードするには、スマートフォンのアプリを使ってください。",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "すべてのタブに適用されます。各タブは 設定 > タブ で個別に設定できます。",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "休憩のあるタスクに適用されます。各タスクのカードでアラームと絵文字を変更できます。",
 "Ver lista": "リストを見る",
 "Ver o CPF inteiro": "CPF をすべて表示",
 "Verde-floresta": "フォレストグリーン",
 "Verde-água": "アクアグリーン",
 "Vibração": "バイブ",
 "Vinho": "ワインレッド",
 "Você pediu para ser avisado agora.": "今すぐ通知するよう設定しました。",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "あなたは次のことができます：データ処理の有無の確認、アクセス、訂正、ポータビリティの請求（設定 > 自分の情報 でデータをダウンロード）、削除の請求、共有先の確認、同意の撤回、ANPD への苦情申立て。",
 "Voltar ao filtro": "フィルターに戻る",
 "Voltar à lista": "リストに戻る",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "設定 › My Planner Web で「ブラウザを接続」をタップしてください。",
 "atividade {n} de {total}": "アクティビティ {n}/{total}",
 "matéria {n} de {t}": "科目 {n}/{t}",
 "padrão": "標準",
 "pausa em {n} min": "{n}分後に休憩",
 "pausa {n} de {total}": "休憩 {n}/{total}",
 "termina em {n} min": "{n}分後に終了",
 "todas as vezes": "すべての回",
 "troca em {n} min": "{n}分後に切り替え",
 "volta em {n} min": "{n}分後に再開",
 "{nome} · {n} dia(s)": "{nome} · {n}日",
 "{n} de {total} vezes": "{n}/{total}回",
 "{n} itens arquivados": "{n}件をアーカイブしました",
 "{n} itens excluídos": "{n}件を削除しました",
 "{n} marcada(s)": "{n}件チェック済み",
 "{n} vezes": "{n}回",
 "{rotulo}: {feito} min / {total}": "{rotulo}：{feito}分 / {total}",
 "📔 Diário": "📔 日誌",
 "Agendados": "予定",
 "Atrasado": "期限超過",
 "Atrasado: {v}": "期限超過：{v}",
 "Atualizar o a receber": "受取予定を更新",
 "Até (fim do contrato, se houver)": "終了日（契約終了日があれば）",
 "Clínica": "クリニック",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "出席を取った日、または\"授業済み\"にした授業計画がある日を1日として数えます。",
 "Data do recebimento": "受取日",
 "Data prevista do pagamento": "支払予定日",
 "Desmarcar como recebido": "受取済みを解除",
 "Dia do pagamento": "支払日",
 "Diferença: {v} (juros/multa)": "差額：{v}（利息/延滞金）",
 "Diferença: {v} (taxas/descontos)": "差額：{v}（手数料/割引）",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "あなたに給与を支払う学校・大学・教室。固定給なら毎月の受取予定を自動作成。時間給（コマ単位）なら、その機関に紐づくクラスの実施授業を合計します。",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "支払タイプを選んでください（編集）。アプリが受取予定額を計算します。",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "この金額は {aba} タブの\"勤務先\"から来ています。ここで受取済みにするか、タブを開いて機関を確認してください。",
 "Ex.: Colégio Estadual, Universidade Federal": "例：県立高校、国立大学",
 "Ex.: Hospital Santa Casa, Clínica Vida": "例：サンタカーザ病院、ヴィダ・クリニック",
 "Ex.: Salário de outubro, 13º, férias": "例：10月分給与、13ヶ月目給与、有給休暇",
 "Feitos": "完了",
 "Horas-aula de cada aula": "1授業あたりのコマ数",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "あなたに給与を支払う病院・クリニック。固定給なら毎月の受取予定を自動作成。当直や診療ごとなら、完了分をチェックするとアプリが計算します。",
 "Hospital": "病院",
 "Instituição": "機関",
 "Instituição (Onde trabalho)": "機関（勤務先）",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "クラスをこの機関に紐づけてください（クラスの 編集 › 機関）。アプリが実施授業を合計します。",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "当直や診療を完了にチェック：アプリが合計して月の金額を計算します。",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "この機関で行った当直や診療をチェックしてください。アプリが合計して月の受取額を計算します。",
 "Nome da instituição": "機関名",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "機関があなたに支払う金額（月ごと）。入金されたら受取済みに：財務タブにも反映されます。",
 "Onde trabalho": "勤務先",
 "Plantão": "当直",
 "Plantão ou atendimento": "当直または診療",
 "Plantões e atendimentos": "当直と診療",
 "Por atendimento ou procedimento": "診療・処置ごと",
 "Por hora-aula": "コマ単位",
 "Por plantão": "当直ごと",
 "Previsto: {v}": "予定：{v}",
 "Previsão do mês: {v}": "今月の見込み：{v}",
 "Quantidade (aulas, plantões ou atendimentos)": "数量（授業・当直・診療）",
 "Recebe no mês seguinte ao trabalhado": "勤務月の翌月に受取",
 "Receber: {t}": "受取：{t}",
 "Recebimentos": "受取",
 "Salário": "給与",
 "Salário (valor do mês)": "給与（月額）",
 "Salário fixo": "固定給",
 "Telefone (RH ou financeiro)": "電話（人事または経理）",
 "Tipo de pagamento": "支払タイプ",
 "Universidade": "大学",
 "Valor da hora-aula": "1コマの単価",
 "Valor de cada um (se for diferente)": "個別の金額（異なる場合）",
 "Valor do plantão": "当直の単価",
 "Valor por atendimento ou procedimento": "診療・処置ごとの金額",
 "Valor previsto": "予定額",
 "feito": "完了",
 "recebido em {d}": "{d} に受取",
 "{n} aula(s) dada(s)": "{n} 回の授業済み",
 "{n} hora(s)-aula": "{n} コマ",
 "{n} plantão(ões)": "{n} 回の当直",
 "Abas do My Planner Anne": "My Planner Anne のタブ",
 "Acesso ao Não perturbe": "おやすみモードへのアクセス",
 "Alarme dos remédios (mesmo no silencioso)": "服薬アラーム（マナーモード中も）",
 "Algodão-doce": "わたあめ",
 "Aplicar tema": "テーマを適用",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "各テーマ専用の色：ピンクの花、緑の葉、青空…",
 "Assim ficam as letras no app.": "アプリ内の文字はこのように表示されます。",
 "Automática": "自動",
 "Baht tailandês": "タイ・バーツ",
 "Boliviano": "ボリビアーノ",
 "Bolívar venezuelano": "ベネズエラ・ボリバル",
 "Botão": "ボタン",
 "Buscar moeda": "通貨を検索",
 "Cor do desenho": "描画の色",
 "Coroa dinamarquesa": "デンマーク・クローネ",
 "Coroa norueguesa": "ノルウェー・クローネ",
 "Coroa sueca": "スウェーデン・クローナ",
 "Coroa tcheca": "チェコ・コルナ",
 "Crepúsculo": "たそがれ",
 "Crescente": "だんだん強く",
 "Curta": "短い",
 "Despesas em outra moeda (fora do lucro): {v}": "他通貨での支出（利益に含まない）：{v}",
 "Dirham dos Emirados Árabes Unidos": "UAEディルハム",
 "Dirham marroquino": "モロッコ・ディルハム",
 "Do seu país": "あなたの国",
 "Dong vietnamita": "ベトナム・ドン",
 "Dupla": "ダブル",
 "Dólar americano": "米ドル",
 "Dólar australiano": "豪ドル",
 "Dólar canadense": "カナダドル",
 "Dólar de Hong Kong": "香港ドル",
 "Dólar de Singapura": "シンガポールドル",
 "Dólar neozelandês": "ニュージーランドドル",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "このリストのすべての項目を送信します。今後作成される新しい項目も含みます。",
 "Enviar todos para a equipe": "すべてチームに送信",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "この薬のアラームをマナーモード中も鳴らすかどうかを選んでください。",
 "Euro": "ユーロ",
 "Exemplo": "例",
 "Falta uma resposta": "回答が1つ足りません",
 "Folha, tema e cores da caneta e das letras": "用紙、テーマ、ペンと文字の色",
 "Franco suíço": "スイス・フラン",
 "Guarani paraguaio": "パラグアイ・グアラニー",
 "Hryvnia ucraniana": "ウクライナ・フリヴニャ",
 "Iene japonês": "日本円",
 "Kwanza angolano": "アンゴラ・クワンザ",
 "Libra egípcia": "エジプト・ポンド",
 "Libra esterlina": "英ポンド",
 "Lira turca": "トルコ・リラ",
 "Longa": "長い",
 "Mais usadas": "よく使う通貨",
 "Metical moçambicano": "モザンビーク・メティカル",
 "Na página, segurar a bolinha faz o mesmo.": "ページ上で丸を長押ししても同じです。",
 "Naira nigeriana": "ナイジェリア・ナイラ",
 "Nenhuma moeda encontrada": "通貨が見つかりません",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Androidでは、\"おやすみモード\"がオンのときに服薬アラームを鳴らすには、My Planner に\"おやすみモード\"へのアクセスを許可する必要があります。\"設定を開く\"をタップし、リストで My Planner を探して許可をオンにしてください。",
 "No My Planner": "My Planner 内",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "iPhoneでは、マナーモードによりアラームが鳴らない場合があります。通常モードにしておいてください。",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "iPhoneでは、▶ で各タイプのイメージを確認できます。実際の通知にはiPhoneの標準のバイブレーションが使われます。",
 "Novo dólar taiwanês": "新台湾ドル",
 "Novo shekel israelense": "新イスラエル・シェケル",
 "Ouvir/Sentir": "聞く/感じる",
 "Peso argentino": "アルゼンチン・ペソ",
 "Peso chileno": "チリ・ペソ",
 "Peso colombiano": "コロンビア・ペソ",
 "Peso filipino": "フィリピン・ペソ",
 "Peso mexicano": "メキシコ・ペソ",
 "Peso uruguaio": "ウルグアイ・ペソ",
 "Política de privacidade": "プライバシーポリシー",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "完了。画面をロックして1分待つと、通知が無音で表示されます。",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "完了。画面をロックして1分待つと、通知が音なしでバイブレーションとともに表示されます。",
 "Páginas e canetas": "ページとペン",
 "Pôr do sol": "夕焼け",
 "Rand sul-africano": "南アフリカ・ランド",
 "Real brasileiro": "ブラジル・レアル",
 "Ringgit malaio": "マレーシア・リンギット",
 "Riyal saudita": "サウジアラビア・リヤル",
 "Rublo russo": "ロシア・ルーブル",
 "Rupia indiana": "インド・ルピー",
 "Rupia indonésia": "インドネシア・ルピア",
 "Rupia paquistanesa": "パキスタン・ルピー",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "My Planner がリストに表示されない場合、この許可はアプリの次のバージョンで追加されます（ストアからアップデートしてください）。",
 "Sentir": "感じる",
 "Sol peruano": "ペルー・ソル",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "ページで使うペンと文字のクイックカラーです。最初の色はページを開いたときの標準色です。丸をタップすると色を変更できます。",
 "Taka bengali": "バングラデシュ・タカ",
 "Teste grátis por {n} dias": "{n}日間の無料トライアル",
 "Tipo de vibração": "バイブレーションの種類",
 "Tirar do My Planner": "My Planner から外す",
 "Tocar mesmo no silencioso e no Não perturbe": "マナーモード・おやすみモード中も鳴らす",
 "Tocar só se o celular estiver no normal": "通常モードのときだけ鳴らす",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "このリストのすべての項目が My Planner に表示されます。新しい項目も含みます。",
 "Vaga-lume": "ほたる",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "バイブレーションするすべての通知に適用されます（バイブレーション、サウンドとバイブレーション）。",
 "Won sul-coreano": "韓国ウォン",
 "Xelim queniano": "ケニア・シリング",
 "Yuan chinês": "人民元",
 "Zloty polonês": "ポーランド・ズウォティ",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 この薬のアラームをマナーモード中も鳴らしますか？",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "フォトギャラリーは次のバージョンで登場します。今のところは「ファイル」または「写真を撮る」をご利用ください。",
 "Abrir o fichário do grupo": "グループのバインダーを開く",
 "Arrastar a barra": "バーをドラッグ",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "バインダーが共有されると、ここに表示されます。",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "名前でアイコンを検索（例：本、家、コーヒー）",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "「勉強」タブでは、バインダーの作成、タイマーの利用、レポートの確認などができます。✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "「{aba}」タブでは、自分だけのものを作成し、すべての機能を使えます。✨",
 "Conhecer a aba": "タブを見てみる",
 "Crie um fichário em Estudos e volte aqui.": "「勉強」でバインダーを作成してから、ここに戻ってきてください。",
 "Em sessão": "セッション中",
 "Encerrar e salvar o cronômetro e começar a sessão?": "タイマーを終了・保存して、セッションを開始しますか？",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "タイマーを終了・保存して、セッションを続けますか？",
 "Enquadre e toque no botão": "枠に収めてボタンをタップ",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "仲間が画面で見るバインダーを選んでください（閲覧のみ）。",
 "Esconder": "隠す",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "このファイルは共有した人の端末またはドライブにのみ保存されているため、ここには表示されません。",
 "Fichário do grupo": "グループのバインダー",
 "Guia passo a passo do app e de cada aba": "アプリと各タブのステップガイド",
 "Há um cronômetro em andamento.": "実行中のタイマーがあります。",
 "Há uma sessão em andamento.": "進行中のセッションがあります。",
 "Inserir imagem": "画像を挿入",
 "Mais ícones": "その他のアイコン",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "その名前のアイコンはありません。別の言葉を試すか、カテゴリから選んでください。",
 "Nenhuma matéria neste fichário ainda.": "このバインダーにはまだ科目がありません。",
 "Nenhuma página nesta matéria ainda.": "この科目にはまだページがありません。",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "勉強グループでは、画像とPDFはこの画面で開きます。この種類のファイルはアプリ内でプレビューできません。",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "今は表示できませんでした。インターネット接続を確認して、もう一度お試しください。",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "バインダーの共有機能はまだ準備中です。しばらくしてからもう一度お試しください。",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "このグループのバインダーはあなたの別の端末にあります。共有はその端末から続いています。",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = タブを見てみる · キャンセル = 今はしない",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "仲間はこのバインダーを見られなくなります。内容はすべてあなたの手元に残ります。",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "仲間はこのバインダーを画面で閲覧のみできます：編集、ダウンロード、印刷、共有はできません。あなたの目標、タイマー、復習済みページはあなただけのものです。",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "PDFをこの画面で見るには、ストアからアプリの最新バージョンをインストールしてください。",
 "Parar de compartilhar": "共有を停止",
 "Pausar a sessão": "セッションを一時停止",
 "Pausar a sessão e estudar só esta?": "セッションを一時停止して、これだけを勉強しますか？",
 "Página em branco.": "空白のページです。",
 "Quer estudar com tudo isso?": "これらすべてを使って勉強しませんか？",
 "Quer usar tudo isso?": "これらすべてを使ってみませんか？",
 "Selecionar todos": "すべて選択",
 "Trocar fichário": "バインダーを変更",
 "Você está participando do grupo de {nome}": "{nome}さんのグループに参加しています",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "このグループで共有されたものを画面で閲覧し、進み具合を確認できます。",
 "abacate, fruta": "アボカド, 果物, フルーツ",
 "academia, musculação, treino, peso": "ジム, 筋トレ, トレーニング, ウエイト",
 "acampamento, camping": "キャンプ, キャンプ場",
 "alfinete, fixar, importante": "ピン, 固定, 重要",
 "almoço, arroz, prato": "昼食, ランチ, ご飯, 皿",
 "alvo, meta, objetivo, foco": "的, 目標, 目的, 集中",
 "aniversário, bolo": "誕生日, ケーキ",
 "anotação, nota, lista, escrever": "メモ, ノート, リスト, 書く",
 "arco-íris": "虹",
 "avião, viagem, voo": "飛行機, 旅行, フライト",
 "balança, direito, justiça, lei, processo": "天秤, 法律, 正義, 法, 訴訟",
 "balde, limpeza": "バケツ, 掃除",
 "banana, fruta": "バナナ, 果物",
 "banheira, banho, banheiro": "バスタブ, 入浴, お風呂",
 "barbear, barba, lâmina": "ひげそり, ひげ, カミソリ",
 "bicicleta, pedalar, bike": "自転車, サイクリング, バイク",
 "bolo, doce, sobremesa": "ケーキ, スイーツ, デザート",
 "brilho, mágica": "きらきら, 魔法",
 "cabelo, cabeleireiro, corte": "髪, 美容師, カット",
 "cachorro, cão, pet": "犬, いぬ, ペット",
 "caderno": "ノート",
 "caderno, fichário, amarelo": "ノート, バインダー, 黄色",
 "café, xícara, pausa": "コーヒー, カップ, 休憩",
 "caixa, pacote, mudança, entrega": "箱, 荷物, 引っ越し, 配達",
 "calendário, agenda, data": "カレンダー, 予定, 日付",
 "cama, quarto": "ベッド, 寝室",
 "caminhada, caminhar, andar": "ウォーキング, 歩く, 散歩",
 "camisa, gravata, roupa, trabalho": "シャツ, ネクタイ, 服, 仕事",
 "carne, churrasco": "肉, バーベキュー",
 "carrinho, mercado, compras, supermercado": "カート, 市場, 買い物, スーパー",
 "carro, dirigir, veículo": "車, 運転, 自動車",
 "certo, feito, visto": "チェック, 完了, 済み",
 "cesto, roupa, lavanderia, lavar roupa": "かご, 服, ランドリー, 洗濯",
 "chave de fenda, ferramenta, conserto": "ドライバー, 工具, 修理",
 "chave, senha": "鍵, パスワード",
 "chocolate, doce": "チョコレート, お菓子",
 "chuveiro, banho": "シャワー, 入浴",
 "chá, xícara": "お茶, カップ",
 "compras, sacolas, shopping": "買い物, 買い物袋, ショッピング",
 "computador, monitor, tela": "パソコン, モニター, 画面",
 "computador, notebook, informática": "パソコン, ノートパソコン, IT",
 "coração amarelo": "黄色のハート",
 "coração azul": "青のハート",
 "coração branco": "白のハート",
 "coração laranja": "オレンジのハート",
 "coração roxo": "紫のハート",
 "coração verde": "緑のハート",
 "coração, amor, saúde, vermelho": "ハート, 愛, 健康, 赤",
 "corrida, correr": "ランニング, 走る",
 "creme, hidratante, pele, skincare": "クリーム, 保湿, 肌, スキンケア",
 "croissant, pão, café da manhã": "クロワッサン, パン, 朝食",
 "câmera, foto, fotografia": "カメラ, 写真, 撮影",
 "cérebro, mente, memória, pensar": "脳, 心, 記憶, 考える",
 "dado, jogo de tabuleiro": "サイコロ, ボードゲーム",
 "dente, dentista": "歯, 歯医者",
 "despertador, relógio, alarme, acordar": "目覚まし時計, 時計, アラーム, 起きる",
 "diamante, joia": "ダイヤモンド, 宝石",
 "dinheiro, pagar, conta, pagamento": "お金, 支払う, 請求, 支払い",
 "dormir, sono, descanso": "寝る, 睡眠, 休息",
 "e-mail, mensagem, carta": "メール, メッセージ, 手紙",
 "escada": "階段",
 "escova de dentes, dentes": "歯ブラシ, 歯",
 "escrever, redação, caneta": "書く, 作文, ペン",
 "esponja, lavar louça": "スポンジ, 皿洗い",
 "esquadro, régua, geometria, desenho técnico": "三角定規, 定規, 幾何, 製図",
 "estrela brilhante, destaque": "輝く星, ハイライト",
 "estrela, favorito": "星, お気に入り",
 "etiqueta, marcador": "タグ, ラベル",
 "extintor, segurança, incêndio": "消火器, 安全, 火事",
 "falar, idioma, inglês, conversa": "話す, 言語, 英語, 会話",
 "feito, concluído, certo": "完了, 終わった, チェック",
 "ferramenta, conserto, manutenção": "工具, 修理, メンテナンス",
 "festa, comemoração": "パーティー, お祝い",
 "filme, cinema, série": "映画, 映画館, ドラマ",
 "fogo, urgente, sequência": "火, 緊急, 連続記録",
 "folha, natureza, erva, chá": "葉, 自然, ハーブ, お茶",
 "fone de ouvido, áudio, música, podcast": "ヘッドホン, オーディオ, 音楽, ポッドキャスト",
 "formatura, capelo, faculdade, diploma, universidade": "卒業, 角帽, 大学, 卒業証書, 学位",
 "força, braço, músculo": "力, 腕, 筋肉",
 "frango, coxa": "鶏肉, もも肉",
 "frigideira, cozinhar, ovo, cozinha": "フライパン, 料理, 卵, キッチン",
 "futebol, bola, esporte": "サッカー, ボール, スポーツ",
 "gato, pet": "猫, ペット",
 "gelo, geladeira, congelador": "氷, 冷蔵庫, 冷凍庫",
 "gráfico, planilha, finanças, relatório": "グラフ, スプレッドシート, 家計, レポート",
 "ingresso, show, evento": "チケット, ライブ, イベント",
 "jogo, videogame, game": "ゲーム, テレビゲーム, ビデオゲーム",
 "lancha, barco": "モーターボート, 船",
 "leite, copo": "牛乳, コップ",
 "letras, alfabeto, português": "文字, アルファベット, 国語",
 "link, corrente": "リンク, 鎖",
 "livro aberto, leitura, ler": "開いた本, 読書, 読む",
 "livro azul, caderno": "青い本, ノート",
 "livro laranja, caderno": "オレンジの本, ノート",
 "livro verde, caderno": "緑の本, ノート",
 "livro vermelho, caderno": "赤い本, ノート",
 "livros, estudo, estudar, biblioteca": "本, 勉強, 学習, 図書館",
 "lixo, lixeira": "ゴミ, ゴミ箱",
 "lua, noite": "月, 夜",
 "lâmpada, ideia, luz": "電球, アイデア, 明かり",
 "macarrão, massa": "パスタ, 麺",
 "maleta, trabalho, escritório, negócios": "ブリーフケース, 仕事, オフィス, ビジネス",
 "massagem, relaxar": "マッサージ, リラックス",
 "maçã, fruta": "りんご, 果物",
 "microfone, cantar, karaokê, palestra": "マイク, 歌う, カラオケ, 講演",
 "microscópio, ciência, biologia": "顕微鏡, 科学, 生物",
 "mochila, escola, filhos": "リュック, 学校, 子ども",
 "montanha, trilha": "山, 登山, ハイキング",
 "mundo, planeta, geografia": "世界, 地球, 地理",
 "médico, consulta, exame, saúde": "医者, 診察, 検査, 健康",
 "música, nota musical": "音楽, 音符",
 "natação, nadar, piscina": "水泳, 泳ぐ, プール",
 "olho, visão, oftalmologista": "目, 視力, 眼科",
 "oração, orar, gratidão, igreja": "祈り, 祈る, 感謝, 教会",
 "ovo": "卵",
 "pastas, arquivo, fichário, divisórias": "フォルダ, ファイル, バインダー, 仕切り",
 "peixe": "魚",
 "pescaria, pescar": "釣り, 釣る",
 "pessoas, reunião, equipe, grupo": "人々, 会議, チーム, グループ",
 "piano, teclado musical": "ピアノ, 鍵盤",
 "pintura, arte, desenho": "絵画, アート, 絵",
 "pipa": "凧",
 "pipoca, cinema": "ポップコーン, 映画館",
 "pizza": "ピザ",
 "planta, vaso, regar": "植物, 鉢, 水やり",
 "porta, entrada": "ドア, 入口",
 "praia, férias": "ビーチ, 休暇",
 "prato, refeição, louça, jantar": "皿, 食事, 食器, 夕食",
 "prédio, história, governo, tribunal": "建物, 歴史, 政府, 裁判所",
 "pão, padaria": "パン, パン屋",
 "pé, podólogo": "足, フットケア",
 "pôr do sol, amanhecer": "夕日, 日の出",
 "quebra-cabeça, peça": "パズル, ピース",
 "queijo": "チーズ",
 "raio, energia, rápido": "稲妻, エネルギー, 速い",
 "refrigerante, suco, bebida": "ソフトドリンク, ジュース, 飲み物",
 "remédio, medicamento, vitamina, farmácia": "薬, 医薬品, ビタミン, 薬局",
 "sabão, sabonete, lavar": "石けん, せっけん, 洗う",
 "salada, dieta, verdura": "サラダ, ダイエット, 野菜",
 "sanduíche, lanche": "サンドイッチ, 軽食",
 "sino, aviso, lembrete": "ベル, お知らせ, リマインダー",
 "skate": "スケートボード",
 "sofá, sala": "ソファ, リビング",
 "sol, manhã, dia": "太陽, 朝, 昼",
 "spa, sauna, autocuidado": "スパ, サウナ, セルフケア",
 "teatro, máscaras": "演劇, 仮面",
 "telefone, ligação, ligar": "電話, 通話, 電話する",
 "tigela, cereal, sopa, mingau": "ボウル, シリアル, スープ, おかゆ",
 "trevo, sorte": "クローバー, 幸運",
 "troféu, conquista, prêmio": "トロフィー, 達成, 賞",
 "tubo de ensaio, química, laboratório": "試験管, 化学, 実験室",
 "tênis, esporte": "テニス, スポーツ",
 "unha, manicure": "爪, ネイル, マニキュア",
 "vassoura, limpeza, faxina, varrer": "ほうき, 掃除, 大掃除, 掃く",
 "violão, guitarra": "ギター, エレキギター",
 "yoga, meditação, alongamento": "ヨガ, 瞑想, ストレッチ",
 "{n} selecionada": "{n}件選択中",
 "{n} selecionadas": "{n}件選択中",
 "{n} selecionado": "{n}件選択中",
 "{n} selecionados": "{n}件選択中",
 "ábaco, matemática, contas, cálculo, contabilidade": "そろばん, 数学, 計算, 算数, 会計",
 "água, gota, hidratar": "水, しずく, 水分補給",
 "árvore, jardim, quintal": "木, 庭, 裏庭",
 "ônibus, transporte": "バス, 交通",
 "1 dia antes": "1日前",
 "1 dia depois": "1日後",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "サブスクリプションはスマートフォンのアプリからアプリストアで購入でき、このサイトでも有効です。",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "キーが不完全です（短すぎます）。キーのページのコピーボタンで、もう一度コピーしてください。",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "キーに含まれない文字が入っています。周りの文字を含めず、キーだけをもう一度コピーしてください。",
 "A galeria chega na próxima atualização do app.": "ギャラリーは次回のアプリのアップデートで追加されます。",
 "ALERTAS": "通知",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "有料のタブを開いて無料トライアルを始めてから、ここに戻ってください。",
 "Abrir a barra do editor": "エディターのバーを開く",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "現在はアプリのおやすみモードの時間です：通知は5秒以内に、音もバイブもなしで届きます。",
 "Aguardando confirmação": "確認待ち",
 "Aguardando envio ao My Planner": "My Planner への送信待ち",
 "Alertas de cada fatura": "請求ごとの通知",
 "Alertas do fim da garantia": "保証終了の通知",
 "Alertas do vencimento": "期限の通知",
 "Alertas: {campo}": "通知：{campo}",
 "Alvorada": "夜明け",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "このタブを開くと、アプリと同じロック解除（パスワード、生体認証、PIN）を求めます。設定 > タブ で変更できます。",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "添付ファイルをタップすると、選んだスマートフォンのアプリで開きます（スマートフォンに聞かれたら「1回のみ」または「常時」）。そこで編集した内容はファイル自体に保存されます。",
 "App instalado": "インストール済みのアプリ",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch：すでにすべてをスマートフォンの「ヘルスケア」アプリに記録しています。何もする必要はありません。",
 "Arquivados e fixados": "アーカイブ済みとピン留め",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "タブごとに整理された、読んで保存するためのファイル。{data} に作成。",
 "As notificações do My Planner estão desligadas no celular.": "My Planner の通知がスマートフォンでオフになっています。",
 "Atualização automática disponível no app instalado.": "インストール済みのアプリで自動アップデートを利用できます。",
 "Aurora": "オーロラ",
 "Avisos: alarme (som)": "通知：アラーム（音）",
 "Baixar o app": "アプリをダウンロード",
 "Baixar o arquivo técnico": "技術ファイルをダウンロード",
 "Baixar para ler (PDF)": "閲覧用をダウンロード（PDF）",
 "Barra do editor (caneta, marca-texto, texto)": "エディターのバー（ペン、蛍光ペン、テキスト）",
 "Brisa": "そよ風",
 "Campainha": "チャイム",
 "Canal": "チャネル",
 "Cole a chave antes de testar.": "テストする前にキーを貼り付けてください。",
 "Começa em": "開始日",
 "Como avisar": "通知方法",
 "Confira a chave": "キーを確認",
 "Conta de teste de compras": "購入テスト用アカウント",
 "Conta vencida": "期限切れの請求",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "すぐにキーをコピーしてください（一度しか表示されません）。\"sk-\" で始まります。",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "すぐにキーをコピーしてください（一度しか表示されません）。\"sk-ant-\" で始まります。",
 "Cristal": "クリスタル",
 "Daqui a 1 hora": "1時間後",
 "Daqui a 1 semana": "1週間後",
 "Daqui a 3 dias": "3日後",
 "Depois de 5 min fora": "5分離れたら",
 "Depois de 5 minutos fora": "5分間離れたら",
 "Desligar a senha desta aba": "このタブのパスワードをオフにする",
 "Detalhes técnicos": "技術的な詳細",
 "Dia {n} de {t}": "{t}日中{n}日目",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "ヒント：キーはパスワードのようなものです。メッセージで送ったり公開したりしないでください。漏れた場合は、サイトで削除して新しいキーを作成してください。",
 "Documento vencido": "期限切れの書類",
 "Ela abre em {d}.": "{d} に開封されます。",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "{d} に開封されます。通知が届きます：{quando}。",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "{d} に開封されます。通知が1件届きます：{quando}。",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "\"API keys\" で \"Create key\"（キーを作成）をタップし、\"My Planner\" などの名前を付けます。",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "\"Billing\"（請求）でカードを追加し、数ドル分のクレジットを入れます。ChatGPT Plus のサブスクリプションはここでは使えません。",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "\"Billing\"（請求）でクレジットを購入します。Claude Pro のサブスクリプションはここでは使えません。",
 "Em breve": "近日公開",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "ChatGPT と同じアカウントでログインするか、新しく作成します。",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Google アカウントでログインします（Gmail のアカウントで大丈夫です）。",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "ログインするかアカウントを作成します（Claude と同じメールアドレスでもかまいません）。",
 "Enviados para o My Planner": "My Planner に送信済み",
 "Enviar agora": "今すぐ送信",
 "Escolha hoje ou uma data futura.": "今日または今後の日付を選んでください。",
 "Escolhas lembradas": "記憶した選択",
 "Escolher a data": "日付を選ぶ",
 "Escolher células": "セルを選ぶ",
 "Escolher quando": "タイミングを選ぶ",
 "Espessura": "太さ",
 "Esquecer": "忘れる",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "このキーは別のサービス（{servico}）のものです。ここでは Claude、ChatGPT、Gemini のキーだけが使えます。",
 "Esta chave é do {ia}, não do {escolhida}.": "このキーは {ia} のもので、{escolhida} のものではありません。",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "このアカウントでは、アプリが新規アカウントとして表示され、解放済みのタブはありません。ロック、無料トライアル、購入の確認用です。他のアカウントは変わりません。",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "このツールは PDF のページを表示する必要があり、新しいアプリ（バージョン 0.50）で使えるようになります。ブラウザーを使うか、ストアで My Planner をアップデートしてください。",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "{ia} のキーではないようです。{ia} のキーは {ini} で始まります。",
 "Este aviso está em \"Desligado\": nada vai tocar.": "この通知は \"オフ\" になっています：何も鳴りません。",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "このスマートフォンは、アプリを閉じているときの通知にまだ対応していません。ストアで My Planner をアップデートしてください（バージョン {v} 以降）。アプリを開いているときは、通知はすでに使えます。",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "この種類の通知は、スマートフォンの通知設定でオフになっています。",
 "Estudado": "勉強済み",
 "Estudado: {dur}": "勉強時間：{dur}",
 "Faltou: {dur}": "不足：{dur}",
 "Fazer os testes terminarem agora": "トライアルを今すぐ終了させる",
 "Fechar a barra do editor": "エディターのバーを閉じる",
 "Fichário": "バインダー",
 "Figurinhas e emojis": "ステッカーと絵文字",
 "Garantia terminou": "保証終了",
 "Gerando…": "作成中…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "書類、検査結果、健康の記録を専用のパスワードで保管します。サポートでも読むことはできません。パスワードを忘れると、復元する方法はありません。",
 "Harpa": "ハープ",
 "Horas por dia": "1日の時間",
 "Identificação": "本人情報",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "これはキーではなく、リンクかメールアドレスのようです。API キーのページでキー全体をコピーしてください。",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "これは送信した場合にのみ My Planner に表示されます。今すぐ送信しますか？",
 "Já dá para confirmar {titulo}?": "{titulo} をもう確認できますか？",
 "Lembrar minha escolha nesta aba": "このタブで選択を記憶する",
 "Lembrete para confirmar: {data}": "確認のリマインダー：{data}",
 "Marimba": "マリンバ",
 "Marque pelo menos um dia da semana no plano.": "プランで曜日を少なくとも1つ選んでください。",
 "Me lembre de confirmar": "確認をリマインドする",
 "Me lembre depois": "あとでリマインドする",
 "Menos": "少なく",
 "Meta somada": "目標の合計",
 "Meta somada: {dur}": "目標の合計：{dur}",
 "Meus dados - My Planner {data}": "マイデータ - My Planner {data}",
 "Meus dados do My Planner": "My Planner のマイデータ",
 "Mostrar a barra": "バーを表示",
 "Mudar senha do diário": "日記のパスワードを変更",
 "Na primeira vez, aceite os termos de uso.": "初回は利用規約に同意してください。",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "ストア版では、購入はスマートフォンのアプリストアで行います。現在、このキーはテスト用にサブスクリプションを再現しています。",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "他のタブの内容が自動で My Planner に送られることはありません。これらの項目には日付があり、まだ送信されていません。",
 "Nenhum estudo registrado neste mês.": "今月の勉強記録はありません。",
 "Nenhum item aguardando envio.": "送信待ちの項目はありません。",
 "Nenhum teste começado": "開始したトライアルはありません",
 "Nesta tela não há nada para adicionar.": "この画面には追加するものはありません。",
 "No dia": "当日",
 "Nova nota rápida": "新しいクイックメモ",
 "Nova página do dia": "新しい日のページ",
 "Não deu certo": "うまくいきませんでした",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "含まれないもの：日記の内容と金庫の項目（パスワードで保護されています）、写真、添付ファイル。アプリにデータを復元するには、技術ファイルを使ってください。",
 "Não foi possível gerar o PDF.": "PDF を作成できませんでした。",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "今はテストできません。数秒後にもう一度お試しください。",
 "Não lembrar": "記憶しない",
 "Não, obrigada": "いいえ、結構です",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "日記は専用のパスワードで保護されているため、このファイルには含まれません。",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "アプリが \"ファイルに保存\" を開くので、保存先のフォルダーを選んでください（iCloud Drive も選べます）。",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "アプリは選んだファイルへのショートカットだけを保存します：ファイルは元の場所（Drive、OneDrive、ダウンロード）にあるまま、スマートフォンのアプリで開きます。何もコピーされません。このオプションはカメラで撮った写真にも適用されます。",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "この端末にインストールされているアプリはバージョン {v} です。音声通話やビデオ通話をするには、ストアで My Planner をアップデートしてください（バージョン 0.35 以降）。メッセージはすでに使えます。",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "通知はサイレントで通知一覧に直接届きます：スマートフォンの設定で My Planner の通知をオンにしてください。",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "通知は音なしで届きます：この種類の通知の音がスマートフォンの設定でオフになっています。",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "通知は届きますが、My Planner の通知音がスマートフォンでオフになっています。",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "招待にはアプリのダウンロードリンクが含まれます。リンクから参加した人は、そのまま事務所に入ります。",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "音声入力はアプリの新しいバージョンで使えるようになります。マイクを使うには、ストアで My Planner をアップデートしてください。",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "アプリと同じロック解除：パスワード、生体認証、PIN。入るときに一度だけ求め、タブ内では再度求めません。ギャラリー、カメラ、ファイルを開いても離れたことにはなりません。大きな項目の削除には引き続きパスワードが必要です。",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "スマートフォンのマナーモードでアラームが鳴らないことがあります。スマートフォンを通常モードにしておいてください。",
 "O plano fica só em Estudos (não vai para o My Planner).": "プランは「勉強」にのみ残ります（My Planner には送られません）。",
 "Opcional: prazo, horas por dia e dias da semana.": "任意：期限、1日の時間、曜日。",
 "Os avisos do celular funcionam no app instalado.": "スマートフォンの通知は、インストール済みのアプリで使えます。",
 "Os avisos no celular funcionam no app instalado.": "スマートフォンでの通知は、インストール済みのアプリで使えます。",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "開始したトライアルは終了しました。タブを開くと \"無料トライアルは終了しました\" が表示されます。",
 "Outros dados": "その他のデータ",
 "Ouvir": "聞く",
 "Pacote em uso": "利用中のパック",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "購読するには、スマートフォンのアプリストアで My Planner をアップデートしてください。",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "閲覧用（PDF）：タブごとに整理され、タイトルと日付付き。どの端末やパソコンでも開けます。",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "\"おやすみモード\" がオンでも薬のアラームを鳴らすには、スマートフォンで My Planner に \"おやすみモード\" へのアクセスを許可する必要があります。\"設定を開く\" をタップし、一覧から My Planner を探して許可をオンにしてください。",
 "Passo a passo para criar a chave": "キー作成の手順",
 "Pedir de novo": "もう一度求める",
 "Pedir senha ao abrir esta aba": "このタブを開くときにパスワードを求める",
 "Plano com período": "期間付きのプラン",
 "Plano começa em {d}": "プランの開始：{d}",
 "Por matéria": "科目別",
 "Prolongar": "延長",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "完了：通知は5秒以内に音付きで届きます。鳴らない場合は、スマートフォンがマナーモードになっていないか確認してください。",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "完了：通知は5秒以内にバイブのみで届きます。",
 "Publicado em": "公開日",
 "Pulso": "パルス",
 "Quando o app bloquear": "アプリがロックされたとき",
 "Quer proteger esta aba com senha?": "このタブをパスワードで保護しますか？",
 "Recolher ou arrastar a barra": "バーをたたむ・ドラッグする",
 "Recomeçar os testes grátis": "無料トライアルをやり直す",
 "Recomeçar os testes grátis?": "無料トライアルをやり直しますか？",
 "Rolar a folha para os lados": "用紙を左右にスクロール",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "時計を接続した場合：歩数、距離、カロリー、運動、心拍数、睡眠の1日ごとの合計を、Health Connect またはスマートフォンの「ヘルスケア」アプリから読み取ります。アプリはこれらのデータを読み取るだけで、変更することはありません。",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "インターネットに接続されていないか、接続が切れました。Wi-Fi またはモバイルデータを確認して、もう一度お試しください。",
 "Senha desta aba": "このタブのパスワード",
 "Seu plano terminou": "プランが終了しました",
 "Sino": "ベル",
 "Som do alarme": "アラーム音",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "法定保証とメーカー保証を合算します。保証書で確認してください。",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "My Planner のデータを含む2つのファイルです（データポータビリティ、LGPD）：",
 "Só quando o app bloquear": "アプリがロックされたときのみ",
 "Tamanho da borracha": "消しゴムのサイズ",
 "Tamanho da letra": "文字サイズ",
 "Tempo": "時間",
 "Termina em": "終了日",
 "Testar": "テスト",
 "Texto de exemplo": "サンプルテキスト",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "\"アラーム（音）\" の通知で鳴ります。\"音とバイブ\" はスマートフォンの通知音を使います。",
 "Toda vez que sair": "離れるたびに",
 "Toda vez que sair da aba": "タブを離れるたびに",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "すべてのタブが新規アカウントのように \"{n}日間の無料トライアル\" に戻ります。シミュレーションのサブスクリプションはオフになります。",
 "Todos os fichários": "すべてのバインダー",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "\"Create API key\"（API キーを作成）をタップします。プロジェクトを求められたら、表示されたものを選ぶか新しく作成します。",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "上の \"API キーを作成\" をタップします。OpenAI のプラットフォームが開きます（ChatGPT のサイトではありません）。",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "上の \"API キーを作成\" をタップします。Anthropic の Console が開きます（Claude のサイトではありません）。",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "上の \"API キーを作成\" をタップします。Google AI Studio が開きます。",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "接続 をタップし、「ヘルスケア」アプリの画面で My Planner が読み取れる項目をオンにします。",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "キーの横にあるコピーのアイコンをタップします。キーは \"AIza\" または \"AQ.\" で始まります。",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "表のセル（または \"セルを選ぶ\"）をタップすると、そのセルの文字サイズを変更できます。",
 "Transparência": "透明度",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "技術用（復元用）：My Planner だけが読める完全なコピー。使うには 設定 › クラウドとバックアップ › ファイルをインポート へ。",
 "Uma carta da {nome} abre em {n} dias 💌": "{nome} からの手紙が {n}日後に開封されます 💌",
 "Usa a senha do app": "アプリのパスワードを使う",
 "Usar no {ia}": "{ia} で使う",
 "Use o app no celular para baixar o arquivo técnico.": "技術ファイルをダウンロードするには、スマートフォンのアプリを使ってください。",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "最終価格はアプリストアが決定し、お住まいの国の通貨で表示されます。",
 "Você ainda não enviou {titulo} para o My Planner.": "{titulo} をまだ My Planner に送信していません。",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "ここに戻り、下の欄に貼り付けて \"保存してテスト\" をタップします。",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "\"API keys\" に戻り、\"Create new secret key\"（キーを作成）をタップします。",
 "atualização automática": "自動アップデート",
 "erro desconhecido": "不明なエラー",
 "estudados no mês": "今月の勉強時間",
 "faltou {dur}": "{dur} 不足",
 "hoje {feito} de {meta}": "今日 {feito} / {meta}",
 "hoje é folga": "今日はお休み",
 "login do Google (não é chave de API)": "Google ログイン（API キーではありません）",
 "meta cumprida": "目標達成",
 "o que veio com a instalação": "インストール時に付属",
 "outro": "その他",
 "provisório": "仮",
 "superou {dur}": "{dur} 超過",
 "token de login (não é chave de API)": "ログイントークン（API キーではありません）",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} の応答に時間がかかりすぎました。少ししてからもう一度お試しください。",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} は現在停止中か混み合っています。キーの問題ではありません：しばらくしてからもう一度お試しください。",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} がモデル {modelo} でテストに応答しました。各タブで使えるようになりました。",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} がこの内容の読み取りを拒否しました（同社の安全フィルター）。",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}：キーは存在しますが、AI を使う権限がありません。手順で案内しているページで新しいキーを作成してください。",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}：無効なキーです。キー全体をコピーしたか確認するか、新しいキーを作成してください。",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}：このキーはインターネット上に公開されたため、同社によりブロックされました。削除して新しいキーを作成してください。",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}：利用上限に達しました。数分（無料プランでは明日まで）待ってから、もう一度お試しください。",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}：選んだモデルはお使いのアカウントでは利用できません。\"モデル\" で別のモデルを選んでください。",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}：このサービスはお住まいの地域、またはこの種類のアカウントでは利用できません。",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}：API アカウントの残高がないか、支払い方法が登録されていません。同社のサイトでクレジットを追加してください。",
 "{item}: a garantia termina hoje ({data}).": "{item}：保証は今日（{data}）で終了します。",
 "{item}: a garantia terminou em {data}.": "{item}：保証は {data} に終了しました。",
 "{item}: venceu em {data}.": "{item}：{data} に期限切れになりました。",
 "{mes} de {ano}": "{ano}年{mes}",
 "{nome} protegida com senha": "{nome} はパスワードで保護されています",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}：プランを終了しますか、それとも新しい終了日で延長しますか？何も削除されません。",
 "{n} dias antes": "{n}日前",
 "{n} dias de estudo no plano · {dur} por dia": "プランの勉強日 {n}日 · 1日 {dur}",
 "{n} dias de plano": "プラン {n}日間",
 "{n} dias depois": "{n}日後",
 "{n} item(ns) aguardando envio ao My Planner": "My Planner への送信待ちが {n}件あります",
 "{n} itens aguardando envio": "送信待ち {n}件",
 "{quando} às {hora}": "{quando} {hora}",
 "ÚLTIMOS 6 MESES": "過去6か月",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "My Planner Anne を開き、CPF またはメールアドレスとパスワードでログインしてください。",
 "Anexo": "添付ファイル",
 "Assédio ou ameaça": "嫌がらせ・脅迫",
 "Bloquear {nome}": "{nome} をブロック",
 "Conte mais (opcional)": "詳細（任意）",
 "Conteúdo impróprio": "不適切なコンテンツ",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "攻撃的なコンテンツや迷惑なユーザーは許容されません。報告は24時間以内にチームが確認します。",
 "Denunciar": "報告",
 "Denunciar contato": "連絡先を報告",
 "Denunciar grupo": "グループを報告",
 "Denunciar mensagem": "メッセージを報告",
 "Denúncia enviada": "報告を送信しました",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "メッセージで行った報告：理由、報告された相手、報告されたメッセージの抜粋。内容を確認するため、My Planner のチームだけが読みます。",
 "Enviar denúncia": "報告を送信",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "アカウントの CPF またはメールアドレスを添えて、削除を依頼するメールを送ってください。15日以内に返信します。",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "メッセージやグループでは、攻撃的・違法・不適切なコンテンツや迷惑なユーザーを許容しません。誰でもメッセージ、連絡先、グループを報告でき（メッセージを長押しするか ⋮ > 報告 をタップ）、誰でもブロックできます。報告は24時間以内にチームが確認し、コンテンツが削除されたり、送信者のアカウントが停止または削除されたりすることがあります。",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "ありがとうございます。24時間以内にチームが確認します。",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "CPF でログインするアカウントの場合、本人のアカウントであることを確認した後、サポートが新しいパスワードを作成します。CPF または登録済みのメールアドレスを書いて {email} までご連絡ください。",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "報告の理由は何ですか？報告された相手に、誰が報告したかは知らされません。",
 "Spam": "スパム",
 "{nome} não pode mais conversar com você.": "{nome} はもうあなたとチャットできません。",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\n有効期限 {d}。証明書は金庫に暗号化して保存され、この端末とあなたのクラウドのコピーにのみ保管されます。",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. パソコンで {url} を開き、「QRコードでログイン」を選びます。",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. ここで「ブラウザを接続」をタップし、パソコンのQRコードにカメラを向けます。",
 "Abandonados": "中断した本",
 "Bloquear o computador": "パソコンをロック",
 "Cheguei na página...": "今のページ…",
 "Computador conectado": "接続中のパソコン",
 "Computador desconectado": "パソコンの接続を解除しました",
 "Conectado em {d}": "{d} に接続",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "グループを作ってリンクを送りましょう。参加した人は本の資料を見て、読書の進み具合を追えます。管理者は追加・編集・写真の追加ができ、このタブを使っている人にも許可できます。メンバーの追加や削除は管理者だけです。",
 "Depois de {n} minutos parado": "{n}分間操作がないとき",
 "Desconectar o computador?": "パソコンの接続を解除しますか？",
 "Difícil demais": "難しすぎる",
 "Editar livro": "本を編集",
 "Entrar com o QR Code": "QRコードでログイン",
 "Escreva (ex.: filosofia)": "入力（例：哲学）",
 "Este computador": "このパソコン",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "このパソコンは接続を解除されました（スマホから、または別のパソコンがログインしたため）。もう一度使うにはQRコードでログインしてください。",
 "Já existe um computador conectado": "すでにパソコンが接続されています",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "すでにパソコンが接続されています。こちらに切り替えますか？もう一方は接続を解除されます。",
 "Navegador": "ブラウザ",
 "Nenhum computador conectado": "接続中のパソコンはありません",
 "Novo livro": "新しい本",
 "Não gostei": "好みじゃなかった",
 "Não, abandonei": "いいえ、やめました",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "パソコンの My Planner が閉じます。もう一度使うにはQRコードで接続するだけです。",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "QRコードは3分ごとに変わり、1回だけ有効です。共用パソコンでは、使い終わったら 設定 › このパソコンからログアウト を使ってください。",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "データはクラウドとスマホに保存されたままです。もう一度ログインするにはQRコードを使います。",
 "Parei em": "中断した日",
 "Perdi o interesse": "興味がなくなった",
 "Por que parei": "中断した理由",
 "Páginas e meta": "ページと目標",
 "Quero voltar a ler?": "また読みたい？",
 "Sair deste computador": "このパソコンからログアウト",
 "Sair deste computador?": "このパソコンからログアウトしますか？",
 "Se quiser, escreva com as suas palavras": "よければ自分の言葉で書いてください",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "この時間マウスやキーボードを使わないと My Planner がロックされます。戻るにはアカウントのパスワードを入力します（またはQRコードで再ログイン）。",
 "Sem tempo": "時間がない",
 "Sim, depois": "はい、あとで",
 "Só um computador pode ficar conectado por vez.": "同時に接続できるパソコンは1台だけです。",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "修了証の写真やPDFは「写真・ファイル・リンク」に入れ、「修了証」として印を付けます。",
 "ABNT copiada": "ABNTをコピーしました",
 "APA copiada": "APAをコピーしました",
 "Ano inválido": "無効な年",
 "Ano ou data de publicação": "出版年または日付",
 "Assisti em": "観た日",
 "Buscando os dados...": "データを検索中…",
 "Calculado pelos módulos": "モジュールから計算",
 "Carga horária (horas)": "時間数（時間）",
 "Certificado": "修了証",
 "Certificado emitido em": "修了証の発行日",
 "Cheguei na aula": "今のレッスン",
 "Cheguei na aula...": "今のレッスン…",
 "Cheguei na temporada": "今のシーズン",
 "Cheguei no episódio": "今のエピソード",
 "Citação copiada": "引用をコピーしました",
 "Colocar em pasta": "フォルダに入れる",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "このフォルダに本・映画・講座を入れるとリストができます。",
 "Comentário": "コメント",
 "Copiar ABNT": "ABNTをコピー",
 "Copiar APA": "APAをコピー",
 "Copiar citação (ABNT)": "引用をコピー（ABNT）",
 "Copiar citação (APA)": "引用をコピー（APA）",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "この科目用に、チェックリスト・リスト・自由テキスト・手書きのカードを作れます。右にスワイプで削除、左にスワイプでアーカイブまたは複製。",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "グループを作ってリンクを送りましょう。参加した人はリストを見て追えます。管理者は追加・編集・写真の追加ができ、このタブを使っている人にも許可できます。メンバーの追加や削除は管理者だけです。",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "グループを作ってリンクを送りましょう。参加した人は講座の資料を見て追えます。管理者は追加・編集・写真の追加ができ、このタブを使っている人にも許可できます。メンバーの追加や削除は管理者だけです。",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "まずこのタブの 📁 フォルダ でフォルダを作ってください。",
 "DOI (artigos)": "DOI（論文）",
 "Data de acesso": "アクセス日",
 "Deixar avulsas": "単独のままにする",
 "Descrição (objetivo)": "説明（目的）",
 "Digite o ano com 4 números (ex.: {a}).": "年は4桁で入力してください（例：{a}）。",
 "Direção": "監督",
 "Editar pasta": "フォルダを編集",
 "Editora": "出版社",
 "Edição": "版",
 "Em 1 mês": "1か月後",
 "Em {n} meses": "{n}か月後",
 "Episódios por temporada (opcional)": "1シーズンのエピソード数（任意）",
 "Escreva o trecho na anotação para copiar a citação.": "引用をコピーするには、メモに一節を書いてください。",
 "Este item já está em todas as pastas.": "この項目はすべてのフォルダに入っています。",
 "Ex.: 10.1590/...": "例：10.1590/...",
 "Ex.: TCC — Ética e Direito": "例：卒論 — 倫理と法",
 "Ex.: {a}": "例：{a}",
 "Fazendo": "受講中",
 "Grupo de filmes e séries": "映画・ドラマのグループ",
 "Grupo de leitura": "読書グループ",
 "Grupo do curso": "講座グループ",
 "ISBN": "ISBN",
 "Ideia minha": "自分の考え",
 "Instrutor": "講師",
 "Itens da pasta": "フォルダの項目",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "本・映画・講座をフォルダにまとめましょう（例：「卒論」「小説だけ」）。同じ項目を複数のフォルダに入れられます。",
 "Link (material online)": "リンク（オンライン資料）",
 "Lista copiada": "リストをコピーしました",
 "Lista de referências": "参考文献リスト",
 "Mais de um autor: separe com ponto e vírgula (;).": "著者が複数：セミコロン（;）で区切ります。",
 "Módulo": "モジュール",
 "Nada novo": "新しい情報はありません",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "本・映画・講座の ⋮ で「フォルダに入れる」をタップ。",
 "Nome da pasta": "フォルダ名",
 "Não achei dados novos para completar a ficha.": "補える新しいデータは見つかりませんでした。",
 "Não foi possível preencher": "入力できませんでした",
 "O módulo não tem cards de anotações.": "このモジュールにメモカードはありません。",
 "Organizador": "編者",
 "Os dados vêm da ficha do livro (Editar › Referência).": "データは本の情報から（編集 › 参考文献）。",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "フォルダ内の本・映画・講座は削除されません。タブに残ります。",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "このモジュールのメモカード{n}枚もごみ箱に入ります。",
 "Pasta vazia": "空のフォルダ",
 "Preencha o título (e o que mais tiver) na ficha.": "タイトル（分かる情報も）を入力してください。",
 "Preencher pelo DOI": "DOIから入力",
 "Preencher pelo link": "リンクから入力",
 "Produtora ou país": "制作会社または国",
 "Quero fazer": "受講したい",
 "Quero voltar?": "また再開したい？",
 "Referência vazia": "参考文献が空です",
 "Referências": "参考文献",
 "Se deixar avulsas, elas continuam somando no total do curso.": "単独のままにしても講座の合計に含まれます。",
 "Subtítulo": "副題",
 "Tirar da pasta": "フォルダから外す",
 "Total de episódios (opcional)": "エピソード総数（任意）",
 "Total de temporadas (opcional)": "シーズン総数（任意）",
 "Tradutor": "翻訳者",
 "Trecho (citação)": "抜粋（引用）",
 "Trecho vazio": "抜粋が空です",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "すでに{n}回分のレッスンを受けました。どのモジュールに入れますか？",
 "Volume": "巻",
 "{n} item(ns)": "{n}件",
 "{n} referência(s) em ordem alfabética.": "{n}件の参考文献（五十音・アルファベット順）。",
 "Ícone": "アイコン",
 "ASSISTIDOS POR DIA": "日ごとの視聴",
 "ASSISTIDOS POR MÊS": "月ごとの視聴",
 "AULAS POR DIA": "日ごとのレッスン",
 "AULAS POR MÊS": "月ごとのレッスン",
 "Apagar a meta": "目標を消す",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "観た {a} · 視聴中 {b} · 中断 {c} · 観たい {d}",
 "Aulas": "レッスン",
 "CURSOS": "講座",
 "Concluí {a} · Fazendo {b} · Parei {c}": "修了 {a} · 受講中 {b} · 中断 {c}",
 "Datas": "日付",
 "Datas escolhidas": "選んだ期間",
 "Datas à escolha": "期間を選ぶ",
 "Definir meta de {ano}": "{ano}年の目標を決める",
 "Definir meta do ano": "今年の目標を決める",
 "FILMES E SÉRIES": "映画・ドラマ",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "あと{f}講座：月に約{m}",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "あと{f}冊：月に約{m}冊",
 "Faltam {f} título(s): dá cerca de {m} por mês": "あと{f}本：月に約{m}本",
 "Gênero": "ジャンル",
 "Incluir lista de referências no PDF": "PDFに参考文献リストを入れる",
 "LIVROS": "本",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "読了 {a}冊 · 中断 {b} · 読書中 {c}",
 "Meta de {ano}": "{ano}年の目標",
 "Meta de {ano}: usar a de {antes} ({n})?": "{ano}年の目標：{antes}年と同じ（{n}）にしますか？",
 "Meta do ano cumprida": "今年の目標を達成",
 "Mudar": "変更",
 "Nada neste período.": "この期間はありません。",
 "Nota": "評価",
 "O PDF não leva as suas anotações, resumos e comentários.": "PDFにはメモ・要約・コメントは入りません。",
 "POR ITEM": "項目ごと",
 "Plataforma": "プラットフォーム",
 "PÁGINAS POR DIA": "日ごとのページ",
 "PÁGINAS POR MÊS": "月ごとのページ",
 "Quantos no ano?": "1年で何件？",
 "Quero ler {a} · Abandonei {b}": "読みたい {a} · 中断した本 {b}",
 "Relatório de leitura e mídia": "読書とメディアのレポート",
 "concluídos no período": "期間内に完了",
 "cursos concluídos no período": "期間内に修了した講座",
 "livros lidos no período": "期間内に読んだ本",
 "pág. {a} de {n}": "{a}/{n}ページ",
 "títulos assistidos no período": "期間内に観た作品",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "期間内のレッスン {a}回 · 修了講座 {h}時間",
 "{a} de {n} aulas ({p}%)": "{a}/{n}レッスン（{p}%）",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{ano}年 {a}/{n} 講座を修了",
 "{a} de {n} livro(s) em {ano}": "{ano}年 {a}/{n}冊",
 "{a} de {n} título(s) assistido(s) em {ano}": "{ano}年 {a}/{n}本視聴",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "状態変更日がない項目{n}件：作成日を使いました。",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{d}日で{p}ページ · 最長連続 {s}日",
 "{p}% lido · falta {f}%": "{p}%読了 · 残り{f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "このタブはパスワードが必要です。先にロックを解除すると、ガイドはここから続きます。",
 "Abrir esta aba": "このタブを開く",
 "Mostrar na tela": "画面で見せる",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "いま画面にこの場所が見つかりません。正しい画面を開いてもう一度お試しください。",
 "Primeiros passos": "はじめに",
 "Buscar no guia": "ガイドを検索",
 "Entendi": "わかった",
 "{n} de {total} passos feitos": "{total}ステップ中{n}完了",
 "Já fiz": "できた",
 "Guia em construção": "ガイド準備中",
 "Limpar marcações": "チェックを消す",
 "Este ponto ainda não está marcado no app.": "この場所はまだアプリで印が付いていません。",
 "Dicas e atalhos": "ヒントとショートカット",
 "Gestos do app": "アプリのジェスチャー",
 "Procurando na tela…": "画面で探しています…",
 "Guia das abas": "タブのガイド",
 "Voltar ao guia": "ガイドに戻る",
 "Para que serve": "何に使うか",
 "Disponível no app do celular.": "スマホのアプリで使えます。",
 "Nada encontrado no guia.": "ガイドに見つかりません。",
 "Recursos que valem para todas as abas": "すべてのタブ共通の機能",
 "Perguntas comuns": "よくある質問",
 "Ligar e desligar partes": "パーツのオン・オフ",
 "Entrada cancelada. Este computador não foi conectado.": "ログインをキャンセルしました。このコンピューターは接続されていません。",
 "Alterações ainda não enviadas": "まだ送信されていない変更",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "一部の変更はまだサーバーに送信されていません（インターネット未接続？）。今ログアウトすると失われます。それでもログアウトしますか？",
 "Sair mesmo assim": "それでもログアウト",
 "O seu papel no grupo não permite mudar aqui.": "グループでのあなたの役割では、ここを変更できません。",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "今は DOI を照会できませんでした（インターネット未接続？）。もう一度お試しください。",
 "DOI inválido.": "DOI が無効です。",
 "DOI não encontrado.": "DOI が見つかりません。",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "このサイトはここからデータを読み取らせませんでした（パソコンのブラウザではよくあります）。スマートフォンのアプリを使うか、DOI を使うか、項目を入力してください。",
 "Atualizando...": "更新中...",
 "Banco de dados (Supabase, plano grátis)": "データベース（Supabase、無料プラン）",
 "Cadeado (HTTPS) até": "HTTPS の鍵の期限",
 "Dados das abas: {d}": "タブのデータ：{d}",
 "Disco": "ディスク",
 "Esta conta não tem acesso a estas informações.": "このアカウントはこの情報にアクセスできません。",
 "Ligado há": "稼働時間",
 "Livre: {l} · site: {s}": "空き：{l} · サイト：{s}",
 "Maiores tabelas": "大きいテーブル",
 "Memória em uso": "使用中のメモリ",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "サーバーはまだレポートを送信していません。53-SERVIDOR-0.78.bat の後、10 分ごとに送信します。",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "サーバーにはまだこの機能がありません。コンピューターで 53-SERVIDOR-0.78.bat を実行してください。",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "サーバーのシステムが再起動を求めています（セキュリティ更新をインストール済み）。",
 "Processador": "プロセッサー",
 "Relatório do servidor: {q}": "サーバーレポート：{q}",
 "Servidor": "サーバー",
 "Servidor do site (Locaweb)": "サイトのサーバー（Locaweb）",
 "Sistema": "システム",
 "Só você vê este quadro.": "このパネルはあなただけに表示されます。",
 "Versão do site no ar": "公開中のサイトのバージョン",
 "atrasado: confira se o servidor está ligado": "遅延中：サーバーが動いているか確認してください",
 "sem cadeado": "鍵なし",
 "{a} ({n} guardadas)": "{a}（{n} 件保存）",
 "{d} dia(s) e {h} h": "{d} 日と {h} 時間",
 "{n} núcleo(s) · carga {c}": "{n} コア · 負荷 {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · 7 日間で新規 {novas}、アクティブ {ativas}",
 "{u} de {t} ({p}%)": "{u} / {t}（{p}%）",
 "Fechar teclado": "キーボードを閉じる",
 "Mostrar as ferramentas": "ツールを表示",
 "Últimas cores usadas": "最近使った色",
 "Voltar ao topo": "先頭へ戻る",
 "Topo": "先頭",
 "1 atividade do roteiro por fazer": "旅程の未完了アクティビティ 1 件",
 "1 dia": "1 日",
 "1 item por pôr na mala": "未パッキングのアイテム 1 件",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "「旅行」のリスト 1 件は My Planner に丸ごと送られていましたが、そこから削除されました。今後は各項目の ⋮ から 1 件ずつ送ります。",
 "1 lugar não visitado": "未訪問の場所 1 件",
 "1 reserva por confirmar": "未確認の予約 1 件",
 "Abrir o bloco": "セクションを開く",
 "Adicionar pessoa": "人を追加",
 "Ainda pode gastar {v}": "あと {v} 使えます",
 "Ao ligar, o valor entra em Gastos como pago.": "オンにすると、金額は支払済みとして「支出」に入ります。",
 "Até (dd/mm/aaaa)": "終了日（日/月/年）",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "\"同行者\"に人を追加してください（旅行を編集）。",
 "Como foi?": "どうでしたか？",
 "Concluído em {d}": "{d} に完了",
 "Confirmada em {d}": "{d} に確定",
 "Confirmadas": "確定済み",
 "Dia anterior": "前の日",
 "Dias": "日数",
 "Dias × valor por dia": "日数 × 1日あたりの金額",
 "Documentos (só o tipo e a validade)": "書類（種類と有効期限のみ）",
 "EXIGÊNCIAS DO DESTINO": "渡航先の要件",
 "Em mãos": "手元にあり",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "渡航先の要件を入力してください（例：パスポートの空白ページ 2 ページ、予防接種証明書）。その国の公式サイトで確認してください。",
 "Ex.: Lisboa (LIS)": "例：リスボン (LIS)",
 "Ex.: São Paulo (GRU)": "例：サンパウロ (GRU)",
 "Falta confirmar": "未確認",
 "Falta pôr": "未パッキング",
 "Faltou ({n}): {l}": "忘れ物 ({n}): {l}",
 "Foi ({n}): {l}": "持参 ({n}): {l}",
 "Fotos (lista das legendas)": "写真（キャプション一覧）",
 "Gasto de {nome} em {d}": "{d} の {nome} の支出",
 "Gastos do dia": "その日の支出",
 "Gastos em outras moedas (não convertidos): {v}": "他通貨での支出（未換算）: {v}",
 "Gastos por dia": "日別の支出",
 "Horário de chegada": "到着時刻",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "場所（訪問済み・未訪問・必見・評価）",
 "Mala (o que foi e o que faltou)": "荷物（持参したもの・忘れたもの）",
 "Marcar como acertado": "精算済みにする",
 "Marcar como acertado?": "精算済みにしますか？",
 "Na mala": "パッキング済み",
 "Nenhuma parada ainda": "立ち寄り先はまだありません",
 "Nova exigência": "新しい要件",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "書類の番号や金庫の中身はレポートに含まれません。異なる通貨の金額は分けて表示されます。",
 "O QUE AINDA FALTA": "まだ残っていること",
 "O QUE INCLUIR": "含める内容",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "任意。帰国日から数えてそれより前にパスポートが切れる場合、アプリが通知します。その国の要件を確認してください。",
 "Orçamento previsto × gasto por categoria": "予算 × カテゴリ別の支出",
 "Passou do previsto em {v}": "予算を {v} 超過",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "各書類の有効期限を入力してください。期限切れ前にアプリが通知します。書類の写真は金庫で保護されます。",
 "Próximo dia": "次の日",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "旅行グループのメンバーは自動で追加されます。アプリを使っていない人は\"+ 人を追加\"を使ってください。",
 "Recolher o bloco": "セクションを閉じる",
 "Relatório da viagem": "旅行レポート",
 "Reserva confirmada": "予約確定",
 "Resumo da viagem": "旅行の概要",
 "Resumo da viagem (datas, destino, pessoas)": "旅行の概要（日程・目的地・同行者）",
 "Roteiro por dia (feito e falta)": "日別の旅程（完了・未完了）",
 "Sem data": "日付なし",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "パスポートが受け付けられない可能性があります。その国の要件を確認してください",
 "Subir": "上へ移動",
 "Total do dia: {v}": "その日の合計: {v}",
 "Uma frase (opcional)": "ひとこと（任意）",
 "Validade mínima exigida (meses)": "パスポートの必要最低有効期間（月）",
 "Validade: {d}": "有効期限: {d}",
 "Valor por dia": "1日あたりの金額",
 "Viagens no My Planner": "My Planner の旅行",
 "Visitado": "訪問済み",
 "Visitado em {d}": "{d} に訪問",
 "Voltaria: {r}": "また行きたい: {r}",
 "Voltaria?": "また行きたいですか？",
 "confirmada": "確定済み",
 "em mãos": "手元にあり",
 "gasto na viagem {d}": "旅行の支出 {d}",
 "meses": "か月",
 "outro gasto": "その他の支出",
 "vence em {d}": "{d} に期限切れ",
 "{a} de {b} confirmadas": "{a}/{b} 件確定",
 "{a} de {b} em mãos": "{a}/{b} 件手元にあり",
 "{a} de {b} feitos": "{a}/{b} 件完了",
 "{a} de {b} na mala": "{a}/{b} 件パッキング済み",
 "{a} de {b} pagos": "{a}/{b} 件支払済み",
 "{a} de {b} visitados": "{a}/{b} 件訪問済み",
 "{de} deve {v} a {para}": "{de} は {para} に {v} 支払う",
 "{g} de {p}": "{g} / {p}",
 "{n} atividades do roteiro por fazer": "旅程の未完了アクティビティ {n} 件",
 "{n} item(ns) enviado(s).": "{n} 件を送信しました。",
 "{n} itens por pôr na mala": "未パッキングのアイテム {n} 件",
 "{n} já estava(m) no My Planner.": "{n} 件はすでに My Planner にありました。",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "「旅行」のリスト {n} 件は My Planner に丸ごと送られていましたが、そこから削除されました。今後は各項目の ⋮ から 1 件ずつ送ります。",
 "{n} lugares não visitados": "未訪問の場所 {n} 件",
 "{n} reservas por confirmar": "未確認の予約 {n} 件",
 "{n} sem data (não foi).": "{n} 件は日付なし（未送信）。",
 "ARTIGOS E SITES": "記事とサイト",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "送信は項目ごとになりました（項目の ⋮ から、または複数選択して）。以下のリストは丸ごと送られていたため My Planner から外しました（{n} 件、何も削除していません）：",
 "Artigo científico": "学術論文",
 "Artigo de site ou blog": "サイト・ブログ記事",
 "Artigo ou site": "記事またはサイト",
 "Artigos e sites": "記事とサイト",
 "Autor(es)": "著者",
 "Cadastrar pela foto ou PDF": "写真やPDFから登録",
 "Capítulo de livro": "書籍の章",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "グループを作ってリンクを送ります。参加した人は記事を見て読書の様子を追えます。管理者は追加・編集・写真の追加ができ、このタブを使っている人にも許可できます。メンバーの追加・削除は管理者のみです。",
 "DOI": "DOI",
 "Data ou ano de publicação": "発行日または年",
 "Editar artigo ou site": "記事・サイトを編集",
 "Enviar para o My Planner (lembrete de renovação)": "My Planner に送る（更新のリマインダー）",
 "Envio para o My Planner": "My Planner への送信",
 "Ex.: 2024 ou 12/03/2024": "例：2024 または 2024/03/12",
 "Ex.: 45-60": "例：45-60",
 "Grupo de artigos": "記事グループ",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "記事・ニュース・ウェブページを参考文献付き（ABNT・APA）で保存。DOI やリンクから入力できます。",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "読了 {a} · 読書中 {b} · 中断 {c} · 読みたい {d}",
 "Minhas anotações do artigo": "記事のメモ",
 "Notícia": "ニュース",
 "Novo artigo ou site": "新しい記事・サイト",
 "Os dados vêm da ficha do artigo (Editar).": "データは記事のカードから（編集）。",
 "Páginas (opcional)": "ページ（任意）",
 "Revista, site ou veículo": "雑誌・サイト・媒体",
 "artigos e sites lidos no período": "期間中に読んだ記事・サイト",
 "1 confirmado": "1 人確定",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "「保留中」だったゲスト 1 人を「招待予定」に移しました。アプリから招待を送ると、自動で「招待済み・未回答」になります。",
 "1 extra": "予備 1 人",
 "1 talvez": "1 人未定",
 "A convidar": "招待予定",
 "Agendar na igreja": "教会を予約",
 "Agora": "今",
 "Agradeci": "お礼済み",
 "Agradeci em {d}": "{d} にお礼済み",
 "Agradecidos": "お礼済み",
 "Alianças": "結婚指輪",
 "Aluguéis (mesas, cadeiras, louças)": "レンタル（テーブル・椅子・食器）",
 "Avisar a data (save the date)": "日程を知らせる（セーブ・ザ・デート）",
 "Bebidas": "飲み物",
 "Beca e cerimônia": "ガウンと式典",
 "Bolo": "ケーキ",
 "Brincadeiras": "ゲーム",
 "Brincadeiras e amigo secreto": "ゲームとプレゼント交換",
 "Brindes": "記念品",
 "Buffet": "ケータリング",
 "Calculado sozinho: valor menos o sinal.": "自動計算：金額から手付金を引いた額。",
 "Calcular quantidades": "数量を計算",
 "Categoria do orçamento": "予算カテゴリ",
 "Celebrante": "司式者",
 "Cerimônia": "式",
 "Cerveja (adultos)": "ビール（大人）",
 "Checklist de preparação": "準備チェックリスト",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "イベントの日付を設定（イベントを編集）すると、各項目の期限が表示されます。",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "「イベントのメンバー」に人を追加してください（イベントを編集）。",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "カテゴリごとに使う予定の金額を入力してください。⊕ でゲスト 1 人あたりで計算できます。契約した業者は選んだカテゴリに自動で入ります。",
 "Combinado: {v}": "合意額：{v}",
 "Comprado": "購入済み",
 "Comprados": "購入済み",
 "Comprar a decoração e as lembrancinhas": "飾り付けとプチギフトを買う",
 "Comprar as alianças": "結婚指輪を買う",
 "Comprar as lembrancinhas": "プチギフトを買う",
 "Comprar bebidas e gelo": "飲み物と氷を買う",
 "Comprar comida e bebidas": "食べ物と飲み物を買う",
 "Comprar o que falta": "足りない物を買う",
 "Comprar ou alugar a roupa": "衣装を買うかレンタルする",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "同伴者を含む確定人数。誰かが確定または取り消すと自動で変わります。",
 "Confirmar a presença dos convidados": "ゲストの出欠を確認",
 "Confirmar os fornecedores": "業者を確認",
 "Confirmar os fornecedores e os convidados": "業者とゲストを確認",
 "Contratar a comida": "料理を手配",
 "Contratar a comida e o bolo": "料理とケーキを手配",
 "Contratar a decoração": "装飾を手配",
 "Contratar comida e bebidas": "料理と飲み物を手配",
 "Contratar foto e vídeo": "写真・ビデオを手配",
 "Contratar o buffet": "ケータリングを手配",
 "Convidado, sem resposta": "招待済み・未回答",
 "Convidados (por situação, com acompanhantes)": "ゲスト（状況別・同伴者込み）",
 "Convidados que contam no ⊕": "⊕ で数えるゲスト",
 "Convites": "招待状",
 "Cronograma do dia (com responsáveis e situação)": "当日のスケジュール（担当者・状況付き）",
 "Data do restante": "残金の日付",
 "Data do sinal": "手付金の日付",
 "Decoração": "装飾",
 "Definir a data e o orçamento": "日付と予算を決める",
 "Definir a lista de convidados": "ゲストリストを決める",
 "Doces": "お菓子",
 "Dá para mudar, tirar e incluir itens depois.": "項目は後から変更・削除・追加できます。",
 "Enviar os convites": "招待状を送る",
 "Equipamentos (projetor, som)": "機材（プロジェクター・音響）",
 "Equipe (garçons, limpeza)": "スタッフ（給仕・清掃）",
 "Escolha \"Outro\" para escrever o nome.": "「その他」を選ぶと名前を入力できます。",
 "Escolher a roupa": "衣装を選ぶ",
 "Escolher a roupa dos noivos": "新郎新婦の衣装を選ぶ",
 "Escolher os padrinhos": "介添人・代父母を選ぶ",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "ゲスト {n} 人分の目安です。反映する前に自由に変更できます。",
 "Eu faço": "私がやる",
 "Ex.: 200 un.": "例：200 個",
 "Ex.: Copos descartáveis": "例：使い捨てコップ",
 "Ex.: Jogo de panelas": "例：鍋セット",
 "Ex.: Reservar o local": "例：会場を予約",
 "Ex.: em negociação": "例：交渉中",
 "Extras de margem (quem aparece sem avisar)": "予備人数（連絡なしで来る人）",
 "Falta 1 dia": "あと 1 日",
 "Falta agradecer": "お礼未済",
 "Falta comprar": "未購入",
 "Falta pagar": "未払い",
 "Fazer a lista de presentes": "ギフトリストを作る",
 "Fazer o curso de batismo": "洗礼の講座を受ける",
 "Fornecedores (contratado, pago, falta)": "業者（契約額・支払済・残り）",
 "Foto e vídeo": "写真・ビデオ",
 "Fraldas": "おむつ",
 "Frase curta (opcional)": "短いひとこと（任意）",
 "Hoje é o dia do evento!": "今日はイベント当日です！",
 "Igreja e celebrante": "教会と司式者",
 "Incluir os Talvez": "未定を含める",
 "Incluir telefones": "電話番号を含める",
 "Item da lista de compras": "買い物リストの項目",
 "Item da preparação": "準備の項目",
 "Já deram: {d} · Falta: {f}": "集まった額：{d} · 残り：{f}",
 "Já deu": "支払済み",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "使った金額をここに記録します。業者への支払いとチェックした買い物は自動で入ります。",
 "Lançar o gasto": "支出を記録",
 "Lembrancinhas": "プチギフト",
 "Levar para os itens": "項目に反映",
 "Local / espaço": "会場",
 "Mais um extra": "予備を 1 人増やす",
 "Menos um extra": "予備を 1 人減らす",
 "Música / som / DJ": "音楽・音響・DJ",
 "No dia do evento": "イベント当日",
 "O que comprar": "買う物",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "誰かが確定または取り消すと、合計は自動で変わります。",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "契約金額はこのカテゴリの予定額として自動で入り、支払った分は支出に入ります。",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "金額はイベントの支出の、項目のカテゴリに入ります。スキップしてもかまいません。",
 "Onde comprar": "購入先",
 "Orçamento do evento": "イベントの予算",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "チェックした項目は ⊕（ゲスト 1 人あたり）でカテゴリに入ります。あとは ⊕ をタップして単価を入れるだけです。",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "ゲストの電話番号は「電話番号を含める」をオンにした場合のみ PDF に載ります。異なる通貨の金額は別々に表示されます。",
 "Pago em {d}": "{d} 支払済み",
 "Parte da vaquinha": "割り勘の分",
 "Pessoas do evento": "イベントのメンバー",
 "Pessoas do evento: {p}": "イベントのメンバー：{p}",
 "Preparar as brincadeiras": "ゲームを準備",
 "Preparação": "準備",
 "Presente recebido": "受け取ったプレゼント",
 "Presentes": "プレゼント",
 "Prova final da roupa": "最終試着",
 "Pular": "スキップ",
 "Quantidade por convidado": "ゲスト 1 人あたりの量",
 "Quantidade por convidado × valor unitário": "1 人あたりの量 × 単価",
 "Quanto custou?": "いくらでしたか？",
 "Quanto já deu": "支払済みの額",
 "Quanto vai contribuir": "出す予定の額",
 "Quantos dias antes do evento": "イベントの何日前",
 "Quem deu": "贈り主",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "イベントのグループのメンバーは自動で入ります。アプリを使っていない人は「+ 人を追加」で追加してください。このリストはスケジュール、支出、割り勘で使われます。",
 "Recreação e brinquedos": "レクリエーションと遊具",
 "Refrigerante": "ソフトドリンク",
 "Relatório do evento": "イベントレポート",
 "Relatório do evento (PDF)": "イベントレポート（PDF）",
 "Reservar o local": "会場を予約",
 "Reservar o local da cerimônia e da festa": "式とパーティーの会場を予約",
 "Reservar o local ou a mesa da festa": "パーティーの会場か席を予約",
 "Restante": "残金",
 "Restante pago": "残金支払済み",
 "Resumo do evento": "イベントの概要",
 "Roupa e beleza": "衣装と美容",
 "Salgados": "軽食（塩味）",
 "Separar a roupa e o que levar": "衣装と持ち物を用意する",
 "Separar os documentos e as alianças": "書類と結婚指輪を用意する",
 "Separar os documentos e os ingressos": "書類とチケットを用意する",
 "Sinal": "手付金",
 "Sinal pago": "手付金支払済み",
 "Sinal {v} pago": "手付金 {v} 支払済み",
 "Usar a lista pronta para {tipo}": "{tipo} 用の既成リストを使う",
 "Vai contribuir": "参加する",
 "Valor unitário": "単価",
 "Vaquinha": "割り勘",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "共有されたものはすべて常に最新の状態で確認できます。追加・編集・タスクの引き受けをするには、このタブを購読してください。",
 "agradeci": "お礼済み",
 "atrasado": "期限切れ",
 "completo": "達成",
 "deu {d} de {v}": "{v} 中 {d} 支払済み",
 "em {l}": "{l} で",
 "falta o valor": "金額未入力",
 "falta {v} até {d}": "{d} までに残り {v}",
 "gasto em {e}": "{e} の支出",
 "kg": "kg",
 "o evento": "イベント",
 "restante": "残金",
 "sinal": "手付金",
 "total": "合計",
 "un.": "個",
 "{n} confirmados": "{n} 人確定",
 "{n} convidados contam no ⊕ por convidado.": "{n} 人のゲストが ⊕（1 人あたり）で数えられます。",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "「保留中」だったゲスト {n} 人を「招待予定」に移しました。アプリから招待を送ると、自動で「招待済み・未回答」になります。",
 "{n} extras": "予備 {n} 人",
 "{n} talvez": "{n} 人未定",
 "{q} por convidado": "1 人あたり {q}",
 "{v} por convidado": "1 人あたり {v}",
 "Item completo": "詳しい項目",
 "Nota rápida": "クイックメモ",
 "📝 Nota rápida": "📝 クイックメモ",
 "Conteúdo da nota": "メモの内容",
 "{c} confirmado(s) de {n} convidado(s)": "招待客 {n} 人中 {c} 人確定",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "オフィス「{nome}」の書類・予定の会議・録画が全員分削除されます。会話はメッセージに残ります。",
 "Confirme para apagar o escritório": "オフィスを削除するには確認してください",
 "Escreva o assunto da reunião para poder marcar.": "予定するには会議の件名を入力してください。",
 "{n} min (marcada para {m} min)": "{n} 分（予定 {m} 分）",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "今はファイルをダウンロードできません。ネット接続を確認してもう一度お試しください。",
 "Meus clientes": "マイ顧客",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "すべての仕事タブで使う、ひとつの顧客リスト：連絡先、住所、タグ、メモ、ファイル。",
 "Copiar para Meus clientes": "マイ顧客にコピー",
 "Ver ou mudar": "表示・変更",
 "Ver o documento completo": "番号をすべて表示",
 "CEP incompleto": "CEP が不完全です",
 "O CEP tem 8 números.": "CEP は8桁です。",
 "CEP não encontrado": "CEP が見つかりません",
 "Confira os números ou preencha o endereço à mão.": "番号を確認するか、住所を手入力してください。",
 "Não foi possível buscar o CEP": "CEP を検索できませんでした",
 "Confira a internet ou preencha o endereço à mão.": "インターネット接続を確認するか、住所を手入力してください。",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "このメールアドレスは何か足りないようです（例：name@site.com）。",
 "opcional": "任意",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "顧客はひとつのリストにまとまり、すべての仕事タブで使われるようになりました。",
 "Portal do Cliente: {n} cliente(s).": "顧客ポータル：{n} 件の顧客。",
 "Freelancer & Projetos: {n} cliente(s).": "フリーランス＆プロジェクト：{n} 件の顧客。",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} 件は複数のタブで同じ顧客だったため、ひとつの記録にまとめました。",
 "Nenhum cliente repetido.": "重複した顧客はいません。",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "何も削除されていません：書類、注文、カード、時間は元の場所にあります。",
 "Já está em Meus clientes": "すでにマイ顧客にあります",
 "{nome} já está na lista.": "{nome} はすでにリストにあります。",
 "Copiado para Meus clientes": "マイ顧客にコピーしました",
 "Só o nome e o contato foram copiados.": "名前と連絡先のみコピーしました。",
 "Aniversário hoje!": "今日が誕生日！",
 "Fechar tudo": "すべて閉じる",
 "Abrir tudo": "すべて開く",
 "Quem é": "基本情報",
 "Razão social": "法人名",
 "Nome fantasia": "屋号",
 "Data de abertura": "設立日",
 "Inscrição estadual / municipal": "州・市の登録番号",
 "Outras pessoas de contato": "その他の担当者",
 "Como chamar": "呼び名",
 "Cliente desde": "顧客になった日",
 "Outro telefone": "その他の電話",
 "Site": "ウェブサイト",
 "Melhor jeito de falar": "おすすめの連絡方法",
 "Autorizou receber mensagens": "メッセージ受信に同意済み",
 "Outros endereços": "その他の住所",
 "Relacionamento": "関係",
 "Como me conheceu": "知ったきっかけ",
 "Etiquetas": "タグ",
 "Nada anotado ainda.": "メモはまだありません。",
 "Bloco da aba {aba}": "{aba} タブの欄",
 "Abrir na aba {aba}": "{aba} タブで開く",
 "Uma lista só, usada por todas as abas de trabalho.": "すべての仕事タブで使う、ひとつのリスト。",
 "Escreva o nome do cliente.": "顧客名を入力してください。",
 "Telefone / WhatsApp": "電話 / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "必須は名前だけです。入力したい項目を開いてください。",
 "Como chamar (apelido)": "呼び名（ニックネーム）",
 "Inscrição estadual / municipal (opcional)": "州・市の登録番号（任意）",
 "Cargo": "役職",
 "Telefone da pessoa de contato": "担当者の電話",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "その他の担当者（1行に1人：名前、役職、電話）",
 "O telefone principal é WhatsApp": "メインの電話は WhatsApp",
 "O outro telefone é WhatsApp": "その他の電話は WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "例：@name",
 "Ex.: WhatsApp, à tarde": "例：WhatsApp、午後",
 "Estado (UF)": "州（UF）",
 "Endereço (como estava escrito)": "住所（元の表記）",
 "Outros endereços (trabalho, entrega...)": "その他の住所（勤務先、配送先…）",
 "Google": "Google",
 "Passou na frente": "店の前を通った",
 "Indicado por": "紹介者",
 "Criar etiqueta": "タグを作成",
 "Ex.: VIP, Mensal, Atacado": "例：VIP、月額、卸売",
 "Ativo": "アクティブ",
 "Inativo": "非アクティブ",
 "Em negociação": "商談中",
 "O cliente autorizou receber mensagens?": "顧客はメッセージ受信に同意していますか？",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "同意がない場合、この顧客には誕生日メッセージ、自動の支払い催促、キャンペーン案内を送りません。",
 "aniversário hoje": "今日が誕生日",
 "contato: {n}": "担当者：{n}",
 "com esse telefone": "この電話番号で",
 "com esse e-mail": "このメールアドレスで",
 "com esse documento": "この番号で",
 "com esse nome": "この名前で",
 "Cliente parecido": "似た顧客",
 "Já existe {nome} {por}. Abrir?": "{nome} はすでにあります（{por}）。開きますか？",
 "Cadastrar mesmo assim": "このまま登録",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "この顧客の記録、メモ、ファイルが削除されます。",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "次のタブからも：{abas}（そこにある書類、注文、カード、時間を含む）。",
 "Juntar com outra ficha": "別の記録と統合",
 "Juntar fichas": "記録を統合",
 "Não há outra ficha para juntar.": "統合できる記録がほかにありません。",
 "Juntar \"{nome}\" com:": "「{nome}」を次と統合：",
 "Juntar as duas fichas?": "2つの記録を統合しますか？",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "「{a}」が「{b}」のすべて（情報、メモ、ファイル、タブとのつながり）を引き継ぎます。「{b}」の記録はなくなります。",
 "Juntar": "統合",
 "Confirme para juntar as fichas": "記録の統合を確認してください",
 "Aniversariantes do mês": "今月の誕生日",
 "Ativos": "アクティブ",
 "Inativos": "非アクティブ",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "顧客は一度登録するだけで、使っているすべての仕事タブに表示されます。",
 "Novo cliente": "新規顧客",
 "Editar cliente": "顧客を編集",
 "Linha do tempo": "タイムライン",
 "{n} registro(s)": "{n} 件の記録",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "まだありません。売上、支払い、書類、作業時間がここに表示されます。",
 "Me deve": "未払い額",
 "Total pago": "支払い合計",
 "Última compra ou atendimento": "最後の購入・対応",
 "Próximo compromisso": "次の予定",
 "na entrega": "引き渡し時",
 "Passou do limite de fiado ({v}).": "ツケの上限（{v}）を超えました。",
 "Recebeu {v} ({p})": "{v} 受領（{p}）",
 "Hoje é aniversário de {n}.": "今日は{n}さんの誕生日です。",
 "Mandar parabéns": "お祝いを送る",
 "{n}: parcela de {v} atrasada.": "{n}：{v}の分割払いが延滞中。",
 "Cobrar": "請求する",
 "{n} não compra há {d} dias.": "{n}さんは{d}日間購入がありません。",
 "Chamar de volta": "声をかける",
 "🟢 em dia · 🟡 sumido": "🟢 問題なし · 🟡 ご無沙汰",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 問題なし · 🟡 期日間近またはご無沙汰 · 🔴 延滞",
 "Limite de fiado (opcional)": "ツケの上限（任意）",
 "Avisa quando o que ele deve passar deste valor.": "未払い額がこの金額を超えるとお知らせします。",
 "A prazo": "分割払い",
 "parcela atrasada": "延滞中の分割払い",
 "falta na entrega": "引き渡し時に残金",
 "Sumidos": "ご無沙汰",
 "Sinal pago, falta o resto": "手付金済み、残金あり",
 "Pagou {a} de {b}": "{b}のうち{a}支払い済み",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "この分割払いは「マイ顧客」から来ています。ここで受領済みにするか、顧客を開いて請求し、領収書を作成してください。",
 "Sinal + restante": "手付金＋残金",
 "Pix": "Pix",
 "Cartão de crédito à vista": "クレジットカード一括",
 "Cartão de crédito parcelado": "クレジットカード分割",
 "Fiado / a prazo": "ツケ・分割払い",
 "Parcela única": "一括払い",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "{nome}さん、こんにちは！お誕生日おめでとうございます！🎉 素敵な一日になりますように。",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "{nome}さん、こんにちは！ご無沙汰しています。何かお手伝いできることはありますか？またお会いできるのを楽しみにしています！",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "{nome}さん、こんにちは！{d}が期日だった{v}のお支払いについて、念のためご連絡しました。何かあればお気軽にどうぞ。よろしくお願いします！",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "{nome}さん、こんにちは！{v}のお支払い{d}について、念のためご連絡しました。何かあればお気軽にどうぞ。よろしくお願いします！",
 "que vence dia {d}": "（期日：{d}）",
 "Quanto recebeu?": "受け取った金額は？",
 "Falta {v}. Pode ser só uma parte.": "残り{v}。一部だけでも構いません。",
 "(seu nome ou sua marca, em Como você recebe?)": "（お名前またはブランド名、「受け取り方法」で設定）",
 "Recibo {c}": "領収書 {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "{c}様より、{o}の代金として{v}を受領いたしました。",
 "{v} no {f} → recebe {l}": "{v}（{f}）→ 受取額 {l}",
 "Pagou {a} de {b}, faltam {c}": "{b}のうち{a}支払い済み、残り{c}",
 "Recebido em {d}": "{d}に受領",
 "Cobrar pelo WhatsApp": "WhatsAppで請求",
 "Sem autorização": "許可なし",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "この顧客はメッセージの受信を許可していません（顧客情報 › 関係）。",
 "Sem telefone": "電話番号なし",
 "Coloque o telefone na ficha do cliente.": "顧客情報に電話番号を入力してください。",
 "Gerar recibo": "領収書を作成",
 "Como você recebe?": "受け取り方法",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "「一括」のみ：分割払いや赤い表示のないすっきりした画面。",
 "Taxa da maquininha (%)": "カード決済手数料（%）",
 "Taxa {k}": "{k}の手数料",
 "Cliente sumido depois de (dias sem comprar)": "ご無沙汰とみなすまで（購入なしの日数）",
 "Dias para considerar sumido": "ご無沙汰とみなす日数",
 "Lembretes de cobrança por parcela atrasada": "延滞分の支払いリマインダー",
 "Nome ou marca no recibo": "領収書の名前・ブランド名",
 "Ex.: Ana Beatriz Doces": "例：Ana Beatriz スイーツ",
 "Venda ou serviço": "販売またはサービス",
 "O que foi vendido ou feito": "販売・作業の内容",
 "Ex.: Bolo de aniversário": "例：バースデーケーキ",
 "Como paga": "支払い方法",
 "Sinal (%)": "手付金（%）",
 "Ou escreva o valor do sinal logo abaixo.": "または、すぐ下に手付金の金額を入力。",
 "Sinal (valor)": "手付金（金額）",
 "Restante na entrega": "残金は引き渡し時",
 "Próximo vencimento": "次回期日",
 "Sinal a receber": "未受領の手付金",
 "falta {v}{q}": "残り {v}{q}",
 "quitado": "完済",
 "Parcelas mantidas": "分割払いはそのまま",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "すでに支払いが記録されているため、分割払いは作り直していません。変更するには、先に支払いを取り消してください。",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "顧客が購入したもの、または行ったサービスと、支払い方法を記録します。",
 "Débito": "デビット",
 "Crédito à vista": "クレジット一括",
 "Crédito 2x": "クレジット2回払い",
 "Crédito 3x": "クレジット3回払い",
 "Crédito 4x": "クレジット4回払い",
 "Crédito 5x": "クレジット5回払い",
 "Crédito 6x": "クレジット6回払い",
 "Crédito 7x": "クレジット7回払い",
 "Crédito 8x": "クレジット8回払い",
 "Crédito 9x": "クレジット9回払い",
 "Crédito 10x": "クレジット10回払い",
 "Crédito 11x": "クレジット11回払い",
 "Crédito 12x": "クレジット12回払い",
 "ATRASADOS": "期限切れ",
 "Atrasado (hoje): {v}": "期限切れ（今日時点）：{v}",
 "Buscar um cliente": "顧客を検索",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "CPF/CNPJ全桁、住所全体、生年月日。アプリのパスワードが必要です。",
 "Cliente cadastrado": "顧客を登録しました",
 "Com documentos: guarde o arquivo em lugar seguro.": "書類あり：ファイルは安全な場所に保管してください。",
 "Como pagou": "支払い方法",
 "Esse contato não tem nome.": "この連絡先には名前がありません。",
 "Exportar planilha": "スプレッドシートを書き出す",
 "Falta receber": "未回収",
 "Falta receber (hoje): {v}": "未回収（今日時点）：{v}",
 "Importar dos contatos": "連絡先から読み込む",
 "Importar dos contatos do celular": "スマホの連絡先から読み込む",
 "Incluir documentos": "書類を含める",
 "Incluir documentos no relatório": "レポートに書類を含める",
 "MELHORES CLIENTES": "優良顧客",
 "Melhores clientes": "優良顧客",
 "Não foi possível gerar a planilha.": "スプレッドシートを作成できませんでした。",
 "O que foi": "内容",
 "Pago em": "支払日",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "スマホの連絡先から顧客を読み込むには、アプリストアで My Planner を更新してください。",
 "RECEBIDO POR DIA": "日別の受取額",
 "RECEBIDO POR MÊS": "月別の受取額",
 "Recebeu": "受取額",
 "Recebeu no período": "期間内の受取額",
 "Recebeu no período: {v}": "期間内の受取額：{v}",
 "Recebido no período": "期間内の受取額",
 "Relatório de clientes": "顧客レポート",
 "Relatório deste cliente": "この顧客のレポート",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "連絡先へのアクセスを許可しないと連絡先を選べません。スマホの設定で許可できます。",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "書類なし：CPF/CNPJは末尾2桁のみ表示されます。メモは含まれません。",
 "Todos os clientes": "すべての顧客",
 "Trabalha em: {e}": "勤務先：{e}",
 "Trazer outro": "別の連絡先を追加",
 "VENDAS E ATENDIMENTOS": "売上と対応",
 "Vence": "期限",
 "Venceu": "期限切れ",
 "Vendas e atendimentos": "売上と対応",
 "Vendeu": "売上額",
 "Vendeu no período": "期間内の売上額",
 "Vendeu no período: {v}": "期間内の売上額：{v}",
 "venceu {d}": "{d} に期限切れ",
 "vendido no período": "期間内の売上",
 "{nome} comprou no período": "{nome} の期間内の購入額",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} を「マイ顧客」に追加しました。詳細を確認し、メッセージ受信の同意があるかを設定してください。",
 "{n} compra(s)": "{n} 件の購入",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "ボックスを左にスワイプでアーカイブ、右にスワイプで削除。ボックスの空いている所を長押ししてドラッグすると並べ替えできます。",
 "Bloco": "ブロック",
 "Confirme para apagar o grupo": "グループを削除するには確認してください",
 "Descer": "下へ",
 "Opções do bloco": "ブロックのオプション",
 "Exigências do destino": "渡航先の条件",
 "{n} para acertar": "精算待ち {n} 件",
 "{n} parada(s)": "立ち寄り先 {n} 件",
 "Cor do item selecionado": "選択した項目の色",
 "Abrir o grupo": "グループを開く",
 "Recolher o grupo": "グループを閉じる",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "ボックスを右にスワイプで削除、左にスワイプでアーカイブ。長押ししてドラッグで並べ替え。",
 "Editar subtítulo": "小見出しを編集",
 "Início da caixa": "ボックスの先頭",
 "Mover para…": "移動先…",
 "Mover {n} item(ns) para": "{n} 件を移動",
 "Opções do item": "項目のオプション",
 "Transformar em subtítulo": "小見出しに変換",
 "Transformar em texto": "テキストに変換",
 "esta caixa": "このボックス",
 "{a} de {n} feitos": "{n} 件中 {a} 件完了",
 "1 documento pedido atrasado": "依頼した書類 1 件が期限切れ",
 "1 pedido vence logo": "依頼 1 件の期限が近い",
 "A lista vem de \"Meus clientes\".": "リストは「マイ顧客」から取得されます。",
 "Abrir Meus clientes": "マイ顧客を開く",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "「事務所」と「クライアントポータル」のタブが 1 つになりました。",
 "Clientes com pendência": "未対応のある顧客",
 "Com pendência ({n})": "未対応 ({n})",
 "Conversa da equipe": "チームチャット",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "事務所を作成してチームを招待（アプリの友達または招待リンク）：チャット、ビデオ会議、社内書類。1 人で仕事ですか？「顧客」だけを使いましょう。",
 "Documentos internos": "社内書類",
 "Entrar com um código de convite": "招待コードで参加",
 "Escritório & Clientes": "事務所と顧客",
 "Escritórios: {n}": "事務所：{n}",
 "Esta parte é para quem trabalha com equipe": "ここはチームで働く人向けです",
 "Guias vencendo": "期限が近い納付書",
 "Minhas tarefas": "マイタスク",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "何も削除されていません：チーム、チャット、会議、書類、招待した顧客はそのままです。",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "まだ顧客がいません。「マイ顧客」で登録すると、すぐここに表示されます。",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "顧客と仕事をする人向け（1 人でもチームでも）：顧客ごとのフォルダ（書類、依頼、納付書）、チーム、チャット、会議、社内書類。",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "ポータルの顧客フォルダ：{c}（書類 {d} 件、依頼 {p} 件）",
 "Pessoa física": "個人",
 "Procurar por nome, CNPJ ou CPF": "名前、CNPJ、CPF で検索",
 "Reuniões hoje": "今日の会議",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "事務所（チーム）がありません。タップして作成するか、コードで参加。",
 "Só a equipe vê. Clientes nunca veem esta parte.": "チームだけが見られます。顧客には表示されません。",
 "Tudo em dia": "すべて対応済み",
 "Vencendo ({n})": "期限間近 ({n})",
 "chega na próxima versão": "次のバージョンで登場",
 "nos próximos 7 dias": "今後 7 日間",
 "vence amanhã": "明日期限",
 "vence hoje": "今日期限",
 "{doc} venceu em {d}": "{doc} は {d} に期限切れ",
 "{n} documentos pedidos atrasados": "依頼した書類 {n} 件が期限切れ",
 "{n} pedidos vencem logo": "依頼 {n} 件の期限が近い",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 対応済み · 🟡 期限が近い · 🔴 依頼の遅れまたは納付書の期限切れ",
 "Acesso ao gov.br": "gov.br のアクセス情報",
 "Alvará": "営業許可証",
 "Até o dia (do mês)": "期日（毎月）",
 "CCMEI (certificado do MEI)": "CCMEI（MEI の証明書）",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "WhatsApp でリマインドするには、顧客の電話番号を登録してください。",
 "Cartão CNPJ": "CNPJ カード",
 "Checklist criado": "チェックリストを作成しました",
 "Checklist de cliente novo": "新規顧客チェックリスト",
 "Cliente viu {doc}": "顧客が {doc} を確認しました",
 "Cole no app do banco, em Pix copia e cola.": "銀行アプリの Pix コピー＆ペーストに貼り付けてください。",
 "Cole no app do banco.": "銀行アプリに貼り付けてください。",
 "Comprovante de endereço": "住所証明書",
 "Contrato social e alterações": "定款および変更",
 "Copiado": "コピーしました",
 "Copiar Pix": "Pix をコピー",
 "Copiar código de barras": "バーコードをコピー",
 "Código de barras (linha digitável)": "バーコード（入力用番号）",
 "Dados bancários": "銀行口座情報",
 "Escreva o recado.": "メッセージを入力してください。",
 "Escritório enviou {doc}": "事務所が {doc} を送信しました",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "この顧客はメッセージの受信を許可していません（「マイ顧客」の情報を参照）。",
 "Extratos bancários": "銀行取引明細",
 "Ficha completa": "詳細情報",
 "Guia": "納付書",
 "Guias a pagar": "未払いの納付書",
 "Honorário": "報酬",
 "Honorário por": "報酬の単位",
 "Informes de rendimentos": "所得証明書",
 "Lembrar pelo WhatsApp": "WhatsApp でリマインド",
 "Ler a guia ou o boleto com a minha IA": "納付書や boleto を自分の AI で読み取る",
 "Lucro presumido": "推定利益課税",
 "Lucro real": "実額利益課税",
 "Nada ainda.": "まだありません。",
 "Nenhum pedido em aberto.": "未対応の依頼はありません。",
 "Notas fiscais emitidas": "発行済み請求書",
 "O cliente": "顧客",
 "O pedido entrou em Pedidos de documentos.": "依頼を「書類の依頼」に追加しました。",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "{nome}さん、こんにちは！不足しているもの：{itens}。こちらで送っていただけますか？",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "{nome}さん、こんにちは！不足しているもの：{itens}。こちらで送っていただけますか？",
 "Oi, {nome}! Tudo certo por aí?": "{nome}さん、こんにちは！お変わりありませんか？",
 "Pedido criado": "依頼を作成しました",
 "Pedido feito: {o}": "依頼済み：{o}",
 "Pedido recebido: {o}": "依頼を受領：{o}",
 "Pedidos pendentes": "未対応の依頼",
 "Pedir de novo todo mês": "毎月もう一度依頼する",
 "Pedir nova ({c})": "新しく依頼（{c}）",
 "Pendentes": "未対応",
 "Que tipo de cliente?": "どの種類の顧客ですか？",
 "RG e CPF": "RG と CPF",
 "RG e CPF do titular": "事業主の RG と CPF",
 "RG e CPF dos sócios": "共同経営者の RG と CPF",
 "Recados": "メッセージ",
 "Recados entre você e o cliente, presos à pasta dele.": "あなたと顧客のメッセージは、その顧客のフォルダーに保存されます。",
 "Responde ao pedido": "依頼への回答",
 "Tipo / regime": "種類 / 課税方式",
 "Visto pelo cliente em {d}": "{d} に顧客が確認",
 "Válido até": "有効期限",
 "ano": "年",
 "código Pix copia e cola, se houver": "Pix コピー＆ペーストのコード（あれば）",
 "data de vencimento": "支払期限",
 "documento": "書類",
 "linha digitável do boleto ou da guia, só números": "boleto または納付書の入力用番号（数字のみ）",
 "mês": "月",
 "novo": "新規",
 "todo mês, até o dia {n}": "毎月{n}日まで",
 "valor a pagar": "支払金額",
 "válido até {d}": "{d} まで有効",
 "{c} nova": "新しい {c}",
 "{doc} pago": "{doc} 支払い済み",
 "{n} a pagar": "未払い {n} 件",
 "{n} enviou {doc}": "{n} が {doc} を送信しました",
 "{n} novo(s)": "新規 {n} 件",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "書類の依頼を {n} 件作成しました（期限は7日）。",
 "{n} vencida(s)": "期限切れ {n} 件",
 "Última declaração do Imposto de Renda": "最新の所得税申告書",
 "Últimas guias pagas": "最近支払った納付書",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "オフィスのこの部分はまだサーバーに接続されていません。パソコンで 56-SERVIDOR-0.96.bat を実行してください（1回だけ）。",
 "Só vê": "閲覧のみ",
 "Nova versão": "新しいバージョン",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "同じ名前のファイルが既にあります。以前のファイルはバージョン {n} として保存されます。",
 "Visto por e comentários": "既読者とコメント",
 "Arquivar (só neste aparelho)": "アーカイブ（この端末のみ）",
 "Tirar do topo": "トップから外す",
 "Fixar no topo (para todos)": "トップに固定（全員向け）",
 "Mover para a pasta…": "フォルダに移動…",
 "versão {n}": "バージョン {n}",
 "visto por {n}": "{n} 人が既読",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "1ファイルあたり最大50 MB。同じ名前のファイルをアップロードすると、以前のファイルはバージョンとして保存されます。",
 "Procurar documento ou pasta": "ドキュメントまたはフォルダを検索",
 "Fixados": "固定済み",
 "Abrir o documento": "ドキュメントを開く",
 "enviado por {nome}": "{nome} がアップロード",
 "Versões ({n})": "バージョン ({n})",
 "Versão {n} (atual)": "バージョン {n}（現在）",
 "Versão {n}": "バージョン {n}",
 "Visto por ({n})": "既読 ({n})",
 "Ninguém da equipe abriu ainda.": "チームの誰もまだ開いていません。",
 "{nome} em {d}": "{nome}（{d}）",
 "Comentários ({n})": "コメント ({n})",
 "Escreva um comentário": "コメントを書く",
 "Contratos": "契約書",
 "Financeiro do escritório": "オフィスの財務",
 "RH": "人事",
 "Mover para a pasta": "フォルダに移動",
 "Ou escreva o nome de uma pasta nova": "または新しいフォルダ名を入力",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "毎週繰り返されます。キャンセルすると、すべての週、リスト、チームの受信から削除されます。",
 "a equipe toda": "チーム全員",
 "Com {quem}": "{quem} と",
 "toda semana": "毎週",
 "Vão: {n}": "参加：{n}",
 "Não vão: {n}": "不参加：{n}",
 "Vou": "参加する",
 "Não vou": "参加しない",
 "Pauta": "議題",
 "Ata": "議事録",
 "Escrever a ata": "議事録を書く",
 "Abrir o link": "リンクを開く",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "招待された人は受信にミーティングが届き、ワンタップで通知付きでPlannerに追加できます。",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "まずミーティングのメモ（話した内容と決定事項）を書いてください。AIが議事録にまとめます。",
 "Ata: {nome}": "議事録：{nome}",
 "Gerando...": "生成中...",
 "Gerar ata com a minha IA": "自分のAIで議事録を作成",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "AIが議題とメモを議事録にまとめます。保存前に確認してください。",
 "Ainda sem ata.": "議事録はまだありません。",
 "Tarefas da reunião ({n})": "ミーティングのタスク ({n})",
 "Tarefa da reunião": "ミーティングのタスク",
 "Salvar a ata": "議事録を保存",
 "Repetir toda semana ({dia})": "毎週繰り返す（{dia}）",
 "Quem participa": "参加者",
 "A equipe toda": "チーム全員",
 "Link externo (opcional: Meet, Zoom, Teams)": "外部リンク（任意：Meet, Zoom, Teams）",
 "O link precisa começar com https://": "リンクは https:// で始まる必要があります",
 "Marcar e avisar quem participa": "予定を入れて参加者に通知",
 "Cargo e papel": "役職と権限",
 "Passar o Admin": "管理者を譲渡",
 "Passar o Admin para {nome}?": "{nome} に管理者を譲渡しますか？",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} がオフィスの管理を担当します（削除も可能）。あなたは管理者としてチームに残ります（受け取った人が後で変更できます）。",
 "Passar": "譲渡",
 "{nome} agora cuida do escritório.": "{nome} がオフィスの管理を担当します。",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "ここでのあなたの権限は「閲覧のみ」です。お知らせ、タスク、ミーティング、ドキュメントを確認できます。",
 "Edita": "編集可",
 "Incluir": "追加",
 "Novo aviso no mural": "掲示板に新しいお知らせ",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "このオフィスは閲覧のみ可能です。管理者があなたに「閲覧のみ」の権限を設定しました。必要な場合は管理者に変更を依頼してください。",
 "Quem viu": "既読者",
 "Apagar aviso": "お知らせを削除",
 "Mural de avisos": "掲示板",
 "Novo aviso": "新しいお知らせ",
 "Ex.: Feriado na sexta: escritório fechado": "例：金曜は祝日のためオフィス休業",
 "Fixar no mural": "掲示板に固定",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "お知らせはありません。お知らせはここに固定され、チーム全員に表示されます。",
 "visto por {n} de {m}": "{m}人中{n}人が既読",
 "sem responsável": "担当者なし",
 "atrasada desde {d}": "{d} から期限超過",
 "prazo {d}": "期限 {d}",
 "Comecei": "開始した",
 "Terminei": "完了",
 "Reabrir": "再開",
 "Tarefas da equipe": "チームのタスク",
 "1 aberta": "未完了 1件",
 "{n} abertas": "未完了 {n}件",
 "Minhas tarefas ({n})": "自分のタスク ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "あなたの未完了タスクはありません。チームのタスクで「私がやる」をタップしてください。",
 "Nenhuma tarefa aberta.": "未完了のタスクはありません。",
 "Feitas ({n})": "完了 ({n})",
 "Apagar a tarefa?": "タスクを削除しますか？",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "何をする必要がありますか？（例：3月のDASを算出）",
 "Cliente (opcional)": "顧客（任意）",
 "Prazo (opcional)": "期限（任意）",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "担当者（任意。未設定の場合は誰かが「私がやる」をタップ）",
 "Escreva a tarefa para poder salvar.": "保存するにはタスクの内容を入力してください。",
 "Membro": "メンバー",
 "Cargo (livre)": "役職（自由入力）",
 "Ex.: Advogada, Assistente, Estagiário": "例：弁護士、アシスタント、インターン",
 "Papel": "権限",
 "Admin: pode tudo no escritório.": "管理者：オフィス内のすべての操作ができます。",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "編集可：タスク、お知らせ、ドキュメント、ミーティングを追加できます",
 "Só vê: acompanha tudo, sem incluir nem mudar": "閲覧のみ：すべて確認できますが、追加や変更はできません",
 "Proposta": "提案書",
 "Documento sensível (pede a senha do app para abrir)": "機密書類（開くときにアプリのパスワードが必要）",
 "Li e concordo: {d}": "確認・同意済み：{d}",
 "Li e concordo": "確認して同意します",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "「同意する」をタップすると、「{doc}」を読んで同意した日時をアプリが保存します。簡易的な同意で、正式な電子署名の代わりにはなりません。",
 "Concordo": "同意する",
 "Fotos (escolha quais entram)": "写真（入れるものを選ぶ）",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 枚の写真をこの端末で読み込めず、除外しました。",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} 枚の写真をこの端末で読み込めず、除外しました。",
 "Nenhuma foto no álbum desta viagem.": "この旅行のアルバムに写真がありません。",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "写真をタップして選択・解除します。PDF が軽くなるよう縮小して入ります。",
 "Sugerir até 12": "最大12枚を提案",
 "1 foto marcada": "1 枚選択",
 "{n} fotos marcadas": "{n} 枚選択",
 "Com mais de 12 fotos o PDF fica mais pesado.": "12枚を超えると PDF が重くなります。",
 "Confirme para abrir este documento": "この書類を開くには確認してください",
 "Como usar esta aba": "このタブの使い方",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 人の顧客が複数のタブにあり、1 件にまとめました。",
 "Juntar {n} fotos num PDF?": "{n} 枚の写真を1つのPDFにまとめますか？",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "写真はリストの順に1つのPDFのページになります。個別の写真はこのカードから削除されます。",
 "Não foi possível ler as fotos neste dispositivo.": "この端末では写真を読み込めませんでした。",
 "PDF criado": "PDFを作成しました",
 "Montando o PDF...": "PDFを作成中...",
 "Juntar as {n} fotos num PDF": "{n} 枚の写真を1つのPDFにまとめる",
 "Baixar o mês": "月をダウンロード",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "今月のファイルは別の端末にあるため、ここでは読み込めませんでした。",
 "Os documentos deste mês não têm arquivos.": "今月の書類にはファイルがありません。",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1件のファイルは別の端末にあるため、含まれていません。",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n}件のファイルは別の端末にあるため、含まれていません。",
 "Conversa sobre este documento": "この書類についてのやり取り",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "この書類について質問または返信できます。事務所とお客様の両方に表示されます。",
 "Escreva a mensagem": "メッセージを入力",
 "Usar um modelo de pedido ({n})": "リクエストのテンプレートを使う（{n}）",
 "Lembrar {nome} pelo WhatsApp: {o}": "WhatsAppで{nome}にリマインド：{o}",
 "Sem honorário": "報酬なし",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "「マイ顧客」にある顧客カードの「事務所」ブロックに報酬額を登録してください。",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "{c}より{v}を受領しました。{m}分の報酬です。",
 "Recibo honorário {m} {c}": "報酬領収書 {m} {c}",
 "Recibo do honorário {m}": "報酬領収書 {m}",
 "Recibo criado": "領収書を作成しました",
 "O recibo entrou em Documentos, na competência {m}.": "領収書は「書類」の{m}分に追加されました。",
 "Vendo como o cliente": "お客様として表示中",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "お客様にはフォルダがこのように見えます。社内メモやチーム専用の内容は表示されません。このモードでは何も変更できません。",
 "Voltar a ver como escritório": "事務所表示に戻る",
 "Ver como o cliente": "お客様として表示",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 社内メモ（お客様には表示されません）",
 "Recibo do honorário…": "報酬領収書…",
 "Competência do recibo": "領収書の対象月",
 "⬇️ Baixar o mês": "⬇️ 月をダウンロード",
 "Me avisar para lembrar o cliente": "お客様へのリマインドを通知する",
 "Guardar como modelo": "テンプレートとして保存",
 "Modelo guardado": "テンプレートを保存しました",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "任意のお客様のリクエストを作成するときに、「リクエストのテンプレートを使う」をタップしてください。",
 "Relatório do mês": "月次レポート",
 "Notas rápidas": "クイックメモ",
 "Item completo: {o}": "項目の全文：{o}",
 "Reuniões do mês": "今月の会議",
 "Tarefas feitas e pendentes": "完了済みと未完了のタスク",
 "Documentos internos enviados": "送信した社内書類",
 "Documentos enviados e recebidos dos clientes": "お客様との送受信書類",
 "Documentos da competência": "対象月の書類",
 "Guias pagas e vencidas": "支払済みと期限超過の納付書",
 "Honorários": "報酬",
 "Relatório do mês · {m}": "月次レポート · {m}",
 "Reuniões ({n})": "会議（{n}）",
 "Tarefas: {f} feitas no mês · {p} pendentes": "タスク：今月完了 {f}件 · 未完了 {p}件",
 "Quem fez": "担当者",
 "Feita em": "完了日",
 "Documentos internos enviados ({n})": "送信した社内書類（{n}）",
 "Documentos trocados com os clientes": "お客様とやり取りした書類",
 "Enviados pelo escritório": "事務所から送信",
 "Recebidos do cliente": "お客様から受信",
 "Nenhum documento trocado neste mês.": "今月やり取りした書類はありません。",
 "Clientes com pendência ({n})": "未対応のあるお客様（{n}）",
 "Pendência": "未対応事項",
 "Nenhum cliente com pendência.": "未対応のお客様はいません。",
 "Documentos da competência {m} ({n})": "{m}分の書類（{n}）",
 "Pedidos de documentos ({n})": "書類リクエスト（{n}）",
 "Guias do mês: {p} pagas · {v} vencidas": "今月の納付書：支払済み {p} · 期限超過 {v}",
 "Vencida": "期限超過",
 "Recebido no mês": "今月の受領額",
 "Relatório {m} {q}": "レポート {m} {q}",
 "MÊS": "月",
 "DE QUEM": "対象",
 "O escritório": "事務所",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "事務所（チーム）がある場合、会議・タスク・社内書類が含まれます。",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF、CNPJ、社内メモ、やり取りがレポートに含まれることはありません。",
 "Anotações recebidas": "受け取ったメモ",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "このリストの未収金額は My Planner に表示されます（新しいものも含む）。",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "このリストの未収金額だけを送ります（予約は自動で入ります）。新しいものも含みます。",
 "Acrescentar": "追加",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "{n} 個のボックスは {aba} の「受け取ったメモ」にあります。",
 "Enviadas": "送信しました",
 "Enviar para": "送信先",
 "Excluir 1 item?": "1 件を削除しますか？",
 "Excluir {n} itens?": "{n} 件を削除しますか？",
 "Inserir abaixo": "下に挿入",
 "Mover para": "移動先",
 "Mover {n} selecionados para": "選択した {n} 件の移動先",
 "adicionar aqui": "ここに追加",
 "continue segurando para selecionar": "長押しを続けて選択"
}
